{
  "version": 2,
  "generatedAt": "2026-09-25T21:38:12.566Z",
  "totalRecipes": 481,
  "recipes": [
    {
      "id": "bd023b96-4f7f-4dc7-9334-0b41c34b5e57",
      "title": "Aguachile Shrimp Salad",
      "image": "images/bd023b96-4f7f-4dc7-9334-0b41c34b5e57_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sea salt and black pepper",
        "peeled",
        "½ lime juice",
        "serrano chiles",
        "tightly packed cilantro leaves and tender stems",
        "tightly packed parsley leaves and tender stems",
        "tightly packed mint leaves",
        "full-fat sour cream",
        "mayonnaise",
        "cucumber",
        "tomatillos",
        "red onion",
        "avocado",
        "uette or tostadas"
      ],
      "searchText": "aguachile shrimp salad sea salt and black pepper peeled ½ lime juice serrano chiles tightly packed cilantro leaves and tender stems tightly packed parsley leaves and tender stems tightly packed mint leaves full-fat sour cream mayonnaise cucumber tomatillos red onion avocado uette or tostadas",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1027103-aguachile-shrimp-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 211,
      "translatedTitles": {
        "fr": "Salade de crevettes Aguachile"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 49
    },
    {
      "id": "6d913882-da5e-432c-9a0e-7d5d194db40d",
      "title": "Pain farci au saumon fumé, courgette et aneth",
      "image": "images/6d913882-da5e-432c-9a0e-7d5d194db40d_0.jpg",
      "servings": "1",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "courgette",
        "petit oignon rouge",
        "de yogourt grec nature",
        "de mayonnaise",
        "citron",
        "miche de pain d’environ 500",
        "pavé de saumon fumé à chaud d’environ 200",
        "de câpres",
        "d’aneth frais",
        "de jeunes épinards"
      ],
      "searchText": "pain farci au saumon fumé, courgette et aneth courgette petit oignon rouge de yogourt grec nature de mayonnaise citron miche de pain d’environ 500 pavé de saumon fumé à chaud d’environ 200 de câpres d’aneth frais de jeunes épinards",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/8242a408-dcd9-4678-a10b-6512a92f0f09__7C___0.html?utm_content=ulink&utm_source=lpp&utm_medium=referral&utm_campaign=internal+share",
      "translatedTitles": {
        "en": "Stuffed Loaf with Smoked Salmon, Zucchini and Dill"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "9db4a0d1-d08e-409d-b432-6b1ff3ba9293",
      "title": "Aperol sour",
      "image": "images/9db4a0d1-d08e-409d-b432-6b1ff3ba9293_0.jpg",
      "servings": "1 portion(s)",
      "readyInMinutes": 3,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de glaçons",
        "d’aperol ou autre liqueur d’orange amère",
        "de gin",
        "de jus de citron",
        "de sirop simple",
        "rondelle de citron"
      ],
      "searchText": "aperol sour de glaçons d’aperol ou autre liqueur d’orange amère de gin de jus de citron de sirop simple rondelle de citron",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9986-aperol-sour",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Aperol sour"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 3,
      "readyInMinutesMin": 3
    },
    {
      "id": "c250bda0-f96c-4dcc-a16f-5340b9d7fd81",
      "title": "Aubergines alla parmigiana",
      "image": "images/c250bda0-f96c-4dcc-a16f-5340b9d7fd81_0.jpg",
      "servings": "8",
      "readyInMinutes": 85,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "aubergines",
        "grosses aubergines coupées en longues tranches d’environ 1 cm d’épaisseur",
        "d’huile d’olive",
        "sauce tomate",
        "oignon",
        "gousses d’ail",
        "d’huile d’olive",
        "boîte de 796 de tomates broyées",
        "garniture",
        "feuilles de basilic",
        "de fromage mozzarella râpé",
        "de fromage parmesan frais râpé"
      ],
      "searchText": "aubergines alla parmigiana aubergines grosses aubergines coupées en longues tranches d’environ 1 cm d’épaisseur d’huile d’olive sauce tomate oignon gousses d’ail d’huile d’olive boîte de 796 de tomates broyées garniture feuilles de basilic de fromage mozzarella râpé de fromage parmesan frais râpé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6235-aubergines-alla-parmigiana",
      "sourceRating": 5,
      "sourceRatingCount": 96,
      "translatedTitles": {
        "en": "Eggplant alla parmigiana"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 85
    },
    {
      "id": "5ebacc32-241f-403b-8479-6948a22daf5f",
      "title": "Aubergines grillées de l'Argentine de Steven Raichlen",
      "image": "images/5ebacc32-241f-403b-8479-6948a22daf5f_0.jpg",
      "servings": "1",
      "readyInMinutes": 40,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "petites aubergines italiennes de 120 à 180 chacune",
        "gousses d'ail",
        "d'huile d'olive vierge",
        "d'origan séché",
        "de basilic séché",
        "de feuilles de thym frais",
        "de paprika doux",
        "sel et poivre noir fraîchement moulu"
      ],
      "searchText": "aubergines grillées de l'argentine de steven raichlen petites aubergines italiennes de 120 à 180 chacune gousses d'ail d'huile d'olive vierge d'origan séché de basilic séché de feuilles de thym frais de paprika doux sel et poivre noir fraîchement moulu",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/3904-aubergines-grillees-de-l-argentine-de-steven-raichlen",
      "sourceRating": 5,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Grilled Eggplant from Argentina by Steven Raichlen"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 36
    },
    {
      "id": "cebd75d8-3420-43de-b420-555a57a0488a",
      "title": "Avocado Corn Salad",
      "image": "images/cebd75d8-3420-43de-b420-555a57a0488a_0.jpg",
      "servings": "6 as a side salad",
      "readyInMinutes": 23,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cherry tomatoes",
        "ears of corn (cooked",
        "avocados (peeled",
        "red onion",
        "cilantro)",
        "olive oil",
        "to 3 lime juice",
        "garlic cloves",
        "sea salt",
        "black pepper"
      ],
      "searchText": "avocado corn salad cherry tomatoes ears of corn (cooked avocados (peeled red onion cilantro) olive oil to 3 lime juice garlic cloves sea salt black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://natashaskitchen.com/avocado-corn-salad/",
      "sourceRating": 4.99,
      "sourceRatingCount": 358,
      "translatedTitles": {
        "fr": "Salade de maïs et avocat"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 23
    },
    {
      "id": "2aeb91f8-7193-4a5c-9589-08d8994c4eca",
      "title": "Avocats grillés à la provençale",
      "image": "images/2aeb91f8-7193-4a5c-9589-08d8994c4eca_0.jpg",
      "servings": "4",
      "readyInMinutes": 40,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de chair de tomate",
        "d'ail",
        "d'échalote française",
        "de basilic frais",
        "d'huile d'olive",
        "sel et poivre noir du moulin",
        "avocats",
        "de parmesan frais",
        "de chapelure"
      ],
      "searchText": "avocats grillés à la provençale de chair de tomate d'ail d'échalote française de basilic frais d'huile d'olive sel et poivre noir du moulin avocats de parmesan frais de chapelure",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.saq.com/fr/avocats-grilles-provencale",
      "translatedTitles": {
        "en": "Grilled Provençal Avocados"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 39
    },
    {
      "id": "ddb109fb-fce1-4a90-a952-33864dc71b21",
      "title": "Baguette au fromage, aux pommes et au miel",
      "image": "images/ddb109fb-fce1-4a90-a952-33864dc71b21_0.jpg",
      "servings": "6",
      "readyInMinutes": 24,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "uette de pain",
        "fromage camembert ou brie",
        "paes naturelles",
        "pommes",
        "roquette",
        "miel"
      ],
      "searchText": "baguette au fromage, aux pommes et au miel uette de pain fromage camembert ou brie paes naturelles pommes roquette miel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/baguette-fromage-pommes-miel/",
      "translatedTitles": {
        "en": "Baguette with cheese, apples, and honey"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 21
    },
    {
      "id": "75669955-3efd-42ce-a9d0-30ae56bff42c",
      "title": "Baked Chicken Drumsticks",
      "image": "images/75669955-3efd-42ce-a9d0-30ae56bff42c_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 53,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "smoked paprika",
        "onion powder",
        "garlic powder",
        "kosher salt",
        "black pepper",
        "chicken drumsticks",
        "- olive oil",
        "parsley"
      ],
      "searchText": "baked chicken drumsticks smoked paprika onion powder garlic powder kosher salt black pepper chicken drumsticks - olive oil parsley",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026479-baked-chicken-drumsticks?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 809,
      "translatedTitles": {
        "fr": "Pilons de Poulet au Four"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 48
    },
    {
      "id": "261ca100-fc10-451b-ac0e-6edfec238d69",
      "title": "Baked Chicken Drumsticks",
      "image": "images/261ca100-fc10-451b-ac0e-6edfec238d69_0.jpg",
      "servings": "4",
      "readyInMinutes": 53,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "smoked paprika",
        "onion powder",
        "garlic powder",
        "kosher salt",
        "black pepper",
        "chicken drumsticks",
        "- olive oil",
        "parsley"
      ],
      "searchText": "baked chicken drumsticks smoked paprika onion powder garlic powder kosher salt black pepper chicken drumsticks - olive oil parsley",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026479-baked-chicken-drumsticks?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 809,
      "translatedTitles": {
        "fr": "Pilons de poulet au four"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 48
    },
    {
      "id": "558755ee-ea49-4c42-8875-6d6d851651ac",
      "title": "Baked Quinoa Falafel Sandwiches",
      "image": "images/558755ee-ea49-4c42-8875-6d6d851651ac_0.jpg",
      "servings": "4 sandwiches",
      "readyInMinutes": 92,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "quinoa",
        "vegetable broth",
        "cooked or ned chickpeas",
        "onion",
        "garlic cloves",
        "cumin",
        "coriander",
        "cilantro",
        "lemon juice",
        "olive oil",
        "salt and pepper to taste",
        "pitas",
        "hummus and/or tahini",
        "greens"
      ],
      "searchText": "baked quinoa falafel sandwiches quinoa vegetable broth cooked or ned chickpeas onion garlic cloves cumin coriander cilantro lemon juice olive oil salt and pepper to taste pitas hummus and/or tahini greens",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.connoisseurusveg.com/baked-quinoa-falafel-sandwiches/#recipe",
      "sourceRating": 5,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "fr": "Sandwichs de falafel de quinoa au four"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 92
    },
    {
      "id": "fabfb08d-dc8f-44ef-ac6e-db272863884a",
      "title": "Banana Nut Chocolate Chip Muffins",
      "image": "images/fabfb08d-dc8f-44ef-ac6e-db272863884a_0.jpg",
      "servings": "Yield: 9 1x",
      "readyInMinutes": 64,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bananas",
        "eggs",
        "maple syrup",
        "vanilla ct",
        "smooth almond butter",
        "coconut flour",
        "cinnamon",
        "baking soda",
        "baking powder",
        "pinch of salt",
        "walnuts",
        "eating evolved baking chocolate"
      ],
      "searchText": "banana nut chocolate chip muffins bananas eggs maple syrup vanilla ct smooth almond butter coconut flour cinnamon baking soda baking powder pinch of salt walnuts eating evolved baking chocolate",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://paleomg.com/banana-nut-chocolate-chip-muffins/",
      "sourceRating": 4.9,
      "sourceRatingCount": 39,
      "translatedTitles": {
        "fr": "Muffins aux bananes, noix et pépites de chocolat"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 64
    },
    {
      "id": "f164b781-cc10-4a82-8d2b-99321afba383",
      "title": "Barbacoa Beef Tacos with Two Sauces",
      "image": "images/f164b781-cc10-4a82-8d2b-99321afba383_0.jpg",
      "servings": "Serves : 6",
      "readyInMinutes": 260,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ancho chiles",
        "chipotle chiles",
        "celery ribs",
        "carrots",
        "onion",
        "garlic cloves",
        "bay leaves",
        "six 1-.",
        "oregano",
        "cumin",
        "kosher salt",
        "pepper",
        "warm corn tortillas",
        "salsa verde cruda"
      ],
      "searchText": "barbacoa beef tacos with two sauces ancho chiles chipotle chiles celery ribs carrots onion garlic cloves bay leaves six 1-. oregano cumin kosher salt pepper warm corn tortillas salsa verde cruda main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/barbacoa-beef-tacos-two-sauces",
      "translatedTitles": {
        "fr": "Tacos de bœuf Barbacoa avec deux sauces"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 50,
      "readyInMinutesMin": 260
    },
    {
      "id": "f7202221-1111-4e7e-9655-8285ac3a2f0d",
      "title": "Barbecue Vegetable Salad",
      "image": "images/f7202221-1111-4e7e-9655-8285ac3a2f0d_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 44,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bunch lacinato kale",
        "salt and black pepper",
        "head romaine",
        "bunch cilantro",
        "store-bought or homemade barbecue sauce",
        "¼ lime juice",
        "white beans",
        "ripe",
        "red onion",
        "grilling vegetables",
        "neutral oil such as grapeseed",
        "handful of corn chips"
      ],
      "searchText": "barbecue vegetable salad bunch lacinato kale salt and black pepper head romaine bunch cilantro store-bought or homemade barbecue sauce ¼ lime juice white beans ripe red onion grilling vegetables neutral oil such as grapeseed handful of corn chips",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025571-barbecue-vegetable-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 137,
      "translatedTitles": {
        "fr": "Salade de légumes au barbecue"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 44,
      "readyInMinutesMin": 36
    },
    {
      "id": "750c4888-223b-4cbc-8df6-a9ab4be2a377",
      "title": "Barbecue Vegetable Salad",
      "image": "images/750c4888-223b-4cbc-8df6-a9ab4be2a377_0.jpg",
      "servings": "4",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bunch lacinato kale",
        "salt and black pepper",
        "head romaine",
        "bunch cilantro",
        "store-bought or homemade barbecue sauce",
        "¼ lime juice",
        "white beans",
        "ripe",
        "red onion",
        "grilling vegetables",
        "neutral oil such as grapeseed",
        "handful of corn chips"
      ],
      "searchText": "barbecue vegetable salad bunch lacinato kale salt and black pepper head romaine bunch cilantro store-bought or homemade barbecue sauce ¼ lime juice white beans ripe red onion grilling vegetables neutral oil such as grapeseed handful of corn chips",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025571-barbecue-vegetable-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 137,
      "translatedTitles": {
        "fr": "Salade de Légumes Barbecue"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 48,
      "readyInMinutesMin": 40
    },
    {
      "id": "fee2c1a0-ba92-4e09-93d3-cf5143c1e06f",
      "title": "Barre granola sans cuisson au soya",
      "image": "images/fee2c1a0-ba92-4e09-93d3-cf5143c1e06f_0.jpg",
      "servings": "16 barres",
      "readyInMinutes": 137,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de riz soufflé",
        "de flocons de soya",
        "de flocons d'avoine à cuisson rapide",
        "de fèves de soya rôties non salées",
        "de noix (noisettes",
        "de sirop d'érable",
        "de beurre",
        "de cassonade",
        "de beurre de soya",
        "½ bouchon d'essence d'amande",
        "de confiture de framboises"
      ],
      "searchText": "barre granola sans cuisson au soya de riz soufflé de flocons de soya de flocons d'avoine à cuisson rapide de fèves de soya rôties non salées de noix (noisettes de sirop d'érable de beurre de cassonade de beurre de soya ½ bouchon d'essence d'amande de confiture de framboises",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/5799/barre-granola-sans-cuisson-au-soya?fbclid=IwAR3gqKNlf3YY_M5bSjpoIy29llL6FFP0NrfpOHoa7Lw3rN7Cj8w6RAqByZA",
      "translatedTitles": {
        "en": "No-Bake Granola Bar with Soy"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 137
    },
    {
      "id": "fd812600-92aa-4d3a-95fa-87fb047c1eb0",
      "title": "Barres tendres",
      "image": "images/fd812600-92aa-4d3a-95fa-87fb047c1eb0_0.jpg",
      "servings": "18 barres",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de neberges",
        "de riz soufflé",
        "de flocons d'avoine à cuisson rapide",
        "de noix de coco râpée",
        "d'amandes tranchées",
        "de graines de lin moulues",
        "oeufs",
        "d'huile véétale",
        "de miel"
      ],
      "searchText": "barres tendres de neberges de riz soufflé de flocons d'avoine à cuisson rapide de noix de coco râpée d'amandes tranchées de graines de lin moulues oeufs d'huile véétale de miel collation",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2309/barres-tendres",
      "translatedTitles": {
        "en": "Soft Bars"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 38
    },
    {
      "id": "9ba67de6-0203-451a-818c-087a00a3c2f0",
      "title": "BBQ Pepper Shrimp",
      "image": "images/9ba67de6-0203-451a-818c-087a00a3c2f0_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unsalted butter",
        "shrimp",
        "salt",
        "- olive oil",
        "garlic cloves",
        "shallot",
        "dry white wine",
        "rosemary sprig",
        "thyme sprig",
        "heavy cream",
        "worcestershire sauce",
        "cayenne hot sauce",
        "lemon juice",
        "coarsely black pepper",
        "crusty bread or cooked pasta"
      ],
      "searchText": "bbq pepper shrimp unsalted butter shrimp salt - olive oil garlic cloves shallot dry white wine rosemary sprig thyme sprig heavy cream worcestershire sauce cayenne hot sauce lemon juice coarsely black pepper crusty bread or cooked pasta",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026093-bbq-pepper-shrimp?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 878,
      "translatedTitles": {
        "fr": "Crevettes au poivre BBQ"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "7cc941cc-d074-4261-8191-95737e470255",
      "title": "BBQ Pepper Shrimp",
      "image": "images/7cc941cc-d074-4261-8191-95737e470255_0.jpg",
      "servings": "4",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unsalted butter",
        "shrimp",
        "salt",
        "- olive oil",
        "garlic cloves",
        "shallot",
        "dry white wine",
        "rosemary sprig",
        "thyme sprig",
        "heavy cream",
        "worcestershire sauce",
        "cayenne hot sauce",
        "lemon juice",
        "coarsely black pepper",
        "crusty bread or cooked pasta"
      ],
      "searchText": "bbq pepper shrimp unsalted butter shrimp salt - olive oil garlic cloves shallot dry white wine rosemary sprig thyme sprig heavy cream worcestershire sauce cayenne hot sauce lemon juice coarsely black pepper crusty bread or cooked pasta",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026093-bbq-pepper-shrimp?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 878,
      "translatedTitles": {
        "fr": "Crevettes au poivre BBQ"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "47fa27fa-0f2c-44de-865c-178f0ef6464e",
      "title": "Beef Empanadas",
      "image": "images/47fa27fa-0f2c-44de-865c-178f0ef6464e_0.jpg",
      "servings": "36 empanadas",
      "readyInMinutes": 90,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "lard or butter",
        "fine sea salt",
        "all-purpose flour",
        "beef chuck",
        "salt and pepper",
        "lard or olive oil",
        "onion",
        "chorizo",
        "potatoes",
        "garlic cloves",
        "thyme",
        "marjoram or 1 oregano",
        "tomato paste",
        "pimentón dulce or paprika",
        "pinch cayenne",
        "beef or chicken broth",
        "scallions",
        "pitted green olives",
        "hard-cooked eggs"
      ],
      "searchText": "beef empanadas lard or butter fine sea salt all-purpose flour beef chuck salt and pepper lard or olive oil onion chorizo potatoes garlic cloves thyme marjoram or 1 oregano tomato paste pimentón dulce or paprika pinch cayenne beef or chicken broth scallions pitted green olives hard-cooked eggs",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1014844-beef-empanadas?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1938,
      "translatedTitles": {
        "fr": "Empanadas de bœuf"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "25997c7e-0be4-4faa-98bc-78bdc1fcff87",
      "title": "Beef Stroganoff",
      "image": "images/25997c7e-0be4-4faa-98bc-78bdc1fcff87_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "kosher salt and ly black pepper",
        "sirloin roast",
        "all-purpose flour",
        "hot paprika",
        "neutral oil",
        "unsalted butter",
        "button mushrooms",
        "shallots",
        "wide egg noodles",
        "dry white wine",
        "heavy cream or crème fraîche",
        "worcestershire sauce",
        "dijon mustard",
        "parsley"
      ],
      "searchText": "beef stroganoff kosher salt and ly black pepper sirloin roast all-purpose flour hot paprika neutral oil unsalted butter button mushrooms shallots wide egg noodles dry white wine heavy cream or crème fraîche worcestershire sauce dijon mustard parsley",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1020862-beef-stroganoff?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 4507,
      "translatedTitles": {
        "fr": "Bœuf Stroganoff"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 52,
      "readyInMinutesMin": 53
    },
    {
      "id": "c6d3fe4b-3ef9-4e30-b216-aa762a8a3431",
      "title": "Beet, Orange and Arugula Salad",
      "image": "images/c6d3fe4b-3ef9-4e30-b216-aa762a8a3431_0.jpg",
      "servings": "Serves 4",
      "readyInMinutes": 14,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ly squeezed orange juice",
        "balsamic vinegar",
        "sherry vinegar or red wine vinegar",
        "salt and ly pepper to taste",
        "grapeseed oil or sunflower oil",
        "olive oil",
        "or 4 beets",
        "oranges",
        "wild or baby arugula",
        "cilantro",
        "walnuts"
      ],
      "searchText": "beet, orange and arugula salad ly squeezed orange juice balsamic vinegar sherry vinegar or red wine vinegar salt and ly pepper to taste grapeseed oil or sunflower oil olive oil or 4 beets oranges wild or baby arugula cilantro walnuts",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1015857-beet-orange-and-arugula-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1089,
      "translatedTitles": {
        "fr": "Salade de betteraves, d'oranges et de roquette"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 14
    },
    {
      "id": "b28890c8-8f76-482b-8f0b-05ec059ed996",
      "title": "Best Gazpacho",
      "image": "images/b28890c8-8f76-482b-8f0b-05ec059ed996_0.jpg",
      "servings": "8 to 12 servings, about 1 quart",
      "readyInMinutes": 746,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "about 2 ripe red tomatoes",
        "italian frying pepper or another long",
        "cucumber",
        "mild onion",
        "clove garlic",
        "sherry vinegar",
        "salt",
        "- olive oil"
      ],
      "searchText": "best gazpacho about 2 ripe red tomatoes italian frying pepper or another long cucumber mild onion clove garlic sherry vinegar salt - olive oil",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1017577-best-gazpacho?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 16471,
      "translatedTitles": {
        "fr": "Meilleur Gaspacho"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 386
    },
    {
      "id": "899147d6-c315-40b1-8bbc-7ef2d4c8a637",
      "title": "Bettes à carde à l'asiatique",
      "image": "images/899147d6-c315-40b1-8bbc-7ef2d4c8a637_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 18,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bottes de bettes à carde (2",
        "d'huile d'olive",
        "de sauce aux huîtres",
        "d'huile de sésame grillé",
        "de gingembre frais",
        "de sambal oeleck ou au goût"
      ],
      "searchText": "bettes à carde à l'asiatique bottes de bettes à carde (2 d'huile d'olive de sauce aux huîtres d'huile de sésame grillé de gingembre frais de sambal oeleck ou au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/2350-bettes-a-carde-a-l-asiatique",
      "sourceRating": 4,
      "sourceRatingCount": 9,
      "translatedTitles": {
        "en": "Asian Swiss Chard"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 18
    },
    {
      "id": "5ffea921-631f-44b1-abbf-733d8a128642",
      "title": "Bettes à carde à la crème d’estragon",
      "image": "images/5ffea921-631f-44b1-abbf-733d8a128642_0.jpg",
      "servings": "1",
      "readyInMinutes": 67,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "– 2 gousses d’ail hachées",
        "– 30 d’estragon haché",
        "– 60 de noilly prat",
        "– 150 de crème à cuisson",
        "– 45 de fromage",
        "– 30 de beurre",
        "– sel et poivre"
      ],
      "searchText": "bettes à carde à la crème d’estragon – 2 gousses d’ail hachées – 30 d’estragon haché – 60 de noilly prat – 150 de crème à cuisson – 45 de fromage – 30 de beurre – sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ledevoir.com/plaisirs/recettes/477027/recette-de-la-semaine-bettes-a-carde-a-la-creme-d-estragon?",
      "translatedTitles": {
        "en": "Swiss Chard with Tarragon Cream"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 67
    },
    {
      "id": "a12cf5ab-a479-4eba-9aab-75f96a5f0e06",
      "title": "Bircher muesli aux bleuets",
      "image": "images/a12cf5ab-a479-4eba-9aab-75f96a5f0e06_0.jpg",
      "servings": "4 à 6",
      "readyInMinutes": 737,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasses de gros flocons d’avoine sans gluten ou ordinaires",
        "c. à soupe de graines de chanvre",
        "poire non pelée",
        "pomme verte non pelée",
        "c. à soupe de jus de citron",
        "c. à thé (1",
        "c. à thé (2",
        "tasse de dattes hachées finement et bien tassées",
        "conserve de 400 de lait de coco léger",
        "tasse de yogourt nature véétal ou ordinaire",
        "tasse de sirop d’érable",
        "tasse de noix de grenoble",
        "tasse de bleuets frais ou surgelés",
        "tasse de bleuets frais",
        "tasse d’amandes tranchées"
      ],
      "searchText": "bircher muesli aux bleuets tasses de gros flocons d’avoine sans gluten ou ordinaires c. à soupe de graines de chanvre poire non pelée pomme verte non pelée c. à soupe de jus de citron c. à thé (1 c. à thé (2 tasse de dattes hachées finement et bien tassées conserve de 400 de lait de coco léger tasse de yogourt nature véétal ou ordinaire tasse de sirop d’érable tasse de noix de grenoble tasse de bleuets frais ou surgelés tasse de bleuets frais tasse d’amandes tranchées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/bircher-muesli-aux-bleuets/",
      "translatedTitles": {
        "en": "Bircher muesli with blueberries"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 257
    },
    {
      "id": "7dd523c3-cc8c-4290-ba4a-baf4ceef8a53",
      "title": "Birria de Res",
      "image": "images/7dd523c3-cc8c-4290-ba4a-baf4ceef8a53_0.jpg",
      "servings": "8 to 10 servings",
      "readyInMinutes": 165,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poblano chiles",
        "guajillo chiles",
        "bone-in beef shoulder",
        "fine sea salt",
        "neutral oil",
        "white onion",
        "tomatoes",
        "plus 2 distilled white vinegar",
        "garlic cloves",
        "finely grated ginger",
        "mexi oregano",
        "toasted white sesame seeds",
        "cumin",
        "cloves",
        "black pepper",
        "cinnamon stick",
        "or bay leaves",
        "cilantro",
        "limes",
        "corn tortillas"
      ],
      "searchText": "birria de res poblano chiles guajillo chiles bone-in beef shoulder fine sea salt neutral oil white onion tomatoes plus 2 distilled white vinegar garlic cloves finely grated ginger mexi oregano toasted white sesame seeds cumin cloves black pepper cinnamon stick or bay leaves cilantro limes corn tortillas",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021858-birria-de-res",
      "sourceRating": 4,
      "sourceRatingCount": 3168,
      "translatedTitles": {
        "fr": "Birria de Res"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "1b102f88-781f-42c7-89f2-8e7d630851bc",
      "title": "Biryani au poulet et au chou-fleur",
      "image": "images/1b102f88-781f-42c7-89f2-8e7d630851bc_0.jpg",
      "servings": "6 portions",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignons verts",
        "hauts de cuisse de poulet désossés",
        "de riz basmati brun",
        "de bouillon de poulet réduit en sodium",
        "sac de 400 de chou-fleur haché finement",
        "d'ail haché en pot",
        "de gingembre haché en pot",
        "de curcuma moulu",
        "de paprika doux",
        "de garam masala",
        "de coriandre moulue",
        "de cardamome moulue",
        "anis étoilés",
        "bâtons de nelle",
        "de sel",
        "de coriandre fraîche hachée",
        "de noix de cajou naturelles",
        "lime ou 1 citron en quartiers"
      ],
      "searchText": "biryani au poulet et au chou-fleur oignons verts hauts de cuisse de poulet désossés de riz basmati brun de bouillon de poulet réduit en sodium sac de 400 de chou-fleur haché finement d'ail haché en pot de gingembre haché en pot de curcuma moulu de paprika doux de garam masala de coriandre moulue de cardamome moulue anis étoilés bâtons de nelle de sel de coriandre fraîche hachée de noix de cajou naturelles lime ou 1 citron en quartiers",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2641/biryani-au-poulet-et-au-chou-fleur?fbclid=IwAR1X8WvjDasnGCR_bo_84n0yA9ykSne2noM0iI2Nwbcybd7g6t_Io7OWJHk",
      "translatedTitles": {
        "en": "Chicken and Cauliflower Biryani"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "51067595-4816-4539-8882-88f6a8be45d3",
      "title": "Biscuit géant choco-caramel aux pacanes",
      "servings": "12",
      "readyInMinutes": 87,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de farine tout usage non blanchie",
        "de sel",
        "de beurre non salé",
        "de cassonade",
        "jaunes d’œufs",
        "d’it de vanille",
        "de chocolat noir",
        "de sauce au caramel",
        "de paes grillées"
      ],
      "searchText": "biscuit géant choco-caramel aux pacanes de farine tout usage non blanchie de sel de beurre non salé de cassonade jaunes d’œufs d’it de vanille de chocolat noir de sauce au caramel de paes grillées collation",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8190-biscuit-geant-choco-caramel-aux-pacanes",
      "image": "images/51067595-4816-4539-8882-88f6a8be45d3_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 14,
      "translatedTitles": {
        "en": "Giant choco-caramel pecan cookie"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 87
    },
    {
      "id": "92fead1a-99cc-4485-9160-c09e7fd092de",
      "title": "Biscuits moelleux aux brisures de chocolat",
      "image": "images/92fead1a-99cc-4485-9160-c09e7fd092de_0.jpg",
      "servings": "16 biscuits",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de haricots blancs rincés et égouttés",
        "d'eau",
        "de cassonade léèrement tassée",
        "de beurre ramolli",
        "oeufs",
        "de vanille",
        "de farine de blé entier",
        "de poudre à pâte",
        "de nelle moulue",
        "de brisures de chocolat mi-sucré"
      ],
      "searchText": "biscuits moelleux aux brisures de chocolat de haricots blancs rincés et égouttés d'eau de cassonade léèrement tassée de beurre ramolli oeufs de vanille de farine de blé entier de poudre à pâte de nelle moulue de brisures de chocolat mi-sucré dessert",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2306/biscuits-moelleux-aux-brisures-de-chocolat",
      "sourceRating": 4,
      "sourceRatingCount": 100,
      "translatedTitles": {
        "en": "Soft Chocolate Chip Cookies"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 59
    },
    {
      "id": "a8b2ed9e-2017-4384-a7db-b29dcff5434c",
      "title": "Black Cod with Miso",
      "image": "images/a8b2ed9e-2017-4384-a7db-b29dcff5434c_0.jpg",
      "servings": "2",
      "readyInMinutes": 644,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "mirin",
        "sake",
        "white miso paste",
        "sugar",
        "skinless black cod fillets",
        "vegetable oil",
        "pickled ginger"
      ],
      "searchText": "black cod with miso mirin sake white miso paste sugar skinless black cod fillets vegetable oil pickled ginger main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/black-cod-miso?utm_source=facebook.com&utm_medium=social%2520&utm_content=video&utm_campaign=foodandwine&fbclid=IwAR1i8JMJRRDjIKtFinheSatClVXY3UZFm85IuoRCZKPrTmfBUeldMHVsT2s_aem_AdB8Fli4AKgHn7elFmwOAYs3pmsF2rxc2tLtOVFFFUDS9D0Ir39r8yOSkFKTEigPz4s",
      "translatedTitles": {
        "fr": "Morue noire au miso"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 524
    },
    {
      "id": "25af1971-c35e-4d6c-a7f5-4c84f6afa021",
      "title": "Blistered Asparagus with Peanut-Coconut Sprinkle",
      "image": "images/25af1971-c35e-4d6c-a7f5-4c84f6afa021_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 16,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        ". vegetable oil",
        ". asparagus",
        "fresno chile",
        ". soy sauce",
        ". lime juice",
        ". honey",
        ". toasted sesame oil",
        ". finely grated peeled ginger",
        ". salted",
        ". toasted unsweetened shredded coconut"
      ],
      "searchText": "blistered asparagus with peanut-coconut sprinkle . vegetable oil . asparagus fresno chile . soy sauce . lime juice . honey . toasted sesame oil . finely grated peeled ginger . salted . toasted unsweetened shredded coconut plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/blistered-asparagus?intcid=inline_amp&_gl=1*33bm9h*_ga*YW1wLXNDM0pmNnpjalZGZVpPZmlkRE1YMVlJX3daaDJpREJUT1NpOHJBeEF6WFNkd3dGdE1mLWpoWS1zNjdTbzJlWDE",
      "sourceRating": 5,
      "sourceRatingCount": 7,
      "translatedTitles": {
        "fr": "Asperges Blisterées avec Saupoudrage Cacahuète-Noix de Coco"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 16
    },
    {
      "id": "a2489b23-050f-5c8a-8e5d-12fdb9fdeea3",
      "title": "Blueberry Cheesecake",
      "image": "images/a2489b23-050f-5c8a-8e5d-12fdb9fdeea3_0.jpg",
      "servings": "12",
      "readyInMinutes": 70,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "graham cracker crumbs / 8 digestive biscuit crumbs",
        "/50g butter",
        "./600g cream cheese",
        "all-purpose flour",
        "/175g caster sugar",
        "eggs",
        "pot soured cream",
        "vanilla ct",
        "/ 300g or blueberries",
        "icing sugar"
      ],
      "searchText": "blueberry cheesecake graham cracker crumbs / 8 digestive biscuit crumbs /50g butter ./600g cream cheese all-purpose flour /175g caster sugar eggs pot soured cream vanilla ct / 300g or blueberries icing sugar dessert",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceRating": 4.97,
      "sourceRatingCount": 117,
      "translatedTitles": {
        "fr": "Cheesecake aux myrtilles"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 63
    },
    {
      "id": "a8e31651-0020-477a-be0e-23a7c1f0ff41",
      "title": "Boeuf bourguignon (le meilleur)",
      "image": "images/a8e31651-0020-477a-be0e-23a7c1f0ff41_0.jpg",
      "servings": "6",
      "readyInMinutes": 176,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boeuf",
        "de beurre",
        "de farine tout usage non blanchie",
        "de flanc de porc frais",
        "d’huile d’olive",
        "gros oignon",
        "carotte",
        "gousses d’ail",
        "de brandy",
        "de vin rouge",
        "de bouillon de bœuf réduit en sel",
        "branche de thym frais",
        "feuille de laurier",
        "garniture",
        "de champignons blancs",
        "de petits oignons blancs perlés",
        "de beurre",
        "de persil frais ciselé"
      ],
      "searchText": "boeuf bourguignon (le meilleur) boeuf de beurre de farine tout usage non blanchie de flanc de porc frais d’huile d’olive gros oignon carotte gousses d’ail de brandy de vin rouge de bouillon de bœuf réduit en sel branche de thym frais feuille de laurier garniture de champignons blancs de petits oignons blancs perlés de beurre de persil frais ciselé plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7859-boeuf-bourguignon-le-meilleur",
      "sourceRating": 5,
      "sourceRatingCount": 99,
      "translatedTitles": {
        "en": "Beef Bourguignon (The Best)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 73,
      "readyInMinutesMin": 176
    },
    {
      "id": "4c09fba7-7e8d-43b9-ade2-a9a1053b6d84",
      "title": "Boeuf braisé au vin rouge",
      "image": "images/4c09fba7-7e8d-43b9-ade2-a9a1053b6d84_0.jpg",
      "servings": "6",
      "readyInMinutes": 284,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "rôti de palette de boeuf désossé d’environ 1",
        "d’huile d’olive",
        "échalotes françaises",
        "de baies de genièvre concassées",
        "de muscade moulue",
        "de farine tout usage non blanchie",
        "de vin rouge",
        "de fond de veau",
        "de ketchup",
        "grosses carottes",
        "de pancetta",
        "de miel",
        "sel et poivre"
      ],
      "searchText": "boeuf braisé au vin rouge rôti de palette de boeuf désossé d’environ 1 d’huile d’olive échalotes françaises de baies de genièvre concassées de muscade moulue de farine tout usage non blanchie de vin rouge de fond de veau de ketchup grosses carottes de pancetta de miel sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6082-boeuf-braise-au-vin-rouge",
      "sourceRating": 5,
      "sourceRatingCount": 165,
      "translatedTitles": {
        "en": "Braised Beef in Red Wine"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 284
    },
    {
      "id": "33fd783d-5dec-4ed6-9b89-f671243a8bc4",
      "title": "Bœuf grillé à la citronnelle",
      "image": "images/33fd783d-5dec-4ed6-9b89-f671243a8bc4_0.jpg",
      "servings": "4",
      "readyInMinutes": 60,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bœuf",
        "de bavette de bœuf",
        "oignons",
        "gousses d’ail",
        "branche de citronnelle",
        "lime",
        "de sauce de poisson",
        "d’huile véétale",
        "garniture",
        "de vermicelles de riz",
        "concombres libanais",
        "de feuilles de coriandre",
        "d’arachides grillées",
        "de sauce ou trempette vietnamienne"
      ],
      "searchText": "bœuf grillé à la citronnelle bœuf de bavette de bœuf oignons gousses d’ail branche de citronnelle lime de sauce de poisson d’huile véétale garniture de vermicelles de riz concombres libanais de feuilles de coriandre d’arachides grillées de sauce ou trempette vietnamienne plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8173-b-uf-grille-a-la-citronnelle",
      "sourceRating": 4,
      "sourceRatingCount": 5,
      "translatedTitles": {
        "en": "Lemongrass Grilled Beef"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 47,
      "readyInMinutesMin": 58
    },
    {
      "id": "4fc50296-d033-4b1a-8c77-5497b24b17da",
      "title": "Bok choy au sésame",
      "image": "images/4fc50296-d033-4b1a-8c77-5497b24b17da_0.jpg",
      "servings": "4",
      "readyInMinutes": 15,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de mini bok choy",
        "d’huile d’olive",
        "d’huile de sésame grillé",
        "de bouillon de poulet",
        "de graines de sésame noires",
        "sel et poivre"
      ],
      "searchText": "bok choy au sésame de mini bok choy d’huile d’olive d’huile de sésame grillé de bouillon de poulet de graines de sésame noires sel et poivre plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5738-bok-choy-au-sesame",
      "sourceRating": 5,
      "sourceRatingCount": 42,
      "translatedTitles": {
        "en": "Sesame Bok Choy"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 10,
      "readyInMinutesMin": 15
    },
    {
      "id": "36741a6a-0034-43bd-84f8-eb4477a70d4c",
      "title": "Bol de brochettes de poulet aux herbes et mayo à la mangue",
      "image": "images/36741a6a-0034-43bd-84f8-eb4477a70d4c_0.jpg",
      "servings": "6",
      "readyInMinutes": 99,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de «yogourt» de coco nature",
        "c. à soupe de jus de lime",
        "tasse de menthe fraîche hachée",
        "tasse de coriandre fraîche hachée",
        "c. à soupe d’huile d’olive",
        "c. à soupe de miel",
        "gousse d’ail",
        "c. à thé de sel",
        "c. à thé (2",
        "poitrines de poulet désossées sans la peau",
        "brochettes de bois",
        "tasse de «yogourt» de coco nature",
        "tasse de mayonnaise",
        "mangue miel bien mûre",
        "c. à soupe de miel",
        "c. à soupe de jus de lime",
        "c. à thé de sauce piquante sriracha",
        "c. à thé (2",
        "tasses (1",
        "mangues jaunes en cubes",
        "concombres libanais",
        "coriandre fraîche ou menthe fraîche hachée",
        "piment chili frais"
      ],
      "searchText": "bol de brochettes de poulet aux herbes et mayo à la mangue tasse de «yogourt» de coco nature c. à soupe de jus de lime tasse de menthe fraîche hachée tasse de coriandre fraîche hachée c. à soupe d’huile d’olive c. à soupe de miel gousse d’ail c. à thé de sel c. à thé (2 poitrines de poulet désossées sans la peau brochettes de bois tasse de «yogourt» de coco nature tasse de mayonnaise mangue miel bien mûre c. à soupe de miel c. à soupe de jus de lime c. à thé de sauce piquante sriracha c. à thé (2 tasses (1 mangues jaunes en cubes concombres libanais coriandre fraîche ou menthe fraîche hachée piment chili frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/bol-de-brochettes-de-poulet-et-mayo-a-la-mangue/",
      "translatedTitles": {
        "en": "Herbed Chicken Skewers Bowl with Mango Mayo"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 57,
      "readyInMinutesMin": 96
    },
    {
      "id": "8b8681a8-e699-4038-ac55-1b8f1fc839b0",
      "title": "Bol de riz au porc croustillant et aux légumes marinés",
      "image": "images/8b8681a8-e699-4038-ac55-1b8f1fc839b0_0.jpg",
      "servings": "4",
      "readyInMinutes": 65,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "légumes marinés",
        "d’un mélange de légumes coupés en fine julienne (courgettes",
        "de chou vert émincé",
        "de vinaigre de riz",
        "de cassonade",
        "de sambal oelek",
        "riz",
        "de riz blanc calrose",
        "d’eau",
        "porc",
        "de farine tout usage non blanchie",
        "œufs",
        "de biscuits soda réduits en chapelure",
        "de côtelettes de porc désossées d’environ 2 cm d’épaisseur",
        "huile véétale",
        "sauce hoisin"
      ],
      "searchText": "bol de riz au porc croustillant et aux légumes marinés légumes marinés d’un mélange de légumes coupés en fine julienne (courgettes de chou vert émincé de vinaigre de riz de cassonade de sambal oelek riz de riz blanc calrose d’eau porc de farine tout usage non blanchie œufs de biscuits soda réduits en chapelure de côtelettes de porc désossées d’environ 2 cm d’épaisseur huile véétale sauce hoisin plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7482-bol-de-riz-au-porc-croustillant-et-aux-legumes-marines",
      "sourceRating": 5,
      "sourceRatingCount": 49,
      "translatedTitles": {
        "en": "Crispy Pork and Marinated Vegetable Rice Bowl"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "61f25f2a-310d-4b62-9596-ef41da8c3b67",
      "title": "Bol poké",
      "image": "images/61f25f2a-310d-4b62-9596-ef41da8c3b67_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 86,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de riz calrose",
        "d’eau",
        "de sauce soya",
        "d’huile de sésame grillé",
        "de vinaigre de riz",
        "de thon ou de saumon très frais sans la peau",
        "de graines de sésame noir",
        "de mayonnaise",
        "d’eau",
        "de sauce sriracha",
        "d’edamames surgelés",
        "concombres libanais",
        "carottes",
        "avocat",
        "de feuilles de coriandre",
        "quartiers de lime"
      ],
      "searchText": "bol poké de riz calrose d’eau de sauce soya d’huile de sésame grillé de vinaigre de riz de thon ou de saumon très frais sans la peau de graines de sésame noir de mayonnaise d’eau de sauce sriracha d’edamames surgelés concombres libanais carottes avocat de feuilles de coriandre quartiers de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8143-bol-poke",
      "sourceRating": 5,
      "sourceRatingCount": 49,
      "translatedTitles": {
        "en": "Poké Bowl"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 86
    },
    {
      "id": "ca8e276b-d6eb-4af3-bfec-656ded816a6e",
      "title": "Bols-repas au tofu laqué",
      "image": "images/ca8e276b-d6eb-4af3-bfec-656ded816a6e_0.jpg",
      "servings": "4",
      "readyInMinutes": 40,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de sauce soya à faible teneur en sodium",
        "de miel",
        "de vinaigre de riz",
        "de mayonnaise",
        "au goût sel",
        "de tofu ferme",
        "de fécule de maïs",
        "de huile véétale",
        "de graine de sésame grillée",
        "de nouilles de riz",
        "de laitue frisée",
        "carotte",
        "avocat",
        "quantité suffisante lime"
      ],
      "searchText": "bols-repas au tofu laqué de sauce soya à faible teneur en sodium de miel de vinaigre de riz de mayonnaise au goût sel de tofu ferme de fécule de maïs de huile véétale de graine de sésame grillée de nouilles de riz de laitue frisée carotte avocat quantité suffisante lime plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/7465/bols-repas-tofu-laque",
      "sourceRating": 4.5,
      "sourceRatingCount": 12,
      "translatedTitles": {
        "en": "Glazed Tofu Meal Bowls"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 38
    },
    {
      "id": "93f87a91-3533-4205-b113-482ebb2d5f39",
      "title": "Bols-repas au tofu laqué",
      "image": "images/93f87a91-3533-4205-b113-482ebb2d5f39_0.jpg",
      "servings": "4",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de sauce soya à faible teneur en sodium",
        "de miel",
        "de vinaigre de riz",
        "de mayonnaise",
        "au goût sel",
        "de tofu ferme",
        "de fécule de maïs",
        "de huile véétale",
        "de graine de sésame grillée",
        "de nouilles de riz",
        "de laitue frisée",
        "carotte",
        "avocat",
        "quantité suffisante lime"
      ],
      "searchText": "bols-repas au tofu laqué de sauce soya à faible teneur en sodium de miel de vinaigre de riz de mayonnaise au goût sel de tofu ferme de fécule de maïs de huile véétale de graine de sésame grillée de nouilles de riz de laitue frisée carotte avocat quantité suffisante lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/7465/bols-repas-tofu-laque",
      "sourceRating": 4.5,
      "sourceRatingCount": 12,
      "translatedTitles": {
        "en": "Glazed Tofu Meal Bowls"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 37,
      "readyInMinutesMin": 41
    },
    {
      "id": "08d6ed49-908d-40ff-babf-265054dc8048",
      "title": "Bouchées de brioche à la cannelle",
      "image": "images/08d6ed49-908d-40ff-babf-265054dc8048_0.jpg",
      "servings": "8 portions de 2 brioches",
      "readyInMinutes": 63,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de beurre fondu",
        "de cassonade léèrement tassée",
        "pomme cortland râpée avec la pelure",
        "de paes hachées",
        "de nelle moulue",
        "tranches épaisses de pain ménage de blé entier",
        "de jus de pomme pur"
      ],
      "searchText": "bouchées de brioche à la cannelle de beurre fondu de cassonade léèrement tassée pomme cortland râpée avec la pelure de paes hachées de nelle moulue tranches épaisses de pain ménage de blé entier de jus de pomme pur",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2534/bouchees-de-brioche-a-la-cannelle",
      "translatedTitles": {
        "en": "Cinnamon Brioche Bites"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 63
    },
    {
      "id": "81e2be75-2e18-46a2-b8d9-8574a5f4aade",
      "title": "Bouchées de brownies",
      "image": "images/81e2be75-2e18-46a2-b8d9-8574a5f4aade_0.jpg",
      "servings": "6 portions",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de dattes séchées dénoyautées et hachées grossièrement",
        "d'eau",
        "de chapelure de biscuits graham"
      ],
      "searchText": "bouchées de brownies de dattes séchées dénoyautées et hachées grossièrement d'eau de chapelure de biscuits graham dessert",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2303/bouchees-de-brownies",
      "translatedTitles": {
        "en": "Brownie Bites"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "9ff1bb68-ad05-4d85-8e89-91c7e7ab9bbc",
      "title": "Bouillon de bœuf à fondue classique",
      "image": "images/9ff1bb68-ad05-4d85-8e89-91c7e7ab9bbc_0.jpg",
      "servings": "Pour 4",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe d’huile véétale",
        "oignons jaunes",
        "gousses d’ail",
        "c. à soupe de pâte de tomates",
        "tasse de vin rouge",
        "tasse d’eau",
        "boîte de bouillon de bœuf faible en sel",
        "de tasse de sauce soya",
        "c. à thé de purée de raifort",
        "sel et poivre"
      ],
      "searchText": "bouillon de bœuf à fondue classique c. à soupe d’huile véétale oignons jaunes gousses d’ail c. à soupe de pâte de tomates tasse de vin rouge tasse d’eau boîte de bouillon de bœuf faible en sel de tasse de sauce soya c. à thé de purée de raifort sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/soupes-plats/bouillon-de-boeuf-a-fondue-classique/",
      "translatedTitles": {
        "en": "Classic beef fondue broth"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 30
    },
    {
      "id": "166dcc53-cab8-4b9c-943b-087133c4883d",
      "title": "Bouillon de poulet ou de dinde",
      "image": "images/166dcc53-cab8-4b9c-943b-087133c4883d_0.jpg",
      "servings": "2 l (8 tasses)",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de carcasses",
        "c. à soupe d’huile d’olive",
        "½ c. à thé de sel",
        "petit oignon",
        "carotte pelée",
        "branche de céleri avec feuilles en 2",
        "feuille de laurier",
        "ruban de zeste de citron lavé de 10 cm",
        "½ c. à thé de poivre noir en grains",
        "gousses d’ail écrasées",
        "½ c. à thé de gros sel de mer"
      ],
      "searchText": "bouillon de poulet ou de dinde de carcasses c. à soupe d’huile d’olive ½ c. à thé de sel petit oignon carotte pelée branche de céleri avec feuilles en 2 feuille de laurier ruban de zeste de citron lavé de 10 cm ½ c. à thé de poivre noir en grains gousses d’ail écrasées ½ c. à thé de gros sel de mer plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/soupes-potages/bouillon-de-poulet-ou-de-dinde/",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Chicken or Turkey Broth"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "f5849dd3-906b-49ea-9a13-20a4fd4479c1",
      "title": "Boulettes d’agneau épicées et tzatziki",
      "image": "images/f5849dd3-906b-49ea-9a13-20a4fd4479c1_0.jpg",
      "servings": "4 à 6",
      "readyInMinutes": 52,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’agneau haché la bêlerie",
        "de veau haché",
        "c. à thé (2",
        "c. à thé (2",
        "c. à thé de sel",
        "gousse d’ail",
        "tasse de ciboulette",
        "tasse de menthe fraîche",
        "c. à soupe (22",
        "c. à soupe de pâte de tomates",
        "oeuf",
        "tasse d’abricots séchés",
        "tasse de crème de soya ou délice véétal de coco nature de maison riviera",
        "c. à soupe de vinaigre blanc",
        "gousse d’ail",
        "c. à thé (2",
        "poivre",
        "tasse de concombres du québec en petits dés",
        "tasse de menthe fraîche"
      ],
      "searchText": "boulettes d’agneau épicées et tzatziki d’agneau haché la bêlerie de veau haché c. à thé (2 c. à thé (2 c. à thé de sel gousse d’ail tasse de ciboulette tasse de menthe fraîche c. à soupe (22 c. à soupe de pâte de tomates oeuf tasse d’abricots séchés tasse de crème de soya ou délice véétal de coco nature de maison riviera c. à soupe de vinaigre blanc gousse d’ail c. à thé (2 poivre tasse de concombres du québec en petits dés tasse de menthe fraîche",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/boulettes-dagneau-epicees-et-tzatziki/",
      "translatedTitles": {
        "en": "Spiced lamb meatballs and tzatziki"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 52
    },
    {
      "id": "3db95fbf-8d21-4076-87af-3539256e9e6b",
      "title": "Boulettes de boeuf aux edamames et choux-fleurs aigres-douces",
      "image": "images/3db95fbf-8d21-4076-87af-3539256e9e6b_0.jpg",
      "servings": "4",
      "readyInMinutes": 63,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de boeuf",
        "de choux-fleurs",
        "de vinaigre",
        "de sauce soya",
        "de panko",
        "d'edamames",
        "gousses d'ail",
        "riz blanc",
        "poivre",
        "gingembre blanc",
        "sel",
        "huile de ola",
        "paprika",
        "sésame doux"
      ],
      "searchText": "boulettes de boeuf aux edamames et choux-fleurs aigres-douces de boeuf de choux-fleurs de vinaigre de sauce soya de panko d'edamames gousses d'ail riz blanc poivre gingembre blanc sel huile de ola paprika sésame doux",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Beef meatballs with edamame and sweet and sour cauliflower"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 61
    },
    {
      "id": "d8f17d3b-263f-483b-b7e8-c1b1e38755b0",
      "title": "Boulettes de dinde façon thaï",
      "image": "images/d8f17d3b-263f-483b-b7e8-c1b1e38755b0_0.jpg",
      "servings": "Pour 16 petites boulettes",
      "readyInMinutes": 53,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à thé de sriracha",
        "oignons verts",
        "c. à thé de pâte de cari",
        "le jus d’une lime",
        "gousse d’ail hachée",
        "feuilles de basilic",
        "une poignée de coriandre fraîche",
        "de dinde hachée",
        "de tasse de chapelure japonaise panko",
        "sel et poivre",
        "huile véétale pour la cuisson",
        "coriandre fraîche",
        "boîte de 398 de lait de coco",
        "c. à soupe de pâte de cari",
        "c. à soupe de pâte de tomates",
        "sel et poivre"
      ],
      "searchText": "boulettes de dinde façon thaï c. à thé de sriracha oignons verts c. à thé de pâte de cari le jus d’une lime gousse d’ail hachée feuilles de basilic une poignée de coriandre fraîche de dinde hachée de tasse de chapelure japonaise panko sel et poivre huile véétale pour la cuisson coriandre fraîche boîte de 398 de lait de coco c. à soupe de pâte de cari c. à soupe de pâte de tomates sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/poulet-volaille/boulettes-de-dinde-facon-thai/",
      "translatedTitles": {
        "en": "Thai-style Turkey Meatballs"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 51
    },
    {
      "id": "e8ab46e7-717d-45a9-9b10-ed10bd99023d",
      "title": "Boulettes de porc laquées, pomme verte et basilic",
      "servings": "1",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "laque",
        "de sauce soya réduite en sodium",
        "d’eau",
        "de mirin",
        "de cassonade",
        "boulettes",
        "de porc haché maigre",
        "de chapelure panko",
        "jaune d’œuf",
        "de cassonade",
        "de sauce de poisson",
        "de sambal oelek",
        "oignon vert",
        "de feuilles de basilic ciselées",
        "d’huile véétale",
        "garniture",
        "pomme verte",
        "petites feuilles de basilic"
      ],
      "searchText": "boulettes de porc laquées, pomme verte et basilic laque de sauce soya réduite en sodium d’eau de mirin de cassonade boulettes de porc haché maigre de chapelure panko jaune d’œuf de cassonade de sauce de poisson de sambal oelek oignon vert de feuilles de basilic ciselées d’huile véétale garniture pomme verte petites feuilles de basilic apéritif",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7756-boulettes-de-porc-laquees-pomme-verte-et-basilic",
      "image": "images/e8ab46e7-717d-45a9-9b10-ed10bd99023d_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 29,
      "translatedTitles": {
        "en": "Glazed Pork Meatballs, Green Apple and Basil"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 40,
      "readyInMinutesMin": 46
    },
    {
      "id": "796af1b9-fa71-4fbd-acbd-c1653ecb5bfb",
      "title": "Boulettes géantes à la viande et au brocoli",
      "image": "images/796af1b9-fa71-4fbd-acbd-c1653ecb5bfb_0.jpg",
      "servings": "4",
      "readyInMinutes": 64,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de chapelure panko",
        "de lait",
        "de petits bouquets de brocoli",
        "de viandes hachées (mélange de veau",
        "œuf",
        "gousse d’ail",
        "sel et poivre"
      ],
      "searchText": "boulettes géantes à la viande et au brocoli de chapelure panko de lait de petits bouquets de brocoli de viandes hachées (mélange de veau œuf gousse d’ail sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7269-boulettes-geantes-a-la-viande-et-au-brocoli",
      "sourceRating": 5,
      "sourceRatingCount": 20,
      "translatedTitles": {
        "en": "Giant Meat and Broccoli Meatballs"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 64
    },
    {
      "id": "507d7bca-cb58-4820-9bd5-f6b4d8258e58",
      "title": "Braised White Beans and Greens With Parmesan",
      "image": "images/507d7bca-cb58-4820-9bd5-f6b4d8258e58_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "fennel bulb",
        "yellow onion",
        "rosemary or thyme",
        "garlic cloves",
        "red-pepper flakes",
        "or 2 bunches escarole",
        "s nellini beans",
        "low-sodium vegetable or chicken broth",
        "kosher salt and black pepper",
        "lemon juice",
        "shredded mozzarella",
        "grated pecorino romano or parmesan",
        "toasted country bread"
      ],
      "searchText": "braised white beans and greens with parmesan olive oil fennel bulb yellow onion rosemary or thyme garlic cloves red-pepper flakes or 2 bunches escarole s nellini beans low-sodium vegetable or chicken broth kosher salt and black pepper lemon juice shredded mozzarella grated pecorino romano or parmesan toasted country bread",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021902-braised-white-beans-and-greens-with-parmesan",
      "sourceRating": 5,
      "sourceRatingCount": 17791,
      "translatedTitles": {
        "fr": "Haricots Blancs Braisés et Légumes Verts au Parmesan"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 43
    },
    {
      "id": "9f6824c7-cd2a-4cbd-a35c-24e2d287455e",
      "title": "Breakfast Egg Muffins",
      "image": "images/9f6824c7-cd2a-4cbd-a35c-24e2d287455e_0.jpg",
      "servings": "12",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "- olive oil",
        "red bell pepper",
        "½ scallions",
        "eggs",
        "garlic clove",
        "heaping ½ sea salt",
        "ly black pepper",
        "all-purpose flour",
        "¾ baking powder",
        "⅓ crumbled feta cheese"
      ],
      "searchText": "breakfast egg muffins - olive oil red bell pepper ½ scallions eggs garlic clove heaping ½ sea salt ly black pepper all-purpose flour ¾ baking powder ⅓ crumbled feta cheese",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/egg-muffins/",
      "sourceRating": 4.86,
      "sourceRatingCount": 89,
      "translatedTitles": {
        "fr": "Muffins aux œufs pour le petit-déjeuner"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 48
    },
    {
      "id": "9b130f37-cde5-4d26-9d66-dd0d3686f333",
      "title": "Breakfast Egg Muffins",
      "image": "images/9b130f37-cde5-4d26-9d66-dd0d3686f333_0.jpg",
      "servings": "12",
      "readyInMinutes": 64,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bacon",
        "onion",
        "or 2 russet potatoes",
        "baby spinach (2 lightly packed",
        "mild cheddar cheese",
        "eggs",
        "half and half",
        "tabasco sauce"
      ],
      "searchText": "breakfast egg muffins bacon onion or 2 russet potatoes baby spinach (2 lightly packed mild cheddar cheese eggs half and half tabasco sauce",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://natashaskitchen.com/breakfast-egg-muffins/",
      "sourceRating": 4.96,
      "sourceRatingCount": 285,
      "translatedTitles": {
        "fr": "Muffins aux œufs pour le petit-déjeuner"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 50,
      "readyInMinutesMin": 63
    },
    {
      "id": "8bdcf9bb-b93e-43f5-abb3-5d6d688b326a",
      "title": "Brie en croûte avec pommes et poires",
      "image": "images/8bdcf9bb-b93e-43f5-abb3-5d6d688b326a_0.jpg",
      "servings": "12 portions de 1/12 de la recette chacune",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe de beurre",
        "pomme granny smith",
        "poire anjou",
        "tasse de miel",
        "c. à soupe de moutarde de dijon heinz",
        "tranches de bacon",
        "tasse de noix hachées",
        "feuille de pâte feuilletée surgelée",
        "fromage brie rond",
        "œuf",
        "c. à soupe d’eau"
      ],
      "searchText": "brie en croûte avec pommes et poires c. à soupe de beurre pomme granny smith poire anjou tasse de miel c. à soupe de moutarde de dijon heinz tranches de bacon tasse de noix hachées feuille de pâte feuilletée surgelée fromage brie rond œuf c. à soupe d’eau petit-déjeuner",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kraftwhatscooking.ca/fr-ca/recette/brie-en-croute-avec-pommes-et-poires-214048",
      "translatedTitles": {
        "en": "Brie in Crust with Apples and Pears"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "ad12350c-59e5-40ac-84cb-d31a3bca8508",
      "title": "Brie en croûte avec pommes et poires",
      "image": "images/ad12350c-59e5-40ac-84cb-d31a3bca8508_0.jpg",
      "servings": "12 portions de 1/12 de la recette chacune",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe de beurre",
        "pomme granny smith",
        "poire anjou",
        "tasse de miel",
        "c. à soupe de moutarde de dijon heinz",
        "tranches de bacon",
        "tasse de noix hachées",
        "feuille de pâte feuilletée surgelée",
        "fromage brie rond",
        "œuf",
        "c. à soupe d’eau"
      ],
      "searchText": "brie en croûte avec pommes et poires c. à soupe de beurre pomme granny smith poire anjou tasse de miel c. à soupe de moutarde de dijon heinz tranches de bacon tasse de noix hachées feuille de pâte feuilletée surgelée fromage brie rond œuf c. à soupe d’eau petit-déjeuner",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kraftwhatscooking.ca/fr-ca/recette/brie-en-croute-avec-pommes-et-poires-214048",
      "translatedTitles": {
        "en": "Brie in Crust with Apples and Pears"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "05bf6fa4-255b-42e1-affb-7427eb3b08f3",
      "title": "Brioches à la cannelle",
      "image": "images/05bf6fa4-255b-42e1-affb-7427eb3b08f3_0.jpg",
      "servings": "24",
      "readyInMinutes": 298,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de levure",
        "de lait",
        "de sucre",
        "de sel",
        "oeuf",
        "de beurre non salé",
        "de cassonade",
        "de nelle",
        "de beurre",
        "de sucre en poudre",
        "de lait",
        "de jus de citron",
        "de zeste"
      ],
      "searchText": "brioches à la cannelle de levure de lait de sucre de sel oeuf de beurre non salé de cassonade de nelle de beurre de sucre en poudre de lait de jus de citron de zeste",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/3650/brioches-automne",
      "sourceRating": 4,
      "sourceRatingCount": 9,
      "translatedTitles": {
        "en": "Cinnamon Buns"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 298
    },
    {
      "id": "9a37e1a0-fd03-4971-b07d-1073e9e47c3f",
      "title": "Broccoli Salad",
      "image": "images/9a37e1a0-fd03-4971-b07d-1073e9e47c3f_0.jpg",
      "servings": "4 to 6",
      "readyInMinutes": 36,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "broccoli crowns",
        "- olive oil",
        "mayo",
        "½ apple cider vinegar",
        "dijon mustard",
        "maple syrup or honey",
        "garlic clove",
        "¼ sea salt",
        "⅓ red onions",
        "⅓ cranberries",
        "½ almonds",
        "½ pepitas",
        "tamari",
        "½ maple syrup",
        "¼ smoked paprika"
      ],
      "searchText": "broccoli salad broccoli crowns - olive oil mayo ½ apple cider vinegar dijon mustard maple syrup or honey garlic clove ¼ sea salt ⅓ red onions ⅓ cranberries ½ almonds ½ pepitas tamari ½ maple syrup ¼ smoked paprika plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/broccoli-salad/",
      "sourceRating": 4.98,
      "sourceRatingCount": 475,
      "translatedTitles": {
        "fr": "Salade de brocoli"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 32
    },
    {
      "id": "7a57d006-353c-415e-b573-956072fe241f",
      "title": "Broccoli-Walnut Pesto Pasta",
      "image": "images/7a57d006-353c-415e-b573-956072fe241f_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "kosher salt",
        "broccoli florets",
        "cut pasta",
        "garlic clove",
        "packed mint leaves",
        "black pepper",
        "- olive oil",
        "lemon",
        "parmigiano-reggiano",
        "walnuts"
      ],
      "searchText": "broccoli-walnut pesto pasta kosher salt broccoli florets cut pasta garlic clove packed mint leaves black pepper - olive oil lemon parmigiano-reggiano walnuts",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1019642-broccoli-walnut-pesto-pasta?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 3372,
      "translatedTitles": {
        "fr": "Pâtes au Pesto Brocoli-Noix"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 51
    },
    {
      "id": "b4343e6f-06ae-4b5e-be1b-d4aab83137c3",
      "title": "Brochettes de poulet à la grecque",
      "image": "images/b4343e6f-06ae-4b5e-be1b-d4aab83137c3_0.jpg",
      "servings": "6 brochettes",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de poitrine de poulet ou de dindon",
        "d’huile d’olive",
        "d’origan séché",
        "de paprika doux",
        "gousse d’ail",
        "tranches de bacon ou 100 de chorizo doux coupé en tranches de 1/2 cm d’épaisseur",
        "brochettes de bois de 8 po de longueur",
        "salade grecque"
      ],
      "searchText": "brochettes de poulet à la grecque de poitrine de poulet ou de dindon d’huile d’olive d’origan séché de paprika doux gousse d’ail tranches de bacon ou 100 de chorizo doux coupé en tranches de 1/2 cm d’épaisseur brochettes de bois de 8 po de longueur salade grecque",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/poulet-et-volailles/brochettes-de-poulet-a-la-grecque/",
      "sourceRating": 5,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Greek Chicken Skewers"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "6d0664e0-750c-4c1b-823d-de7815a4cc3b",
      "title": "Brochettes de poulet aux olives et au chorizo",
      "image": "images/6d0664e0-750c-4c1b-823d-de7815a4cc3b_0.jpg",
      "servings": "8",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "brochettes",
        "de demi-poitrines ou de hauts de cuisses de poulet désossés et sans la peau",
        "d’huile d’olive",
        "de sel",
        "tranches de saucisson chorizo d’environ 1 cm d’épaisseur",
        "olives vertes dénoyautées",
        "brochettes de métal ou brochettes de bois",
        "garniture",
        "citron",
        "sauce tzatziki",
        "houmous"
      ],
      "searchText": "brochettes de poulet aux olives et au chorizo brochettes de demi-poitrines ou de hauts de cuisses de poulet désossés et sans la peau d’huile d’olive de sel tranches de saucisson chorizo d’environ 1 cm d’épaisseur olives vertes dénoyautées brochettes de métal ou brochettes de bois garniture citron sauce tzatziki houmous",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7310-brochettes-de-poulet-aux-olives-et-au-chorizo",
      "sourceRating": 5,
      "sourceRatingCount": 16,
      "translatedTitles": {
        "en": "Chicken Skewers with Olives and Chorizo"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "464dcdc1-9be3-42d6-951c-a4c7c6916b79",
      "title": "Brochettes de saumon à la lime et au gingembre",
      "image": "images/464dcdc1-9be3-42d6-951c-a4c7c6916b79_0.jpg",
      "servings": "1",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "morceau de gingembre frais",
        "piment chili frais",
        "cuillères à table de coriandre fraîche",
        "cuillères à table de sauce soja réduite en sel",
        "cuillère à table de jus de lime",
        "cuillères à thé d' huile véétale",
        "pincée de sucre",
        "filets de saumon",
        "poivron rouge coupé en morceaux de 1 1/2 po",
        "oignons verts coupés en morceaux de 1 1/2 po",
        "quartiers de lime",
        "fibres 1",
        "sodium 385 mg",
        "protéines 31",
        "calories 316",
        "total gras 19",
        "cholestérol 84 mg",
        "gras saturés 4",
        "total glucides 5"
      ],
      "searchText": "brochettes de saumon à la lime et au gingembre morceau de gingembre frais piment chili frais cuillères à table de coriandre fraîche cuillères à table de sauce soja réduite en sel cuillère à table de jus de lime cuillères à thé d' huile véétale pincée de sucre filets de saumon poivron rouge coupé en morceaux de 1 1/2 po oignons verts coupés en morceaux de 1 1/2 po quartiers de lime fibres 1 sodium 385 mg protéines 31 calories 316 total gras 19 cholestérol 84 mg gras saturés 4 total glucides 5",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.coupdepouce.com/cuisine/plats-principaux/recette/brochettes-de-saumon-a-la-lime-et-au-gingembre",
      "translatedTitles": {
        "en": "Lime and Ginger Salmon Skewers"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 47
    },
    {
      "id": "2cb65027-8bc8-4f2f-94d1-ca33707e5768",
      "title": "Brochettes de tofu mariné",
      "image": "images/2cb65027-8bc8-4f2f-94d1-ca33707e5768_0.jpg",
      "servings": "2",
      "readyInMinutes": 141,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de tofu ferme coupé en cubes",
        "de tasse de sauce soya",
        "de tasse de sirop d’érable",
        "c à soupe de fumée liquide",
        "gousses d’ail hachées",
        "c à soupe d’huile véétale pour badigeonner les brochettes"
      ],
      "searchText": "brochettes de tofu mariné de tofu ferme coupé en cubes de tasse de sauce soya de tasse de sirop d’érable c à soupe de fumée liquide gousses d’ail hachées c à soupe d’huile véétale pour badigeonner les brochettes",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.lacuisinedejeanphilippe.com/recipe/brochettes-de-tofu-marine/",
      "translatedTitles": {
        "en": "Marinated Tofu Skewers"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 131
    },
    {
      "id": "cdaa8a42-04bb-47d9-8123-534c1bbdc18c",
      "title": "Brocolis grillés sur le barbecue",
      "image": "images/cdaa8a42-04bb-47d9-8123-534c1bbdc18c_0.jpg",
      "servings": "4",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grosses têtes de brocoli",
        "huile d’olive",
        "sel de fantaisie à la sauge et au citron par la pincée",
        "origan séché",
        "poivre du moulin"
      ],
      "searchText": "brocolis grillés sur le barbecue grosses têtes de brocoli huile d’olive sel de fantaisie à la sauge et au citron par la pincée origan séché poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://lecoupdegrace.ca/recette/brocolis-grilles-sur-le-barbecue/",
      "sourceRating": 4.3,
      "sourceRatingCount": 9,
      "translatedTitles": {
        "en": "Grilled Broccoli on the Barbecue"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 36
    },
    {
      "id": "e7649dd7-80b9-464d-a167-b24c5de0e00a",
      "title": "Buffalo Cauliflower Wings",
      "image": "images/e7649dd7-80b9-464d-a167-b24c5de0e00a_0.jpg",
      "servings": "4",
      "readyInMinutes": 61,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "⅔ all-purpose flour",
        "¼ cornstarch",
        "garlic powder",
        "onion powder",
        "paprika",
        "½ sea salt",
        "¾ water",
        "cauliflower (about 2",
        "buffalo sauce",
        "ranch dressing or vegan ranch"
      ],
      "searchText": "buffalo cauliflower wings ⅔ all-purpose flour ¼ cornstarch garlic powder onion powder paprika ½ sea salt ¾ water cauliflower (about 2 buffalo sauce ranch dressing or vegan ranch",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/buffalo-cauliflower-wings/",
      "sourceRating": 4.85,
      "sourceRatingCount": 70,
      "translatedTitles": {
        "fr": "Ailes de chou-fleur Buffalo"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 58
    },
    {
      "id": "abf0138b-1151-4fd7-994a-60df0575d111",
      "title": "Burgers à la marocaine",
      "image": "images/abf0138b-1151-4fd7-994a-60df0575d111_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de mayonnaise",
        "d’harissa",
        "gousse d’ail",
        "de boeuf haché mi-maigre",
        "de cumin moulu",
        "de curcuma",
        "courgettes",
        "oignon",
        "d’huile d’olive",
        "pains à hamburger au sésame",
        "de feuilles de menthe"
      ],
      "searchText": "burgers à la marocaine de mayonnaise d’harissa gousse d’ail de boeuf haché mi-maigre de cumin moulu de curcuma courgettes oignon d’huile d’olive pains à hamburger au sésame de feuilles de menthe",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/10055-burgers-a-la-marocaine",
      "sourceRating": 5,
      "sourceRatingCount": 3,
      "translatedTitles": {
        "en": "Moroccan Burgers"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 36
    },
    {
      "id": "0eb34edf-1176-488b-bd8f-ac06f4ac077a",
      "title": "Burgers de porc et mangue",
      "image": "images/0eb34edf-1176-488b-bd8f-ac06f4ac077a_0.jpg",
      "servings": "4",
      "readyInMinutes": 57,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½ poivron rouge",
        "¼ de concombre anglais",
        "mangue",
        "de jus de lime",
        "de porc haché",
        "huile véétale",
        "pains à hamburger",
        "de sauce tzatziki",
        "feuilles de laitue romaine",
        "de feuilles de coriandre",
        "sauce sriracha"
      ],
      "searchText": "burgers de porc et mangue ½ poivron rouge ¼ de concombre anglais mangue de jus de lime de porc haché huile véétale pains à hamburger de sauce tzatziki feuilles de laitue romaine de feuilles de coriandre sauce sriracha",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9033-burgers-de-porc-et-mangue",
      "sourceRating": 5,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Pork and Mango Burgers"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 45,
      "readyInMinutesMin": 55
    },
    {
      "id": "06964545-59e2-4e8f-b3d5-366f5650292a",
      "title": "Burrata",
      "image": "images/06964545-59e2-4e8f-b3d5-366f5650292a_0.jpg",
      "servings": "4",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½ - olive oil",
        "garlic clove",
        "peel from 1 lemon",
        "thyme sprigs",
        "heirloom tomatoes",
        "ripe peach",
        "ball burrata",
        "½ basil and/or mint leaves",
        "toasted pistachios",
        "cherries or currants",
        "flaky sea salt",
        "ly black pepper",
        "toasted bread"
      ],
      "searchText": "burrata ½ - olive oil garlic clove peel from 1 lemon thyme sprigs heirloom tomatoes ripe peach ball burrata ½ basil and/or mint leaves toasted pistachios cherries or currants flaky sea salt ly black pepper toasted bread",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/burrata/",
      "sourceRating": 4.98,
      "sourceRatingCount": 40,
      "translatedTitles": {
        "fr": "Burrata"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 46
    },
    {
      "id": "7a315d11-4aa8-4dc3-be7e-b3adf1a40944",
      "title": "Burrata aux pêches grillées et aux tomates confites",
      "image": "images/7a315d11-4aa8-4dc3-be7e-b3adf1a40944_0.jpg",
      "servings": "4 à 6 portion(s)",
      "readyInMinutes": 61,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de tomates cerises",
        "d’huile d’olive",
        "de vinaigre balsamique blanc",
        "de miel",
        "de piment d’espelette",
        "grosses pêches",
        "d’huile d’olive",
        "burrata de 225",
        "de miel",
        "feuilles de basilic",
        "fleur de sel",
        "tranches de pain grillées"
      ],
      "searchText": "burrata aux pêches grillées et aux tomates confites de tomates cerises d’huile d’olive de vinaigre balsamique blanc de miel de piment d’espelette grosses pêches d’huile d’olive burrata de 225 de miel feuilles de basilic fleur de sel tranches de pain grillées appetizer",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9512-burrata-aux-peches-grillees-et-aux-tomates-confites",
      "sourceRating": 5,
      "sourceRatingCount": 11,
      "translatedTitles": {
        "en": "Burrata with grilled peaches and confit tomatoes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 61
    },
    {
      "id": "355e8edc-a062-4346-94f3-9944938f9314",
      "title": "Butter chicken",
      "servings": "1",
      "readyInMinutes": 117,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "for the marinade:",
        "full-fat greek yoghurt",
        "ginger & garlic paste",
        "vegetable oil",
        "½ salt",
        "juice of 1 lemon",
        "red chili powder",
        "cumin",
        "½ garam masala",
        "for the sauce:",
        "kilogram tomatoes",
        "centimeter piece of ginger",
        "ginger-garlic paste",
        "bay leaf",
        "red chili powder",
        "butter",
        "green chilis",
        "milliliters single cream",
        "salt",
        "fenugreek leaves",
        "½ garam masala",
        "sugar"
      ],
      "searchText": "butter chicken for the marinade: full-fat greek yoghurt ginger & garlic paste vegetable oil ½ salt juice of 1 lemon red chili powder cumin ½ garam masala for the sauce: kilogram tomatoes centimeter piece of ginger ginger-garlic paste bay leaf red chili powder butter green chilis milliliters single cream salt fenugreek leaves ½ garam masala sugar plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://apple.news/AQlZ6hAxPRUWVdnNgxEiJfQ",
      "image": "images/355e8edc-a062-4346-94f3-9944938f9314_0.jpg",
      "translatedTitles": {
        "fr": "Poulet au beurre"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 105
    },
    {
      "id": "cdc5ee36-5856-477b-a398-65a60836044e",
      "title": "Butter-Soy Chicken and Asparagus Stir-Fry",
      "image": "images/cdc5ee36-5856-477b-a398-65a60836044e_0.jpg",
      "servings": "2 to 4 servings",
      "readyInMinutes": 115,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boneless",
        "cornstarch",
        "baking soda",
        "sugar",
        "salt",
        "soy sauce",
        "black pepper",
        "vegetable oil",
        "egg white",
        "vegetable oil",
        "asparagus",
        "button mushrooms",
        "red bell pepper",
        "salt and black pepper",
        "butter",
        "soy sauce",
        "lemon wedge",
        "toasted sesame seeds",
        "cooked rice"
      ],
      "searchText": "butter-soy chicken and asparagus stir-fry boneless cornstarch baking soda sugar salt soy sauce black pepper vegetable oil egg white vegetable oil asparagus button mushrooms red bell pepper salt and black pepper butter soy sauce lemon wedge toasted sesame seeds cooked rice",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026426-butter-soy-chicken-and-asparagus-stir-fry?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1480,
      "translatedTitles": {
        "fr": "Sauté de poulet et d'asperges au beurre et à la sauce soja"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 70
    },
    {
      "id": "2a819726-5f64-4451-af4f-4ff2d80e6113",
      "title": "Canapés de pomme au halloumi",
      "image": "images/2a819726-5f64-4451-af4f-4ff2d80e6113_0.jpg",
      "servings": "8 portions de 2 bouchées",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de fromage halloumi ou dorémi en 16 morceaux de 0",
        "pomme cortland",
        "sirop d'érable",
        "petites feuilles de basilic frais"
      ],
      "searchText": "canapés de pomme au halloumi de fromage halloumi ou dorémi en 16 morceaux de 0 pomme cortland sirop d'érable petites feuilles de basilic frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2574/canapes-de-pomme-au-halloumi",
      "translatedTitles": {
        "en": "Halloumi Apple Canapés"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "ee50c9b7-b744-4f3d-ab94-155ffcbc177e",
      "title": "Caramel maison",
      "image": "images/ee50c9b7-b744-4f3d-ab94-155ffcbc177e_0.jpg",
      "servings": "1",
      "readyInMinutes": 10,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de sucre",
        "d’eau",
        "de crème",
        "de beurre non salé"
      ],
      "searchText": "caramel maison de sucre d’eau de crème de beurre non salé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6668-caramel-maison",
      "sourceRating": 5,
      "sourceRatingCount": 104,
      "translatedTitles": {
        "en": "Homemade Caramel"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "ffcced0e-782e-42d2-920b-352848e3c7dd",
      "title": "Cari de poulet et de poivron rouge",
      "image": "images/ffcced0e-782e-42d2-920b-352848e3c7dd_0.jpg",
      "servings": "4",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gros oignon",
        "poivron rouge",
        "d'huile d'olive",
        "de poitrines de poulet désossées et sans la peau",
        "gousses d'ail",
        "de poudre de chili",
        "de poudre de cari",
        "boîte de 398 de lait de coco",
        "de miel",
        "sel et poivre"
      ],
      "searchText": "cari de poulet et de poivron rouge gros oignon poivron rouge d'huile d'olive de poitrines de poulet désossées et sans la peau gousses d'ail de poudre de chili de poudre de cari boîte de 398 de lait de coco de miel sel et poivre plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/3012-cari-de-poulet-et-de-poivron-rouge",
      "sourceRating": 4,
      "sourceRatingCount": 143,
      "translatedTitles": {
        "en": "Chicken and Red Pepper Curry"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 33
    },
    {
      "id": "bfc176f5-7e7c-4712-b0cb-29b4c8784690",
      "title": "Carnitas (Mexican Slow Cooker Pulled Pork)",
      "image": "images/bfc176f5-7e7c-4712-b0cb-29b4c8784690_0.jpg",
      "servings": "10 - 12",
      "readyInMinutes": 671,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "/ 4 pork shoulder (",
        "salt",
        "black pepper",
        "onion (",
        "jalapeno (",
        "cloves garlic",
        "juice from orange",
        "oregano",
        "cumin",
        "olive oil"
      ],
      "searchText": "carnitas (mexican slow cooker pulled pork) / 4 pork shoulder ( salt black pepper onion ( jalapeno ( cloves garlic juice from orange oregano cumin olive oil",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://www.recipetineats.com/pork-carnitas-mexican-slow-cooker-pulled-pork/",
      "sourceRating": 4.96,
      "sourceRatingCount": 1096,
      "translatedTitles": {
        "fr": "Carnitas (Porc effiloché mexicain à la mijoteuse)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 51,
      "readyInMinutesMin": 486
    },
    {
      "id": "2b70c568-3173-40c6-8464-7c9da3deffa7",
      "title": "Carottes rôties à la menthe",
      "image": "images/2b70c568-3173-40c6-8464-7c9da3deffa7_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 79,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de carottes",
        "poireau",
        "d'huile d'olive",
        "de gingembre frais",
        "sel et poivre",
        "de menthe fraîche ciselée"
      ],
      "searchText": "carottes rôties à la menthe de carottes poireau d'huile d'olive de gingembre frais sel et poivre de menthe fraîche ciselée",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/108-carottes-roties-a-la-menthe",
      "sourceRating": 5,
      "sourceRatingCount": 7,
      "translatedTitles": {
        "en": "Roasted Carrots with Mint"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 79
    },
    {
      "id": "085345ae-5ce1-4887-98cc-bb333ac3d9b4",
      "title": "Carré d’agneau en croûte d’herbes de Stefano Faita",
      "image": "images/085345ae-5ce1-4887-98cc-bb333ac3d9b4_0.jpg",
      "servings": "6",
      "readyInMinutes": 65,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de chapelure",
        "gousses d’ail",
        "de romarin frais",
        "de thym frais",
        "d’huile d’olive",
        "carrés d’agneau d’environ 675 chacun",
        "au goût",
        "d’huile de pépins de raisins",
        "de moutarde de dijon"
      ],
      "searchText": "carré d’agneau en croûte d’herbes de stefano faita de chapelure gousses d’ail de romarin frais de thym frais d’huile d’olive carrés d’agneau d’environ 675 chacun au goût d’huile de pépins de raisins de moutarde de dijon",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.iga.net/fr/recettes_inspirantes/recettes/carre_dagneau_en_croute_dherbes",
      "translatedTitles": {
        "en": "Rack of lamb in a herb crust by Stefano Faita"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 58
    },
    {
      "id": "708c11fd-e30e-4100-9026-bf4d8506b02a",
      "title": "Carrés aux Rice Krispies à l’érable",
      "image": "images/708c11fd-e30e-4100-9026-bf4d8506b02a_0.jpg",
      "servings": "1",
      "readyInMinutes": 142,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½ tasse de beurre",
        "½ tasse de sirop d’érable",
        "tasses de guimauves miniatures ou 40 grosses guimauves",
        "une pincée de sel",
        "tasses de céréales rice krispies"
      ],
      "searchText": "carrés aux rice krispies à l’érable ½ tasse de beurre ½ tasse de sirop d’érable tasses de guimauves miniatures ou 40 grosses guimauves une pincée de sel tasses de céréales rice krispies",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/desserts/barres-carres/carres-aux-rice-krispies-a-lerable/?fbclid=IwAR2EerI-Rnh0S1hWr8pQcXCkaAQO6wVRg5MwPczKhrHGapnEVaPxZg3QZp8",
      "translatedTitles": {
        "en": "Maple Rice Krispies Squares"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 142
    },
    {
      "id": "67627cd9-1bea-4169-b01f-d1b3ea946060",
      "title": "Casserole de pain doré aux framboises et aux pistaches",
      "image": "images/67627cd9-1bea-4169-b01f-d1b3ea946060_0.jpg",
      "servings": "8",
      "readyInMinutes": 773,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "beurre",
        "pain en cubes",
        "œufs",
        "lait",
        "miel",
        "it de vanille",
        "nelle moulue",
        "muscade moulue",
        "pistaches naturelles",
        "framboises surgelées"
      ],
      "searchText": "casserole de pain doré aux framboises et aux pistaches beurre pain en cubes œufs lait miel it de vanille nelle moulue muscade moulue pistaches naturelles framboises surgelées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/casserole-de-pain-dore-aux-framboises-et-aux-pistaches/",
      "sourceRating": 5,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Raspberry and Pistachio French Toast Casserole"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 58
    },
    {
      "id": "44ecf0b8-29d6-412d-a342-45fd33d0651e",
      "title": "Casserole petit-déj'",
      "image": "images/44ecf0b8-29d6-412d-a342-45fd33d0651e_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 98,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "beurre",
        "farine",
        "lait",
        "fromage gruyère",
        "sel et poivre",
        "pommes de terre",
        "oignon",
        "champignons",
        "origan frais",
        "huile d'olive",
        "sel et poivre",
        "saucisses douces",
        "ou 8 œufs"
      ],
      "searchText": "casserole petit-déj' beurre farine lait fromage gruyère sel et poivre pommes de terre oignon champignons origan frais huile d'olive sel et poivre saucisses douces ou 8 œufs petit-déjeuner",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/182/casserole-petit-dej",
      "translatedTitles": {
        "en": "Breakfast Casserole"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 98
    },
    {
      "id": "a5b50692-8a7c-4952-8d00-6e4cade67244",
      "title": "Ceviche",
      "image": "images/a5b50692-8a7c-4952-8d00-6e4cade67244_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 39,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "very",
        "salt",
        "lime juice",
        "tomatoes",
        "persian or mini seedless cucumbers",
        "red onion",
        "jalapeños",
        "avocado",
        "cilantro leaves and tender stems",
        "tortilla"
      ],
      "searchText": "ceviche very salt lime juice tomatoes persian or mini seedless cucumbers red onion jalapeños avocado cilantro leaves and tender stems tortilla",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024717-ceviche?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 645,
      "translatedTitles": {
        "fr": "Ceviche"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 29,
      "readyInMinutesMin": 39
    },
    {
      "id": "9cf6f85f-53d3-46d7-a791-cf776c6209d8",
      "title": "Ceviche",
      "image": "images/9cf6f85f-53d3-46d7-a791-cf776c6209d8_0.jpg",
      "servings": "4",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "very",
        "salt",
        "lime juice",
        "tomatoes",
        "persian or mini seedless cucumbers",
        "red onion",
        "jalapeños",
        "avocado",
        "cilantro leaves and tender stems",
        "tortilla"
      ],
      "searchText": "ceviche very salt lime juice tomatoes persian or mini seedless cucumbers red onion jalapeños avocado cilantro leaves and tender stems tortilla",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024717-ceviche?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 645,
      "translatedTitles": {
        "fr": "Ceviche"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 37
    },
    {
      "id": "b2c96f0b-a2a1-4202-9689-72ee031550b0",
      "title": "Ceviche à la diablo",
      "image": "images/b2c96f0b-a2a1-4202-9689-72ee031550b0_0.jpg",
      "servings": "4",
      "readyInMinutes": 91,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ceviche",
        "de filet de flétan très frais",
        "de pétoncles très frais",
        "de jus de lime",
        "le zeste râpé de 1/2 lime",
        "d'huile d'olive",
        "de sucre",
        "de poivron rouge",
        "de piment jalapeño",
        "gousse d'ail",
        "de coriandre fraîche",
        "sel et poivre",
        "chips de tortillas épicées",
        "d'huile d'olive",
        "de sauce tabasco au jalapeño",
        "le zeste râpé de 1 lime",
        "petites tortillas",
        "garniture",
        "poivron jaune",
        "tomate",
        "de feuilles de coriandre fraîche"
      ],
      "searchText": "ceviche à la diablo ceviche de filet de flétan très frais de pétoncles très frais de jus de lime le zeste râpé de 1/2 lime d'huile d'olive de sucre de poivron rouge de piment jalapeño gousse d'ail de coriandre fraîche sel et poivre chips de tortillas épicées d'huile d'olive de sauce tabasco au jalapeño le zeste râpé de 1 lime petites tortillas garniture poivron jaune tomate de feuilles de coriandre fraîche",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/2192-ceviche-a-la-diablo",
      "sourceRating": 5,
      "sourceRatingCount": 22,
      "translatedTitles": {
        "en": "Ceviche à la diablo"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 91
    },
    {
      "id": "25af04e3-c0be-4679-ad63-69455e8a5f97",
      "title": "Ceviche de flétan",
      "image": "images/25af04e3-c0be-4679-ad63-69455e8a5f97_0.jpg",
      "servings": "4",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de filet de flétan",
        "de sel",
        "piment jalapeno",
        "d'échalote française",
        "de céleri",
        "ail",
        "coriandre fraîche",
        "de sel",
        "lime",
        "citron",
        "de jus d'orange",
        "de sucre semoule",
        "anis étoilé",
        "patate douce",
        "de huile de ola",
        "de grain de maïs grillé",
        "d'échalote française",
        "piment jalapeno",
        "coriandre fraîche",
        "quelques feuilles oseille",
        "piment oiseau"
      ],
      "searchText": "ceviche de flétan de filet de flétan de sel piment jalapeno d'échalote française de céleri ail coriandre fraîche de sel lime citron de jus d'orange de sucre semoule anis étoilé patate douce de huile de ola de grain de maïs grillé d'échalote française piment jalapeno coriandre fraîche quelques feuilles oseille piment oiseau",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/6348/ceviche-fletan",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Halibut Ceviche"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "300ec0a6-77b9-4f81-a616-ed5980a64c3a",
      "title": "Chana Masala",
      "image": "images/300ec0a6-77b9-4f81-a616-ed5980a64c3a_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ghee or neutral oil",
        "garlic paste or ly grated garlic",
        "ginger paste or ly grated ginger",
        "red onion",
        "thai green or bird’s eye chiles",
        "cumin seeds",
        "turmeric",
        "coriander",
        "kashmiri or other hot red chile powder",
        "roma tomatoes",
        "fine sea salt",
        "s of chickpeas",
        "unsalted chicken or vegetable stock",
        "garam masala",
        "cilantro leaves and tender stems",
        "rice or roti and lemon wedges"
      ],
      "searchText": "chana masala ghee or neutral oil garlic paste or ly grated garlic ginger paste or ly grated ginger red onion thai green or bird’s eye chiles cumin seeds turmeric coriander kashmiri or other hot red chile powder roma tomatoes fine sea salt s of chickpeas unsalted chicken or vegetable stock garam masala cilantro leaves and tender stems rice or roti and lemon wedges",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024429-chana-masala?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2582,
      "translatedTitles": {
        "fr": "Chana Masala"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 40
    },
    {
      "id": "24f099e4-3bec-4d20-8952-16885e415a8e",
      "title": "Chaudrée de maïs express aux crevettes",
      "image": "images/24f099e4-3bec-4d20-8952-16885e415a8e_0.jpg",
      "servings": "4 à 6 portions (en repas)",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "pommes de terre moyennes",
        "grosse carotte",
        "branches de céleri",
        "tasses bouillon de légumes",
        "tasse préparation crémeuse de soya",
        "tasses maïs en grains",
        "tasse crevettes nordiques surgelées",
        "sel et poivre",
        "persil frais ou séché"
      ],
      "searchText": "chaudrée de maïs express aux crevettes oignon pommes de terre moyennes grosse carotte branches de céleri tasses bouillon de légumes tasse préparation crémeuse de soya tasses maïs en grains tasse crevettes nordiques surgelées sel et poivre persil frais ou séché",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/4224/chaudree-de-mais-express-aux-crevettes",
      "translatedTitles": {
        "en": "Express Shrimp Corn Chowder"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 42
    },
    {
      "id": "b9bd40ad-8481-4086-adf6-1cfb0da9a367",
      "title": "Chaussons aux amandes",
      "image": "images/b9bd40ad-8481-4086-adf6-1cfb0da9a367_0.jpg",
      "servings": "8 chaussons",
      "readyInMinutes": 167,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de pâte d’amandes",
        "de sucre",
        "de beurre non salé",
        "jaunes d’oeufs",
        "gouttes d’it d’amandes",
        "d’amandes blanchies",
        "abaisses de 200 chacune de pâte feuilletée du commerce",
        "oeuf",
        "d’amandes tranchées",
        "de sucre à glacer"
      ],
      "searchText": "chaussons aux amandes de pâte d’amandes de sucre de beurre non salé jaunes d’oeufs gouttes d’it d’amandes d’amandes blanchies abaisses de 200 chacune de pâte feuilletée du commerce oeuf d’amandes tranchées de sucre à glacer",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5041-chaussons-aux-amandes",
      "sourceRating": 5,
      "sourceRatingCount": 6,
      "translatedTitles": {
        "en": "Almond Turnovers"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 40,
      "readyInMinutesMin": 167
    },
    {
      "id": "fe494b92-5ac5-41a4-94b3-930eceff96bc",
      "title": "Chayote-Jicama Salad",
      "image": "images/fe494b92-5ac5-41a4-94b3-930eceff96bc_0.jpg",
      "servings": "6 servings",
      "readyInMinutes": 263,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "lime juice",
        "vegetable oil",
        "to 1 red jalapeno",
        "kosher salt",
        "chayotes",
        "jicama",
        "carrots"
      ],
      "searchText": "chayote-jicama salad lime juice vegetable oil to 1 red jalapeno kosher salt chayotes jicama carrots plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodnetwork.com/recipes/food-network-kitchen/chayote-jicama-salad-recipe-2107168",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "fr": "Salade de Chayote et Jicama"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 23
    },
    {
      "id": "634f99e4-670b-4904-a0a4-6b48f9690999",
      "title": "Cheesy Sweet Potato & Black Bean Casserole",
      "image": "images/634f99e4-670b-4904-a0a4-6b48f9690999_0.jpg",
      "servings": "1",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "- olive oil",
        "¼ sweet potatoes",
        "chili powder",
        "cumin",
        "¼ kosher salt",
        "¼ pepper",
        "fire-roasted tomatoes",
        "mild green chiles",
        "no-salt-added black beans",
        "¾ ned no-salt-added sweet corn",
        "¼ shredded sharp cheddar cheese",
        "scallions",
        "¼ roughly cilantro",
        "lime"
      ],
      "searchText": "cheesy sweet potato & black bean casserole - olive oil ¼ sweet potatoes chili powder cumin ¼ kosher salt ¼ pepper fire-roasted tomatoes mild green chiles no-salt-added black beans ¾ ned no-salt-added sweet corn ¼ shredded sharp cheddar cheese scallions ¼ roughly cilantro lime",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.eatingwell.com/recipe/7992209/cheesy-sweet-potato-black-bean-casserole/",
      "translatedTitles": {
        "fr": "Gratin de Patates Douces et Haricots Noirs au Fromage"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 29,
      "readyInMinutesMin": 50
    },
    {
      "id": "e4ae2c7e-4634-4bae-b2ca-52036ae3bb42",
      "title": "Chicago Thin-Crust (Tavern-Style) Pizza Dough",
      "image": "images/e4ae2c7e-4634-4bae-b2ca-52036ae3bb42_0.jpg",
      "servings": "2 (14-inch) crusts",
      "readyInMinutes": 7230,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bread flour (about 2 1/4",
        "sugar",
        "salt",
        "instant yeast",
        "cold water (150 milliliters",
        "neutral oil",
        "semolina or cornmeal"
      ],
      "searchText": "chicago thin-crust (tavern-style) pizza dough bread flour (about 2 1/4 sugar salt instant yeast cold water (150 milliliters neutral oil semolina or cornmeal",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024060-chicago-thin-crust-tavern-style-pizza-dough?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 599,
      "translatedTitles": {
        "fr": "Pâte à pizza fine (style taverne) de Chicago"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "22b169be-2f6a-4dc8-9b7d-1fe7ff6dd7df",
      "title": "Chicken Enchiladas",
      "image": "images/22b169be-2f6a-4dc8-9b7d-1fe7ff6dd7df_0.jpg",
      "servings": "6 servings",
      "readyInMinutes": 85,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vegetable oil",
        "corn tortillas",
        "white onion",
        "poblano or green bell pepper",
        "garlic cloves",
        "tomatoes",
        "kosher salt",
        "cooked shredded chicken",
        "enchilada sauce or from 2 s",
        "sharp cheddar",
        "pico de gallo"
      ],
      "searchText": "chicken enchiladas vegetable oil corn tortillas white onion poblano or green bell pepper garlic cloves tomatoes kosher salt cooked shredded chicken enchilada sauce or from 2 s sharp cheddar pico de gallo",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024437-chicken-enchiladas?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4566,
      "translatedTitles": {
        "fr": "Enchiladas au poulet"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 65,
      "readyInMinutesMin": 67
    },
    {
      "id": "df6942ce-1d31-47f0-a8cb-0cc7999e7901",
      "title": "Chicken Katsu",
      "image": "images/df6942ce-1d31-47f0-a8cb-0cc7999e7901_0.jpg",
      "servings": "4",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "skinless",
        "salt",
        "all-purpose flour",
        "eggs",
        "panko bread crumbs",
        "vegetable oil",
        "tonkatsu sauce"
      ],
      "searchText": "chicken katsu skinless salt all-purpose flour eggs panko bread crumbs vegetable oil tonkatsu sauce",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/chicken-katsu",
      "translatedTitles": {
        "fr": "Poulet Katsu"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 42,
      "readyInMinutesMin": 42
    },
    {
      "id": "f6baeefc-7f4e-471e-9a4e-22ab7ca1a18c",
      "title": "Chicken-Coconut Soup",
      "image": "images/f6baeefc-7f4e-471e-9a4e-22ab7ca1a18c_0.jpg",
      "servings": "8 servings",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "stalks lemon grass",
        "unsweetened ned coconut milk",
        "or ned chicken stock",
        "boneless chicken cut in bite-size pieces",
        "slices galangal or ginger each the size of a quarter",
        "black peppercorns",
        "makrut lime leaves",
        "well-drained ned straw mushrooms halved lengthwise",
        "thai fish sauce",
        "lime juice",
        "coriander leaves"
      ],
      "searchText": "chicken-coconut soup stalks lemon grass unsweetened ned coconut milk or ned chicken stock boneless chicken cut in bite-size pieces slices galangal or ginger each the size of a quarter black peppercorns makrut lime leaves well-drained ned straw mushrooms halved lengthwise thai fish sauce lime juice coriander leaves",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/5686-chicken-coconut-soup?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 100,
      "translatedTitles": {
        "fr": "Soupe Poulet-Noix de Coco"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 37
    },
    {
      "id": "7334c253-f8a3-42a0-9be7-eac10bf1abcc",
      "title": "Chili classique au boeuf",
      "image": "images/7334c253-f8a3-42a0-9be7-eac10bf1abcc_0.jpg",
      "servings": "6 portion(s)",
      "readyInMinutes": 73,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "piment jalapeño",
        "de beurre",
        "gousses d’ail",
        "d'assaisonnement au chili",
        "de cumin moulu",
        "boîte de 796 de tomates en dés",
        "boîte de 540 de haricots rouges",
        "de café allongé ou de café fort",
        "de bouillon de bœuf ou d’eau",
        "de ketchup",
        "de jus de lime",
        "de coriandre ciselée"
      ],
      "searchText": "chili classique au boeuf oignon piment jalapeño de beurre gousses d’ail d'assaisonnement au chili de cumin moulu boîte de 796 de tomates en dés boîte de 540 de haricots rouges de café allongé ou de café fort de bouillon de bœuf ou d’eau de ketchup de jus de lime de coriandre ciselée",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5762-chili-classique-au-boeuf",
      "sourceRating": 5,
      "sourceRatingCount": 354,
      "translatedTitles": {
        "en": "Classic Beef Chili"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 73
    },
    {
      "id": "2f137063-e785-4edc-b0fc-fad495d7618b",
      "title": "Chili con carne",
      "image": "images/2f137063-e785-4edc-b0fc-fad495d7618b_0.jpg",
      "servings": "Pour 6-8 Personnes",
      "readyInMinutes": 283,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "poivron rouge",
        "poivron jaune",
        "gousses d’ail",
        "de boeuf haché maigre",
        "de veau haché",
        "tasse de chorizo",
        "c. à thé de poudre de chili",
        "boîte de 540 de haricots rouges",
        "boîte de 800 de tomates entières",
        "boîte de 284 de soupe condensée aux tomates",
        "tasse de bouillon de poulet",
        "c. à thé de miel",
        "le jus d’un citron",
        "sel et poivre"
      ],
      "searchText": "chili con carne oignon poivron rouge poivron jaune gousses d’ail de boeuf haché maigre de veau haché tasse de chorizo c. à thé de poudre de chili boîte de 540 de haricots rouges boîte de 800 de tomates entières boîte de 284 de soupe condensée aux tomates tasse de bouillon de poulet c. à thé de miel le jus d’un citron sel et poivre plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/casseroles-gratins/chili-con-carne/",
      "translatedTitles": {
        "en": "Chili con carne"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 223
    },
    {
      "id": "afcd115c-7390-46f0-9b86-b3f0cd109eaf",
      "title": "Chili de dinde et de légumes gratiné",
      "servings": "6",
      "readyInMinutes": 100,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "branches de céleri",
        "carottes",
        "oignon",
        "poivron rouge",
        "d’huile d’olive",
        "de dinde hachée",
        "patate douce",
        "boîte de 796 de tomates en dés",
        "boîte de 540 de haricots rouges",
        "de ketchup",
        "de moutarde de dijon",
        "d’assaisonnement au chili",
        "de coriandre moulue",
        "de coriandre fraîche",
        "oignons verts",
        "de jus de lime",
        "de fromage édam ou cheddar doux râpé",
        "sel et poivre"
      ],
      "searchText": "chili de dinde et de légumes gratiné branches de céleri carottes oignon poivron rouge d’huile d’olive de dinde hachée patate douce boîte de 796 de tomates en dés boîte de 540 de haricots rouges de ketchup de moutarde de dijon d’assaisonnement au chili de coriandre moulue de coriandre fraîche oignons verts de jus de lime de fromage édam ou cheddar doux râpé sel et poivre plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7428-chili-de-dinde-et-de-legumes-gratine",
      "image": "images/afcd115c-7390-46f0-9b86-b3f0cd109eaf_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 65,
      "translatedTitles": {
        "en": "Gratiné Turkey and Vegetable Chili"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "1988ae5b-36f3-4386-a82a-709b67f14bb1",
      "title": "Chips cuites au four et trempette piquante aux haricots noirs",
      "image": "images/1988ae5b-36f3-4386-a82a-709b67f14bb1_0.jpg",
      "servings": "12",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "petites tortillas de grains entiers ou de maïs",
        "de poudre de chili",
        "boîte de haricots noirs",
        "de salsa moyenne ou forte",
        "de zeste de lime",
        "mll de jus de lime",
        "échalote émincée",
        "de cumin moulu",
        "une pincée de poivre moulu",
        "de coriandre fraîche hachée",
        "de basilic frais haché"
      ],
      "searchText": "chips cuites au four et trempette piquante aux haricots noirs petites tortillas de grains entiers ou de maïs de poudre de chili boîte de haricots noirs de salsa moyenne ou forte de zeste de lime mll de jus de lime échalote émincée de cumin moulu une pincée de poivre moulu de coriandre fraîche hachée de basilic frais haché",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://guide-alimentaire.canada.ca/fr/recettes/chips-trempette-ole-ole-haricots-noirs/",
      "translatedTitles": {
        "en": "Baked Chips and Spicy Black Bean Dip"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 54
    },
    {
      "id": "b717601e-dc75-4a4f-8662-5f45168bc88c",
      "title": "Chips de wontons au canard confit",
      "servings": "1",
      "readyInMinutes": 71,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "petite carotte",
        "de vinaigre de riz",
        "de sucre",
        "de sel",
        "cuisse de ard confit",
        "de sauce hoisin",
        "de sambal oelek",
        "oignon vert",
        "carrés de pâte à wontons",
        "graines de sésame noir",
        "huile véétale"
      ],
      "searchText": "chips de wontons au canard confit petite carotte de vinaigre de riz de sucre de sel cuisse de ard confit de sauce hoisin de sambal oelek oignon vert carrés de pâte à wontons graines de sésame noir huile véétale plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7760-chips-de-wontons-au-canard-confit",
      "image": "images/b717601e-dc75-4a4f-8662-5f45168bc88c_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 21,
      "translatedTitles": {
        "en": "Confit Duck Wonton Chips"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 71
    },
    {
      "id": "41b8e7bf-d6f4-468a-81e8-61926773d28f",
      "title": "Chocolat chaud maison",
      "image": "images/41b8e7bf-d6f4-468a-81e8-61926773d28f_0.jpg",
      "servings": "2 portions",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de cacao en poudre",
        "de sucre",
        "de lait",
        "nelle moulue ou cacao (facultatif"
      ],
      "searchText": "chocolat chaud maison de cacao en poudre de sucre de lait nelle moulue ou cacao (facultatif apéritif",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2317/chocolat-chaud-maison",
      "translatedTitles": {
        "en": "Homemade Hot Chocolate"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "b0bcddc4-23e8-50cc-a879-22b1b2e63919",
      "title": "Chocolate Chip Cookies",
      "image": "images/b0bcddc4-23e8-50cc-a879-22b1b2e63919_0.jpg",
      "servings": "12",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "all-purpose flour",
        "baking soda",
        "salt",
        "butter",
        "caster sugar",
        "soft brown sugar",
        "vanilla ct",
        "eggs",
        "dark chocolate"
      ],
      "searchText": "chocolate chip cookies all-purpose flour baking soda salt butter caster sugar soft brown sugar vanilla ct eggs dark chocolate snack",
      "isPersonalRecipe": true,
      "nutritionScore": 40,
      "originalLanguage": "en",
      "sourceRating": 4.7,
      "sourceRatingCount": 1877,
      "translatedTitles": {
        "fr": "Biscuits aux pépites de chocolat"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 40
    },
    {
      "id": "318cc724-0226-4964-a06c-26c0a62232e1",
      "title": "Chopped Salad With Chickpeas, Feta and Avocado",
      "image": "images/318cc724-0226-4964-a06c-26c0a62232e1_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "stale bread",
        "olive oil",
        "kosher salt and black pepper",
        "romaine heart",
        "chickpeas",
        "english cucumber",
        "pitted castelvetrano or other green olives",
        "thinly scallions",
        "red wine vinegar",
        "drained capers",
        "shallots",
        "dijon mustard",
        "firm-ripe avocado",
        "or crumbled feta cheese",
        "herbs"
      ],
      "searchText": "chopped salad with chickpeas, feta and avocado stale bread olive oil kosher salt and black pepper romaine heart chickpeas english cucumber pitted castelvetrano or other green olives thinly scallions red wine vinegar drained capers shallots dijon mustard firm-ripe avocado or crumbled feta cheese herbs",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021454-chopped-salad-with-chickpeas-feta-and-avocado?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 8954,
      "translatedTitles": {
        "fr": "Salade Hachée aux Pois Chiches, Feta et Avocat"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 48
    },
    {
      "id": "e161f967-650c-42b6-8dab-43755c3cdee7",
      "title": "Christmas Morning Wife Saver",
      "image": "images/e161f967-650c-42b6-8dab-43755c3cdee7_0.jpg",
      "servings": "1",
      "readyInMinutes": 814,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "slices white bread",
        "slices adian back bacon or ham",
        "slices sharp cheddar cheese",
        "eggs",
        ". pepper 2",
        ". dry mustard 2-5",
        "onion 60",
        "finely green pepper 60ml",
        ". worcestershire sauce 5-10",
        "milk 750",
        "dash tabasco",
        "butter 125",
        "special k or corn flakes"
      ],
      "searchText": "christmas morning wife saver slices white bread slices adian back bacon or ham slices sharp cheddar cheese eggs . pepper 2 . dry mustard 2-5 onion 60 finely green pepper 60ml . worcestershire sauce 5-10 milk 750 dash tabasco butter 125 special k or corn flakes breakfast",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bestofbridge.com/christmas-morning-wife-saver/",
      "translatedTitles": {
        "fr": "Christmas Morning Wife Saver"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 574
    },
    {
      "id": "35cfd6dc-64f7-48f1-ab1b-daff1ed41aea",
      "title": "cinnamon brown butter breakfast puffs",
      "image": "images/35cfd6dc-64f7-48f1-ab1b-daff1ed41aea_0.jpg",
      "servings": "Yield: 9 to 12 standard muffin-size puffs or 30-ish miniature ones. Try not to overfill as I did or",
      "readyInMinutes": 61,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cinnamon brown butter breakfast puffs",
        "adapted from betty crocker and others",
        "if you don’t wish to use buttermilk",
        "coating",
        "granulated sugar",
        "cinnamon",
        "unsalted butter",
        "puffs",
        "all-purpose flour",
        "baking powder",
        "baking soda",
        "table salt",
        "ly grated nutmeg",
        "granulated sugar",
        "unsalted butter",
        "egg",
        "pure vanilla ct",
        "buttermilk"
      ],
      "searchText": "cinnamon brown butter breakfast puffs cinnamon brown butter breakfast puffs adapted from betty crocker and others if you don’t wish to use buttermilk coating granulated sugar cinnamon unsalted butter puffs all-purpose flour baking powder baking soda table salt ly grated nutmeg granulated sugar unsalted butter egg pure vanilla ct buttermilk",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://smittenkitchen.com/2011/12/cinnamon-brown-butter-breakfast-puffs/",
      "translatedTitles": {
        "fr": "bouffées de petit-déjeuner au beurre noisette à la cannelle"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 48
    },
    {
      "id": "d1d91d45-eb73-47ad-851a-1f0be994e7f6",
      "title": "Coconut Chicken Curry",
      "image": "images/d1d91d45-eb73-47ad-851a-1f0be994e7f6_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 725,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boneless",
        "paprika",
        "turmeric",
        "kosher salt",
        "ola oil",
        "yellow onions",
        "garlic cloves",
        "unsweetened coconut milk",
        "fish sauce",
        "madras curry powder",
        "cayenne",
        "cooked rice or noodles",
        "cilantro sprigs",
        "lime or lemon"
      ],
      "searchText": "coconut chicken curry boneless paprika turmeric kosher salt ola oil yellow onions garlic cloves unsweetened coconut milk fish sauce madras curry powder cayenne cooked rice or noodles cilantro sprigs lime or lemon",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021760-coconut-chicken-curry",
      "sourceRating": 5,
      "sourceRatingCount": 9576,
      "translatedTitles": {
        "fr": "Curry de poulet à la noix de coco"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 39,
      "readyInMinutesMin": 588
    },
    {
      "id": "6cb9cf21-cde8-46c0-8f07-06b4453f993f",
      "title": "Coconut Curry Shrimp",
      "image": "images/6cb9cf21-cde8-46c0-8f07-06b4453f993f_0.jpg",
      "servings": "6 servings",
      "readyInMinutes": 36,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salted butter",
        "peeled and deveined raw shrimp (i used u10",
        "cloves garlic",
        "onion",
        "curry powder",
        "one 13 1/2-ounce coconut milk",
        "honey",
        "kosher salt",
        "juice of 1 lime",
        "basil leaves",
        "hot sauce",
        "cooked basmati rice"
      ],
      "searchText": "coconut curry shrimp salted butter peeled and deveined raw shrimp (i used u10 cloves garlic onion curry powder one 13 1/2-ounce coconut milk honey kosher salt juice of 1 lime basil leaves hot sauce cooked basmati rice",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodnetwork.com/recipes/ree-drummond/coconut-curry-shrimp-2770459",
      "sourceRating": 4.7,
      "sourceRatingCount": 108,
      "translatedTitles": {
        "fr": "Crevettes au Curry et Lait de Coco"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 34
    },
    {
      "id": "c2577e6f-d222-421f-96ff-a6b4aea81032",
      "title": "Cod with bacon, lettuce & peas",
      "image": "images/c2577e6f-d222-421f-96ff-a6b4aea81032_0.jpg",
      "servings": "Serves 2",
      "readyInMinutes": 26,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sunflower oil",
        "rashers rindless smoked streaky bacon",
        "long shallot or onion",
        "garlic clove",
        "x 140g/5oz thick skinless cod fillets",
        "pea",
        "chicken stock",
        "little gem lettuces",
        "half-fat crème fraîche",
        "thick slices crusty wholegrain bread"
      ],
      "searchText": "cod with bacon, lettuce & peas sunflower oil rashers rindless smoked streaky bacon long shallot or onion garlic clove x 140g/5oz thick skinless cod fillets pea chicken stock little gem lettuces half-fat crème fraîche thick slices crusty wholegrain bread plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 70,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bbcgoodfood.com/recipes/cod-bacon-lettuce-peas?_gl=1*18k4wl5*_ga*YW1wLWo1OUtRQ25Sd0RrQmpyUGlrMGc3OVpUbjB3ZGhwMFNBN25RVl9qb3lDSzhTc2xFaFduUTN6ZW8zSWdFRXpwNUE",
      "translatedTitles": {
        "fr": "Cabillaud au lard, laitue et petits pois"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 26
    },
    {
      "id": "769322e6-e035-4829-9ac2-633037101d33",
      "title": "Pavé de pommes de terre à la crème et à l’ail",
      "image": "images/769322e6-e035-4829-9ac2-633037101d33_0.jpg",
      "servings": "1",
      "readyInMinutes": 908,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de crème à cuisson ou",
        "gousses d’ail",
        "d’huile d’olive",
        "branches de thym"
      ],
      "searchText": "pavé de pommes de terre à la crème et à l’ail de crème à cuisson ou gousses d’ail d’huile d’olive branches de thym",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/efcfb568-c295-45d4-97fb-b018546e6542__7C___0.html?utm_content=ulink&utm_source=lpp&utm_medium=referral&utm_campaign=internal+share",
      "translatedTitles": {
        "en": "Pressed Potatoes with Garlic Cream"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 41,
      "readyInMinutesMin": 668
    },
    {
      "id": "008e86f2-42e0-4b63-a0dd-5d6e768db1b3",
      "title": "Compote de pommes",
      "servings": "1",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’eau",
        "litre de pommes mcintosh non pelées"
      ],
      "searchText": "compote de pommes d’eau litre de pommes mcintosh non pelées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6784-compote-de-pommes",
      "image": "images/008e86f2-42e0-4b63-a0dd-5d6e768db1b3_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 75,
      "translatedTitles": {
        "en": "Applesauce"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "d4ec6509-712d-4432-9926-3cd7dd5780a6",
      "title": "Contre-filet de boeuf et salade de chou-fleur grillé au raifort",
      "image": "images/d4ec6509-712d-4432-9926-3cd7dd5780a6_0.jpg",
      "servings": "4",
      "readyInMinutes": 81,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de mayonnaise",
        "de moutarde de dijon",
        "de raifort préparé",
        "biftecks de contre-filet de boeuf vieilli de 2",
        "chou-fleur",
        "gousses d’ail",
        "oignon",
        "de beurre",
        "d’edamames surgelés",
        "de feuilles d’aneth",
        "de feuilles de persil plat",
        "de ciboulette ciselée"
      ],
      "searchText": "contre-filet de boeuf et salade de chou-fleur grillé au raifort de mayonnaise de moutarde de dijon de raifort préparé biftecks de contre-filet de boeuf vieilli de 2 chou-fleur gousses d’ail oignon de beurre d’edamames surgelés de feuilles d’aneth de feuilles de persil plat de ciboulette ciselée",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9493-contre-filet-de-boeuf-et-salade-de-chou-fleur-grille-au-raifort",
      "sourceRating": 5,
      "sourceRatingCount": 2,
      "translatedTitles": {
        "en": "Beef sirloin and grilled cauliflower salad with horseradish"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 45,
      "readyInMinutesMin": 81
    },
    {
      "id": "990fe938-a024-4807-b2a4-5f81ef5dc2aa",
      "title": "Corn and Cod Green Curry",
      "image": "images/990fe938-a024-4807-b2a4-5f81ef5dc2aa_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ears of corn",
        "piece of ginger",
        "green curry paste",
        "coconut oil or neutral oil such as grapeseed",
        "full-fat coconut milk",
        "fish sauce",
        "½ cod",
        "baby bok choy",
        "juice from 1 lime",
        "basil or cilantro leaves",
        "thinly thai bird or serrano chile"
      ],
      "searchText": "corn and cod green curry ears of corn piece of ginger green curry paste coconut oil or neutral oil such as grapeseed full-fat coconut milk fish sauce ½ cod baby bok choy juice from 1 lime basil or cilantro leaves thinly thai bird or serrano chile",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025363-corn-and-cod-green-curry?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1282,
      "translatedTitles": {
        "fr": "Curry Vert de Maïs et de Cabillaud"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 39
    },
    {
      "id": "fe7a940b-4b66-400d-ad3c-fbeda54561ff",
      "title": "Cornmeal Waffles With Smoked Salmon",
      "image": "images/fe7a940b-4b66-400d-ad3c-fbeda54561ff_0.jpg",
      "servings": "6 servings as a main course servings, 12 as an appetizer",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "/380 all-purpose flour",
        "/90 fine cornmeal",
        "salt",
        "baking powder",
        "baking soda",
        "/840 milliliters buttermilk",
        "eggs",
        "/120 milliliters melted butter",
        "crème fraîche or sour cream",
        "grated lemon zest",
        "smoked salmon",
        "salmon roe",
        "finely chives",
        "roughly dill",
        "ly black pepper"
      ],
      "searchText": "cornmeal waffles with smoked salmon /380 all-purpose flour /90 fine cornmeal salt baking powder baking soda /840 milliliters buttermilk eggs /120 milliliters melted butter crème fraîche or sour cream grated lemon zest smoked salmon salmon roe finely chives roughly dill ly black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1019852-cornmeal-waffles-with-smoked-salmon?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 260,
      "translatedTitles": {
        "fr": "Gaufres de Farine de Maïs au Saumon Fumé"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "b686790b-2380-4a05-96fd-8ef6e66f53be",
      "title": "Côtelettes d’agneau grillées et salade de carottes",
      "image": "images/b686790b-2380-4a05-96fd-8ef6e66f53be_0.jpg",
      "servings": "1",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de sauce soja",
        "cuillères à table de cassonade tassée",
        "oignons verts coupés en tranches",
        "gousses d'ail hachées finement",
        "côtelettes d'agneau",
        "carottes râpées",
        "concombre coupé en deux sur la longueur",
        "tasse de coriandre fraîche",
        "cuillères à table de jus de lime",
        "cuillères à thé de sauce de poisson",
        "cuillère à table d' huile véétale",
        "cuillère à thé de sucre",
        "cuillère à table de graine de sésame grillées",
        "fibres 3",
        "sodium 628 mg",
        "protéines 16",
        "calories 202",
        "total gras 11",
        "cholestérol 32 mg",
        "gras saturés 3",
        "total glucides 12"
      ],
      "searchText": "côtelettes d’agneau grillées et salade de carottes tasse de sauce soja cuillères à table de cassonade tassée oignons verts coupés en tranches gousses d'ail hachées finement côtelettes d'agneau carottes râpées concombre coupé en deux sur la longueur tasse de coriandre fraîche cuillères à table de jus de lime cuillères à thé de sauce de poisson cuillère à table d' huile véétale cuillère à thé de sucre cuillère à table de graine de sésame grillées fibres 3 sodium 628 mg protéines 16 calories 202 total gras 11 cholestérol 32 mg gras saturés 3 total glucides 12",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.coupdepouce.com/cuisine/plats-principaux/recette/cotelettes-d-agneau-grillees-et-salade-de-carottes",
      "translatedTitles": {
        "en": "Grilled Lamb Chops and Carrot Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 46
    },
    {
      "id": "380fea2f-626a-43a5-904d-cde0c6bc6bcf",
      "title": "Côtelettes d’agneau sur le grill",
      "image": "images/380fea2f-626a-43a5-904d-cde0c6bc6bcf_0.jpg",
      "servings": "1",
      "readyInMinutes": 21,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pour 4 personnes",
        "côtelettes d'agneau d’environ 2 cm d'épaisseur",
        "cuillère à thé de sucre",
        "cuillère à thé de sel",
        "cuillère à thé de cumin moulu",
        "en accompagnement - patates deluxe",
        "pommes de terre russett",
        "fromage feta",
        "huile",
        "sel et poivre"
      ],
      "searchText": "côtelettes d’agneau sur le grill pour 4 personnes côtelettes d'agneau d’environ 2 cm d'épaisseur cuillère à thé de sucre cuillère à thé de sel cuillère à thé de cumin moulu en accompagnement - patates deluxe pommes de terre russett fromage feta huile sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.recettes.cuisinefestive.com/cotelettes-dagneau-sur-le-grill/",
      "translatedTitles": {
        "en": "Grilled Lamb Chops"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "08ab7ec3-faa6-4ae6-9e09-f374b8984d3f",
      "title": "Côtelettes de porc au fenouil et aux agrumes",
      "image": "images/08ab7ec3-faa6-4ae6-9e09-f374b8984d3f_0.jpg",
      "servings": "4",
      "readyInMinutes": 1114,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "marinade",
        "de jus d’agrumes ou d’orange",
        "d’huile d’olive",
        "de flocons de piment fort broyés",
        "de grains de poivre noir",
        "de graines de fenouil",
        "côtelettes de porc d’environ 2"
      ],
      "searchText": "côtelettes de porc au fenouil et aux agrumes marinade de jus d’agrumes ou d’orange d’huile d’olive de flocons de piment fort broyés de grains de poivre noir de graines de fenouil côtelettes de porc d’environ 2",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4805-cotelettes-de-porc-au-fenouil-et-aux-agrumes",
      "sourceRating": 5,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Pork Chops with Fennel and Citrus"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 754
    },
    {
      "id": "6cd5e4a0-d415-4868-ba9b-933f7a75a24a",
      "title": "Côtelettes de porc sauce à la moutarde",
      "image": "images/6cd5e4a0-d415-4868-ba9b-933f7a75a24a_0.jpg",
      "servings": "2",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "côtelettes de porc avec os",
        "c.à thé poivre moulu",
        "échalotes françaises",
        "c.à soupe huile d'olive",
        "c.à soupe beurre non salé",
        "tasse bouillon de poulet",
        "c.à thé moutarde de dijon",
        "c.à soupe crème à fouetter",
        "c.à thé citron",
        "pincée sel",
        "papier d'aluminium"
      ],
      "searchText": "côtelettes de porc sauce à la moutarde côtelettes de porc avec os c.à thé poivre moulu échalotes françaises c.à soupe huile d'olive c.à soupe beurre non salé tasse bouillon de poulet c.à thé moutarde de dijon c.à soupe crème à fouetter c.à thé citron pincée sel papier d'aluminium",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.soscuisine.com/recette/cotelettes-porc-sauce-moutarde",
      "sourceRating": 4.5,
      "sourceRatingCount": 164,
      "translatedTitles": {
        "en": "Pork Chops with Mustard Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 32
    },
    {
      "id": "775b81f7-be4e-423d-8520-52604cc826c4",
      "title": "Côtes levées au barbecue (les meilleures)",
      "image": "images/775b81f7-be4e-423d-8520-52604cc826c4_0.jpg",
      "servings": "4",
      "readyInMinutes": 165,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "marinade sèche",
        "de cassonade",
        "de poudre de chili",
        "de sel",
        "de poivre moulu",
        "de moutarde sèche",
        "sauce barbecue",
        "de poudre de chili",
        "de poudre d’oignon",
        "de beurre",
        "de ketchup",
        "de gelée de pommes",
        "de vinaigre de cidre",
        "de mélasse",
        "de moutarde de dijon",
        "de sauce worcestershire",
        "quelques gouttes de tabasco",
        "sel et poivre"
      ],
      "searchText": "côtes levées au barbecue (les meilleures) marinade sèche de cassonade de poudre de chili de sel de poivre moulu de moutarde sèche sauce barbecue de poudre de chili de poudre d’oignon de beurre de ketchup de gelée de pommes de vinaigre de cidre de mélasse de moutarde de dijon de sauce worcestershire quelques gouttes de tabasco sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4726-cotes-levees-au-barbecue-les-meilleures",
      "sourceRating": 5,
      "sourceRatingCount": 733,
      "translatedTitles": {
        "en": "Barbecue Ribs (The Best)"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "db6853ec-95eb-4238-b23e-56fcee263477",
      "title": "Courge spaghetti au kale, bacon et chèvre",
      "image": "images/db6853ec-95eb-4238-b23e-56fcee263477_0.jpg",
      "servings": "2",
      "readyInMinutes": 60,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "courge spaghetti",
        "tranches de bacon",
        "c. à soupe de gras du bacon réservé",
        "gousses d'ail",
        "c. à soupe de vinaigre de vin rouge",
        "c. à soupe de crème",
        "feuilles de kale",
        "petit paquet de fromage de chèvre",
        "sel"
      ],
      "searchText": "courge spaghetti au kale, bacon et chèvre courge spaghetti tranches de bacon c. à soupe de gras du bacon réservé gousses d'ail c. à soupe de vinaigre de vin rouge c. à soupe de crème feuilles de kale petit paquet de fromage de chèvre sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.noovomoi.ca/cuisiner/recettes/recette.courge-spaghetti-au-kale-bacon-et-chevre.1.2043003.html",
      "translatedTitles": {
        "en": "Spaghetti squash with kale, bacon and goat cheese"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "6b104451-c131-48bc-8e41-5a6685e0c33f",
      "title": "Crème de chou-fleur",
      "image": "images/6b104451-c131-48bc-8e41-5a6685e0c33f_0.jpg",
      "servings": "8 portion(s)",
      "readyInMinutes": 49,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de poireau haché",
        "gousse d'ail",
        "de beurre",
        "litre de chou-fleur",
        "de pommes de terre",
        "de crème",
        "sel et poivre"
      ],
      "searchText": "crème de chou-fleur de poireau haché gousse d'ail de beurre litre de chou-fleur de pommes de terre de crème sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/3376-creme-de-chou-fleur",
      "sourceRating": 5,
      "sourceRatingCount": 163,
      "translatedTitles": {
        "en": "Cream of Cauliflower"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 49
    },
    {
      "id": "3bbf272f-233b-41a3-ab5b-f11644b4b18f",
      "title": "Crème de lentilles épicée au citron",
      "image": "images/3bbf272f-233b-41a3-ab5b-f11644b4b18f_0.jpg",
      "servings": "6 portions",
      "readyInMinutes": 132,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon espagnol",
        "d’huile d’olive",
        "gousses d’ail",
        "c. à thé de cumin moulu",
        "c. à thé de coriandre moulue",
        "½ c. à thé de poivre de cayenne",
        "de lentilles corail",
        "de feuilles de céleri",
        "carotte moyenne",
        "litres de bouillon de poulet",
        "sel et poivre du moulin",
        "le jus et le zeste de 1 citron",
        "gros oignons",
        "d’huile d’olive",
        "pains pita",
        "citrons"
      ],
      "searchText": "crème de lentilles épicée au citron oignon espagnol d’huile d’olive gousses d’ail c. à thé de cumin moulu c. à thé de coriandre moulue ½ c. à thé de poivre de cayenne de lentilles corail de feuilles de céleri carotte moyenne litres de bouillon de poulet sel et poivre du moulin le jus et le zeste de 1 citron gros oignons d’huile d’olive pains pita citrons",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/5638/creme-de-lentilles-epicee-au-citron",
      "translatedTitles": {
        "en": "Spicy Lemon Lentil Cream"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 65,
      "readyInMinutesMin": 117
    },
    {
      "id": "b34a0343-648f-48a7-b82f-e64d0489ff7c",
      "title": "Crème de rutabaga et carottes à l'érable",
      "image": "images/b34a0343-648f-48a7-b82f-e64d0489ff7c_0.jpg",
      "servings": "10",
      "readyInMinutes": 58,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de carottes",
        "de rutaa",
        "oignons",
        "de beurre",
        "litres de bouillon de poulet",
        "pommes de terre russet",
        "de sirop d’érable",
        "de crème"
      ],
      "searchText": "crème de rutabaga et carottes à l'érable de carottes de rutaa oignons de beurre litres de bouillon de poulet pommes de terre russet de sirop d’érable de crème",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5174-creme-de-rutabaga-et-carottes-a-l-erable",
      "sourceRating": 5,
      "sourceRatingCount": 265,
      "translatedTitles": {
        "en": "Cream of Rutabaga and Carrots with Maple"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 58
    },
    {
      "id": "02ebe570-7aac-48e8-96a9-29408c0fdad3",
      "title": "Crémeux au chocolat, aux poires et aux pacanes",
      "image": "images/02ebe570-7aac-48e8-96a9-29408c0fdad3_0.jpg",
      "servings": "4",
      "readyInMinutes": 270,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poires dans le sirop",
        "d’eau",
        "de sucre",
        "de jus de citron",
        "poires mûres mais fermes",
        "de miel",
        "crémeux au chocolat",
        "de chocolat noir de à",
        "de crème",
        "de lait",
        "de sucre",
        "œuf",
        "de paes grillées"
      ],
      "searchText": "crémeux au chocolat, aux poires et aux pacanes poires dans le sirop d’eau de sucre de jus de citron poires mûres mais fermes de miel crémeux au chocolat de chocolat noir de à de crème de lait de sucre œuf de paes grillées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8732-cremeux-au-chocolat-aux-poires-et-aux-pacanes",
      "sourceRating": 5,
      "sourceRatingCount": 12,
      "translatedTitles": {
        "en": "Creamy Chocolate, Pear, and Pecan"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 51,
      "readyInMinutesMin": 265
    },
    {
      "id": "ee36a503-234c-44c1-bfb4-44688b494744",
      "title": "Crêpe soufflée au saumon fumé",
      "image": "images/ee36a503-234c-44c1-bfb4-44688b494744_0.jpg",
      "servings": "4",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oeuf",
        "de farine tout usage",
        "de lait",
        "de beurre",
        "citron",
        "d'aneth frais",
        "de ciboulette fraîche",
        "de saumon fumé à chaud",
        "paquet d’environ 100 de fromage de chèvre non affiné à pâte molle",
        "au goût poivre noir"
      ],
      "searchText": "crêpe soufflée au saumon fumé oeuf de farine tout usage de lait de beurre citron d'aneth frais de ciboulette fraîche de saumon fumé à chaud paquet d’environ 100 de fromage de chèvre non affiné à pâte molle au goût poivre noir",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/266/crepe-soufflee-saumon-fume",
      "sourceRating": 4,
      "sourceRatingCount": 5,
      "translatedTitles": {
        "en": "Puffed Smoked Salmon Crêpe"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 53
    },
    {
      "id": "bbc8b6cf-8e67-44df-9861-88aa6abca793",
      "title": "Crêpes de sarrasin au saumon fumé et aux poireaux",
      "image": "images/bbc8b6cf-8e67-44df-9861-88aa6abca793_0.jpg",
      "servings": "6",
      "readyInMinutes": 25,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "crêpes",
        "de farine tout usage non blanchie",
        "de farine de sarrasin",
        "de sucre",
        "de poudre à pâte",
        "de sel",
        "oeufs",
        "de lait",
        "de beurre",
        "beurre ramolli pour la cuisson",
        "garniture",
        "de tombée de poireaux",
        "de tranches de saumon fumé à froid"
      ],
      "searchText": "crêpes de sarrasin au saumon fumé et aux poireaux crêpes de farine tout usage non blanchie de farine de sarrasin de sucre de poudre à pâte de sel oeufs de lait de beurre beurre ramolli pour la cuisson garniture de tombée de poireaux de tranches de saumon fumé à froid",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ricardocuisine.com/recettes/5743-crepes-de-sarrasin-au-saumon-fume-et-aux-poireaux",
      "sourceRating": 4,
      "sourceRatingCount": 18,
      "translatedTitles": {
        "en": "Buckwheat Crêpes with Smoked Salmon and Leeks"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 22
    },
    {
      "id": "81aeb999-9b0b-4dd7-8ec3-c6e0e13777bd",
      "title": "Crevettes au curry vert & lait de coco",
      "image": "images/81aeb999-9b0b-4dd7-8ec3-c6e0e13777bd_0.jpg",
      "servings": "1",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "un filet d’huile véétale",
        "oignon",
        "c. à soupe de gingembre",
        "gousses d’ail",
        "oignons verts entiers",
        "½ c. à soupe de poudre de cari",
        "sel et poivre",
        "½ tasse de bouillon de poulet",
        "½ tasse de lait de coco",
        "c. à thé de miel",
        "de crevettes crues",
        "tomate",
        "¼ tasse de coriandre fraîche"
      ],
      "searchText": "crevettes au curry vert & lait de coco un filet d’huile véétale oignon c. à soupe de gingembre gousses d’ail oignons verts entiers ½ c. à soupe de poudre de cari sel et poivre ½ tasse de bouillon de poulet ½ tasse de lait de coco c. à thé de miel de crevettes crues tomate ¼ tasse de coriandre fraîche plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/fruits-de-mer/crevettes-au-curry-vert-lait-de-coco/",
      "translatedTitles": {
        "en": "Shrimp with Green Curry & Coconut Milk"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 44
    },
    {
      "id": "21444afc-beba-496e-a0d0-8594ef7733b2",
      "title": "Crevettes et Bok Choy à L’arachide sur Nouilles de Riz",
      "image": "images/21444afc-beba-496e-a0d0-8594ef7733b2_0.jpg",
      "servings": "0",
      "readyInMinutes": 20,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "lime",
        "tasse de bouillon de poulet - moins de sodium 75",
        "tasse de beurre d’arachide crémeux 60",
        "c. à soupe de sauce soya",
        "c. à soupe de gingembre frais",
        "c. à soupe d’huile de sésame grillé",
        "c. à thé d’huile véétale 10",
        "carottes",
        "tasses de bok choy",
        "pqt de crevettes blanches du pacifique non cuites",
        "tasse de coriandre fraîche non tassée 125",
        "de nouilles de riz de largeur moyenne 250"
      ],
      "searchText": "crevettes et bok choy à l’arachide sur nouilles de riz lime tasse de bouillon de poulet - moins de sodium 75 tasse de beurre d’arachide crémeux 60 c. à soupe de sauce soya c. à soupe de gingembre frais c. à soupe d’huile de sésame grillé c. à thé d’huile véétale 10 carottes tasses de bok choy pqt de crevettes blanches du pacifique non cuites tasse de coriandre fraîche non tassée 125 de nouilles de riz de largeur moyenne 250",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.sobeys.com/fr/recipes/crevettes-et-bok-choy-a-larachide-sur-nouilles-de-riz/",
      "translatedTitles": {
        "en": "Shrimp and Bok Choy with Peanut on Rice Noodles"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "802a3b29-7ac1-4c39-8791-3019e9bbc208",
      "title": "Crispy Cheesy Potatoes Stacks",
      "image": "images/802a3b29-7ac1-4c39-8791-3019e9bbc208_0.jpg",
      "servings": "6",
      "readyInMinutes": 70,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "russet or idaho potatoes",
        "stick salted butter",
        "oregano",
        "thyme",
        "cloves garlic",
        "grated parmesan cheese",
        "shredded sharp cheddar or gruyere cheese",
        "kosher salt and black pepper"
      ],
      "searchText": "crispy cheesy potatoes stacks russet or idaho potatoes stick salted butter oregano thyme cloves garlic grated parmesan cheese shredded sharp cheddar or gruyere cheese kosher salt and black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.halfbakedharvest.com/crispy-cheesy-potatoes-stacks/",
      "sourceRating": 3.83,
      "sourceRatingCount": 1979,
      "translatedTitles": {
        "fr": "Piles de pommes de terre croustillantes au fromage"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "e8d88edc-303a-42d5-955c-27edde8db3b4",
      "title": "Crispy Gnocchi With Burst Tomatoes and Mozzarella",
      "image": "images/e8d88edc-303a-42d5-955c-27edde8db3b4_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 56,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "- olive oil",
        "s shelf-stable or refrigerated potato gnocchi",
        "unsalted butter",
        "garlic cloves",
        "red-pepper flakes",
        "kosher salt and black pepper",
        "pints tomatoes",
        "thinly or torn basil leaves",
        "mozzarella"
      ],
      "searchText": "crispy gnocchi with burst tomatoes and mozzarella - olive oil s shelf-stable or refrigerated potato gnocchi unsalted butter garlic cloves red-pepper flakes kosher salt and black pepper pints tomatoes thinly or torn basil leaves mozzarella",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022024-crispy-gnocchi-with-burst-tomatoes-and-mozzarella",
      "sourceRating": 5,
      "sourceRatingCount": 15353,
      "translatedTitles": {
        "fr": "Gnocchis croustillants aux tomates éclatées et mozzarella"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 47
    },
    {
      "id": "43a4151b-6f34-42c6-b0fc-c192d662fd48",
      "title": "Crispy Gnocchi With Sausage and Broccoli",
      "image": "images/43a4151b-6f34-42c6-b0fc-c192d662fd48_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "shelf-stable potato gnocchi",
        "head broccoli",
        "¼ - olive oil",
        "garlic cloves",
        "salt",
        "red pepper",
        "hot or sweet italian sausage",
        "grated parmesan",
        "½ lemon"
      ],
      "searchText": "crispy gnocchi with sausage and broccoli shelf-stable potato gnocchi head broccoli ¼ - olive oil garlic cloves salt red pepper hot or sweet italian sausage grated parmesan ½ lemon",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025733-crispy-gnocchi-with-sausage-and-broccoli?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 12634,
      "translatedTitles": {
        "fr": "Gnocchi Croustillants aux Saucisses et Brocoli"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 43
    },
    {
      "id": "1d52b54e-2d69-4436-8ad2-07e6337ea75a",
      "title": "Crispy Gnocchi With Sausage and Broccoli",
      "image": "images/1d52b54e-2d69-4436-8ad2-07e6337ea75a_0.jpg",
      "servings": "4",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "shelf-stable potato gnocchi",
        "head broccoli",
        "¼ - olive oil",
        "garlic cloves",
        "salt",
        "red pepper",
        "hot or sweet italian sausage",
        "grated parmesan",
        "½ lemon"
      ],
      "searchText": "crispy gnocchi with sausage and broccoli shelf-stable potato gnocchi head broccoli ¼ - olive oil garlic cloves salt red pepper hot or sweet italian sausage grated parmesan ½ lemon",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025733-crispy-gnocchi-with-sausage-and-broccoli?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 12634,
      "translatedTitles": {
        "fr": "Gnocchi Croustillants avec Saucisse et Brocoli"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 43
    },
    {
      "id": "279d4972-40a3-4608-85e7-3b2e5c409362",
      "title": "Croque-madame en casserole",
      "image": "images/279d4972-40a3-4608-85e7-3b2e5c409362_0.jpg",
      "servings": "1",
      "readyInMinutes": 825,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "– 1 gros oignon",
        "– 1 c. à table d’huile d’olive -vierge",
        "– 1 c. à table de beurre",
        "– 12 œufs",
        "– 2 c. à table de moutarde de dijon",
        "– ¼ c. à thé de muscade râpée",
        "– 2 tasses de lait entier",
        "– 1 tasse de crème à café",
        "– 8 de jambon cuit",
        "– 1 ½ tasse de fromage oka",
        "– 1 ½ tasse de cheddar blanc",
        "– ¼ tasse de persil frais",
        "– 1 c. à thé de sel",
        "– ½ c. à thé de poivre noir",
        "– 1 uette ou une miche de pain"
      ],
      "searchText": "croque-madame en casserole – 1 gros oignon – 1 c. à table d’huile d’olive -vierge – 1 c. à table de beurre – 12 œufs – 2 c. à table de moutarde de dijon – ¼ c. à thé de muscade râpée – 2 tasses de lait entier – 1 tasse de crème à café – 8 de jambon cuit – 1 ½ tasse de fromage oka – 1 ½ tasse de cheddar blanc – ¼ tasse de persil frais – 1 c. à thé de sel – ½ c. à thé de poivre noir – 1 uette ou une miche de pain",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://journalmetro.com/inspiration/a-table/2952527/croque-madame-en-casserole/",
      "translatedTitles": {
        "en": "Croque-madame Casserole"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 40,
      "readyInMinutesMin": 153
    },
    {
      "id": "e6eda09e-590a-4133-b8d3-4ce61d293b91",
      "title": "Croquettes de zucchinis",
      "image": "images/e6eda09e-590a-4133-b8d3-4ce61d293b91_0.jpg",
      "servings": "4 portions (12 croquettes)",
      "readyInMinutes": 82,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de quinoa",
        "zucchinis moyens verts et/ou jaunes râpés",
        "de sel",
        "de curcuma",
        "d’eau",
        "¼ tasse de menthe fraîche lavée et ciselée",
        "oignons verts hachés",
        "à 45 de parmesan frais râpé",
        "de feta émietté",
        "œuf",
        "à 125 de farine",
        "un filet d’huile d’olive",
        "yaourt nature",
        "sel et poivre du moulin",
        "quartiers de lime ou de citron"
      ],
      "searchText": "croquettes de zucchinis de quinoa zucchinis moyens verts et/ou jaunes râpés de sel de curcuma d’eau ¼ tasse de menthe fraîche lavée et ciselée oignons verts hachés à 45 de parmesan frais râpé de feta émietté œuf à 125 de farine un filet d’huile d’olive yaourt nature sel et poivre du moulin quartiers de lime ou de citron plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/croquettes-de-zucchinis/",
      "sourceRating": 4.7,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Zucchini Croquettes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 49,
      "readyInMinutesMin": 82
    },
    {
      "id": "9ce496de-e2d1-4796-b725-9a5d0ee4a841",
      "title": "Croustade aux pommes",
      "servings": "6",
      "readyInMinutes": 113,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "croustillant",
        "de flocons d'avoine à cuisson rapide",
        "de farine tout usage non blanchie",
        "de cassonade",
        "de beurre non salé",
        "garniture",
        "de cassonade",
        "pommes cortland",
        "pommes mcintosh",
        "de jus de citron"
      ],
      "searchText": "croustade aux pommes croustillant de flocons d'avoine à cuisson rapide de farine tout usage non blanchie de cassonade de beurre non salé garniture de cassonade pommes cortland pommes mcintosh de jus de citron",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/3655-croustade-aux-pommes",
      "image": "images/9ce496de-e2d1-4796-b725-9a5d0ee4a841_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 357,
      "translatedTitles": {
        "en": "Apple Crisp"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 113
    },
    {
      "id": "a82a8c24-2269-499e-8e5e-0ef12c1e9bd4",
      "title": "Croustade aux pommes protéinée pour le déjeuner, version solo",
      "image": "images/a82a8c24-2269-499e-8e5e-0ef12c1e9bd4_0.jpg",
      "servings": "1",
      "readyInMinutes": 14,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grains entiers",
        "pomme1 datte1ml de nelle½ banane60 de flocons d’avoine80 de protéine véétale texturée8 paes ou noix de grenoble",
        "hachées"
      ],
      "searchText": "croustade aux pommes protéinée pour le déjeuner, version solo grains entiers pomme1 datte1ml de nelle½ banane60 de flocons d’avoine80 de protéine véétale texturée8 paes ou noix de grenoble hachées",
      "isPersonalRecipe": true,
      "nutritionScore": 75,
      "originalLanguage": "fr",
      "sourceUrl": "https://equipenutrition.ca/recette-nutritionniste-dietetiste/croustade-aux-pommes-proteinee-pour-le-dejeuner-version-solo",
      "translatedTitles": {
        "en": "Protein apple crisp for breakfast, solo version"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "2e9988b5-0b5a-4c90-b8ba-b9bc6fa5daed",
      "title": "Crunchy Roasted Za’atar Chickpeas",
      "image": "images/2e9988b5-0b5a-4c90-b8ba-b9bc6fa5daed_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 98,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cooked chickpeas",
        "- olive oil",
        "za’atar",
        "kosher salt"
      ],
      "searchText": "crunchy roasted za’atar chickpeas cooked chickpeas - olive oil za’atar kosher salt",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1017427-crunchy-roasted-zaatar-chickpeas?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 1787,
      "translatedTitles": {
        "fr": "Pois chiches au za’atar rôtis croustillants"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 8,
      "readyInMinutesMin": 98
    },
    {
      "id": "48440882-65cc-4f09-9790-650214e73d70",
      "title": "Crunchy Thai Peanut & Quinoa Salad",
      "image": "images/48440882-65cc-4f09-9790-650214e73d70_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "uncooked quinoa or millet",
        "water",
        "shredded purple cabe",
        "grated carrot",
        "thinly snow peas or sugar snap peas",
        "cilantro",
        "thinly green onion",
        "roasted and salted peanuts",
        "smooth peanut butter",
        "reduced-sodium tamari or soy sauce",
        "maple syrup or honey",
        "rice vinegar",
        "toasted sesame oil",
        "grated ginger",
        "lime",
        "pinch of red pepper flakes"
      ],
      "searchText": "crunchy thai peanut & quinoa salad uncooked quinoa or millet water shredded purple cabe grated carrot thinly snow peas or sugar snap peas cilantro thinly green onion roasted and salted peanuts smooth peanut butter reduced-sodium tamari or soy sauce maple syrup or honey rice vinegar toasted sesame oil grated ginger lime pinch of red pepper flakes",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cookieandkate.com/thai-peanut-quinoa-salad-recipe/",
      "sourceRating": 4.9,
      "sourceRatingCount": 355,
      "translatedTitles": {
        "fr": "Salade croquante thaï aux arachides et quinoa"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 54
    },
    {
      "id": "88187b90-a8ca-4cb8-8075-132f44a1f0b7",
      "title": "Curried Lentil Soup With Coconut and Tomatoes",
      "image": "images/88187b90-a8ca-4cb8-8075-132f44a1f0b7_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 55,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        ". coconut oil or - olive oil",
        "onion",
        "garlic cloves",
        "piece ginger",
        ". curry powder",
        "¼ . red pepper flakes",
        "¾ red lentils",
        "tomatoes",
        "½ finely cilantro",
        "kosher salt and ly black pepper",
        "unsweetened coconut milk",
        "lime wedges"
      ],
      "searchText": "curried lentil soup with coconut and tomatoes . coconut oil or - olive oil onion garlic cloves piece ginger . curry powder ¼ . red pepper flakes ¾ red lentils tomatoes ½ finely cilantro kosher salt and ly black pepper unsweetened coconut milk lime wedges",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/curried-lentil-tomato-and-coconut-soup?srsltid=AfmBOoqimQC5ge4o5I3YtAjGXMAKr2F4qIY0dcom91gW23SEPqEaMzys",
      "sourceRating": 4.9,
      "sourceRatingCount": 266,
      "translatedTitles": {
        "fr": "Soupe de lentilles au curry avec noix de coco et tomates"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 48
    },
    {
      "id": "393fe2d4-12c6-4f9f-9352-b19820dad0f9",
      "title": "Curried Squash Galette",
      "image": "images/393fe2d4-12c6-4f9f-9352-b19820dad0f9_0.jpg",
      "servings": "6-8",
      "readyInMinutes": 161,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "¼ all-purpose flour",
        "kosher salt and pepper",
        "stick unsalted butter",
        "ice water",
        "butternut squash (peeled",
        "kabocha squash (peeled",
        "red onion",
        "¼ - olive oil",
        "madras curry powder",
        "kosher salt and pepper",
        "½ sour cream",
        "½ shredded manchego"
      ],
      "searchText": "curried squash galette ¼ all-purpose flour kosher salt and pepper stick unsalted butter ice water butternut squash (peeled kabocha squash (peeled red onion ¼ - olive oil madras curry powder kosher salt and pepper ½ sour cream ½ shredded manchego plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/curried-squash-galette",
      "translatedTitles": {
        "fr": "Galette de courge au curry"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 151
    },
    {
      "id": "8c2f242d-436b-4da1-ac61-67dc300fb280",
      "title": "Dijon Chicken With Tomatoes and Scallions",
      "image": "images/8c2f242d-436b-4da1-ac61-67dc300fb280_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "boneless",
        "salt and black pepper",
        "scallions",
        "garlic cloves",
        "oregano",
        "dijon mustard",
        "white wine",
        "pints cherry or grape tomatoes",
        "packed cilantro"
      ],
      "searchText": "dijon chicken with tomatoes and scallions olive oil boneless salt and black pepper scallions garlic cloves oregano dijon mustard white wine pints cherry or grape tomatoes packed cilantro",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1027150-dijon-chicken-with-tomatoes-and-scallions?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2466,
      "translatedTitles": {
        "fr": "Poulet à la moutarde de Dijon avec tomates et oignons verts"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 30
    },
    {
      "id": "3e15ddad-9745-4342-b2c4-6833af802f20",
      "title": "Dorades royales barbecue à la sauce persillée d’Helena Loureiro",
      "image": "images/3e15ddad-9745-4342-b2c4-6833af802f20_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’huile d’olive vierge",
        "de persil plat ciselé",
        "d’oignon rouge haché",
        "de vinaigre de framboise",
        "de câpres",
        "gousse d’ail",
        "sel de mer et poivre du moulin",
        "dorades royales entières d’environ 1 chacune",
        "d’huile d’olive vierge",
        "citron",
        "gousses d’ail"
      ],
      "searchText": "dorades royales barbecue à la sauce persillée d’helena loureiro d’huile d’olive vierge de persil plat ciselé d’oignon rouge haché de vinaigre de framboise de câpres gousse d’ail sel de mer et poivre du moulin dorades royales entières d’environ 1 chacune d’huile d’olive vierge citron gousses d’ail plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6177-dorades-royales-barbecue-a-la-sauce-persillee-d-helena-loureiro",
      "sourceRating": 5,
      "sourceRatingCount": 18,
      "translatedTitles": {
        "en": "Barbecue Sea Bream with Helena Loureiro's Parsley Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 37
    },
    {
      "id": "4f3bb5bf-5c4c-4977-bde5-42b969470c7b",
      "title": "Dumpling and Smashed Cucumber Salad With Peanut Sauce",
      "image": "images/4f3bb5bf-5c4c-4977-bde5-42b969470c7b_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "smooth peanut butter",
        "garlic clove",
        "just boiled water",
        "soy sauce",
        "rice vinegar",
        "granulated sugar",
        "chile crisp or oil",
        "persian cucumbers",
        "salt",
        "vegetable oil or other neutral oil",
        "potsticker dumplings",
        "big handful cilantro",
        "toasted white sesame seeds or roasted peanuts",
        "chile crisp or chile oil"
      ],
      "searchText": "dumpling and smashed cucumber salad with peanut sauce smooth peanut butter garlic clove just boiled water soy sauce rice vinegar granulated sugar chile crisp or oil persian cucumbers salt vegetable oil or other neutral oil potsticker dumplings big handful cilantro toasted white sesame seeds or roasted peanuts chile crisp or chile oil",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025695-dumpling-and-smashed-cucumber-salad-with-peanut-sauce?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 5635,
      "translatedTitles": {
        "fr": "Salade de raviolis et concombres écrasés à la sauce aux arachides"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 31
    },
    {
      "id": "f7e75a82-bd2d-47dc-8420-6a8ebb95758a",
      "title": "Dumpling Soup",
      "image": "images/f7e75a82-bd2d-47dc-8420-6a8ebb95758a_0.jpg",
      "servings": "4 to 6",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vegetable oil or avocado oil",
        "shiitake mushrooms",
        "tamari or soy sauce",
        "vegetable broth",
        "garlic cloves",
        "grated ginger",
        "carrot",
        "vegetable dumplings",
        "scallions",
        "spinach",
        "rice vinegar",
        "lime juice",
        "sesame seeds",
        "sichuan chili crisp (optional"
      ],
      "searchText": "dumpling soup vegetable oil or avocado oil shiitake mushrooms tamari or soy sauce vegetable broth garlic cloves grated ginger carrot vegetable dumplings scallions spinach rice vinegar lime juice sesame seeds sichuan chili crisp (optional main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/dumpling-soup/?fbclid=IwZXh0bgNhZW0CMTEAAR1qKVgo8S467lA5ruEsvrXFUprXX5VzmSbTrv7PDPpvTnHS24VM296-eEA_aem_Yt2RFKVMK77snNoHG1oDZw",
      "sourceRating": 4.96,
      "sourceRatingCount": 73,
      "translatedTitles": {
        "fr": "Soupe aux Dumplings"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 30
    },
    {
      "id": "b038ac42-b230-499d-ba69-a5ef085f501f",
      "title": "Easy side salad with lemon dressing",
      "image": "images/b038ac42-b230-499d-ba69-a5ef085f501f_0.jpg",
      "servings": "6",
      "readyInMinutes": 26,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "fennel bulbs",
        "5oz radishes",
        "/7oz salad leaves of your choice",
        "english cucumber/ 8 baby cucumbers",
        "avocados",
        "½ feta cheese",
        "¼ olive oil",
        "¼ lemon juice",
        "salt",
        "pepper"
      ],
      "searchText": "easy side salad with lemon dressing fennel bulbs 5oz radishes /7oz salad leaves of your choice english cucumber/ 8 baby cucumbers avocados ½ feta cheese ¼ olive oil ¼ lemon juice salt pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://simply-delicious-food.com/easy-side-salad-with-lemon-dressing/",
      "sourceRating": 4.36,
      "sourceRatingCount": 57,
      "translatedTitles": {
        "fr": "Salade d'accompagnement facile avec vinaigrette au citron"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 26
    },
    {
      "id": "6721cf86-98a3-4603-9171-ff3b0b7a75f6",
      "title": "Edamame Dip With Red Onion and Sesame Oil",
      "image": "images/6721cf86-98a3-4603-9171-ff3b0b7a75f6_0.jpg",
      "servings": "About 3 cups",
      "readyInMinutes": 744,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "shelled edamame",
        "cilantro",
        "finely red onion",
        "cloves garlic",
        "olive oil",
        "toasted sesame oil",
        "kosher salt",
        "sriracha or sambal",
        "lemons",
        "rice crackers"
      ],
      "searchText": "edamame dip with red onion and sesame oil shelled edamame cilantro finely red onion cloves garlic olive oil toasted sesame oil kosher salt sriracha or sambal lemons rice crackers",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/12287-edamame-dip-with-red-onion-and-sesame-oil?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 191,
      "translatedTitles": {
        "fr": "Trempette d'Edamame à l'Oignon Rouge et à l'Huile de Sésame"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 84
    },
    {
      "id": "b885925c-16b9-4b99-91d0-6b4981872129",
      "title": "Endives farcies au pamplemousse, pacanes et chèvre",
      "image": "images/b885925c-16b9-4b99-91d0-6b4981872129_0.jpg",
      "servings": "1",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boîte de pamplemousses en quartiers m’lord de 284",
        "de vinaigre balsamique",
        "de miel",
        "de fromage de chèvre émietté",
        "de paes hachées",
        "de persil frais haché",
        "de ciboulette fraîche hachée",
        "sel et poivre au goût",
        "grosses feuilles d’endive",
        "micropousses au choix et au goût"
      ],
      "searchText": "endives farcies au pamplemousse, pacanes et chèvre boîte de pamplemousses en quartiers m’lord de 284 de vinaigre balsamique de miel de fromage de chèvre émietté de paes hachées de persil frais haché de ciboulette fraîche hachée sel et poivre au goût grosses feuilles d’endive micropousses au choix et au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://mlord.ca/fr/recette/endives-farcies-au-pamplemousse-pacanes-et-chevre",
      "translatedTitles": {
        "en": "Stuffed Endives with Grapefruit, Pecans, and Goat Cheese"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 33
    },
    {
      "id": "08c2ae92-86fe-41aa-8c09-141d7bfa73be",
      "title": "Épis de maïs en papillote au beurre d’épices",
      "image": "images/08c2ae92-86fe-41aa-8c09-141d7bfa73be_0.jpg",
      "servings": "4",
      "readyInMinutes": 44,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de beurre",
        "de moutarde de dijon",
        "de poudre de cari",
        "épis de maïs",
        "de labneh ou de yogourt grec nature",
        "d’amandes tranchées",
        "sauce à la coriandre et au piment",
        "feuilles de coriandre déchirées",
        "quartiers de lime"
      ],
      "searchText": "épis de maïs en papillote au beurre d’épices de beurre de moutarde de dijon de poudre de cari épis de maïs de labneh ou de yogourt grec nature d’amandes tranchées sauce à la coriandre et au piment feuilles de coriandre déchirées quartiers de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9166-epis-de-mais-en-papillote-au-beurre-d-epices",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Corn on the cob en papillote with spiced butter"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 44
    },
    {
      "id": "0e102e2a-7d2f-4d14-b8b5-59cf18857d0c",
      "title": "Escalopes de poulet, gnocchis et kale, sauce crémeuse aux champignons",
      "image": "images/0e102e2a-7d2f-4d14-b8b5-59cf18857d0c_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de beurre",
        "branches de sauge",
        "gousse d’ail",
        "d’escalopes de poulet",
        "de champignons blancs",
        "de vin blanc sec",
        "de bouillon de poulet",
        "de crème",
        "paquets de 350 chacun de gnocchis frais ou sous vide",
        "de chou kale"
      ],
      "searchText": "escalopes de poulet, gnocchis et kale, sauce crémeuse aux champignons de beurre branches de sauge gousse d’ail d’escalopes de poulet de champignons blancs de vin blanc sec de bouillon de poulet de crème paquets de 350 chacun de gnocchis frais ou sous vide de chou kale",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9385-escalopes-de-poulet-gnocchis-et-kale-sauce-cremeuse-aux-champignons",
      "sourceRating": 5,
      "sourceRatingCount": 47,
      "translatedTitles": {
        "en": "Chicken cutlets, gnocchi and kale, creamy mushroom sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 37
    },
    {
      "id": "55d4e866-492e-4889-b288-64f0078a461e",
      "title": "Escargots et aubergines fondantes, caramel de soya",
      "image": "images/55d4e866-492e-4889-b288-64f0078a461e_0.jpg",
      "servings": "4",
      "readyInMinutes": 72,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "caramel de soya",
        "de miel",
        "de sauce soya",
        "légumes",
        "oignons perlés",
        "d'huile d'olive",
        "demi-rondelles d'aubergine d'environ 1",
        "sel et poivre",
        "escargots",
        "gousses d'ail",
        "d'huile de sésame grillé",
        "boîte de 200 d'escargots"
      ],
      "searchText": "escargots et aubergines fondantes, caramel de soya caramel de soya de miel de sauce soya légumes oignons perlés d'huile d'olive demi-rondelles d'aubergine d'environ 1 sel et poivre escargots gousses d'ail d'huile de sésame grillé boîte de 200 d'escargots",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4079-escargots-et-aubergines-fondantes-caramel-de-soya",
      "sourceRating": 5,
      "sourceRatingCount": 11,
      "translatedTitles": {
        "en": "Snails and melting eggplants, soy caramel"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 55,
      "readyInMinutesMin": 72
    },
    {
      "id": "29f21689-6cd4-44e0-be72-ad9b4fac9891",
      "title": "Fajitas au poulet au four à pizza",
      "image": "images/29f21689-6cd4-44e0-be72-ad9b4fac9891_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon rouge",
        "poivron rouge ou jaune",
        "d’huile véétale",
        "de hauts de cuisses de poulet désossés et sans la peau",
        "d’assaisonnement au chili",
        "de feuilles de coriandre",
        "lime",
        "tortillas de blé souples de 18 cm de diamètre",
        "de fromage cheddar orange doux râpé",
        "salsa maison ou du commerce",
        "guacamole maison ou du commerce",
        "crème sure"
      ],
      "searchText": "fajitas au poulet au four à pizza oignon rouge poivron rouge ou jaune d’huile véétale de hauts de cuisses de poulet désossés et sans la peau d’assaisonnement au chili de feuilles de coriandre lime tortillas de blé souples de 18 cm de diamètre de fromage cheddar orange doux râpé salsa maison ou du commerce guacamole maison ou du commerce crème sure plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/10361-fajitas-au-poulet-au-four-a-pizza",
      "translatedTitles": {
        "en": "Chicken Fajitas in a Pizza Oven"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 44
    },
    {
      "id": "554ad478-442b-4615-a064-0c1e30bac4c9",
      "title": "Family-Style Fish Tacos",
      "image": "images/554ad478-442b-4615-a064-0c1e30bac4c9_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 93,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½-. piece white fish",
        ". kosher salt",
        "jalapeños",
        "⅓ vegetable oil",
        "garlic cloves",
        "bunch of cilantro",
        "pint cherry tomatoes",
        "¼ white onion",
        "limes",
        "¼ head of green cabe",
        "avocado",
        "corn tortillas or 12 flour tortillas",
        "hot sauce"
      ],
      "searchText": "family-style fish tacos ½-. piece white fish . kosher salt jalapeños ⅓ vegetable oil garlic cloves bunch of cilantro pint cherry tomatoes ¼ white onion limes ¼ head of green cabe avocado corn tortillas or 12 flour tortillas hot sauce",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/family-style-fish-tacos",
      "sourceRating": 4.8,
      "sourceRatingCount": 47,
      "translatedTitles": {
        "fr": "Tacos de poisson style familial"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 60,
      "readyInMinutesMin": 74
    },
    {
      "id": "c4e217a6-c4cd-456e-8507-1145cb78957b",
      "title": "feta tapenade tarte soleil",
      "image": "images/c4e217a6-c4cd-456e-8507-1145cb78957b_0.jpg",
      "servings": "1",
      "readyInMinutes": 92,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sun tomatoes in oil",
        "pitted kalamata olives",
        "oregano or 2 oregano leaves; thyme and rosemary would work too",
        "garlic clove",
        "olive oil or reserved oil from tomatoes",
        "salt and ly black pepper or red pepper flakes to taste",
        "assembly",
        "s puffed pastry",
        "egg yolk beaten with 1 water",
        "sesame or poppy seeds to sprinkle",
        "dip",
        "feta",
        "cream cheese",
        "olive oil",
        "lemon juice",
        "coarse or kosher salt",
        "ly black pepper"
      ],
      "searchText": "feta tapenade tarte soleil sun tomatoes in oil pitted kalamata olives oregano or 2 oregano leaves; thyme and rosemary would work too garlic clove olive oil or reserved oil from tomatoes salt and ly black pepper or red pepper flakes to taste assembly s puffed pastry egg yolk beaten with 1 water sesame or poppy seeds to sprinkle dip feta cream cheese olive oil lemon juice coarse or kosher salt ly black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://smittenkitchen.com/2015/12/feta-tapenade-tarte-soleil/",
      "translatedTitles": {
        "fr": "feta tapenade tarte soleil"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 87
    },
    {
      "id": "53a2ff06-01ed-444c-88c7-45b39e1a10c0",
      "title": "Fettuccine aux crevettes, ail et citron",
      "image": "images/53a2ff06-01ed-444c-88c7-45b39e1a10c0_0.jpg",
      "servings": "4",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de pâtes fettuccine",
        "de crevettes décortiquées",
        "gousses d ail",
        "cuillerées à soupe d'huile d'olive",
        "cuillerées à soupe de beurre",
        "jus et zeste d'un demi citron jaune",
        "sel et poivre du moulin",
        "cuillerées à soupe de persil plat ciselé"
      ],
      "searchText": "fettuccine aux crevettes, ail et citron de pâtes fettuccine de crevettes décortiquées gousses d ail cuillerées à soupe d'huile d'olive cuillerées à soupe de beurre jus et zeste d'un demi citron jaune sel et poivre du moulin cuillerées à soupe de persil plat ciselé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.cuisineculinaire.com/fettuccine-aux-crevettes-ail-citron/",
      "translatedTitles": {
        "en": "Fettuccine with Shrimp, Garlic, and Lemon"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 44
    },
    {
      "id": "038b9ddb-ac3f-41cb-8144-f941d5b12554",
      "title": "Filet de poisson blanc à la coriandre fraîche",
      "image": "images/038b9ddb-ac3f-41cb-8144-f941d5b12554_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 26,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’huile d’olive",
        "gousses d’ail écrasées au presse-ail ou hachées finement",
        "de cumin moulu",
        "gros bouquetde coriandre fraîche haché finement",
        "de gingembre frais râpé",
        "de zeste de citron ou lime",
        "sel et poivre du moulin",
        "un filet d’huile d’olive",
        "filets de poisson blanc idéalement éco-responsable (flétan",
        "asperges",
        "quartiers de lime"
      ],
      "searchText": "filet de poisson blanc à la coriandre fraîche d’huile d’olive gousses d’ail écrasées au presse-ail ou hachées finement de cumin moulu gros bouquetde coriandre fraîche haché finement de gingembre frais râpé de zeste de citron ou lime sel et poivre du moulin un filet d’huile d’olive filets de poisson blanc idéalement éco-responsable (flétan asperges quartiers de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/filet-de-poisson-blanc-a-la-coriandre-fraiche/",
      "sourceRating": 4.5,
      "sourceRatingCount": 2,
      "translatedTitles": {
        "en": "White fish fillet with fresh cilantro"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 25
    },
    {
      "id": "bb9942da-689b-4c6a-85cb-bdd786a80767",
      "title": "Filet de porc teriyaki sur le BBQ",
      "image": "images/bb9942da-689b-4c6a-85cb-bdd786a80767_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sauce soya",
        "saké",
        "sirop d'érable",
        "huile de sésame",
        "huile de sésame",
        "oignon vert",
        "gingembre",
        "gousse d'ail",
        "filet de porc",
        "pinot noir"
      ],
      "searchText": "filet de porc teriyaki sur le bbq sauce soya saké sirop d'érable huile de sésame huile de sésame oignon vert gingembre gousse d'ail filet de porc pinot noir",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.zeste.ca/recettes/filet-de-porc-teriyaki-sur-le-bbq",
      "translatedTitles": {
        "en": "Teriyaki Pork Tenderloin on the BBQ"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "f18fa9c0-6f60-4fbb-9673-74bb3dd7696c",
      "title": "Filets de porc à l’érable et sauce soya",
      "image": "images/f18fa9c0-6f60-4fbb-9673-74bb3dd7696c_0.jpg",
      "servings": "6",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de moutarde de dijon",
        "de sauce soya",
        "de sirop d'érable",
        "de vinaigre de cidre",
        "de 450 chacun de filet de porc",
        "au goût huile de ola",
        "de cidre sec",
        "de fond de veau"
      ],
      "searchText": "filets de porc à l’érable et sauce soya de moutarde de dijon de sauce soya de sirop d'érable de vinaigre de cidre de 450 chacun de filet de porc au goût huile de ola de cidre sec de fond de veau",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/4626/filet-porc-erable",
      "sourceRating": 3,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Maple and Soy Sauce Pork Tenderloins"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 42
    },
    {
      "id": "ee51d372-5bde-4306-b23c-fbf2465f89f1",
      "title": "Filets de porc aigres-doux aux pommes et quartiers de chou braisés",
      "image": "images/ee51d372-5bde-4306-b23c-fbf2465f89f1_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 63,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "chou vert",
        "de beurre",
        "de bouillon de poulet",
        "de bouillon de poulet",
        "de gelée de pomme",
        "de vinaigre de cidre",
        "de miel",
        "de moutarde à l’ancienne",
        "de fécule de maïs",
        "filets de porc d’environ 340 chacun",
        "de beurre",
        "pommes cortland"
      ],
      "searchText": "filets de porc aigres-doux aux pommes et quartiers de chou braisés chou vert de beurre de bouillon de poulet de bouillon de poulet de gelée de pomme de vinaigre de cidre de miel de moutarde à l’ancienne de fécule de maïs filets de porc d’environ 340 chacun de beurre pommes cortland",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7525-filets-de-porc-aigres-doux-aux-pommes-et-quartiers-de-chou-braises",
      "sourceRating": 5,
      "sourceRatingCount": 72,
      "translatedTitles": {
        "en": "Sweet and Sour Pork Tenderloins with Apples and Braised Cabbage Wedges"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 63
    },
    {
      "id": "cc5f1f86-c385-4068-b54c-f94ccfa56ac2",
      "title": "Filets de porc aux pommes, farcis aux oignons caramélisés",
      "servings": "6",
      "readyInMinutes": 85,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignons",
        "gousses d'ail",
        "de beurre",
        "filets de porc",
        "farine",
        "d'huile véétale",
        "de vin blanc",
        "de bouillon de poulet",
        "pommes cortland",
        "de crème",
        "crème épaisse",
        "sel et poivre"
      ],
      "searchText": "filets de porc aux pommes, farcis aux oignons caramélisés oignons gousses d'ail de beurre filets de porc farine d'huile véétale de vin blanc de bouillon de poulet pommes cortland de crème crème épaisse sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/2293-filets-de-porc-aux-pommes-farcis-aux-oignons-caramelises",
      "image": "images/cc5f1f86-c385-4068-b54c-f94ccfa56ac2_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 94,
      "translatedTitles": {
        "en": "Pork fillets with apples, stuffed with caramelized onions"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 53,
      "readyInMinutesMin": 80
    },
    {
      "id": "1bbaaed3-704d-445b-8b4f-03f603e58256",
      "title": "Fish Tacos",
      "image": "images/1bbaaed3-704d-445b-8b4f-03f603e58256_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tomatoes",
        "red onion",
        "clove garlic",
        "roughly cilantro",
        "jalapeño",
        "mayonnaise",
        "sour cream",
        "limes",
        "kosher salt",
        "ly black pepper",
        "ned chipotle pepper",
        "flour",
        "chili powder",
        "milk",
        "peanut oil",
        "pat of butter",
        "flounder or any firm white-fleshed fish",
        "inch corn tortillas",
        "shredded green cabe",
        "a saucy hot sauce"
      ],
      "searchText": "fish tacos tomatoes red onion clove garlic roughly cilantro jalapeño mayonnaise sour cream limes kosher salt ly black pepper ned chipotle pepper flour chili powder milk peanut oil pat of butter flounder or any firm white-fleshed fish inch corn tortillas shredded green cabe a saucy hot sauce",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1012445-fish-tacos?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 9147,
      "translatedTitles": {
        "fr": "Tacos de poisson"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "b55bcd75-ad7f-4346-bca2-520f5fa5f6c4",
      "title": "Fresh Corn and Black Bean Salad With Corn Chips",
      "image": "images/b55bcd75-ad7f-4346-bca2-520f5fa5f6c4_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "lime juice",
        "garlic clove",
        "cumin",
        "sugar",
        "red pepper",
        "- olive oil",
        "salt and pepper",
        "corn kernels",
        "s black beans",
        "a big handful of cilantro leaves",
        "/4 corn tortilla chips",
        "to 2 ripe avocados",
        "hot sauce"
      ],
      "searchText": "fresh corn and black bean salad with corn chips lime juice garlic clove cumin sugar red pepper - olive oil salt and pepper corn kernels s black beans a big handful of cilantro leaves /4 corn tortilla chips to 2 ripe avocados hot sauce",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1027095-fresh-corn-and-black-bean-salad-with-corn-chips?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2525,
      "translatedTitles": {
        "fr": "Salade fraîche de maïs et haricots noirs aux chips de maïs"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 38
    },
    {
      "id": "1a783288-a1a1-402a-9c53-bcff3daa95ae",
      "title": "Gaspacho",
      "image": "images/1a783288-a1a1-402a-9c53-bcff3daa95ae_0.jpg",
      "servings": "6 petites portions",
      "readyInMinutes": 1103,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de tomates mûres en 8 quartiers",
        "de concombres anglais ou libanais pelés",
        "d’oignons rouges",
        "de poivron rouge",
        "ou 2 gousses d’ail dégermées",
        "de pain sec sans croûte",
        "d’huile d’olive",
        "c. à soupe de vinaigre de xérès ou de vin rouge",
        "c. à thé de sel",
        "c. à thé de tabasco ou autre sauce piquante",
        "à 375 et plus d’eau",
        "poivre du moulin",
        "concombre en dés et tomates cerises en quartiers",
        "feta en dés",
        "crevettes nordiques ou crabe en morceaux",
        "croûtons à l’ail ou nature"
      ],
      "searchText": "gaspacho de tomates mûres en 8 quartiers de concombres anglais ou libanais pelés d’oignons rouges de poivron rouge ou 2 gousses d’ail dégermées de pain sec sans croûte d’huile d’olive c. à soupe de vinaigre de xérès ou de vin rouge c. à thé de sel c. à thé de tabasco ou autre sauce piquante à 375 et plus d’eau poivre du moulin concombre en dés et tomates cerises en quartiers feta en dés crevettes nordiques ou crabe en morceaux croûtons à l’ail ou nature apéritif",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/soupes-potages/gaspacho/",
      "sourceRating": 4.88,
      "sourceRatingCount": 8,
      "translatedTitles": {
        "en": "Gaspacho"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 743
    },
    {
      "id": "553b916b-ce17-455a-be86-0bffc070eea2",
      "title": "Gaufres de sarrasin au Zacharie Cloutier et aux asperges rôties",
      "image": "images/553b916b-ce17-455a-be86-0bffc070eea2_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 76,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de farine tout usage non blanchie",
        "de farine de sarrasin",
        "de poudre à pâte",
        "de sel",
        "œufs",
        "de sucre",
        "de beurre fondu",
        "de bière blonde",
        "de lait",
        "de fromage zacharie cloutier",
        "oignons verts hachés",
        "botte d'asperges",
        "huile d'olive",
        "sirop d'érable",
        "sel et poivre du moulin"
      ],
      "searchText": "gaufres de sarrasin au zacharie cloutier et aux asperges rôties de farine tout usage non blanchie de farine de sarrasin de poudre à pâte de sel œufs de sucre de beurre fondu de bière blonde de lait de fromage zacharie cloutier oignons verts hachés botte d'asperges huile d'olive sirop d'érable sel et poivre du moulin breakfast",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Buckwheat Waffles with Zacharie Cloutier and Roasted Asparagus"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 71
    },
    {
      "id": "0f505563-bb26-4617-b482-ea53ed77884a",
      "title": "Gigot d'agneau de 7 heures",
      "image": "images/0f505563-bb26-4617-b482-ea53ed77884a_0.jpg",
      "servings": "6 portion(s)",
      "readyInMinutes": 452,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gigot d'agneau désossé de 1",
        "gousses d'ail",
        "d'huile d'olive",
        "oignon",
        "de vin rouge",
        "branches de romarin frais"
      ],
      "searchText": "gigot d'agneau de 7 heures gigot d'agneau désossé de 1 gousses d'ail d'huile d'olive oignon de vin rouge branches de romarin frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/105-gigot-d-agneau-de-7-heures",
      "sourceRating": 4,
      "sourceRatingCount": 51,
      "translatedTitles": {
        "en": "7-Hour Leg of Lamb"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 452
    },
    {
      "id": "c0a9821d-2cdc-4e74-a43b-55f8ec74ff6a",
      "title": "Gigot d'agneau et son jus de romarin",
      "image": "images/c0a9821d-2cdc-4e74-a43b-55f8ec74ff6a_0.jpg",
      "servings": "8",
      "readyInMinutes": 134,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gousses d'ail",
        "de chapelure italienne",
        "oeuf",
        "de moutarde de dijon",
        "de romarin frais",
        "de thym séché",
        "d'huile d'olive",
        "sel et poivre",
        "gigot d'agneau de 3",
        "environ 1",
        "de consommé de boeuf",
        "de porto",
        "branches de romarin frais"
      ],
      "searchText": "gigot d'agneau et son jus de romarin gousses d'ail de chapelure italienne oeuf de moutarde de dijon de romarin frais de thym séché d'huile d'olive sel et poivre gigot d'agneau de 3 environ 1 de consommé de boeuf de porto branches de romarin frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/36-gigot-d-agneau-et-son-jus-de-romarin",
      "sourceRating": 5,
      "sourceRatingCount": 16,
      "translatedTitles": {
        "en": "Leg of lamb and its rosemary jus"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 134
    },
    {
      "id": "d8fc0891-6c03-4623-8066-ea5f1c41e239",
      "title": "Gigot d'agneau et son jus de romarin",
      "image": "images/d8fc0891-6c03-4623-8066-ea5f1c41e239_0.jpg",
      "servings": "8",
      "readyInMinutes": 127,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gousses d'ail",
        "de chapelure italienne",
        "oeuf",
        "de moutarde de dijon",
        "de romarin frais",
        "de thym séché",
        "d'huile d'olive",
        "sel et poivre",
        "gigot d'agneau de 3",
        "environ 1",
        "de consommé de boeuf",
        "de porto",
        "branches de romarin frais"
      ],
      "searchText": "gigot d'agneau et son jus de romarin gousses d'ail de chapelure italienne oeuf de moutarde de dijon de romarin frais de thym séché d'huile d'olive sel et poivre gigot d'agneau de 3 environ 1 de consommé de boeuf de porto branches de romarin frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/36-gigot-d-agneau-et-son-jus-de-romarin",
      "sourceRating": 5,
      "sourceRatingCount": 16,
      "translatedTitles": {
        "en": "Leg of lamb and its rosemary jus"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 127
    },
    {
      "id": "f9a244ed-c79f-4799-875d-8d15679a132a",
      "title": "Gin fizz à la menthe et aux agrumes",
      "image": "images/f9a244ed-c79f-4799-875d-8d15679a132a_0.jpg",
      "servings": "1 portion(s)",
      "readyInMinutes": 5,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de gin",
        "de sirop de ne ou de sirop simple",
        "de jus de pamplemousse",
        "de jus de citron",
        "de jus de lime",
        "glaçons",
        "branche de menthe",
        "d’eau pétillante au pamplemousse"
      ],
      "searchText": "gin fizz à la menthe et aux agrumes de gin de sirop de ne ou de sirop simple de jus de pamplemousse de jus de citron de jus de lime glaçons branche de menthe d’eau pétillante au pamplemousse",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9089-gin-fizz-a-la-menthe-et-aux-agrumes",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Mint and citrus Gin Fizz"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 5,
      "readyInMinutesMin": 5
    },
    {
      "id": "7f747dd3-2a0d-4a32-805d-0546fb2bbdb4",
      "title": "Ginger Chicken and Rice Soup With Zucchini",
      "image": "images/7f747dd3-2a0d-4a32-805d-0546fb2bbdb4_0.jpg",
      "servings": "6 to 8 servings",
      "readyInMinutes": 56,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boneless",
        "salt and black pepper",
        "neutral oil",
        "ginger",
        "garlic cloves",
        "turmeric",
        "brown rice",
        "zucchini",
        "or bay leaf",
        "chile crisp"
      ],
      "searchText": "ginger chicken and rice soup with zucchini boneless salt and black pepper neutral oil ginger garlic cloves turmeric brown rice zucchini or bay leaf chile crisp",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026507-ginger-chicken-and-rice-soup-with-zucchini?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4102,
      "translatedTitles": {
        "fr": "Soupe de poulet au gingembre et riz avec courgette"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 56
    },
    {
      "id": "66c97ecf-d58c-405d-9041-7f7948c4fa98",
      "title": "Ginger-Dill Salmon",
      "image": "images/66c97ecf-d58c-405d-9041-7f7948c4fa98_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 44,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salmon fillet",
        "kosher salt and black pepper",
        "finely dill",
        "piece ginger",
        "- olive oil",
        "grapefruit",
        "oranges",
        "radishes",
        "avocado",
        "flaky sea salt"
      ],
      "searchText": "ginger-dill salmon salmon fillet kosher salt and black pepper finely dill piece ginger - olive oil grapefruit oranges radishes avocado flaky sea salt",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021938-ginger-dill-salmon",
      "sourceRating": 4,
      "sourceRatingCount": 7408,
      "translatedTitles": {
        "fr": "Saumon au Gingembre et à l'Aneth"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 39
    },
    {
      "id": "adbbf463-a169-4fff-ae36-570039eb6296",
      "title": "Gluten-Free Espresso Banana-Acai Bowls",
      "image": "images/adbbf463-a169-4fff-ae36-570039eb6296_0.jpg",
      "servings": "2 servings",
      "readyInMinutes": 13,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "two 3.5-ounce unsweetened acai smoothie packs",
        "pitted medjool dates",
        "ripe banana",
        "unsweetened dairy-free milk",
        "unsweetened cacao powder",
        "walnut butter or raw walnuts",
        "shots espresso",
        "dark chocolate"
      ],
      "searchText": "gluten-free espresso banana-acai bowls two 3.5-ounce unsweetened acai smoothie packs pitted medjool dates ripe banana unsweetened dairy-free milk unsweetened cacao powder walnut butter or raw walnuts shots espresso dark chocolate",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodnetwork.com/recipes/gluten-free-espresso-banana-acai-bowls-3687892",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "fr": "Bols d'Açaï-Banane Expresso sans Gluten"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 13
    },
    {
      "id": "31e0b9a7-2087-41a1-8e9e-ecd17399bea5",
      "title": "Gnocchis à la parisienne à la courge",
      "image": "images/31e0b9a7-2087-41a1-8e9e-ecd17399bea5_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 296,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "courge butternut d’environ 1",
        "de vinaigre de vin blanc",
        "d’eau",
        "d’épices à marinade",
        "de sirop d’érable",
        "d’huile d’olive",
        "tête d’ail",
        "de beurre",
        "de lait",
        "de beurre",
        "de farine tout usage non blanchie",
        "œufs",
        "de fromage parmesan frais râpé finement",
        "huile d’olive",
        "de beurre",
        "d’huile d’olive",
        "de fromage parmesan frais râpé finement",
        "d’un mélange d’herbes ciselées (aneth",
        "feuilles de sauge",
        "citron",
        "de graines de citrouille salées et grillées"
      ],
      "searchText": "gnocchis à la parisienne à la courge courge butternut d’environ 1 de vinaigre de vin blanc d’eau d’épices à marinade de sirop d’érable d’huile d’olive tête d’ail de beurre de lait de beurre de farine tout usage non blanchie œufs de fromage parmesan frais râpé finement huile d’olive de beurre d’huile d’olive de fromage parmesan frais râpé finement d’un mélange d’herbes ciselées (aneth feuilles de sauge citron de graines de citrouille salées et grillées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/10513-gnocchis-a-la-parisienne-a-la-courge",
      "sourceRating": 4,
      "sourceRatingCount": 7,
      "translatedTitles": {
        "en": "Parisian Gnocchi with Squash"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 80,
      "readyInMinutesMin": 277
    },
    {
      "id": "bc63a7e1-ff21-4759-8321-40ef3ef84eaf",
      "title": "Gnocchis à la ricotta, chou-fleur caramélisé et chapelure croustillante aux amandes",
      "image": "images/bc63a7e1-ff21-4759-8321-40ef3ef84eaf_0.jpg",
      "servings": "4",
      "readyInMinutes": 134,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gnocchis à la ricotta",
        "de fromage ricotta",
        "de fromage parmesan frais râpé finement",
        "jaunes d’oeufs",
        "de farine tout usage non blanchie",
        "chou-fleur caramélisé",
        "de chou-fleur coupé en petits bouquets",
        "d’huile véétale",
        "velouté de poulet",
        "de beurre ramolli",
        "de farine tout usage non blanchie",
        "échalote française",
        "d’huile véétale",
        "litre de bouillon de poulet",
        "de jus de citron",
        "chapelure croustillante",
        "de pain rassis coupé en dés",
        "d’huile d’olive",
        "d’amandes grillées",
        "de ciboulette ciselée",
        "montage",
        "de beurre",
        "jaunes d’oeufs",
        "copeaux de parmesan frais"
      ],
      "searchText": "gnocchis à la ricotta, chou-fleur caramélisé et chapelure croustillante aux amandes gnocchis à la ricotta de fromage ricotta de fromage parmesan frais râpé finement jaunes d’oeufs de farine tout usage non blanchie chou-fleur caramélisé de chou-fleur coupé en petits bouquets d’huile véétale velouté de poulet de beurre ramolli de farine tout usage non blanchie échalote française d’huile véétale litre de bouillon de poulet de jus de citron chapelure croustillante de pain rassis coupé en dés d’huile d’olive d’amandes grillées de ciboulette ciselée montage de beurre jaunes d’oeufs copeaux de parmesan frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/9312-gnocchis-a-la-ricotta-chou-fleur-caramelise-et-chapelure-croustillante-aux-amandes",
      "sourceRating": 4,
      "sourceRatingCount": 5,
      "translatedTitles": {
        "en": "Ricotta Gnocchi, Caramelized Cauliflower, and Crispy Almond Breadcrumbs"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 54,
      "readyInMinutesMin": 133
    },
    {
      "id": "590935a1-838b-4be6-9bde-cfbf9fce64b0",
      "title": "Gnocchis crémeux aux champignons à la plaque",
      "image": "images/590935a1-838b-4be6-9bde-cfbf9fce64b0_0.jpg",
      "servings": "4 à 6 portions",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de pleurotes déchirés à la main",
        "tomates cerises",
        "petit bulbe de fenouil en 8 quartiers",
        "de gnocchis prêts à poêler du commerce",
        "gousses d’ail hachées finement",
        "d’huile d’olive",
        "sel et flocons de piments forts au goût",
        "à 6 tranches de pancetta",
        "de poudre de champignons séchés",
        "feuilles de basilic + quelques feuilles pour garnir",
        "de levure alimentaire",
        "d’huile",
        "de crème",
        "de parmesan râpé",
        "sel au goût",
        "poivre du moulin"
      ],
      "searchText": "gnocchis crémeux aux champignons à la plaque de pleurotes déchirés à la main tomates cerises petit bulbe de fenouil en 8 quartiers de gnocchis prêts à poêler du commerce gousses d’ail hachées finement d’huile d’olive sel et flocons de piments forts au goût à 6 tranches de pancetta de poudre de champignons séchés feuilles de basilic + quelques feuilles pour garnir de levure alimentaire d’huile de crème de parmesan râpé sel au goût poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/6387/gnocchis-cremeux-aux-champignons-a-la-plaque?fbclid=IwAR2Z24z8KxZBzGASz5d1DiTI5_WaB_oLf9c_b5e1AKokI_Qst_MuIJLHrl4",
      "sourceRating": 5,
      "sourceRatingCount": 22,
      "translatedTitles": {
        "en": "Creamy Sheet Pan Mushroom Gnocchi"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "6a3205e2-e0e4-4bcd-8569-c2e4300bcc61",
      "title": "Gochujang-Glazed Salmon with Garlic Spinach",
      "image": "images/6a3205e2-e0e4-4bcd-8569-c2e4300bcc61_0.jpg",
      "servings": "1",
      "readyInMinutes": 29,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gochujang",
        "mirin",
        "reduced-sodium tamari",
        "honey",
        "½ toasted sesame oil",
        "cloves garlic",
        "grated ginger",
        "¼ salmon",
        "baby spinach",
        "sesame seeds & scallions for garnish"
      ],
      "searchText": "gochujang-glazed salmon with garlic spinach gochujang mirin reduced-sodium tamari honey ½ toasted sesame oil cloves garlic grated ginger ¼ salmon baby spinach sesame seeds & scallions for garnish main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.eatingwell.com/recipe/7944667/gochujang-glazed-salmon-with-garlic-spinach/",
      "translatedTitles": {
        "fr": "Saumon glacé au Gochujang avec épinards à l'ail"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 29,
      "readyInMinutesMin": 29
    },
    {
      "id": "35b67b00-5706-4ae9-ad3e-5e2efc75996f",
      "title": "Gratin de bettes à carde",
      "image": "images/35b67b00-5706-4ae9-ad3e-5e2efc75996f_0.jpg",
      "servings": "1",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bettes a carde feuille: 250 gr",
        "ail: 2 gousse",
        "huile d'olive : 2 càs",
        "crème : 150",
        "oeuf : 1 un",
        "muscade râpée : 1 càt",
        "sel et poivre :",
        "emmental râpé : 1/2 tasse"
      ],
      "searchText": "gratin de bettes à carde bettes a carde feuille: 250 gr ail: 2 gousse huile d'olive : 2 càs crème : 150 oeuf : 1 un muscade râpée : 1 càt sel et poivre : emmental râpé : 1/2 tasse",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://restauranttandem.com/recette/gratin-de-bettes-a-carde/",
      "translatedTitles": {
        "en": "Swiss Chard Gratin"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 42
    },
    {
      "id": "f19eac45-1da6-4023-9e6b-11de08e902bc",
      "title": "Gratin de morue aux herbes",
      "image": "images/f19eac45-1da6-4023-9e6b-11de08e902bc_0.jpg",
      "servings": "4",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de feuilles de persil frisé",
        "de feuilles d’aneth",
        "oignon vert",
        "gousse d’ail",
        "piment fresno ou jalapeño",
        "d’huile d’olive",
        "de filets de morue",
        "de chapelure panko",
        "quartiers de citron"
      ],
      "searchText": "gratin de morue aux herbes de feuilles de persil frisé de feuilles d’aneth oignon vert gousse d’ail piment fresno ou jalapeño d’huile d’olive de filets de morue de chapelure panko quartiers de citron",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9387-gratin-de-morue-aux-herbes",
      "sourceRating": 4,
      "sourceRatingCount": 20,
      "translatedTitles": {
        "en": "Cod Gratin with Herbs"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 47
    },
    {
      "id": "ed388eee-3852-469c-ac42-af93bdf3c2f1",
      "title": "Gravlax de saumon au gin et au miel",
      "image": "images/ed388eee-3852-469c-ac42-af93bdf3c2f1_0.jpg",
      "servings": "16",
      "readyInMinutes": 2189,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gravlax",
        "de gin",
        "de moutarde à l’ancienne",
        "de miel",
        "de gros sel",
        "de sucre",
        "d’aneth frais ciselé",
        "de baies de genièvre concassées",
        "filet de saumon avec la peau d’environ 1",
        "laque au gin et au miel",
        "de gin",
        "de miel",
        "d’aneth frais ciselé",
        "garniture",
        "de crème sure",
        "de miel",
        "de moutarde à l’ancienne"
      ],
      "searchText": "gravlax de saumon au gin et au miel gravlax de gin de moutarde à l’ancienne de miel de gros sel de sucre d’aneth frais ciselé de baies de genièvre concassées filet de saumon avec la peau d’environ 1 laque au gin et au miel de gin de miel d’aneth frais ciselé garniture de crème sure de miel de moutarde à l’ancienne plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7483-gravlax-de-saumon-au-gin-et-au-miel",
      "sourceRating": 5,
      "sourceRatingCount": 35,
      "translatedTitles": {
        "en": "Salmon Gravlax with Gin and Honey"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 29,
      "readyInMinutesMin": 2189
    },
    {
      "id": "293ae634-8876-45fc-9468-a045d0b0d92d",
      "title": "Gravlax de saumon au gin et au miel",
      "image": "images/293ae634-8876-45fc-9468-a045d0b0d92d_0.jpg",
      "servings": "16",
      "readyInMinutes": 2189,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gravlax",
        "de gin",
        "de moutarde à l’ancienne",
        "de miel",
        "de gros sel",
        "de sucre",
        "d’aneth frais ciselé",
        "de baies de genièvre concassées",
        "filet de saumon avec la peau d’environ 1",
        "laque au gin et au miel",
        "de gin",
        "de miel",
        "d’aneth frais ciselé",
        "garniture",
        "de crème sure",
        "de miel",
        "de moutarde à l’ancienne"
      ],
      "searchText": "gravlax de saumon au gin et au miel gravlax de gin de moutarde à l’ancienne de miel de gros sel de sucre d’aneth frais ciselé de baies de genièvre concassées filet de saumon avec la peau d’environ 1 laque au gin et au miel de gin de miel d’aneth frais ciselé garniture de crème sure de miel de moutarde à l’ancienne",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7483-gravlax-de-saumon-au-gin-et-au-miel",
      "sourceRating": 5,
      "sourceRatingCount": 35,
      "translatedTitles": {
        "en": "Gin and Honey Salmon Gravlax"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 29,
      "readyInMinutesMin": 2189
    },
    {
      "id": "fb4c5269-e626-40ae-b6ce-5f96b9e48402",
      "title": "Gravlax maison",
      "image": "images/fb4c5269-e626-40ae-b6ce-5f96b9e48402_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 1533,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cassonade",
        "gros sel",
        "graines de fenouil",
        "aneth frais",
        "poivre noir moulu",
        "zeste de 1 citron",
        "saumon frais sans la peau",
        "gin",
        "crème sure",
        "miel",
        "aneth frais",
        "piment d'espelette",
        "tranches de pain de seigle"
      ],
      "searchText": "gravlax maison cassonade gros sel graines de fenouil aneth frais poivre noir moulu zeste de 1 citron saumon frais sans la peau gin crème sure miel aneth frais piment d'espelette tranches de pain de seigle plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/152/gravlax-maison",
      "sourceRating": 4,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Homemade Gravlax"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 1533
    },
    {
      "id": "205d46d7-36c3-41b6-9cf1-37d1ff1b48de",
      "title": "Greek Style French Fry Omelette",
      "image": "images/205d46d7-36c3-41b6-9cf1-37d1ff1b48de_0.jpg",
      "servings": "8",
      "readyInMinutes": 109,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "potatoes",
        "olive oil for frying",
        "salt",
        "ly cracked black pepper to taste",
        "oregano",
        "eggs",
        "yogurt or sour cream",
        "milk",
        "feta cheese",
        "shredded gruyere"
      ],
      "searchText": "greek style french fry omelette potatoes olive oil for frying salt ly cracked black pepper to taste oregano eggs yogurt or sour cream milk feta cheese shredded gruyere",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.dimitrasdishes.com/greek-style-french-fry-omelette/",
      "sourceRating": 5,
      "sourceRatingCount": 3,
      "translatedTitles": {
        "fr": "Omelette frites à la grecque"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 72,
      "readyInMinutesMin": 94
    },
    {
      "id": "504dd02a-a495-4462-96b7-1ef43e8a78aa",
      "title": "Green Goddess Roasted Chicken",
      "image": "images/504dd02a-a495-4462-96b7-1ef43e8a78aa_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 626,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "buttermilk or plain yogurt",
        "packed basil leaves",
        "packed chives",
        "garlic cloves",
        "anchovy fillets",
        "scallion",
        "finely grated zest and juice of 1 lime",
        "coarse kosher salt",
        "black pepper",
        "chicken",
        "to 2 - olive oil"
      ],
      "searchText": "green goddess roasted chicken buttermilk or plain yogurt packed basil leaves packed chives garlic cloves anchovy fillets scallion finely grated zest and juice of 1 lime coarse kosher salt black pepper chicken to 2 - olive oil",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1015232-green-goddess-roasted-chicken?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4721,
      "translatedTitles": {
        "fr": "Poulet Rôti Green Goddess"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 431
    },
    {
      "id": "c46660ff-be6a-47d8-bd14-626cda59a155",
      "title": "Grilled Cauliflower Steaks",
      "image": "images/c46660ff-be6a-47d8-bd14-626cda59a155_0.jpg",
      "servings": "4 –6 servings",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "heads cauliflower",
        "olive oil",
        "lemons",
        "cloves garlic",
        "honey",
        "kosher salt",
        "red pepper flakes",
        "parsley",
        "toasted walnuts",
        "lemon wedges"
      ],
      "searchText": "grilled cauliflower steaks heads cauliflower olive oil lemons cloves garlic honey kosher salt red pepper flakes parsley toasted walnuts lemon wedges",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://www.wellplated.com/grilled-cauliflower-steaks/",
      "sourceRating": 4.57,
      "sourceRatingCount": 64,
      "translatedTitles": {
        "fr": "Steaks de chou-fleur grillés"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 41
    },
    {
      "id": "02350c31-16da-4bf2-baa6-3c4d1e54edb1",
      "title": "Grilled Corn Salad",
      "image": "images/02350c31-16da-4bf2-baa6-3c4d1e54edb1_0.jpg",
      "servings": "4 as a side",
      "readyInMinutes": 23,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ears of grilled corn on the cob",
        "red pepper",
        "green pepper",
        "½ cucumber",
        "ripe peaches",
        "avocado",
        "basil leaves",
        "juice of 1 lime",
        "chile lime dressing",
        "sea salt",
        "¼ sir kensington’s avocado oil mayo or vegan fabanaise",
        "olive oil",
        "¼ cilantro",
        "lime juice",
        "⅓ serrano chile",
        "pinch of garlic powder",
        "pinch of onion powder",
        "sea salt"
      ],
      "searchText": "grilled corn salad ears of grilled corn on the cob red pepper green pepper ½ cucumber ripe peaches avocado basil leaves juice of 1 lime chile lime dressing sea salt ¼ sir kensington’s avocado oil mayo or vegan fabanaise olive oil ¼ cilantro lime juice ⅓ serrano chile pinch of garlic powder pinch of onion powder sea salt",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/corn-salad/",
      "translatedTitles": {
        "fr": "Salade de maïs grillé"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "69d470c1-f70f-4609-a04a-7436389288d5",
      "title": "Grilled Merguez and Onions With Mint-Lemon Couscous",
      "image": "images/69d470c1-f70f-4609-a04a-7436389288d5_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boiling water",
        "couscous",
        "salt",
        "lemons",
        "cumin",
        "ly black pepper",
        "- olive oil",
        "thinly radishes",
        "red onion",
        "merguez",
        "halved cherry tomatoes",
        "roughly mint leaves",
        "roughly parsley leaves and stems",
        "thinly cucumber",
        "toasted pine nuts or slivered almonds"
      ],
      "searchText": "grilled merguez and onions with mint-lemon couscous boiling water couscous salt lemons cumin ly black pepper - olive oil thinly radishes red onion merguez halved cherry tomatoes roughly mint leaves roughly parsley leaves and stems thinly cucumber toasted pine nuts or slivered almonds",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022246-grilled-merguez-and-onions-with-mint-lemon-couscous?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 749,
      "translatedTitles": {
        "fr": "Merguez et oignons grillés avec du couscous à la menthe et au citron"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "ce7d4729-19e6-4dd7-837f-de16216ede27",
      "title": "Grilled Za’atar Chicken With Garlic Yogurt and Cilantro",
      "image": "images/ce7d4729-19e6-4dd7-837f-de16216ede27_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 170,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "garlic cloves",
        "lemons",
        "plain -milk yogurt",
        "cilantro",
        "- olive oil",
        "za’atar",
        "oregano or marjoram",
        "salt",
        "ly black pepper",
        "boneless"
      ],
      "searchText": "grilled za’atar chicken with garlic yogurt and cilantro garlic cloves lemons plain -milk yogurt cilantro - olive oil za’atar oregano or marjoram salt ly black pepper boneless",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022300-grilled-zaatar-chicken-with-garlic-yogurt-and-cilantro",
      "sourceRating": 5,
      "sourceRatingCount": 6834,
      "translatedTitles": {
        "fr": "Poulet Za’atar Grillé avec Yaourt à l'Ail et Coriandre"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 42,
      "readyInMinutesMin": 164
    },
    {
      "id": "ce344ab8-c5a4-4b58-a7dc-76de52c563ba",
      "title": "Guacamole",
      "image": "images/ce344ab8-c5a4-4b58-a7dc-76de52c563ba_0.jpg",
      "servings": "1",
      "readyInMinutes": 11,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "avocats mûrs",
        "de jus de lime",
        "oignon vert",
        "de coriandre fraîche",
        "sauce au piment fort au goût"
      ],
      "searchText": "guacamole avocats mûrs de jus de lime oignon vert de coriandre fraîche sauce au piment fort au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/5717-guacamole",
      "translatedTitles": {
        "en": "Guacamole"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 11
    },
    {
      "id": "7749ba11-5e5c-4e40-a72a-968b3d094401",
      "title": "Guacamole",
      "image": "images/7749ba11-5e5c-4e40-a72a-968b3d094401_0.jpg",
      "servings": "6",
      "readyInMinutes": 90,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "haas avocados",
        "lime",
        "kosher salt",
        "cumin",
        "cayenne",
        "onion",
        "jalapeno pepper",
        "roma tomatoes",
        "cilantro",
        "clove garlic"
      ],
      "searchText": "guacamole haas avocados lime kosher salt cumin cayenne onion jalapeno pepper roma tomatoes cilantro clove garlic",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodnetwork.com/recipes/alton-brown/guacamole-recipe-1940609",
      "sourceRating": 4.8,
      "sourceRatingCount": 1134,
      "translatedTitles": {
        "fr": "Guacamole"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 90
    },
    {
      "id": "6de56eff-d6e8-4063-933b-9b3cb02cd7b4",
      "title": "Guacamole avec tomates",
      "image": "images/6de56eff-d6e8-4063-933b-9b3cb02cd7b4_0.jpg",
      "servings": "6 portion(s)",
      "readyInMinutes": 24,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "avocats mûrs",
        "limes",
        "tomates italiennes",
        "oignon vert",
        "de coriandre fraîche ciselée",
        "sauce de type tabasco"
      ],
      "searchText": "guacamole avec tomates avocats mûrs limes tomates italiennes oignon vert de coriandre fraîche ciselée sauce de type tabasco",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/764-guacamole-avec-tomates",
      "sourceRating": 5,
      "sourceRatingCount": 48,
      "translatedTitles": {
        "en": "Guacamole with Tomatoes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 24
    },
    {
      "id": "ac5db17e-620b-4599-b63a-b022fab7ada1",
      "title": "Guacamole traditionnelle",
      "image": "images/ac5db17e-620b-4599-b63a-b022fab7ada1_0.jpg",
      "servings": "8",
      "readyInMinutes": 12,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gros avocats mûrs",
        "piment jalapeño",
        "petite gousse d’ail",
        "de coriandre ciselée",
        "de jus de lime"
      ],
      "searchText": "guacamole traditionnelle gros avocats mûrs piment jalapeño petite gousse d’ail de coriandre ciselée de jus de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/8818-guacamole-traditionnelle",
      "translatedTitles": {
        "en": "Traditional Guacamole"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 12
    },
    {
      "id": "e47913c7-f505-43b2-b2f7-fe425954e85d",
      "title": "GUEDILLE AUX CREVETTES DE MATANE",
      "servings": "4",
      "readyInMinutes": 14,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de crevettes de matane",
        "¼ tasse de mayonnaise",
        "¼ tasse de yogourt grec",
        "bâton de céleri en dés",
        "jus de 2 limes ou de 1 citron",
        "à 2 oignons verts hachés finement",
        "½ c. à thé (2",
        "½ c. à thé (2",
        "pincée de poivre de cayenne ou de sambal olek",
        "pains hot-dog briochés ou réguliers",
        "un peu de beurre pour tartiner l’extérieur des pains et les faire dorer dans la poêle",
        "sel de mer et poivre du moulin"
      ],
      "searchText": "guedille aux crevettes de matane de crevettes de matane ¼ tasse de mayonnaise ¼ tasse de yogourt grec bâton de céleri en dés jus de 2 limes ou de 1 citron à 2 oignons verts hachés finement ½ c. à thé (2 ½ c. à thé (2 pincée de poivre de cayenne ou de sambal olek pains hot-dog briochés ou réguliers un peu de beurre pour tartiner l’extérieur des pains et les faire dorer dans la poêle sel de mer et poivre du moulin plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/tele/par-ici-l-ete/2016/complements/recette/1448/guedille-aux-crevettes-de-matane",
      "image": "images/e47913c7-f505-43b2-b2f7-fe425954e85d_0.jpg",
      "translatedTitles": {
        "en": "MATANE SHRIMP ROLL"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 13
    },
    {
      "id": "14693452-a60c-4066-a5b4-e7c14f9d0609",
      "title": "guédilles au dindon effiloché, sauce barbecue crémeuse aux épices à steak de Montréal",
      "image": "images/14693452-a60c-4066-a5b4-e7c14f9d0609_0.jpg",
      "servings": "8",
      "readyInMinutes": 900,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "dindon",
        "de cassonade",
        "de paprika fumé",
        "de sel",
        "de poivre moulu",
        "demi-poitrine de dindon de 800",
        "avec la peau et le dos",
        "de vinaigre de cidre",
        "de bière",
        "sauce barbecue",
        "de ketchup",
        "de mayonnaise",
        "de cassonade",
        "de moutarde jaune préparée",
        "de vinaigre de cidre",
        "d'épices à steak de montréal",
        "",
        "de paprika fumé",
        "gousse d'ail",
        "montage",
        "pains à hot-dog",
        "concombres libanais",
        "petit oignon rouge"
      ],
      "searchText": "guédilles au dindon effiloché, sauce barbecue crémeuse aux épices à steak de montréal dindon de cassonade de paprika fumé de sel de poivre moulu demi-poitrine de dindon de 800 avec la peau et le dos de vinaigre de cidre de bière sauce barbecue de ketchup de mayonnaise de cassonade de moutarde jaune préparée de vinaigre de cidre d'épices à steak de montréal  de paprika fumé gousse d'ail montage pains à hot-dog concombres libanais petit oignon rouge",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceRating": 5,
      "sourceRatingCount": 3,
      "translatedTitles": {
        "en": "Guédilles with pulled turkey, creamy barbecue sauce with Montreal steak spice"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 660
    },
    {
      "id": "8d8cf553-4eac-4d9e-ad79-12f5cedf3cff",
      "title": "Guedilles au homard",
      "image": "images/8d8cf553-4eac-4d9e-ad79-12f5cedf3cff_0.jpg",
      "servings": "Pour 4 guedilles",
      "readyInMinutes": 18,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "la chair de 2 homards décortiqués",
        "sel et poivre",
        "pains à hot-dog",
        "c. à soupe de beurre",
        "tasse de laitue frisée",
        "concombre libanais",
        "c. à soupe de mayonnaise",
        "c. à thé de miel",
        "le zeste et le jus de ½ lime",
        "c. à thé de raifort préparé",
        "c. à soupe de câpres",
        "c. à soupe de ciboulette",
        "¼ c. à thé de paprika doux"
      ],
      "searchText": "guedilles au homard la chair de 2 homards décortiqués sel et poivre pains à hot-dog c. à soupe de beurre tasse de laitue frisée concombre libanais c. à soupe de mayonnaise c. à thé de miel le zeste et le jus de ½ lime c. à thé de raifort préparé c. à soupe de câpres c. à soupe de ciboulette ¼ c. à thé de paprika doux",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/fruits-de-mer/guedilles-au-homard/",
      "translatedTitles": {
        "en": "Lobster Rolls"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 18
    },
    {
      "id": "1be937fe-4a16-4196-a74f-d4f22e1b6afd",
      "title": "Gyros au rôti de porc et à la mangue",
      "image": "images/1be937fe-4a16-4196-a74f-d4f22e1b6afd_0.jpg",
      "servings": "2",
      "readyInMinutes": 11,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pains pitas grecs ou ordinaires",
        "de sauce tzatziki maison ou du commerce",
        "de fines tranches de rôti de porc froid ou de dinde froide",
        "feuilles de laitue boston ou frisée",
        "petite mangue mûre",
        "cure-dents",
        "sel et poivre"
      ],
      "searchText": "gyros au rôti de porc et à la mangue pains pitas grecs ou ordinaires de sauce tzatziki maison ou du commerce de fines tranches de rôti de porc froid ou de dinde froide feuilles de laitue boston ou frisée petite mangue mûre cure-dents sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6462-gyros-au-roti-de-porc-et-a-la-mangue",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Pork Roast and Mango Gyros"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 11
    },
    {
      "id": "0a50c99e-658c-4d87-8217-183d95f588c4",
      "title": "Halloumi grillé au sésame et à la menthe",
      "image": "images/0a50c99e-658c-4d87-8217-183d95f588c4_0.jpg",
      "servings": "4",
      "readyInMinutes": 11,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "fromage à griller",
        "huile d’olive",
        "graines de sésame",
        "concombres libanais",
        "menthe",
        "citron",
        "poivre du moulin"
      ],
      "searchText": "halloumi grillé au sésame et à la menthe fromage à griller huile d’olive graines de sésame concombres libanais menthe citron poivre du moulin plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/halloumi-sesame-menthe/",
      "sourceRating": 4,
      "sourceRatingCount": 12,
      "translatedTitles": {
        "en": "Grilled Halloumi with Sesame and Mint"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "5fbf7219-82b5-4b4f-9aca-28fecbfa69b0",
      "title": "Haricots verts amandine",
      "image": "images/5fbf7219-82b5-4b4f-9aca-28fecbfa69b0_0.jpg",
      "servings": "6",
      "readyInMinutes": 13,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de haricots verts",
        "de beurre",
        "le jus d'un demi-citron",
        "d'amandes tranchées",
        "sel"
      ],
      "searchText": "haricots verts amandine de haricots verts de beurre le jus d'un demi-citron d'amandes tranchées sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/2040-haricots-verts-amandine",
      "sourceRating": 5,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Green Beans Almondine"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 7,
      "readyInMinutesMin": 13
    },
    {
      "id": "fd9e088f-9484-45c1-a3e7-b1b9730c7dff",
      "title": "Healthy Caesar Dressing",
      "image": "images/fd9e088f-9484-45c1-a3e7-b1b9730c7dff_0.jpg",
      "servings": "4 to 6",
      "readyInMinutes": 5,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "⅓ milk greek yogurt",
        "- olive oil",
        "lemon juice",
        "dijon mustard",
        "½ garlic clove",
        "capers",
        "ly black pepper"
      ],
      "searchText": "healthy caesar dressing ⅓ milk greek yogurt - olive oil lemon juice dijon mustard ½ garlic clove capers ly black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/healthy-caesar-dressing/",
      "sourceRating": 4.8,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "fr": "Vinaigrette César saine"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 5,
      "readyInMinutesMin": 5
    },
    {
      "id": "f63896cd-e70a-45d6-80f0-85cc70fa52af",
      "title": "Healthy Caesar Dressing",
      "image": "images/f63896cd-e70a-45d6-80f0-85cc70fa52af_0.jpg",
      "servings": "4",
      "readyInMinutes": 5,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "⅓ milk greek yogurt",
        "- olive oil",
        "lemon juice",
        "dijon mustard",
        "½ garlic clove",
        "capers",
        "ly black pepper"
      ],
      "searchText": "healthy caesar dressing ⅓ milk greek yogurt - olive oil lemon juice dijon mustard ½ garlic clove capers ly black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/healthy-caesar-dressing/",
      "sourceRating": 4.8,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "fr": "Vinaigrette César Saine"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 5,
      "readyInMinutesMin": 5
    },
    {
      "id": "26254614-2767-4fa3-a6b1-49e658e33886",
      "title": "HEART-STUFFED SHELLS IN A RICOTTA SAUCE",
      "image": "images/26254614-2767-4fa3-a6b1-49e658e33886_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 127,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "shells",
        "jumbo pasta shells",
        "unsalted butter",
        "to 2 olive oil",
        "onion",
        "artichoke hearts",
        "dry white wine",
        "finely grated romano cheese",
        "finely grated parmigiano-reggiano cheese",
        "egg yolks",
        "ly squeezed lemon juice",
        "salt",
        "ly black pepper to taste",
        "sauce",
        "unsalted butter",
        "all-purpose flour",
        "milk",
        "garlic clove",
        "ricotta cheese",
        "ly squeezed lemon juice",
        "salt",
        "ly black pepper to taste",
        "flat-leaf parsley or basil leaves"
      ],
      "searchText": "heart-stuffed shells in a ricotta sauce shells jumbo pasta shells unsalted butter to 2 olive oil onion artichoke hearts dry white wine finely grated romano cheese finely grated parmigiano-reggiano cheese egg yolks ly squeezed lemon juice salt ly black pepper to taste sauce unsalted butter all-purpose flour milk garlic clove ricotta cheese ly squeezed lemon juice salt ly black pepper to taste flat-leaf parsley or basil leaves",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.epicurious.com/recipes/member/views/heart-stuffed-shells-in-a-ricotta-sauce-50121710",
      "translatedTitles": {
        "fr": "COQUILLES FARCIES AUX CŒURS DANS UNE SAUCE À LA RICOTTA"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 54,
      "readyInMinutesMin": 126
    },
    {
      "id": "30ab0416-9614-4063-ae6b-c3ae980a370b",
      "title": "Hetty Lui McKinnon's broccoli and feta pasta is cheap, easy and delicious - ABC News",
      "image": "images/30ab0416-9614-4063-ae6b-c3ae980a370b_0.jpg",
      "servings": "Serves: 4-5",
      "readyInMinutes": 41,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "fusilli or other short pasta",
        "heads of broccoli",
        "olive oil",
        "cloves garlic",
        "½ -1 red chilli flakes",
        "sea salt and black pepper",
        "greek feta",
        "zest and juice of 1 lemon",
        "roasted walnuts"
      ],
      "searchText": "hetty lui mckinnon's broccoli and feta pasta is cheap, easy and delicious - abc news fusilli or other short pasta heads of broccoli olive oil cloves garlic ½ -1 red chilli flakes sea salt and black pepper greek feta zest and juice of 1 lemon roasted walnuts",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.abc.net.au/news/2023-04-12/hetty-lui-mckinnon-broccoli-feta-walnut-pasta/102184434?utm_campaign=mb&utm_medium=newsletter&utm_source=morning_brew",
      "translatedTitles": {
        "fr": "Les pâtes au brocoli et à la feta de Hetty Lui McKinnon sont bon marché, faciles et délicieuses - ABC News"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 39
    },
    {
      "id": "1734bf5e-b702-48fb-96eb-3ac2615d0a4b",
      "title": "Homemade fish fingers",
      "image": "images/1734bf5e-b702-48fb-96eb-3ac2615d0a4b_0.jpg",
      "servings": "4",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "egg",
        "white breadcrumb",
        "zest and juice 1 lemon",
        "oregano",
        "olive oil",
        "skinless sustainable white fish",
        "mayonnaise",
        "pea",
        "young leaf spinach"
      ],
      "searchText": "homemade fish fingers egg white breadcrumb zest and juice 1 lemon oregano olive oil skinless sustainable white fish mayonnaise pea young leaf spinach plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bbcgoodfood.com/recipes/homemade-fish-fingers",
      "translatedTitles": {
        "fr": "Bâtonnets de poisson maison"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 38
    },
    {
      "id": "9feed48a-4640-44f0-9a6c-318e9442e6cf",
      "title": "Homemade Ranch Dressing",
      "image": "images/9feed48a-4640-44f0-9a6c-318e9442e6cf_0.jpg",
      "servings": "6 to 8",
      "readyInMinutes": 5,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½ sour cream or milk greek yogurt",
        "¼ to ½ mayonnaise",
        "to 4 buttermilk or any milk",
        "dill",
        "lemon juice",
        "distilled white vinegar",
        "½ garlic powder",
        "¼ onion powder",
        "¼ to ½ sea salt",
        "ly black pepper",
        "chives",
        "dill"
      ],
      "searchText": "homemade ranch dressing ½ sour cream or milk greek yogurt ¼ to ½ mayonnaise to 4 buttermilk or any milk dill lemon juice distilled white vinegar ½ garlic powder ¼ onion powder ¼ to ½ sea salt ly black pepper chives dill",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/ranch-dressing/",
      "sourceRating": 4.78,
      "sourceRatingCount": 27,
      "translatedTitles": {
        "fr": "Vinaigrette Ranch Maison"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 5,
      "readyInMinutesMin": 5
    },
    {
      "id": "5a48f9b5-8ff1-4a0b-95f4-b7f8ee2bcf90",
      "title": "Jambon « La Quercia » et poires à l'argan",
      "image": "images/5a48f9b5-8ff1-4a0b-95f4-b7f8ee2bcf90_0.jpg",
      "servings": "1",
      "readyInMinutes": 12,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poires coupées en morceaux",
        "huile d'argan ou huile d'olive",
        "sel de maldon ou fleur de sel",
        "poivre du moulin",
        "tranches minces de jambon la quercia ou prosciutto",
        "vinaigre de cassis",
        "huile d'olive"
      ],
      "searchText": "jambon « la quercia » et poires à l'argan poires coupées en morceaux huile d'argan ou huile d'olive sel de maldon ou fleur de sel poivre du moulin tranches minces de jambon la quercia ou prosciutto vinaigre de cassis huile d'olive",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/3707/jambon-la-quercia-et-poires-a-l-argan",
      "translatedTitles": {
        "en": "La Quercia Ham and Argan Pears"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 12
    },
    {
      "id": "b755dff9-4edf-4510-9115-74f0b09a283e",
      "title": "Jambon à l'érable et à la bière à la mijoteuse",
      "image": "images/b755dff9-4edf-4510-9115-74f0b09a283e_0.jpg",
      "servings": "10",
      "readyInMinutes": 611,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "jambon fumé dans l’épaule avec os d’environ 3",
        "de moutarde de dijon",
        "à 4 clous de girofle",
        "bouteille de 341 de bière blonde",
        "de sirop d’érable",
        "eau"
      ],
      "searchText": "jambon à l'érable et à la bière à la mijoteuse jambon fumé dans l’épaule avec os d’environ 3 de moutarde de dijon à 4 clous de girofle bouteille de 341 de bière blonde de sirop d’érable eau",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5803-jambon-a-l-erable-et-a-la-biere-a-la-mijoteuse",
      "sourceRating": 5,
      "sourceRatingCount": 229,
      "translatedTitles": {
        "en": "Maple and Beer Ham in the Slow Cooker"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 611
    },
    {
      "id": "5da156a9-0df2-41c1-aad2-d3f8861f8209",
      "title": "Jambon au four à l’érable",
      "image": "images/5da156a9-0df2-41c1-aad2-d3f8861f8209_0.jpg",
      "servings": "10 portion(s)",
      "readyInMinutes": 294,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "jambon fumé dans l’épaule avec l’os d’environ 3 (6",
        "boîte de 540 de sirop d'érable",
        "de cidre",
        "de bouillon de poulet",
        "poivre noir moulu"
      ],
      "searchText": "jambon au four à l’érable jambon fumé dans l’épaule avec l’os d’environ 3 (6 boîte de 540 de sirop d'érable de cidre de bouillon de poulet poivre noir moulu",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5054-jambon-au-four-a-l-erable",
      "sourceRating": 5,
      "sourceRatingCount": 197,
      "translatedTitles": {
        "en": "Maple Baked Ham"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 52,
      "readyInMinutesMin": 284
    },
    {
      "id": "ae89485a-1b7d-4ef5-8eba-01e6a8ee6a32",
      "title": "Jambon mijoté à l’érable (le meilleur)",
      "image": "images/ae89485a-1b7d-4ef5-8eba-01e6a8ee6a32_0.jpg",
      "servings": "8",
      "readyInMinutes": 271,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "jambon fumé dans l’épaule avec os d’environ 2 (4",
        "de sirop d’érable ambré",
        "oignon",
        "de grains de poivre"
      ],
      "searchText": "jambon mijoté à l’érable (le meilleur) jambon fumé dans l’épaule avec os d’environ 2 (4 de sirop d’érable ambré oignon de grains de poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/9101-jambon-mijote-a-l-erable-le-meilleur",
      "sourceRating": 5,
      "sourceRatingCount": 14,
      "translatedTitles": {
        "en": "Maple Braised Ham (the best)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 271
    },
    {
      "id": "8963c2bb-0eb7-4a81-a5c6-847730d9511b",
      "title": "Jarrets d’agneau braisés de Stefano Faita",
      "image": "images/8963c2bb-0eb7-4a81-a5c6-847730d9511b_0.jpg",
      "servings": "4",
      "readyInMinutes": 243,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "rets d’agneau",
        "au goût",
        "quantité suffisante de farine",
        "d’huile d'olive",
        "gousses d'ail",
        "tiges de romarin",
        "de vin blanc sec",
        "de fond de veau",
        "de vinaigre de vin rouge",
        "filets d’anchois ou plus",
        "gousses d'ail",
        "de zeste de citron pour garnir",
        "au goût"
      ],
      "searchText": "jarrets d’agneau braisés de stefano faita rets d’agneau au goût quantité suffisante de farine d’huile d'olive gousses d'ail tiges de romarin de vin blanc sec de fond de veau de vinaigre de vin rouge filets d’anchois ou plus gousses d'ail de zeste de citron pour garnir au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.iga.net/fr/recettes_inspirantes/recettes/jarrets_dagneau_braises",
      "translatedTitles": {
        "en": "Stefano Faita's Braised Lamb Shanks"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 51,
      "readyInMinutesMin": 220
    },
    {
      "id": "a578994e-c109-47ae-9ced-6b98dd0ed429",
      "title": "Joues de bœuf braisées",
      "image": "images/a578994e-c109-47ae-9ced-6b98dd0ed429_0.jpg",
      "servings": "1",
      "readyInMinutes": 200,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de 2 à 3 (de 1 à 1",
        "d’huile véétale",
        "oignons",
        "bière rousse ou brune de 341",
        "l de fond de veau",
        "de sirop d’érable",
        "de vinaigre de cidre de pomme",
        "gousses d’ail",
        "branche de thym frais",
        "beurre",
        "ciboulette fraîche au goût",
        "sel et poivre du moulin"
      ],
      "searchText": "joues de bœuf braisées de 2 à 3 (de 1 à 1 d’huile véétale oignons bière rousse ou brune de 341 l de fond de veau de sirop d’érable de vinaigre de cidre de pomme gousses d’ail branche de thym frais beurre ciboulette fraîche au goût sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/tele/5-chefs-dans-ma-cuisine/site/complements/recette/4349/joues-boeuf-braisees-chuck-hugues",
      "translatedTitles": {
        "en": "Braised Beef Cheeks"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 75,
      "readyInMinutesMin": 185
    },
    {
      "id": "cc667d76-28b0-42db-814c-8013cc026952",
      "title": "Keftas de boeuf, taboulé et sauce au sumac",
      "image": "images/cc667d76-28b0-42db-814c-8013cc026952_0.jpg",
      "servings": "4",
      "readyInMinutes": 80,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sauce au sumac",
        "de mayonnaise",
        "de yogourt grec",
        "de sumac moulu",
        "taboulé",
        "d’eau",
        "de sel",
        "de boulgour fin",
        "de persil ciselé",
        "oignons verts",
        "de tomates cerises",
        "d’huile d’olive",
        "citron",
        "feuilles de menthe",
        "gousse d’ail",
        "keftas",
        "de boeuf haché maigre",
        "gousses d’ail",
        "citron",
        "piment de cayenne ou d’alep"
      ],
      "searchText": "keftas de boeuf, taboulé et sauce au sumac sauce au sumac de mayonnaise de yogourt grec de sumac moulu taboulé d’eau de sel de boulgour fin de persil ciselé oignons verts de tomates cerises d’huile d’olive citron feuilles de menthe gousse d’ail keftas de boeuf haché maigre gousses d’ail citron piment de cayenne ou d’alep",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9047-keftas-de-boeuf-taboule-et-sauce-au-sumac",
      "sourceRating": 5,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Beef Keftas, Tabbouleh, and Sumac Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 48,
      "readyInMinutesMin": 78
    },
    {
      "id": "1ede81e0-1d8f-463c-88a1-9c1f5e0f58ff",
      "title": "Agneau « Pas possible ! » de Christian Bégin",
      "image": "images/1ede81e0-1d8f-463c-88a1-9c1f5e0f58ff_0.jpg",
      "servings": "4",
      "readyInMinutes": 193,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gigot d’agneau du québec",
        "huile d’olive",
        "c. à s. de fleur de sel",
        "c. à s. de cumin entier",
        "c. à s. de graines de fenouil",
        "à 18 pommes de terre rattes",
        "poivrons verts",
        "panais",
        "carottes",
        "tasse de courges butternut",
        "une miche de pain d’un jour"
      ],
      "searchText": "agneau « pas possible ! » de christian bégin gigot d’agneau du québec huile d’olive c. à s. de fleur de sel c. à s. de cumin entier c. à s. de graines de fenouil à 18 pommes de terre rattes poivrons verts panais carottes tasse de courges butternut une miche de pain d’un jour",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://veroniquecloutier.com/cuisine/recette-de-lagneau-possible-de-christian-begin",
      "translatedTitles": {
        "en": "Christian Bégin’s “Pas possible!” Lamb"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 61,
      "readyInMinutesMin": 191
    },
    {
      "id": "b1dfc386-a7fa-4956-814a-d784c3bb7b96",
      "title": "Lamb Biryani",
      "image": "images/b1dfc386-a7fa-4956-814a-d784c3bb7b96_0.jpg",
      "servings": "8 servings",
      "readyInMinutes": 942,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "green finger chiles",
        "garlic cloves",
        "piece ginger",
        "yellow onions",
        "roma tomatoes",
        "full-fat yogurt",
        "mint leaves",
        "cilantro leaves",
        "coriander",
        "cumin",
        "kashmiri chile powder",
        "turmeric",
        "kosher salt",
        "to 3 lamb chops",
        "indian cinnamon sticks",
        "black peppercorns",
        "cloves",
        "green cardamom pods",
        "garam masala",
        "neutral oil",
        "yellow onions",
        "kosher salt",
        "kosher salt",
        "basmati rice",
        "milk",
        "saffron threads",
        "mixed cilantro and mint leaves",
        "unsalted butter"
      ],
      "searchText": "lamb biryani green finger chiles garlic cloves piece ginger yellow onions roma tomatoes full-fat yogurt mint leaves cilantro leaves coriander cumin kashmiri chile powder turmeric kosher salt to 3 lamb chops indian cinnamon sticks black peppercorns cloves green cardamom pods garam masala neutral oil yellow onions kosher salt kosher salt basmati rice milk saffron threads mixed cilantro and mint leaves unsalted butter",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1020915-lamb-biryani?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 1833,
      "translatedTitles": {
        "fr": "Biryani d'agneau"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 92,
      "readyInMinutesMin": 817
    },
    {
      "id": "d3eb24ce-5049-4678-9a60-3b6b952ea977",
      "title": "Lamb Meatballs With Spiced Tomato Sauce",
      "image": "images/d3eb24ce-5049-4678-9a60-3b6b952ea977_0.jpg",
      "servings": "6 to 8 servings",
      "readyInMinutes": 76,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "onion",
        "¼ heavy cream",
        "egg yolks",
        "½ cinnamon",
        "cumin",
        "pinch of red pepper",
        "pinch of cayenne",
        "lamb",
        "kosher salt and black pepper",
        "bread crumbs",
        "¼ parsley",
        "ounce tomatoes",
        "- olive oil",
        "sprig rosemary",
        "red pepper to taste",
        "onion",
        "½ thyme leaves",
        "½ cumin",
        "pinch of cinnamon",
        "pinch of cayenne",
        "bay leaf",
        "½ granulated sugar",
        "¼ orange juice",
        "inch strip of orange peel",
        "kosher salt and black pepper to taste",
        "feta cheese",
        "thinly mint leaves"
      ],
      "searchText": "lamb meatballs with spiced tomato sauce onion ¼ heavy cream egg yolks ½ cinnamon cumin pinch of red pepper pinch of cayenne lamb kosher salt and black pepper bread crumbs ¼ parsley ounce tomatoes - olive oil sprig rosemary red pepper to taste onion ½ thyme leaves ½ cumin pinch of cinnamon pinch of cayenne bay leaf ½ granulated sugar ¼ orange juice inch strip of orange peel kosher salt and black pepper to taste feta cheese thinly mint leaves",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1016255-lamb-meatballs-with-spiced-tomato-sauce?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2569,
      "translatedTitles": {
        "fr": "Boulettes d'agneau à la sauce tomate épicée"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 52,
      "readyInMinutesMin": 65
    },
    {
      "id": "81c67d6d-11c1-4243-8c48-5d638c1932ae",
      "title": "Lamb Tagine",
      "image": "images/81c67d6d-11c1-4243-8c48-5d638c1932ae_0.jpg",
      "servings": "8 servings",
      "readyInMinutes": 314,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bone-in lamb stew meat or lamb neck",
        "kosher salt",
        "lamb or chicken stock",
        "apricots",
        "- olive oil",
        "onions",
        "tomato paste",
        "grated ginger",
        "cinnamon sticks",
        "pinch saffron",
        "ginger",
        "turmeric",
        "black pepper",
        "cinnamon",
        "pinch ly grated nutmeg",
        "cilantro",
        "unsalted butter",
        "slivered almonds",
        "scallions",
        "parsley",
        "lemon juice"
      ],
      "searchText": "lamb tagine bone-in lamb stew meat or lamb neck kosher salt lamb or chicken stock apricots - olive oil onions tomato paste grated ginger cinnamon sticks pinch saffron ginger turmeric black pepper cinnamon pinch ly grated nutmeg cilantro unsalted butter slivered almonds scallions parsley lemon juice",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1018513-lamb-tagine?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2455,
      "translatedTitles": {
        "fr": "Tajine d'agneau"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 55,
      "readyInMinutesMin": 282
    },
    {
      "id": "67f1817c-9191-434d-8e36-5354cf7b3459",
      "title": "Lasagne à la romaine",
      "image": "images/67f1817c-9191-434d-8e36-5354cf7b3459_0.jpg",
      "servings": "Pour 8 à 10 portions",
      "readyInMinutes": 142,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boîte de pâtes à lasagne",
        "tasses de fromage mozzarella",
        "½ tasse de fromage parmesan",
        "c. à soupe d’huile d’olive",
        "oignon",
        "gousse d’ail",
        "boîte de pâte de tomates",
        "boîte de coulis de tomates",
        "c. à thé d’herbes italiennes",
        "sel et poivre",
        "de viande hachée",
        "œufs",
        "c. à soupe de fromage parmesan",
        "c. à soupe de persil frais",
        "contenant de fromage ricotta",
        "contenant de fromage cottage",
        "une pincée de muscade moulue",
        "contenant de bébés épinards"
      ],
      "searchText": "lasagne à la romaine boîte de pâtes à lasagne tasses de fromage mozzarella ½ tasse de fromage parmesan c. à soupe d’huile d’olive oignon gousse d’ail boîte de pâte de tomates boîte de coulis de tomates c. à thé d’herbes italiennes sel et poivre de viande hachée œufs c. à soupe de fromage parmesan c. à soupe de persil frais contenant de fromage ricotta contenant de fromage cottage une pincée de muscade moulue contenant de bébés épinards",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/casseroles-gratins/lasagne-a-la-romaine/",
      "translatedTitles": {
        "en": "Roman Lasagna"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 40,
      "readyInMinutesMin": 134
    },
    {
      "id": "31607804-72cc-4ebb-9214-b4ea2ef9a01c",
      "title": "Lasagne à la viande (la meilleure)",
      "image": "images/31607804-72cc-4ebb-9214-b4ea2ef9a01c_0.jpg",
      "servings": "8",
      "readyInMinutes": 228,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sauce à la viande",
        "de flocons de piment broyé",
        "de porc haché maigre",
        "de boeuf haché maigre",
        "d’huile d’olive",
        "oignons",
        "branches de céleri",
        "gousses d’ail",
        "boîtes de 796 chacune de tomates italiennes entières",
        "d’origan séché",
        "sauce béchamel",
        "de beurre",
        "de farine tout usage non blanchie",
        "de lait",
        "de fromage parmesan frais râpé finement",
        "lasagne",
        "pâtes à lasagne",
        "de fromage caciocavallo ou mozzarella râpé",
        "de persil plat ciselé",
        "de ciboulette ciselée"
      ],
      "searchText": "lasagne à la viande (la meilleure) sauce à la viande de flocons de piment broyé de porc haché maigre de boeuf haché maigre d’huile d’olive oignons branches de céleri gousses d’ail boîtes de 796 chacune de tomates italiennes entières d’origan séché sauce béchamel de beurre de farine tout usage non blanchie de lait de fromage parmesan frais râpé finement lasagne pâtes à lasagne de fromage caciocavallo ou mozzarella râpé de persil plat ciselé de ciboulette ciselée plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9304-lasagne-a-la-viande-la-meilleure",
      "sourceRating": 4,
      "sourceRatingCount": 34,
      "translatedTitles": {
        "en": "Meat Lasagna (the best)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 56,
      "readyInMinutesMin": 228
    },
    {
      "id": "208ee2ce-bd18-4329-be5a-014fd9b737f2",
      "title": "Le boeuf Wellington festif de Daniel Vézina",
      "image": "images/208ee2ce-bd18-4329-be5a-014fd9b737f2_0.jpg",
      "servings": "1",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de cœur de filet mignon",
        "de beurre clarifié",
        "de beurre frais",
        "sel et poivre",
        "duxelles de champignons",
        "de beurre frais",
        "échalotes françaises moyennes",
        "de champignons de paris",
        "de vin blanc",
        "persil haché",
        "sel et poivre",
        "bœuf wellington",
        "de pâté de foie gras",
        "de duxelles de champignons",
        "de pâte feuilletée",
        "œuf",
        "de lait",
        "sauce au madère",
        "de beurre clarifié",
        "échalote française",
        "de porto ou de vin de madère",
        "de fond de veau ou de sauce demi-glace",
        "sel et poivre"
      ],
      "searchText": "le boeuf wellington festif de daniel vézina de cœur de filet mignon de beurre clarifié de beurre frais sel et poivre duxelles de champignons de beurre frais échalotes françaises moyennes de champignons de paris de vin blanc persil haché sel et poivre bœuf wellington de pâté de foie gras de duxelles de champignons de pâte feuilletée œuf de lait sauce au madère de beurre clarifié échalote française de porto ou de vin de madère de fond de veau ou de sauce demi-glace sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://lactualite.com/art-de-vivre/le-boeuf-wellington-festif-de-daniel-vezina/",
      "translatedTitles": {
        "en": "Daniel Vézina's Festive Beef Wellington"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "d45fb97f-61b2-4b87-a24c-14ef86cb9bc3",
      "title": "Le meilleur «mac & cheese» végan aux légumes",
      "image": "images/d45fb97f-61b2-4b87-a24c-14ef86cb9bc3_0.jpg",
      "servings": "Portions",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de macaronis",
        "tasses de carottes émincées finement",
        "tasses de courge musquée émincée finement",
        "oignons jaunes émincés finement",
        "gousses d'ail hachées",
        "c. à soupe d'huile véétale à cuisson au choix",
        "tasses de lait véétal",
        "tasse de levure alimentaire",
        "c. à soupe d'herbes salées",
        "c. à thé de paprika fumé",
        "c. à thé de sambal oelek",
        "c. à thé de sirop d'érable",
        "c. à thé de vinaigre balsamique",
        "c. à thé de curcuma moulu",
        "sel et poivre au goût"
      ],
      "searchText": "le meilleur «mac & cheese» végan aux légumes de macaronis tasses de carottes émincées finement tasses de courge musquée émincée finement oignons jaunes émincés finement gousses d'ail hachées c. à soupe d'huile véétale à cuisson au choix tasses de lait véétal tasse de levure alimentaire c. à soupe d'herbes salées c. à thé de paprika fumé c. à thé de sambal oelek c. à thé de sirop d'érable c. à thé de vinaigre balsamique c. à thé de curcuma moulu sel et poivre au goût plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.fraichementpresse.ca/recettes/recette-meilleur-macaroni-fromage-vegetalien-1.3397295",
      "translatedTitles": {
        "en": "The Best Vegan Mac & Cheese with Vegetables"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 54
    },
    {
      "id": "86f0aec8-39f7-42e9-8210-147b0d24c6a6",
      "title": "Côtes levées au gochugaru et au provolone",
      "image": "images/86f0aec8-39f7-42e9-8210-147b0d24c6a6_0.jpg",
      "servings": "1",
      "readyInMinutes": 115,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe de raifort",
        "c. à soupe de mayonnaise maison ou du commerce",
        "quelques petites feuilles de basilic grec",
        "côtes levées*",
        "oignon",
        "bouquet de coriandre fraîche",
        "c. à soupe de poudre de piment coréen gochugaru",
        "gousses d’ail",
        "d’eau",
        "sel",
        "sauce barbecue",
        "tranches de fromage provolone"
      ],
      "searchText": "côtes levées au gochugaru et au provolone c. à soupe de raifort c. à soupe de mayonnaise maison ou du commerce quelques petites feuilles de basilic grec côtes levées* oignon bouquet de coriandre fraîche c. à soupe de poudre de piment coréen gochugaru gousses d’ail d’eau sel sauce barbecue tranches de fromage provolone",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/e5f0c555-3782-42dd-aeb8-7006dd230d06__7C___0.html?utm_content=ulink&utm_source=lpp&utm_medium=referral&utm_campaign=internal+share",
      "translatedTitles": {
        "en": "Gochugaru Ribs with Provolone"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 111
    },
    {
      "id": "860ab92d-eae5-4c4d-9474-80d228d55d7d",
      "title": "Leftover Roast Beef Stroganoff",
      "image": "images/860ab92d-eae5-4c4d-9474-80d228d55d7d_0.jpg",
      "servings": "4-6 serving(s)",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cooked beef",
        "onion",
        "garlic cloves",
        "vegetable oil",
        "cream of mushroom soup",
        "milk",
        "mushroom",
        "ketchup",
        "beef bouillon",
        "pepper"
      ],
      "searchText": "leftover roast beef stroganoff cooked beef onion garlic cloves vegetable oil cream of mushroom soup milk mushroom ketchup beef bouillon pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.food.com/recipe/leftover-roast-beef-stroganoff-340909",
      "sourceRating": 5,
      "sourceRatingCount": 26,
      "translatedTitles": {
        "fr": "Stroganoff de Bœuf Rôti Restant"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 44
    },
    {
      "id": "7f8d8e3e-6b02-4ba5-b77c-463ec4432143",
      "title": "Lemon Butter Cod",
      "image": "images/7f8d8e3e-6b02-4ba5-b77c-463ec4432143_0.jpg",
      "servings": "4",
      "readyInMinutes": 23,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cod fillets",
        "all-purpose flour",
        "paprika",
        "onion powder",
        "thyme",
        "oregano",
        "cayenne pepper",
        "salt",
        "ly black pepper",
        "danish creamery butter",
        "olive oil",
        "garlic",
        "low-sodium chicken broth",
        "lemon juice",
        "parsley"
      ],
      "searchText": "lemon butter cod cod fillets all-purpose flour paprika onion powder thyme oregano cayenne pepper salt ly black pepper danish creamery butter olive oil garlic low-sodium chicken broth lemon juice parsley",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://www.cookingclassy.com/lemon-butter-cod-recipe/",
      "sourceRating": 4.93,
      "sourceRatingCount": 165,
      "translatedTitles": {
        "fr": "Cabillaud au Beurre Citronné"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 21
    },
    {
      "id": "31adb931-743f-5e9d-b2a2-9269c0775a4a",
      "title": "Lemon Tart",
      "image": "images/31adb931-743f-5e9d-b2a2-9269c0775a4a_0.jpg",
      "servings": "8",
      "readyInMinutes": 104,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "for the tart shell",
        "all-purpose flour",
        "icing sugar",
        "softened butter",
        "pinch of salt",
        "egg yolk",
        "for the lemon curd",
        "lemons",
        "eggs",
        "caster sugar",
        "cream",
        "to serve",
        "icing sugar",
        "cream"
      ],
      "searchText": "lemon tart for the tart shell all-purpose flour icing sugar softened butter pinch of salt egg yolk for the lemon curd lemons eggs caster sugar cream to serve icing sugar cream dessert",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceRating": 4.93,
      "sourceRatingCount": 80,
      "translatedTitles": {
        "fr": "Tarte au Citron"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 99
    },
    {
      "id": "a026aa80-9489-4043-a935-ef24df0115c6",
      "title": "Lemon-Garlic Kale Salad",
      "image": "images/a026aa80-9489-4043-a935-ef24df0115c6_0.jpg",
      "servings": "8 to 12 servings",
      "readyInMinutes": 25,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "almonds",
        "ly squeezed lemon juice",
        "kosher salt",
        "- olive oil",
        "cloves garlic",
        "to 12 washed and kale leaves",
        "ly grated parmesan"
      ],
      "searchText": "lemon-garlic kale salad almonds ly squeezed lemon juice kosher salt - olive oil cloves garlic to 12 washed and kale leaves ly grated parmesan",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1015707-lemon-garlic-kale-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 10603,
      "translatedTitles": {
        "fr": "Salade de chou frisé au citron et à l'ail"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "33969196-cf99-4b56-98ea-f6e4b16ff21b",
      "title": "Lemony Chicken and Rice Soup (Avgolemono)",
      "image": "images/33969196-cf99-4b56-98ea-f6e4b16ff21b_0.jpg",
      "servings": "4 Servings",
      "readyInMinutes": 153,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "chicken",
        "carrot",
        "leek",
        "½ onion",
        "kosher salt",
        "eggs",
        "lemon juice",
        "⅔ long-grain white rice",
        "ly black pepper and olive oil"
      ],
      "searchText": "lemony chicken and rice soup (avgolemono) chicken carrot leek ½ onion kosher salt eggs lemon juice ⅔ long-grain white rice ly black pepper and olive oil plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/lemony-chicken-and-rice-soup-avgolemono",
      "sourceRating": 4.6,
      "sourceRatingCount": 29,
      "translatedTitles": {
        "fr": "Soupe au poulet et riz citronnée (Avgolemono)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 138
    },
    {
      "id": "362bad59-996c-4e8b-815a-b1ef3175f524",
      "title": "Lemony White Bean Soup With Turkey and Greens",
      "image": "images/362bad59-996c-4e8b-815a-b1ef3175f524_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 77,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "onion",
        "carrot",
        "bunch sturdy greens",
        "tomato paste",
        "cumin",
        "red-pepper flakes",
        "turkey",
        "garlic cloves",
        "finely grated ginger",
        "kosher salt",
        "quart chicken stock",
        "s white beans",
        "",
        "lemon juice"
      ],
      "searchText": "lemony white bean soup with turkey and greens olive oil onion carrot bunch sturdy greens tomato paste cumin red-pepper flakes turkey garlic cloves finely grated ginger kosher salt quart chicken stock s white beans  lemon juice",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021776-lemony-white-bean-soup-with-turkey-and-greens",
      "sourceRating": 5,
      "sourceRatingCount": 21086,
      "translatedTitles": {
        "fr": "Soupe de haricots blancs citronnée au dinde et aux légumes verts"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 51
    },
    {
      "id": "250331f7-168c-4ff7-9e85-cc8eb0baeb38",
      "title": "Lemony White Bean Soup With Turkey and Greens",
      "image": "images/250331f7-168c-4ff7-9e85-cc8eb0baeb38_0.jpg",
      "servings": "4",
      "readyInMinutes": 77,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "onion",
        "carrot",
        "bunch sturdy greens",
        "tomato paste",
        "cumin",
        "red-pepper flakes",
        "turkey",
        "garlic cloves",
        "finely grated ginger",
        "kosher salt",
        "quart chicken stock",
        "s white beans",
        "",
        "lemon juice"
      ],
      "searchText": "lemony white bean soup with turkey and greens olive oil onion carrot bunch sturdy greens tomato paste cumin red-pepper flakes turkey garlic cloves finely grated ginger kosher salt quart chicken stock s white beans  lemon juice",
      "isPersonalRecipe": true,
      "nutritionScore": 70,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021776-lemony-white-bean-soup-with-turkey-and-greens?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 21086,
      "translatedTitles": {
        "fr": "Soupe citronnée de haricots blancs au dindon et aux légumes verts"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 51
    },
    {
      "id": "77183f3b-4390-449e-b53f-0e4f559202a7",
      "title": "Linguine alla Chitarra avec poireaux et prosciutto croustillant",
      "image": "images/77183f3b-4390-449e-b53f-0e4f559202a7_0.jpg",
      "servings": "4",
      "readyInMinutes": 68,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "paquet de linguine alla chitarra olivieri®",
        "c. à soupe d’huile d’olive",
        "poireaux",
        "échalotes",
        "gousses d’ail",
        "c. à soupe de thym frais",
        "c. à thé de romarin frais",
        "c. à thé chaque de sel et de poivre",
        "tasse de vin blanc sec",
        "tasse de bouillon de bœuf à teneur réduite en sodium",
        "tasse de crème à fouetter à",
        "tranches de prosciutto",
        "tasse de fromage parmesan",
        "c. à soupe de ciboulette fraîche"
      ],
      "searchText": "linguine alla chitarra avec poireaux et prosciutto croustillant paquet de linguine alla chitarra olivieri® c. à soupe d’huile d’olive poireaux échalotes gousses d’ail c. à soupe de thym frais c. à thé de romarin frais c. à thé chaque de sel et de poivre tasse de vin blanc sec tasse de bouillon de bœuf à teneur réduite en sodium tasse de crème à fouetter à tranches de prosciutto tasse de fromage parmesan c. à soupe de ciboulette fraîche plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://olivieri.ca/fr/recettes/spaghetti-alla-chitarra-avec-poireaux-et-prosciutto-croustillant/",
      "translatedTitles": {
        "en": "Linguine alla Chitarra with leeks and crispy prosciutto"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 65
    },
    {
      "id": "816a8651-36ba-44b4-8042-78d4d02abe2e",
      "title": "linguines au citron et aux artichauts photo p. 40 PRÉPARATION 20 minutes CUISSON 35 minutes PORTIONS",
      "image": "images/816a8651-36ba-44b4-8042-78d4d02abe2e_0.jpg",
      "servings": "4",
      "readyInMinutes": 49,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "linguines au citron et aux artichauts",
        "photo p. 40",
        "préparation 20 minutes",
        "cuisson 35 minutes",
        "portions 4",
        "citrons",
        "tranches de pain uette sec",
        "d'huile d'olive",
        "de flocons de piment broyé",
        "de pancetta coupée en petits dés",
        "boîte de 320 de cours d'artichauts dans l'eau",
        "avec la tige",
        "de vin blanc",
        "de bouillon de poulet",
        "de linguines ou autres pâtes longues",
        "de ciboulette coupée en bâtonnets",
        "de 1",
        "litre",
        "sur un plan de travail",
        "finement le zeste du deuxième citron",
        "obtenir le jus. réserver séparément.",
        "dans une grande casserole à feu moyen",
        "de l'huile avec le piment jusqu'à ce que les",
        "croûtons soient bien dorés. réserver dans un bol.",
        "ajouter le reste de l'huile dans la casserole. y rôtir les",
        "quartiers de citron. réserver sur une grande assiette.",
        "dans la même casserole",
        "artichauts et poursuivre la cuisson 1 minute. réserver sur",
        "l'assiette avec les citrons.",
        "déglacer la casserole avec le vin. ajouter le bouillon et le",
        "zeste de citron. porter à ébullition. ajouter les pâtes et cuire",
        "à feu moyen-élevé 8 minutes en remuant régulièrement ou",
        "jusqu'à ce qu'elles soient al dente.",
        "ajouter le jus de citron",
        "artichauts. cuire 1 minute pour réchauffer les garnitures.",
        "saler et poivrer.",
        "répartir les pâtes dans des bols. garnir des croûtons",
        "et des quartiers de citron.",
        "astuce",
        "prenez soin de toujours laver les agrumes",
        "avant d'en consommer la pelure."
      ],
      "searchText": "linguines au citron et aux artichauts photo p. 40 préparation 20 minutes cuisson 35 minutes portions linguines au citron et aux artichauts photo p. 40 préparation 20 minutes cuisson 35 minutes portions 4 citrons tranches de pain uette sec d'huile d'olive de flocons de piment broyé de pancetta coupée en petits dés boîte de 320 de cours d'artichauts dans l'eau avec la tige de vin blanc de bouillon de poulet de linguines ou autres pâtes longues de ciboulette coupée en bâtonnets de 1 litre sur un plan de travail finement le zeste du deuxième citron obtenir le jus. réserver séparément. dans une grande casserole à feu moyen de l'huile avec le piment jusqu'à ce que les croûtons soient bien dorés. réserver dans un bol. ajouter le reste de l'huile dans la casserole. y rôtir les quartiers de citron. réserver sur une grande assiette. dans la même casserole artichauts et poursuivre la cuisson 1 minute. réserver sur l'assiette avec les citrons. déglacer la casserole avec le vin. ajouter le bouillon et le zeste de citron. porter à ébullition. ajouter les pâtes et cuire à feu moyen-élevé 8 minutes en remuant régulièrement ou jusqu'à ce qu'elles soient al dente. ajouter le jus de citron artichauts. cuire 1 minute pour réchauffer les garnitures. saler et poivrer. répartir les pâtes dans des bols. garnir des croûtons et des quartiers de citron. astuce prenez soin de toujours laver les agrumes avant d'en consommer la pelure. plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceRating": 4,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Linguine with lemon and artichokes photo p. 40 PREPARATION 20 minutes COOKING 35 minutes SERVINGS"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 44,
      "readyInMinutesMin": 49
    },
    {
      "id": "a8d22e02-38ff-4c71-ae0d-c6540c426918",
      "title": "Loaded Focaccia",
      "image": "images/a8d22e02-38ff-4c71-ae0d-c6540c426918_0.jpg",
      "servings": "8 to 12 servings",
      "readyInMinutes": 11,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "-milk ricotta or 6 salted butter",
        "store-bought focaccia",
        "herbs",
        "flaky sea salt",
        "hot or plain honey",
        "- olive oil",
        "toppings of choice"
      ],
      "searchText": "loaded focaccia -milk ricotta or 6 salted butter store-bought focaccia herbs flaky sea salt hot or plain honey - olive oil toppings of choice",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026378-loaded-focaccia?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 146,
      "translatedTitles": {
        "fr": "Focaccia garnie"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 11
    },
    {
      "id": "8e70e74a-1bbe-4420-924d-c429a940fcc6",
      "title": "Macarons à la noix de coco",
      "image": "images/8e70e74a-1bbe-4420-924d-c429a940fcc6_0.jpg",
      "servings": "18 macarons",
      "readyInMinutes": 94,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sac de 200 de noix de coco râpée non sucrée",
        "de blancs d'oeufs liquides",
        "de sucre",
        "de fécule de maïs",
        "de chocolat noir"
      ],
      "searchText": "macarons à la noix de coco sac de 200 de noix de coco râpée non sucrée de blancs d'oeufs liquides de sucre de fécule de maïs de chocolat noir",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2494/macarons-a-la-noix-de-coco",
      "translatedTitles": {
        "en": "Coconut Macarons"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 94
    },
    {
      "id": "61e1eee8-b1ab-4704-b132-1c799731c88a",
      "title": "Magrets de canard à la vodka et aux canneberges",
      "image": "images/61e1eee8-b1ab-4704-b132-1c799731c88a_0.jpg",
      "servings": "4",
      "readyInMinutes": 57,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "magrets de ard",
        "échalotes françaises",
        "de neberges séchées",
        "de vodka",
        "le jus de 2 oranges",
        "de neberges fraîches ou surgelées",
        "de demi-glace",
        "sel et poivre"
      ],
      "searchText": "magrets de canard à la vodka et aux canneberges magrets de ard échalotes françaises de neberges séchées de vodka le jus de 2 oranges de neberges fraîches ou surgelées de demi-glace sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/4518-magrets-de-canard-a-la-vodka-et-aux-canneberges",
      "sourceRating": 5,
      "sourceRatingCount": 23,
      "translatedTitles": {
        "en": "Duck Breasts with Vodka and Cranberries"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 57
    },
    {
      "id": "dcf0bf74-5c93-4dbb-aa4a-73c2df5c07de",
      "title": "Maple and Miso Sheet-Pan Salmon With Green Beans",
      "image": "images/dcf0bf74-5c93-4dbb-aa4a-73c2df5c07de_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 39,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "skin-on salmon fillets",
        "kosher salt",
        "ly black pepper",
        "maple syrup",
        "white or brown miso",
        "rice wine vinegar",
        "soy sauce",
        "garlic clove",
        "green beans",
        "olive oil",
        "pinch of red-pepper flakes",
        "toasted sesame oil",
        "roughly cilantro",
        "lime wedges",
        "flaky sea salt",
        "cooked white rice"
      ],
      "searchText": "maple and miso sheet-pan salmon with green beans skin-on salmon fillets kosher salt ly black pepper maple syrup white or brown miso rice wine vinegar soy sauce garlic clove green beans olive oil pinch of red-pepper flakes toasted sesame oil roughly cilantro lime wedges flaky sea salt cooked white rice",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1019857-maple-and-miso-sheet-pan-salmon-with-green-beans?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 9312,
      "translatedTitles": {
        "fr": "Saumon à l'érable et au miso en plaque avec haricots verts"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 39
    },
    {
      "id": "0edb0846-4cad-4cae-b339-817d7a38248c",
      "title": "Mimosa pamplemousse et framboises",
      "servings": "1",
      "readyInMinutes": 5,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bière nano perroquet ipa de la microbrasserie le trou du diable",
        "jus de citron fraîchement pressé",
        "sucre blanc",
        "framboises",
        "décoration une tranche de pamplemousse rose et quelques framboises"
      ],
      "searchText": "mimosa pamplemousse et framboises bière nano perroquet ipa de la microbrasserie le trou du diable jus de citron fraîchement pressé sucre blanc framboises décoration une tranche de pamplemousse rose et quelques framboises",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.metro.ca/recettes-et-occasions/recettes/mimosa-pamplemousse-et-framboises?utm_source=metro&utm_medium=Link&utm_term=recipes&utm_content=mimosa-pamplemousse-framboises&utm_campaign=Q3-LaPresse_Été_Bières_29 mai 2021-FR",
      "image": "images/0edb0846-4cad-4cae-b339-817d7a38248c_0.jpg",
      "translatedTitles": {
        "en": "Grapefruit and Raspberry Mimosa"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 5,
      "readyInMinutesMin": 5
    },
    {
      "id": "8c9601e5-3258-4f5e-90de-a2ad1c247fdd",
      "title": "Mini crêpes (mini pancakes)",
      "image": "images/8c9601e5-3258-4f5e-90de-a2ad1c247fdd_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasses de farine tout usage",
        "c. à soupe de sucre blanc ou de sirop d'érable*",
        "pincée de sel",
        "tasses de lait",
        "oeufs",
        "c. à soupe de beurre fondu",
        "beurre froid"
      ],
      "searchText": "mini crêpes (mini pancakes) tasses de farine tout usage c. à soupe de sucre blanc ou de sirop d'érable* pincée de sel tasses de lait oeufs c. à soupe de beurre fondu beurre froid",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/6221/mini-crepes-mini-pancakes",
      "translatedTitles": {
        "en": "Mini pancakes (mini pancakes)"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "b05f2993-e697-4bb6-b150-001f07743a81",
      "title": "Mini pâtés au chili",
      "image": "images/b05f2993-e697-4bb6-b150-001f07743a81_0.jpg",
      "servings": "4",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [],
      "searchText": "mini pâtés au chili plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Mini Chili Pies"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 46
    },
    {
      "id": "6d4ae1d7-dbe9-4d4c-86ce-1702779f0caa",
      "title": "Minibagels au saumon fumé",
      "image": "images/6d4ae1d7-dbe9-4d4c-86ce-1702779f0caa_0.jpg",
      "servings": "12",
      "readyInMinutes": 64,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "miniels",
        "de farine tout usage non blanchie",
        "de poudre à pâte",
        "de bicarbonate de soude",
        "œuf",
        "de sucre",
        "d’huile véétale",
        "de lait de beurre",
        "de graines de sésame",
        "garniture",
        "de fromage à la crème à tartiner",
        "de ciboulette ciselée",
        "de saumon fumé en tranches"
      ],
      "searchText": "minibagels au saumon fumé miniels de farine tout usage non blanchie de poudre à pâte de bicarbonate de soude œuf de sucre d’huile véétale de lait de beurre de graines de sésame garniture de fromage à la crème à tartiner de ciboulette ciselée de saumon fumé en tranches petit-déjeuner",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8643-minibagels-au-saumon-fume",
      "sourceRating": 4,
      "sourceRatingCount": 21,
      "translatedTitles": {
        "en": "Minibagels with smoked salmon"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 64
    },
    {
      "id": "8140e33a-bc61-44f7-956e-f79f74c577cc",
      "title": "Mojito",
      "image": "images/8140e33a-bc61-44f7-956e-f79f74c577cc_0.jpg",
      "servings": "6",
      "readyInMinutes": 13,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "mint leaves",
        "sugar",
        "chilled club soda",
        "dark rum",
        "lime juice",
        "ice cubes",
        "lime"
      ],
      "searchText": "mojito mint leaves sugar chilled club soda dark rum lime juice ice cubes lime boisson",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.ricardocuisine.com/en/recipes/3346-mojito",
      "sourceRating": 5,
      "sourceRatingCount": 31,
      "translatedTitles": {
        "fr": "Mojito"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 13
    },
    {
      "id": "583c707c-26de-4da2-8540-3c6bdee1184d",
      "title": "Morue à la puttanesca » Cinq Fourchettes",
      "image": "images/583c707c-26de-4da2-8540-3c6bdee1184d_0.jpg",
      "servings": "4",
      "readyInMinutes": 63,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d'huile d'olive 2 c. table d'ail"
      ],
      "searchText": "morue à la puttanesca » cinq fourchettes d'huile d'olive 2 c. table d'ail plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cinqfourchettes.com/morue-a-la-puttanesca/",
      "translatedTitles": {
        "en": "Cod Puttanesca » Cinq Fourchettes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 62
    },
    {
      "id": "d8f1f717-5bca-4a28-8692-0aa4338413ac",
      "title": "Morue poêlée au gingembre, courgette et avocat",
      "image": "images/d8f1f717-5bca-4a28-8692-0aa4338413ac_0.jpg",
      "servings": "4",
      "readyInMinutes": 39,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "morue",
        "de filet de morue",
        "tranches de gingembre frais",
        "d’huile d’olive",
        "de beurre",
        "garniture",
        "de bouillon de poulet",
        "de sauce soya",
        "de jus de lime",
        "de cassonade",
        "courgette",
        "avocat",
        "oignon vert",
        "de feuilles de coriandre"
      ],
      "searchText": "morue poêlée au gingembre, courgette et avocat morue de filet de morue tranches de gingembre frais d’huile d’olive de beurre garniture de bouillon de poulet de sauce soya de jus de lime de cassonade courgette avocat oignon vert de feuilles de coriandre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7697-morue-poelee-au-gingembre-courgette-et-avocat",
      "sourceRating": 5,
      "sourceRatingCount": 115,
      "translatedTitles": {
        "en": "Pan-fried Cod with Ginger, Zucchini, and Avocado"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 39
    },
    {
      "id": "9086fca0-1b31-45f3-aa7b-8de3165ec26d",
      "title": "Morue poêlée avec sauce au beurre et au citron",
      "image": "images/9086fca0-1b31-45f3-aa7b-8de3165ec26d_0.jpg",
      "servings": "4",
      "readyInMinutes": 28,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de morue",
        "c. à soupe de beurre",
        "sel et poivre du moulin",
        "tasse de vin blanc",
        "c. à soupe de beurre",
        "le jus de 1 citron",
        "c. à soupe de câpres"
      ],
      "searchText": "morue poêlée avec sauce au beurre et au citron de morue c. à soupe de beurre sel et poivre du moulin tasse de vin blanc c. à soupe de beurre le jus de 1 citron c. à soupe de câpres",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://lecoupdegrace.ca/recette/morue-poelee-avec-sauce-au-beurre-et-au-citron/",
      "sourceRating": 5,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Pan-fried Cod with Butter and Lemon Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 24
    },
    {
      "id": "c363c4f5-4a77-4895-95db-a7e2cb681be6",
      "title": "Morue poêlée en croûte de pistaches et de thé vert",
      "image": "images/c363c4f5-4a77-4895-95db-a7e2cb681be6_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pistache",
        "poudre de thé matcha",
        "eau",
        "sucre granulé",
        "lime",
        "beurre",
        "chapelure panko",
        "filet de morue fraîche",
        "beurre",
        "sel et poivre"
      ],
      "searchText": "morue poêlée en croûte de pistaches et de thé vert pistache poudre de thé matcha eau sucre granulé lime beurre chapelure panko filet de morue fraîche beurre sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.zeste.ca/recettes/morue-poelee-en-croute-de-pistaches-et-de-the-vert",
      "translatedTitles": {
        "en": "Pan-seared Cod with Pistachio and Green Tea Crust"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 33
    },
    {
      "id": "6bd03dd7-bdaf-414b-81c2-56b27af9819e",
      "title": "Moscow mule",
      "image": "images/6bd03dd7-bdaf-414b-81c2-56b27af9819e_0.jpg",
      "servings": "1",
      "readyInMinutes": 11,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vodka",
        "lime juice",
        "or 2 drops angostura bitters",
        "ginger beer",
        "ice cubes",
        "lime and lemon slices"
      ],
      "searchText": "moscow mule vodka lime juice or 2 drops angostura bitters ginger beer ice cubes lime and lemon slices boisson",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.saq.com/en/moscow-mule-ec",
      "translatedTitles": {
        "fr": "Moscow mule"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 11
    },
    {
      "id": "a0556ef6-b5f8-45f4-8073-6ec6812dc930",
      "title": "Moscow Mule Cocktail",
      "image": "images/a0556ef6-b5f8-45f4-8073-6ec6812dc930_0.jpg",
      "servings": "1 cocktail",
      "readyInMinutes": 4,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½ fluid vodka",
        "½ fluid ounce lime juice",
        "ice cubes",
        "½ ginger beer",
        "lime wedge for garnish"
      ],
      "searchText": "moscow mule cocktail ½ fluid vodka ½ fluid ounce lime juice ice cubes ½ ginger beer lime wedge for garnish boisson",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceUrl": "https://www.allrecipes.com/recipe/221310/moscow-mule-cocktail/",
      "translatedTitles": {
        "fr": "Cocktail Moscow Mule"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 4,
      "readyInMinutesMin": 4
    },
    {
      "id": "cd783a0c-94a0-452d-b69d-43e10a5e2066",
      "title": "Moules au lait de coco",
      "image": "images/cd783a0c-94a0-452d-b69d-43e10a5e2066_0.jpg",
      "servings": "2",
      "readyInMinutes": 24,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "gousse d'ail",
        "de gingembre frais haché",
        "d'huile d'olive",
        "de lait de coco léger",
        "de miel",
        "de vinaigre de riz",
        "de moules ou autres coquillages (palourdes",
        "sel et poivre"
      ],
      "searchText": "moules au lait de coco oignon gousse d'ail de gingembre frais haché d'huile d'olive de lait de coco léger de miel de vinaigre de riz de moules ou autres coquillages (palourdes sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4076-moules-au-lait-de-coco",
      "sourceRating": 5,
      "sourceRatingCount": 24,
      "translatedTitles": {
        "en": "Mussels with coconut milk"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 24
    },
    {
      "id": "d14f679d-3ea6-47ee-9b9d-b7ccf57a5635",
      "title": "Mousse de foies de volaille à l'érable et au brandy",
      "image": "images/d14f679d-3ea6-47ee-9b9d-b7ccf57a5635_0.jpg",
      "servings": "375 ml (1 1/2 tasse)",
      "readyInMinutes": 20,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de beurre non salé",
        "branches de thym frais",
        "de foies de volaille parés",
        "échalote française",
        "de brandy",
        "de sirop d'érable",
        "de crème",
        "sel et poivre"
      ],
      "searchText": "mousse de foies de volaille à l'érable et au brandy de beurre non salé branches de thym frais de foies de volaille parés échalote française de brandy de sirop d'érable de crème sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/1061-mousse-de-foies-de-volaille-a-l-erable-et-au-brandy",
      "sourceRating": 5,
      "sourceRatingCount": 30,
      "translatedTitles": {
        "en": "Maple and Brandy Chicken Liver Mousse"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "e14e40d2-4569-44fc-b742-b5d6d4e8ec11",
      "title": "Muffins aux carottes, chocolat et noisettes",
      "image": "images/e14e40d2-4569-44fc-b742-b5d6d4e8ec11_0.jpg",
      "servings": "1",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de farine tout usage sans gluten ou ordinaire",
        "tasse de poudre ou farine de noisettes grillées ou de poudre ou farine d’amandes",
        "tasse de flocons d’avoine à cuisson rapide sans gluten ou ordinaires",
        "c. à soupe de poudre à pâte",
        "c. à soupe de nelle moulue",
        "c. à thé de gingembre moulu",
        "c. à thé (1",
        "c. à thé (1",
        "oeufs",
        "tasse d’huile d’olive",
        "tasse de crème de soya de type belsoy ou de lait de coco en conserve bien brassé",
        "tasse de cassonade bien tassée",
        "tasse de carottes râpées",
        "tasse de pépites de chocolat mi-sucré sans produits laitiers ou ordinaires",
        "tasse de noisettes grillées hachées grossièrement",
        "tasse de pépites de chocolat mi-sucré sans produits laitiers ou ordinaires"
      ],
      "searchText": "muffins aux carottes, chocolat et noisettes tasse de farine tout usage sans gluten ou ordinaire tasse de poudre ou farine de noisettes grillées ou de poudre ou farine d’amandes tasse de flocons d’avoine à cuisson rapide sans gluten ou ordinaires c. à soupe de poudre à pâte c. à soupe de nelle moulue c. à thé de gingembre moulu c. à thé (1 c. à thé (1 oeufs tasse d’huile d’olive tasse de crème de soya de type belsoy ou de lait de coco en conserve bien brassé tasse de cassonade bien tassée tasse de carottes râpées tasse de pépites de chocolat mi-sucré sans produits laitiers ou ordinaires tasse de noisettes grillées hachées grossièrement tasse de pépites de chocolat mi-sucré sans produits laitiers ou ordinaires",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/muffins-aux-carottes-chocolat-et-noisettes/",
      "translatedTitles": {
        "en": "Carrot, Chocolate, and Hazelnut Muffins"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 43
    },
    {
      "id": "6477bd48-7a9b-4665-b497-82a646b1310d",
      "title": "Nachos garnis à la saucisse italienne et au fromage râpé Tex Mex",
      "image": "images/6477bd48-7a9b-4665-b497-82a646b1310d_0.jpg",
      "servings": "4 à 6",
      "readyInMinutes": 55,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’huile d’olive",
        "de chair à saucisse italienne",
        "de cumin moulu",
        "de paprika fumé",
        "de salsa mexicaine",
        "de chips tortilla de maïs",
        "de fromage râpé tex mex armstrong",
        "¼ tasse de grains de maïs surgelés",
        "½ tasse de tomates cerises",
        "avocat",
        "feuilles de coriandre fraîche"
      ],
      "searchText": "nachos garnis à la saucisse italienne et au fromage râpé tex mex d’huile d’olive de chair à saucisse italienne de cumin moulu de paprika fumé de salsa mexicaine de chips tortilla de maïs de fromage râpé tex mex armstrong ¼ tasse de grains de maïs surgelés ½ tasse de tomates cerises avocat feuilles de coriandre fraîche collation",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.armstrongcheese.ca/fr-ca/nos-recettes/nachos-garnis-a-la-saucisse-italienne-et-au-fromage-rape-tex-mex",
      "translatedTitles": {
        "en": "Nachos garnished with Italian sausage and Tex Mex shredded cheese"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 50
    },
    {
      "id": "8ef4aa73-de81-4b06-9c7d-5c48d26c69d4",
      "title": "Napoléon de homard, sauce cocktail au Cognac, avocat |",
      "image": "images/8ef4aa73-de81-4b06-9c7d-5c48d26c69d4_0.jpg",
      "servings": "Recette pour 4 personnes",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "homard",
        "avocat",
        "jus de citron",
        "ketchup",
        "échalote",
        "cognac",
        "ciboulette",
        "mayonnaise hellmann's",
        "pousse de pois"
      ],
      "searchText": "napoléon de homard, sauce cocktail au cognac, avocat | homard avocat jus de citron ketchup échalote cognac ciboulette mayonnaise hellmann's pousse de pois",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ateliersetsaveurs.com/les-recettes/culinaires/detail/381/napoleon-de-homard-sauce-cocktail-au-cognac-avocat",
      "translatedTitles": {
        "en": "Lobster Napoleon, Cognac cocktail sauce, avocado |"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 45
    },
    {
      "id": "f5f86c98-7e86-43f4-ac11-445897290a30",
      "title": "Niku Udon (Japanese Beef Noodle Soup)",
      "image": "images/f5f86c98-7e86-43f4-ac11-445897290a30_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 68,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "/about 2 squares kombu",
        "/about 2 loosely packed katsuobushi",
        "thinly shaved beef",
        "yellow onion",
        "bunch scallions",
        "granulated sugar",
        "sake",
        "soy sauce",
        "mirin",
        "soy sauce",
        "mirin",
        "or udon noodles",
        "shichimi or nanami togarashi"
      ],
      "searchText": "niku udon (japanese beef noodle soup) /about 2 squares kombu /about 2 loosely packed katsuobushi thinly shaved beef yellow onion bunch scallions granulated sugar sake soy sauce mirin soy sauce mirin or udon noodles shichimi or nanami togarashi plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1023569-niku-udon-japanese-beef-noodle-soup?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1291,
      "translatedTitles": {
        "fr": "Niku Udon (Soupe japonaise de nouilles au bœuf)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 45,
      "readyInMinutesMin": 55
    },
    {
      "id": "7e3b2b4d-6803-4756-99e5-f83fb9469ee2",
      "title": "Saumon en croûte de pistaches, sauce miel et soya",
      "image": "images/7e3b2b4d-6803-4756-99e5-f83fb9469ee2_0.jpg",
      "servings": "1",
      "readyInMinutes": 129,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’huile d’olive",
        "de miel",
        "sel et poivre au goût",
        "pour la purée :",
        "de beurre",
        "de crème à cuisson",
        "sel et poivre au goût",
        "pour la sauce :",
        "de miel",
        "de sauce soya",
        "de vinaigre de riz",
        "de beurre salé froid coupé en cubes",
        "sel et poivre au goût",
        "pour le saumon :",
        "de pistaches hachées finement",
        "de chapelure panko",
        "pincée de sel",
        "filets de saumon de 150 chacun",
        "de miel",
        "d’huile d’olive"
      ],
      "searchText": "saumon en croûte de pistaches, sauce miel et soya d’huile d’olive de miel sel et poivre au goût pour la purée : de beurre de crème à cuisson sel et poivre au goût pour la sauce : de miel de sauce soya de vinaigre de riz de beurre salé froid coupé en cubes sel et poivre au goût pour le saumon : de pistaches hachées finement de chapelure panko pincée de sel filets de saumon de 150 chacun de miel d’huile d’olive",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/1d07983a-9f8f-4280-acf6-1665e83934ac__7C___0.html?utm_content=ulink&utm_source=lpp&utm_medium=referral&utm_campaign=internal+share",
      "translatedTitles": {
        "en": "Pistachio-Crusted Salmon with Honey-Soy Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 117
    },
    {
      "id": "758cd0ad-b4b6-4ce9-b04a-a9739e130aa8",
      "title": "Nouilles udon au poulet et oignons rôtis au cari",
      "servings": "4",
      "readyInMinutes": 58,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gros oignons",
        "d’huile véétale",
        "de poudre de cari",
        "paquets de 200 chacun de nouilles udon fraîches",
        "de sauce soya",
        "de flocons de piment broyé",
        "de poulet cuit effiloché",
        "petit oignon rouge",
        "radis",
        "de coriandre ciselée",
        "de gingembre mariné pour sushi"
      ],
      "searchText": "nouilles udon au poulet et oignons rôtis au cari gros oignons d’huile véétale de poudre de cari paquets de 200 chacun de nouilles udon fraîches de sauce soya de flocons de piment broyé de poulet cuit effiloché petit oignon rouge radis de coriandre ciselée de gingembre mariné pour sushi",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8738-nouilles-udon-au-poulet-et-oignons-rotis-au-cari",
      "image": "images/758cd0ad-b4b6-4ce9-b04a-a9739e130aa8_0.jpg",
      "sourceRating": 4,
      "sourceRatingCount": 18,
      "translatedTitles": {
        "en": "Udon noodles with chicken and roasted curry onions"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 58
    },
    {
      "id": "a2ccba15-1772-41ca-b325-a4d4946c1126",
      "title": "Olives tièdes au zaatar",
      "image": "images/a2ccba15-1772-41ca-b325-a4d4946c1126_0.jpg",
      "servings": "1",
      "readyInMinutes": 10,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse olives marocaines ou autres olives sèches",
        "c. à soupe huile d'olive",
        "c. à thé zaatar"
      ],
      "searchText": "olives tièdes au zaatar tasse olives marocaines ou autres olives sèches c. à soupe huile d'olive c. à thé zaatar",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://epicesdecru.com/recettes/olives-tièdes-au-zaatar",
      "translatedTitles": {
        "en": "Warm Olives with Za'atar"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 10,
      "readyInMinutesMin": 10
    },
    {
      "id": "8e40bdee-456c-4ff3-a71d-efda01005963",
      "title": "One-Pot Whole Roasted Chicken and Rice",
      "image": "images/8e40bdee-456c-4ff3-a71d-efda01005963_0.jpg",
      "servings": "6 servings",
      "readyInMinutes": 120,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pinch saffron threads",
        "pinch granulated sugar",
        "chicken",
        "kosher salt and black pepper",
        "- olive oil",
        "yellow onion",
        "garlic cloves",
        "turmeric",
        "white basmati rice",
        "lemon juice",
        "green herbs"
      ],
      "searchText": "one-pot whole roasted chicken and rice pinch saffron threads pinch granulated sugar chicken kosher salt and black pepper - olive oil yellow onion garlic cloves turmeric white basmati rice lemon juice green herbs plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024109-one-pot-whole-roasted-chicken-and-rice?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2627,
      "translatedTitles": {
        "fr": "Poulet rôti entier et riz en une seule casserole"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "5c54bbb5-e83b-4cce-86bf-5e523c482cd4",
      "title": "Orecchiette with Veal, Capers and White Wine",
      "image": "images/5c54bbb5-e83b-4cce-86bf-5e523c482cd4_0.jpg",
      "servings": "8",
      "readyInMinutes": 41,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "- olive oil",
        "onion",
        "garlic clove",
        "veal",
        "salt and ly pepper",
        "dry white wine",
        "chicken stock",
        "thyme",
        "rosemary",
        "capers",
        "orecchiette",
        "grated parmigiano-reggiano",
        "flat-leaf parsley",
        "unsalted butter"
      ],
      "searchText": "orecchiette with veal, capers and white wine - olive oil onion garlic clove veal salt and ly pepper dry white wine chicken stock thyme rosemary capers orecchiette grated parmigiano-reggiano flat-leaf parsley unsalted butter main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/orecchiette-veal-capers-and-white-wine",
      "translatedTitles": {
        "fr": "Orecchiette au Veau, Câpres et Vin Blanc"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 41,
      "readyInMinutesMin": 40
    },
    {
      "id": "98db7174-57e8-4413-8989-5d57283258cb",
      "title": "Orecchiettes au poulet, aux olives et aux champignons",
      "image": "images/98db7174-57e8-4413-8989-5d57283258cb_0.jpg",
      "servings": "4",
      "readyInMinutes": 76,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’orecchiettes",
        "de champignons de paris",
        "oignon",
        "d’huile d’olive",
        "gousses d'ail",
        "de bouillon de poulet",
        "d’olives noires dénoyautées",
        "de poulet cuit coupé en dés",
        "de fromage parmigiano reggiano râpé",
        "de ciboulette fraîche ciselée",
        "de beurre",
        "sel et poivre"
      ],
      "searchText": "orecchiettes au poulet, aux olives et aux champignons d’orecchiettes de champignons de paris oignon d’huile d’olive gousses d'ail de bouillon de poulet d’olives noires dénoyautées de poulet cuit coupé en dés de fromage parmigiano reggiano râpé de ciboulette fraîche ciselée de beurre sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6088-orecchiettes-au-poulet-aux-olives-et-aux-champignons",
      "sourceRating": 5,
      "sourceRatingCount": 58,
      "translatedTitles": {
        "en": "Orecchiette with chicken, olives, and mushrooms"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 46,
      "readyInMinutesMin": 69
    },
    {
      "id": "dcd2d4ce-c0bd-4100-8fb9-f34cf3b78880",
      "title": "Orzo au citron",
      "image": "images/dcd2d4ce-c0bd-4100-8fb9-f34cf3b78880_0.jpg",
      "servings": "1",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "zestes de citrons bio",
        "le jus de 2 citron",
        "tasse de parmesan râpé",
        "c. à soupe d'huile d'olive",
        "d'orzo ou autres pâtes courtes",
        "bouillon de poulet",
        "une grosse poignée d'herbes fraîches hachées (basilic",
        "sel et poivre du moulin"
      ],
      "searchText": "orzo au citron zestes de citrons bio le jus de 2 citron tasse de parmesan râpé c. à soupe d'huile d'olive d'orzo ou autres pâtes courtes bouillon de poulet une grosse poignée d'herbes fraîches hachées (basilic sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/3432/orzo-au-citron",
      "translatedTitles": {
        "en": "Lemon Orzo"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 33
    },
    {
      "id": "603bbfeb-520d-4dbd-b895-1555aad066e7",
      "title": "Orzo Salad",
      "image": "images/603bbfeb-520d-4dbd-b895-1555aad066e7_0.jpg",
      "servings": "8 servings",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salt",
        "orzo",
        "- olive oil",
        "red wine vinegar",
        "finely red onion",
        "garlic clove",
        "oregano",
        "black pepper",
        "pint cherry or grape tomatoes",
        "chickpeas",
        "pitted kalamata olives",
        "feta",
        "english cucumber",
        "parsley"
      ],
      "searchText": "orzo salad salt orzo - olive oil red wine vinegar finely red onion garlic clove oregano black pepper pint cherry or grape tomatoes chickpeas pitted kalamata olives feta english cucumber parsley",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025349-orzo-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3582,
      "translatedTitles": {
        "fr": "Salade d'orzo"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 59
    },
    {
      "id": "42b3ea58-e3f5-4319-af52-50214d9efa05",
      "title": "Salade de kale, patate douce rôtie et légumineuses",
      "image": "images/42b3ea58-e3f5-4319-af52-50214d9efa05_0.jpg",
      "servings": "1",
      "readyInMinutes": 52,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "patate douce",
        "d’huile d’olive",
        "poivre et sel",
        "poireau",
        "de kale haché finement",
        "de chou rouge haché finement",
        "branches de céleri",
        "poivron rouge",
        "boîte de 540 de légumineuses",
        "vinaigrette",
        "de moutarde de dijon",
        "de vinaigre de vin blanc",
        "de sirop d’érable",
        "d’eau",
        "d’huile d’olive",
        "poivre et sel"
      ],
      "searchText": "salade de kale, patate douce rôtie et légumineuses patate douce d’huile d’olive poivre et sel poireau de kale haché finement de chou rouge haché finement branches de céleri poivron rouge boîte de 540 de légumineuses vinaigrette de moutarde de dijon de vinaigre de vin blanc de sirop d’érable d’eau d’huile d’olive poivre et sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/b0cb208b-6cde-4aae-8384-014a22fa94c5__7C___0.html",
      "translatedTitles": {
        "en": "Kale, Roasted Sweet Potato and Bean Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 52
    },
    {
      "id": "5a5c7d19-0399-40a4-8661-079fd8570091",
      "title": "Pad Prik King (Red Curry Chicken and Green Beans)",
      "image": "images/5a5c7d19-0399-40a4-8661-079fd8570091_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cornstarch",
        "fine sea salt",
        "boneless",
        "ola or vegetable oil",
        "garlic",
        "to 4 red curry paste",
        "long beans or green beans",
        "oyster sauce",
        "sugar",
        "makrut lime leaves",
        "cooked jasmine rice"
      ],
      "searchText": "pad prik king (red curry chicken and green beans) cornstarch fine sea salt boneless ola or vegetable oil garlic to 4 red curry paste long beans or green beans oyster sauce sugar makrut lime leaves cooked jasmine rice",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026896-pad-prik-king-red-curry-chicken-and-green-beans?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1011,
      "translatedTitles": {
        "fr": "Pad Prik King (Poulet au Curry Rouge et Haricots Verts)"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "d813058a-f15a-4647-a669-8f7c8391e3e5",
      "title": "Pad thaï rapide",
      "image": "images/d813058a-f15a-4647-a669-8f7c8391e3e5_0.jpg",
      "servings": "6 portions",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d'huile véétale",
        "paquet de 200 de nouilles de riz larges pour sauté",
        "de fèves germées",
        "de grosses crevettes crues surgelées",
        "d'eau",
        "de sauce chili thaïe sucrée",
        "de beurre de soya de type wowbutter*",
        "de sauce de poisson",
        "de sauce soya réduite en sodium",
        "d'ail haché en pot",
        "le jus de 1 lime",
        "coriandre fraîche hachée finement",
        "lime en quartiers",
        "graines de soya grillées non salées et concassées (ou arachides rôties à sec et non salées"
      ],
      "searchText": "pad thaï rapide d'huile véétale paquet de 200 de nouilles de riz larges pour sauté de fèves germées de grosses crevettes crues surgelées d'eau de sauce chili thaïe sucrée de beurre de soya de type wowbutter* de sauce de poisson de sauce soya réduite en sodium d'ail haché en pot le jus de 1 lime coriandre fraîche hachée finement lime en quartiers graines de soya grillées non salées et concassées (ou arachides rôties à sec et non salées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2556/pad-thai-rapide?fbclid=IwAR1vQy_BsyDiK5Mu16jex9o1qJ1kCimsuOaaNNLc4G1hY8kjaNg6eEGogeA",
      "translatedTitles": {
        "en": "Quick Pad Thai"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 38
    },
    {
      "id": "01a8686b-90e3-4d42-b7cc-3a3580053c12",
      "title": "Pain brioché (Monkey Bread) aux carottes",
      "image": "images/01a8686b-90e3-4d42-b7cc-3a3580053c12_0.jpg",
      "servings": "12 portions",
      "readyInMinutes": 97,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grosses carottes",
        "d’ananas broyés",
        "½ tasse de paes hachées",
        "¼ de tasse de cassonade",
        "c. à thé de nelle",
        "½ c. à thé (2",
        "½ c. à thé (2",
        "de pâte à petits pains feuilletés",
        "de glaçage au fromage à la crème"
      ],
      "searchText": "pain brioché (monkey bread) aux carottes grosses carottes d’ananas broyés ½ tasse de paes hachées ¼ de tasse de cassonade c. à thé de nelle ½ c. à thé (2 ½ c. à thé (2 de pâte à petits pains feuilletés de glaçage au fromage à la crème",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/6391/pain-brioche-monkey-bread-aux-carottes?fbclid=IwAR2jBwLAWPvaiNVLsxU-rmWCZ3oqtuFbGphbsCaR8tTj0_VcMtrlE_hGGJI",
      "translatedTitles": {
        "en": "Brioche Bread (Monkey Bread) with Carrots"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 87
    },
    {
      "id": "a42408d3-d4fa-4ae0-9ebe-cfc8795d7266",
      "title": "Pain doré au four à la frangipane",
      "servings": "6",
      "readyInMinutes": 70,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pain doré",
        "œufs",
        "de lait",
        "de crème",
        "de sucre",
        "d’it de vanille",
        "pain de campagne aux neberges et paes ou 1 pain aux raisins d’environ 450",
        "frangipane",
        "de beurre non salé",
        "de poudre d’amandes",
        "de cassonade",
        "œufs"
      ],
      "searchText": "pain doré au four à la frangipane pain doré œufs de lait de crème de sucre d’it de vanille pain de campagne aux neberges et paes ou 1 pain aux raisins d’environ 450 frangipane de beurre non salé de poudre d’amandes de cassonade œufs",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8477-pain-dore-au-four-a-la-frangipane",
      "image": "images/a42408d3-d4fa-4ae0-9ebe-cfc8795d7266_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 6,
      "translatedTitles": {
        "en": "Baked French Toast with Frangipane"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 70
    },
    {
      "id": "30bff2a3-cd53-4450-ba8b-667d995c6780",
      "title": "Pain doré croustillant à l'orange",
      "servings": "4",
      "readyInMinutes": 27,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oeuf",
        "lait",
        "crème",
        "zeste d'orange",
        "vanille",
        "pincée sel",
        "quantité suffisante",
        "tranches de pain au choix",
        "au goût"
      ],
      "searchText": "pain doré croustillant à l'orange oeuf lait crème zeste d'orange vanille pincée sel quantité suffisante tranches de pain au choix au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.metro.ca/recettes-et-occasions/recettes/pain-dore-croustillant-a-l-orange",
      "image": "images/30bff2a3-cd53-4450-ba8b-667d995c6780_0.jpg",
      "translatedTitles": {
        "en": "Crispy Orange French Toast"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 27
    },
    {
      "id": "b05310a1-15ec-560e-896d-e7a54223d0a0",
      "title": "Pancakes",
      "image": "images/b05310a1-15ec-560e-896d-e7a54223d0a0_0.jpg",
      "servings": "13",
      "readyInMinutes": 27,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "/375g all-purpose flour",
        "baking powder",
        "caster sugar",
        "/375ml milk",
        "eggs",
        "salt"
      ],
      "searchText": "pancakes /375g all-purpose flour baking powder caster sugar /375ml milk eggs salt breakfast",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceRating": 4.91,
      "sourceRatingCount": 200,
      "translatedTitles": {
        "fr": "Pancakes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 22
    },
    {
      "id": "bc76d24c-cc51-4722-8bd1-ab5f3696ddad",
      "title": "Pantry Pasta With Vegan Cream Sauce",
      "image": "images/bc76d24c-cc51-4722-8bd1-ab5f3696ddad_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "½ plus 2 . - olive oil",
        "walnuts",
        "½ . red pepper flakes",
        "garlic cloves",
        "sprigs rosemary",
        ". s nellini beans",
        ". paccheri",
        "kosher salt",
        "lemon",
        ". finely parsley",
        "ly black pepper"
      ],
      "searchText": "pantry pasta with vegan cream sauce ½ plus 2 . - olive oil walnuts ½ . red pepper flakes garlic cloves sprigs rosemary . s nellini beans . paccheri kosher salt lemon . finely parsley ly black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/pantry-pasta-with-vegan-cream-sauce",
      "sourceRating": 4.2,
      "sourceRatingCount": 144,
      "translatedTitles": {
        "fr": "Pâtes du placard avec sauce crémeuse végétalienne"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 47,
      "readyInMinutesMin": 49
    },
    {
      "id": "64e37a89-116c-45ea-99ca-d9720b99f917",
      "title": "Panzanella aux agrumes et à la feta",
      "image": "images/64e37a89-116c-45ea-99ca-d9720b99f917_0.jpg",
      "servings": "4",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pamplemousse rose",
        "pamplemousse blanc",
        "oranges navel",
        "de pain rassis",
        "oignon",
        "bloc de 100 de fromage feta",
        "de feuilles de basilic frais",
        "de feuilles de persil plat",
        "d’huile d’olive",
        "de vinaigre de vin blanc",
        "sel et poivre"
      ],
      "searchText": "panzanella aux agrumes et à la feta pamplemousse rose pamplemousse blanc oranges navel de pain rassis oignon bloc de 100 de fromage feta de feuilles de basilic frais de feuilles de persil plat d’huile d’olive de vinaigre de vin blanc sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4787-panzanella-aux-agrumes-et-a-la-feta",
      "sourceRating": 4,
      "sourceRatingCount": 6,
      "translatedTitles": {
        "en": "Citrus and Feta Panzanella"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 51
    },
    {
      "id": "6ae1b485-1204-4bf1-818d-6f525f72e52b",
      "title": "Pasta à la sauce puttanesca",
      "image": "images/6ae1b485-1204-4bf1-818d-6f525f72e52b_0.jpg",
      "servings": "4 portions (900 ml / 3 ⅔ tasses de sauce)",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de beurre ou moitié beurre",
        "gousses d’ail",
        "à 8 filets d’anchois",
        "d’olives kalamata ou italiennes de gaeta",
        "de câpres rincées",
        "à 2 de flocons de piment fort",
        "de tomates italiennes en conserve",
        "de pâtes",
        "poivre du moulin",
        "de persil italien"
      ],
      "searchText": "pasta à la sauce puttanesca de beurre ou moitié beurre gousses d’ail à 8 filets d’anchois d’olives kalamata ou italiennes de gaeta de câpres rincées à 2 de flocons de piment fort de tomates italiennes en conserve de pâtes poivre du moulin de persil italien",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/pasta-a-la-sauce-puttanesca/",
      "sourceRating": 5,
      "sourceRatingCount": 8,
      "translatedTitles": {
        "en": "Pasta with Puttanesca Sauce"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "7f2decec-2e7f-594b-90ac-5fed6ed1b4c7",
      "title": "Pasta Puttanesca",
      "image": "images/7f2decec-2e7f-594b-90ac-5fed6ed1b4c7_0.jpg",
      "servings": "5",
      "readyInMinutes": 41,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "butter",
        "cloves garlic",
        "anchovy fillets",
        "plum tomatoes",
        "tomato puree",
        "black olives",
        "capers",
        "spaghetti or any other pasta",
        "parmesan cheese"
      ],
      "searchText": "pasta puttanesca olive oil butter cloves garlic anchovy fillets plum tomatoes tomato puree black olives capers spaghetti or any other pasta parmesan cheese main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceRating": 5,
      "sourceRatingCount": 11,
      "translatedTitles": {
        "fr": "Pâtes Puttanesca"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 40
    },
    {
      "id": "287f3480-abb8-43e2-86ce-f6bb6d860dd7",
      "title": "Pasta With Mussels in Tomato Sauce",
      "image": "images/287f3480-abb8-43e2-86ce-f6bb6d860dd7_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 101,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "or tomatoes",
        "fat garlic cloves; 1",
        "shallot",
        "dry white wine",
        "mussels",
        "- olive oil",
        "red pepper flakes",
        "thyme or marjoram",
        "pinch sugar",
        "salt to taste",
        "linguine or other pasta",
        "flat leaf parsley"
      ],
      "searchText": "pasta with mussels in tomato sauce or tomatoes fat garlic cloves; 1 shallot dry white wine mussels - olive oil red pepper flakes thyme or marjoram pinch sugar salt to taste linguine or other pasta flat leaf parsley",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1017313-pasta-with-mussels-in-tomato-sauce?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 855,
      "translatedTitles": {
        "fr": "Pâtes aux moules en sauce tomate"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 44,
      "readyInMinutesMin": 86
    },
    {
      "id": "90f9e709-d1fe-4d92-8bb7-bd42f6d25608",
      "title": "Patates farcies à la pancetta",
      "servings": "4",
      "readyInMinutes": 149,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grosses pommes de terre russet",
        "échalote française",
        "de pancetta coupée en petits dés",
        "de beurre",
        "de lait",
        "de fromage emmenthal râpé",
        "de petits pois surgelés",
        "poivre de cayenne"
      ],
      "searchText": "patates farcies à la pancetta grosses pommes de terre russet échalote française de pancetta coupée en petits dés de beurre de lait de fromage emmenthal râpé de petits pois surgelés poivre de cayenne",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7153-patates-farcies-a-la-pancetta",
      "image": "images/90f9e709-d1fe-4d92-8bb7-bd42f6d25608_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 3,
      "translatedTitles": {
        "en": "Pancetta Stuffed Potatoes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 44,
      "readyInMinutesMin": 133
    },
    {
      "id": "71c56f35-fefe-43bd-806d-2f562f1296e7",
      "title": "Pâté rustique à la viande",
      "servings": "8",
      "readyInMinutes": 163,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "farce",
        "céleri-rave moyen",
        "d’huile d’olive",
        "oignon",
        "de porc haché maigre",
        "de bouillon de poulet",
        "de chapelure",
        "de nelle moulue",
        "de clou de girofle moulu",
        "de dattes dénoyautées et coupées en dés",
        "croûte",
        "de farine tout usage non blanchie",
        "de beurre froid",
        "d’eau glacée",
        "lait",
        "garniture",
        "branche de céleri",
        "de jus de citron",
        "d’huile d’olive",
        "de persil ciselé"
      ],
      "searchText": "pâté rustique à la viande farce céleri-rave moyen d’huile d’olive oignon de porc haché maigre de bouillon de poulet de chapelure de nelle moulue de clou de girofle moulu de dattes dénoyautées et coupées en dés croûte de farine tout usage non blanchie de beurre froid d’eau glacée lait garniture branche de céleri de jus de citron d’huile d’olive de persil ciselé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8220-pate-rustique-a-la-viande",
      "image": "images/71c56f35-fefe-43bd-806d-2f562f1296e7_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 15,
      "translatedTitles": {
        "en": "Rustic Meat Pie"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 48,
      "readyInMinutesMin": 163
    },
    {
      "id": "3c15f326-cbf5-4dbc-b055-f16db228b5b4",
      "title": "Pâtes au lapin et carottes",
      "image": "images/3c15f326-cbf5-4dbc-b055-f16db228b5b4_0.jpg",
      "servings": "4",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [],
      "searchText": "pâtes au lapin et carottes plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Pasta with rabbit and carrots"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "c2afe702-9a17-40b5-8ddf-640e9aba9b2b",
      "title": "Pâtes au thon et au citron",
      "image": "images/c2afe702-9a17-40b5-8ddf-640e9aba9b2b_0.jpg",
      "servings": "4 personnes",
      "readyInMinutes": 38,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de pâtes complètes",
        "boites de thon au naturel",
        "roquette",
        "de parmesan",
        "citron bio",
        "fleurs de câpres",
        "cuillerées à soupe d'huile d'olive",
        "sel"
      ],
      "searchText": "pâtes au thon et au citron de pâtes complètes boites de thon au naturel roquette de parmesan citron bio fleurs de câpres cuillerées à soupe d'huile d'olive sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://turbigo-gourmandises.fr/pates-thon-citron/",
      "sourceRating": 4.04,
      "sourceRatingCount": 26,
      "translatedTitles": {
        "en": "Tuna and Lemon Pasta"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 38
    },
    {
      "id": "e5a47be0-8474-441d-8aa4-019491f7d5bd",
      "title": "Pâtes aux poireaux et prosciutto (À la Di Stasio)",
      "image": "images/e5a47be0-8474-441d-8aa4-019491f7d5bd_0.jpg",
      "servings": "1",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de pâtes courtes au choix : tortiglioni",
        "une bonne noix de beurre",
        "blancs de poireaux émincés",
        "environ 1/4 tasse de bouillon de poulet",
        "environ 1/4 tasse de crème à de m. .",
        "prosciutto émincé",
        "fromage savello ou fromage de brebis sec du québec ou parmesan fraîchement râpé"
      ],
      "searchText": "pâtes aux poireaux et prosciutto (à la di stasio) de pâtes courtes au choix : tortiglioni une bonne noix de beurre blancs de poireaux émincés environ 1/4 tasse de bouillon de poulet environ 1/4 tasse de crème à de m. . prosciutto émincé fromage savello ou fromage de brebis sec du québec ou parmesan fraîchement râpé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://recettesdemichou.e-monsite.com/pages/saveurs-d-italie/pates-aux-poireaux-et-prosciutto.html",
      "translatedTitles": {
        "en": "Pasta with Leeks and Prosciutto (Di Stasio Style)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 34
    },
    {
      "id": "f06872f1-9b1d-4572-8dae-e7973bafa4cc",
      "title": "Pâtes aux saucisses italiennes et courgettes, sauce aux poivrons rouges",
      "image": "images/f06872f1-9b1d-4572-8dae-e7973bafa4cc_0.jpg",
      "servings": "4",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de poivrons rouges rôtis en pot",
        "tasse de tomates séchées dans l’huile",
        "tasse de basilic",
        "c. à soupe de vinaigre balsamique",
        "tasse d’huile d’olive",
        "c. à thé (1",
        "c. à thé (1",
        "gousse d’ail",
        "de pâtes sans gluten",
        "c. à soupe d’huile d’olive",
        "tasse de noix de pin",
        "courgette",
        "saucisses italiennes",
        "petite gousse d’ail",
        "tasse de basilic haché",
        "sel et poivre"
      ],
      "searchText": "pâtes aux saucisses italiennes et courgettes, sauce aux poivrons rouges tasse de poivrons rouges rôtis en pot tasse de tomates séchées dans l’huile tasse de basilic c. à soupe de vinaigre balsamique tasse d’huile d’olive c. à thé (1 c. à thé (1 gousse d’ail de pâtes sans gluten c. à soupe d’huile d’olive tasse de noix de pin courgette saucisses italiennes petite gousse d’ail tasse de basilic haché sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/pates-aux-saucisses-italiennes-et-courgettes-sauce-aux-poivrons-rouges/",
      "translatedTitles": {
        "en": "Pasta with Italian sausage and zucchini, red pepper sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 43,
      "readyInMinutesMin": 46
    },
    {
      "id": "523711e6-b5b2-48bf-a5df-680ee1230468",
      "title": "Pattes d'ours maison",
      "image": "images/523711e6-b5b2-48bf-a5df-680ee1230468_0.jpg",
      "servings": "16 portions",
      "readyInMinutes": 53,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grosse patate douce ou 250 de chair en purée)",
        "de beurre",
        "de vinaigre de cidre",
        "de cassonade léèrement tassée",
        "de mélasse",
        "oeuf",
        "de nelle",
        "de muscade moulue",
        "de gingembre moulu",
        "de farine tout usage non blanchie",
        "de graines de lin moulues",
        "farine tout usage non blanchie"
      ],
      "searchText": "pattes d'ours maison grosse patate douce ou 250 de chair en purée) de beurre de vinaigre de cidre de cassonade léèrement tassée de mélasse oeuf de nelle de muscade moulue de gingembre moulu de farine tout usage non blanchie de graines de lin moulues farine tout usage non blanchie collation",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2628/pattes-d-ours-maison",
      "translatedTitles": {
        "en": "Homemade Bear Paws"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 51
    },
    {
      "id": "baf29e34-cc03-4f27-b2ff-06005e5f7eca",
      "title": "Pêches grillées au barbecue et framboises",
      "image": "images/baf29e34-cc03-4f27-b2ff-06005e5f7eca_0.jpg",
      "servings": "4",
      "readyInMinutes": 28,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de framboises fraîches",
        "de sucre",
        "petites pêches mûres",
        "boules de crème glacée à la vanille"
      ],
      "searchText": "pêches grillées au barbecue et framboises de framboises fraîches de sucre petites pêches mûres boules de crème glacée à la vanille",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9039-peches-grillees-au-barbecue-et-framboises",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Grilled Peaches and Raspberries"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 28
    },
    {
      "id": "15d3fae8-a02f-41a8-8297-e2361f252f1a",
      "title": "Petits pains au lait",
      "image": "images/15d3fae8-a02f-41a8-8297-e2361f252f1a_0.jpg",
      "servings": "12",
      "readyInMinutes": 253,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de lait tiède",
        "de sucre",
        "de levure instantanée",
        "d'huile d'olive",
        "de farine tout usage non blanchie",
        "huile d'olive pour badigeonner"
      ],
      "searchText": "petits pains au lait de lait tiède de sucre de levure instantanée d'huile d'olive de farine tout usage non blanchie huile d'olive pour badigeonner plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6660-petits-pains-au-lait",
      "sourceRating": 4,
      "sourceRatingCount": 91,
      "translatedTitles": {
        "en": "Small Milk Breads"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 253
    },
    {
      "id": "f181adc6-cff1-4bc6-9459-7d54b4eb7d7d",
      "title": "Petits pancakes aux bleuets",
      "image": "images/f181adc6-cff1-4bc6-9459-7d54b4eb7d7d_0.jpg",
      "servings": "12",
      "readyInMinutes": 21,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de farine tout usage non blanchie",
        "de poudre à pâte",
        "œufs",
        "de sucre",
        "de yogourt nature",
        "d’it de vanille",
        "de lait",
        "de bleuets frais",
        "beurre ramolli",
        "sirop d’érable"
      ],
      "searchText": "petits pancakes aux bleuets de farine tout usage non blanchie de poudre à pâte œufs de sucre de yogourt nature d’it de vanille de lait de bleuets frais beurre ramolli sirop d’érable petit-déjeuner",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8659-petits-pancakes-aux-bleuets",
      "sourceRating": 5,
      "sourceRatingCount": 17,
      "translatedTitles": {
        "en": "Small Blueberry Pancakes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 20
    },
    {
      "id": "c1dd206d-da25-46ed-b1f2-481d2af51847",
      "title": "Pétoncles au parfum de citron et de basilic",
      "servings": "4",
      "readyInMinutes": 63,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "crème citronnée",
        "de crème à cuisson",
        "de bouillon de poulet",
        "le zeste râpé d’un citron",
        "de jus de citron",
        "sel et poivre",
        "huile de basilic",
        "d’huile d’olive",
        "de basilic frais",
        "sel et poivre",
        "julienne de légumes",
        "de beurre",
        "carottes",
        "poireau",
        "pétoncles",
        "gros pétoncles",
        "d’huile d’olive",
        "sel et poivre"
      ],
      "searchText": "pétoncles au parfum de citron et de basilic crème citronnée de crème à cuisson de bouillon de poulet le zeste râpé d’un citron de jus de citron sel et poivre huile de basilic d’huile d’olive de basilic frais sel et poivre julienne de légumes de beurre carottes poireau pétoncles gros pétoncles d’huile d’olive sel et poivre plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4499-petoncles-au-parfum-de-citron-et-de-basilic",
      "image": "images/c1dd206d-da25-46ed-b1f2-481d2af51847_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 161,
      "translatedTitles": {
        "en": "Scallops with lemon and basil scent"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 63
    },
    {
      "id": "9f44d36b-f406-49dd-bb4b-d3ae6d531e2d",
      "title": "Pilons de poulet laqués à l'érable",
      "image": "images/9f44d36b-f406-49dd-bb4b-d3ae6d531e2d_0.jpg",
      "servings": "4",
      "readyInMinutes": 355,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pilons de poulet avec la peau",
        "de sirop d’érable",
        "de sauce chili à base de tomate",
        "de vinaigre de vin blanc",
        "gousses d’ail"
      ],
      "searchText": "pilons de poulet laqués à l'érable pilons de poulet avec la peau de sirop d’érable de sauce chili à base de tomate de vinaigre de vin blanc gousses d’ail",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5774-pilons-de-poulet-laques-a-l-erable",
      "sourceRating": 4,
      "sourceRatingCount": 120,
      "translatedTitles": {
        "en": "Maple-Glazed Chicken Drumsticks"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 43,
      "readyInMinutesMin": 170
    },
    {
      "id": "3c40bdaa-435b-42ef-88b8-aaa54ec916d9",
      "title": "Pineapple Pork Adobo",
      "image": "images/3c40bdaa-435b-42ef-88b8-aaa54ec916d9_0.jpg",
      "servings": "4–6 servings",
      "readyInMinutes": 138,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ripe pineapple",
        ". plus 2 . vegetable oil",
        ". boneless pork shoulder",
        "kosher salt",
        "½ white onion",
        "garlic cloves",
        "⅔ e vinegar or unseasoned rice vinegar",
        "½ datu puti soy sauce or ⅓ other brands soy sauce",
        ". oyster sauce",
        ". black peppercorns",
        "bay leaves",
        "steamed white rice and thinly scallions"
      ],
      "searchText": "pineapple pork adobo ripe pineapple . plus 2 . vegetable oil . boneless pork shoulder kosher salt ½ white onion garlic cloves ⅔ e vinegar or unseasoned rice vinegar ½ datu puti soy sauce or ⅓ other brands soy sauce . oyster sauce . black peppercorns bay leaves steamed white rice and thinly scallions",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/pineapple-pork-adobo",
      "sourceRating": 4.5,
      "sourceRatingCount": 120,
      "translatedTitles": {
        "fr": "Adobo de porc à l'ananas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 74,
      "readyInMinutesMin": 124
    },
    {
      "id": "07efa55c-e343-42a0-9628-ceb1f1fd5e96",
      "title": "Pineapple-Marinated Chicken Breasts",
      "image": "images/07efa55c-e343-42a0-9628-ceb1f1fd5e96_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "packed dark brown sugar",
        "rice vinegar",
        "soy sauce",
        "fish sauce",
        "olive oil",
        "kosher salt",
        "garlic powder",
        "to 1/2 cayenne",
        "black pepper",
        "pineapple",
        "finely red onion",
        "finely cilantro",
        "finely grated pineapple",
        "boneless",
        "cooked white rice"
      ],
      "searchText": "pineapple-marinated chicken breasts packed dark brown sugar rice vinegar soy sauce fish sauce olive oil kosher salt garlic powder to 1/2 cayenne black pepper pineapple finely red onion finely cilantro finely grated pineapple boneless cooked white rice",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022239-pineapple-marinated-chicken-breasts",
      "sourceRating": 4,
      "sourceRatingCount": 4375,
      "translatedTitles": {
        "fr": "Poitrines de poulet marinées à l'ananas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 48
    },
    {
      "id": "371eb684-0923-4b30-9376-0295c8ffcd83",
      "title": "Pineapple-Marinated Chicken Breasts",
      "image": "images/371eb684-0923-4b30-9376-0295c8ffcd83_0.jpg",
      "servings": "4",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "packed dark brown sugar",
        "rice vinegar",
        "soy sauce",
        "fish sauce",
        "olive oil",
        "kosher salt",
        "garlic powder",
        "to 1/2 cayenne",
        "black pepper",
        "pineapple",
        "finely red onion",
        "finely cilantro",
        "finely grated pineapple",
        "boneless",
        "cooked white rice"
      ],
      "searchText": "pineapple-marinated chicken breasts packed dark brown sugar rice vinegar soy sauce fish sauce olive oil kosher salt garlic powder to 1/2 cayenne black pepper pineapple finely red onion finely cilantro finely grated pineapple boneless cooked white rice",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022239-pineapple-marinated-chicken-breasts",
      "sourceRating": 4,
      "sourceRatingCount": 4375,
      "translatedTitles": {
        "fr": "Poitrines de poulet marinées à l'ananas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 48
    },
    {
      "id": "d330b46b-840c-4db5-af41-2760fa47d767",
      "title": "Pitas de salade de crevettes nordiques, maïs grillé et avocat",
      "image": "images/d330b46b-840c-4db5-af41-2760fa47d767_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "épis de maïs frais",
        "de crevettes nordiques",
        "¼ d’oignon rouge",
        "½ poivron rouge",
        "concombre libanais",
        "de coriandre fraîche",
        "le jus d’une lime",
        "une pincée de piment rouge broyé",
        "de mayonnaise",
        "la chair d’un avocat",
        "pitas coupés en deux",
        "feuilles de laitue frisée"
      ],
      "searchText": "pitas de salade de crevettes nordiques, maïs grillé et avocat épis de maïs frais de crevettes nordiques ¼ d’oignon rouge ½ poivron rouge concombre libanais de coriandre fraîche le jus d’une lime une pincée de piment rouge broyé de mayonnaise la chair d’un avocat pitas coupés en deux feuilles de laitue frisée plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://avocadosfrommexico.ca/fr/recettes/pitas-de-salade-de-crevettes-nordiques-mais-grille-et-avocat/",
      "translatedTitles": {
        "en": "Northern shrimp salad pitas, grilled corn and avocado"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 46
    },
    {
      "id": "d4cb7297-cf9e-439f-af7a-6d3c028b8521",
      "title": "Pitas de souvlaki simples au poulet et au Tzatziki",
      "image": "images/d4cb7297-cf9e-439f-af7a-6d3c028b8521_0.jpg",
      "servings": "4",
      "readyInMinutes": 138,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe huile d’olive",
        "c. à soupe vinaigre de vin rouge",
        "gousses ail",
        "c. à thé (2",
        "c. à thé (1",
        "c. à thé origan",
        "tasse concombre anglais",
        "tasse laitue romaine",
        "tasse tomates cerise",
        "pains pitas de blé entier",
        "tasse yogourt nature",
        "tasse crème sure",
        "tasse concombre anglais",
        "gousses ail",
        "c. à thé jus de citron",
        "c. à thé zeste de citron",
        "c. à thé (1",
        "c. à thé aneth"
      ],
      "searchText": "pitas de souvlaki simples au poulet et au tzatziki c. à soupe huile d’olive c. à soupe vinaigre de vin rouge gousses ail c. à thé (2 c. à thé (1 c. à thé origan tasse concombre anglais tasse laitue romaine tasse tomates cerise pains pitas de blé entier tasse yogourt nature tasse crème sure tasse concombre anglais gousses ail c. à thé jus de citron c. à thé zeste de citron c. à thé (1 c. à thé aneth plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.poulet.ca/recettes/pitas-de-souvlaki-simples-au-poulet-et-au-tzatziki",
      "translatedTitles": {
        "en": "Simple Chicken Souvlaki Pitas with Tzatziki"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 47,
      "readyInMinutesMin": 138
    },
    {
      "id": "46622e62-718b-42f1-b024-d5dd1ce9860d",
      "title": "Pizza minute",
      "image": "images/46622e62-718b-42f1-b024-d5dd1ce9860d_0.jpg",
      "servings": "4",
      "readyInMinutes": 29,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sauce",
        "d’huile d’olive",
        "de pâte de tomates",
        "petite gousse d’ail",
        "sel et poivre",
        "pizza",
        "pains naans",
        "tortillas",
        "de garnitures au choix (poivrons",
        "de fromage mozzarella râpé"
      ],
      "searchText": "pizza minute sauce d’huile d’olive de pâte de tomates petite gousse d’ail sel et poivre pizza pains naans tortillas de garnitures au choix (poivrons de fromage mozzarella râpé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6493-pizza-minute",
      "sourceRating": 5,
      "sourceRatingCount": 93,
      "translatedTitles": {
        "en": "Minute Pizza"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 27
    },
    {
      "id": "e7c6d29a-c19d-4f17-a869-038205a9c7e3",
      "title": "Plaque de bœuf et de légumes grillés au vinaigre balsamique",
      "image": "images/e7c6d29a-c19d-4f17-a869-038205a9c7e3_0.jpg",
      "servings": "6",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "courgettes",
        "oignon rouge",
        "poivrons",
        "champignons blancs",
        "radis",
        "vinaigre balsamique",
        "moutarde de dijon",
        "huile d’olive",
        "miel",
        "poivre et sel",
        "bœuf à fondue"
      ],
      "searchText": "plaque de bœuf et de légumes grillés au vinaigre balsamique courgettes oignon rouge poivrons champignons blancs radis vinaigre balsamique moutarde de dijon huile d’olive miel poivre et sel bœuf à fondue plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/plaque-boeuf-legumes-vinaigre-balsamique/",
      "sourceRating": 4,
      "sourceRatingCount": 30,
      "translatedTitles": {
        "en": "Sheet Pan Balsamic Grilled Beef and Vegetables"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 51
    },
    {
      "id": "71bdf27a-624c-4201-bff8-8be7799fc807",
      "title": "Plaque de crevettes, haricots noirs et chorizo",
      "image": "images/71bdf27a-624c-4201-bff8-8be7799fc807_0.jpg",
      "servings": "4",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de tomates cerises",
        "de saucisson chorizo",
        "oignon",
        "d’huile d’olive",
        "de crevettes",
        "de paprika doux",
        "boîte de 540 de haricots noirs",
        "avocat",
        "quartiers de lime",
        "feuilles de coriandre"
      ],
      "searchText": "plaque de crevettes, haricots noirs et chorizo de tomates cerises de saucisson chorizo oignon d’huile d’olive de crevettes de paprika doux boîte de 540 de haricots noirs avocat quartiers de lime feuilles de coriandre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8166-plaque-de-crevettes-haricots-noirs-et-chorizo",
      "sourceRating": 5,
      "sourceRatingCount": 62,
      "translatedTitles": {
        "en": "Sheet Pan Shrimp, Black Beans, and Chorizo"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 51
    },
    {
      "id": "16dcf99e-1867-4019-874d-2782984d420b",
      "title": "Plaque de pizza familiale",
      "image": "images/16dcf99e-1867-4019-874d-2782984d420b_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 217,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de farine tout-usage",
        "de sucre",
        "de sel",
        "de levure à pizza ou à levée rapide",
        "d’eau tiède",
        "conserve de 796 de tomates italiennes",
        "gousses d’ail",
        "d’huile d’olive",
        "de crème fraîche",
        "tranches de jambon blanc",
        "de pistaches hachées",
        "de mozzarella râpée",
        "de sauce tomate",
        "quelques lanières de poivron vert",
        "fonds d’artichauts",
        "d’herbes fraîches hachées (ciboulette",
        "de mozzarella râpée",
        "de sauce tomate",
        "quelques lanières de poivron vert",
        "de chair à saucisse italienne",
        "d’épinards",
        "de mozzarella râpée",
        "de sauce tomate",
        "quelques lanières de poivron vert",
        "tomates cerises",
        "de piments pepperoncinis marinés tranchés",
        "de mozzarella râpée"
      ],
      "searchText": "plaque de pizza familiale de farine tout-usage de sucre de sel de levure à pizza ou à levée rapide d’eau tiède conserve de 796 de tomates italiennes gousses d’ail d’huile d’olive de crème fraîche tranches de jambon blanc de pistaches hachées de mozzarella râpée de sauce tomate quelques lanières de poivron vert fonds d’artichauts d’herbes fraîches hachées (ciboulette de mozzarella râpée de sauce tomate quelques lanières de poivron vert de chair à saucisse italienne d’épinards de mozzarella râpée de sauce tomate quelques lanières de poivron vert tomates cerises de piments pepperoncinis marinés tranchés de mozzarella râpée plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/5812/plaque-de-pizza-familiale",
      "translatedTitles": {
        "en": "Family Sheet Pan Pizza"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 42,
      "readyInMinutesMin": 217
    },
    {
      "id": "beb7d67e-9519-443d-9fe6-c9b36205b795",
      "title": "Plaque de pommes de terre vide-frigo",
      "image": "images/beb7d67e-9519-443d-9fe6-c9b36205b795_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 79,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de moutarde à l'ancienne",
        "d'huile d'olive",
        "d'eau",
        "d'ail haché en pot",
        "poivre et sel",
        "ou 3 pommes de terre moyennes",
        "de légumes surgelés au choix : petits pois",
        "de saumon frais coupé en dés de 1 cm",
        "de yogourt grec",
        "le zeste de 1 citron",
        "fines herbes fraîches hachées au goût : aneth"
      ],
      "searchText": "plaque de pommes de terre vide-frigo de moutarde à l'ancienne d'huile d'olive d'eau d'ail haché en pot poivre et sel ou 3 pommes de terre moyennes de légumes surgelés au choix : petits pois de saumon frais coupé en dés de 1 cm de yogourt grec le zeste de 1 citron fines herbes fraîches hachées au goût : aneth",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/2693/plaque-de-pommes-de-terre-vide-frigo",
      "sourceRating": 4,
      "sourceRatingCount": 19,
      "translatedTitles": {
        "en": "Empty-Fridge Potato Sheet Pan"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 77
    },
    {
      "id": "cf7fef83-8c38-4c1e-bd1e-193e2b5ad1bf",
      "title": "Plaque de poulet au fenouil, abricots et olives",
      "image": "images/cf7fef83-8c38-4c1e-bd1e-193e2b5ad1bf_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 90,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d'huile d'olive",
        "de vinaigre de vin rouge",
        "de confiture d’abricots",
        "d'origan séché",
        "cuisses de poulet avec la peau ou pilons avec la peau",
        "petit fenouil coupé en quartiers",
        "petits oignons rouges pelés et coupés en quartiers",
        "pommes de terre grelots rouges coupées en 2",
        "gousses d'ail en chemise",
        "abricots séchés",
        "olives vertes dénoyautées",
        "sel et poivre du moulin"
      ],
      "searchText": "plaque de poulet au fenouil, abricots et olives d'huile d'olive de vinaigre de vin rouge de confiture d’abricots d'origan séché cuisses de poulet avec la peau ou pilons avec la peau petit fenouil coupé en quartiers petits oignons rouges pelés et coupés en quartiers pommes de terre grelots rouges coupées en 2 gousses d'ail en chemise abricots séchés olives vertes dénoyautées sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/6333/plaque-de-poulet-au-fenouil-abricots-et-olives",
      "sourceRating": 5,
      "sourceRatingCount": 12,
      "translatedTitles": {
        "en": "Sheet Pan Chicken with Fennel, Apricots, and Olives"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 90
    },
    {
      "id": "ab3c8e9d-b1a4-4861-9804-348016bdc6dc",
      "title": "Plaque saucisses, brocolis et poivrons rouges",
      "image": "images/ab3c8e9d-b1a4-4861-9804-348016bdc6dc_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 62,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "l de brocolis",
        "poivrons rouges",
        "ou 6 échalotes grises moyennes",
        "+ 30 d’huile d’olive",
        "de vinaigre de xérès ou de vin rouge",
        "de miel liquide",
        "de sel",
        "poivre du moulin",
        "saucisses italiennes",
        "mayonnaise",
        "pesto"
      ],
      "searchText": "plaque saucisses, brocolis et poivrons rouges l de brocolis poivrons rouges ou 6 échalotes grises moyennes + 30 d’huile d’olive de vinaigre de xérès ou de vin rouge de miel liquide de sel poivre du moulin saucisses italiennes mayonnaise pesto plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/plaque-de-saucisses-brocolis-et-poivrons-rouges/",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Sheet pan sausages, broccoli and red peppers"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 62
    },
    {
      "id": "ba1b4ce3-e5ca-461e-ba9e-805045ab9004",
      "title": "Pois chiches croustillants",
      "image": "images/ba1b4ce3-e5ca-461e-ba9e-805045ab9004_0.jpg",
      "servings": "4",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "légumineuses",
        "de pois chiches",
        "rincés et égouttés 15 d'huile véétale 10 de poudre de chilli 5 de paprika fumé 15 de levure alimentaire 2",
        "de sel poivre au gout"
      ],
      "searchText": "pois chiches croustillants légumineuses de pois chiches rincés et égouttés 15 d'huile véétale 10 de poudre de chilli 5 de paprika fumé 15 de levure alimentaire 2 de sel poivre au gout",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "fr",
      "sourceUrl": "https://equipenutrition.ca/recette-nutritionniste-dietetiste/pois-chiches-croustillants",
      "translatedTitles": {
        "en": "Crispy Chickpeas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 6,
      "readyInMinutesMin": 46
    },
    {
      "id": "7633d7d4-6f67-4c4b-afe2-7b98145514b7",
      "title": "Poisson en croûte de noix, betteraves jaunes minute et huile de ciboulette",
      "image": "images/7633d7d4-6f67-4c4b-afe2-7b98145514b7_0.jpg",
      "servings": "4",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poisson et betteraves",
        "betteraves jaunes",
        "d’huile d’olive",
        "de mayonnaise",
        "de filets d’aiglefin",
        "d’amandes",
        "de graines de tournesol",
        "de graines de pavot",
        "huile à la ciboulette",
        "d’huile d’olive",
        "de ciboulette ciselée",
        "citron"
      ],
      "searchText": "poisson en croûte de noix, betteraves jaunes minute et huile de ciboulette poisson et betteraves betteraves jaunes d’huile d’olive de mayonnaise de filets d’aiglefin d’amandes de graines de tournesol de graines de pavot huile à la ciboulette d’huile d’olive de ciboulette ciselée citron",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8549-poisson-en-croute-de-noix-betteraves-jaunes-minute-et-huile-de-ciboulette",
      "sourceRating": 5,
      "sourceRatingCount": 29,
      "translatedTitles": {
        "en": "Fish in nut crust, minute yellow beets and chive oil"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 46
    },
    {
      "id": "8d709b01-bb7f-4365-ae4a-fe5824a198b6",
      "title": "Poitrine de dinde à l’érable",
      "image": "images/8d709b01-bb7f-4365-ae4a-fe5824a198b6_0.jpg",
      "servings": "6 portions",
      "readyInMinutes": 170,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gros oignon",
        "têtes d’ail",
        "d’huile d’olive",
        "de sirop d’érable",
        "à 5 tiges de romarin frais",
        "de beurre ramolli",
        "de sucre d’érable",
        "de moutarde de dijon",
        "sel et poivre",
        "rôti de dinde désossé de 1 (2"
      ],
      "searchText": "poitrine de dinde à l’érable gros oignon têtes d’ail d’huile d’olive de sirop d’érable à 5 tiges de romarin frais de beurre ramolli de sucre d’érable de moutarde de dijon sel et poivre rôti de dinde désossé de 1 (2",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://erableduquebec.ca/recettes/poitrine-de-dinde-a-lerable/",
      "translatedTitles": {
        "en": "Maple Turkey Breast"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 170
    },
    {
      "id": "0ff9a5b7-1a57-407b-ad47-3987bc871944",
      "title": "Poitrine de dinde rôtie aux pommes",
      "image": "images/0ff9a5b7-1a57-407b-ad47-3987bc871944_0.jpg",
      "servings": "4 - 6 portions",
      "readyInMinutes": 113,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poitrine de dinde désossée et sans la peau",
        "c. à thé de sel",
        "c. à thé de poivre",
        "c. à thé de sauge séchée",
        "c. à soupe de beurre",
        "oignon moyen haché",
        "tranches de bacon hachées",
        "pommes à cuire acidulées évidées et tranchées",
        "c. à soupe de farine tout usage",
        "tasse de lait",
        "tasse de bouillon de poulet",
        "c. à soupe de jus de citron",
        "sel et poivre au goût"
      ],
      "searchText": "poitrine de dinde rôtie aux pommes poitrine de dinde désossée et sans la peau c. à thé de sel c. à thé de poivre c. à thé de sauge séchée c. à soupe de beurre oignon moyen haché tranches de bacon hachées pommes à cuire acidulées évidées et tranchées c. à soupe de farine tout usage tasse de lait tasse de bouillon de poulet c. à soupe de jus de citron sel et poivre au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://producteurslaitiersducanada.ca/fr/plaisirs-laitiers/recettes/poitrine-de-dinde-rotie-aux-pommes",
      "translatedTitles": {
        "en": "Roasted Turkey Breast with Apples"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 46,
      "readyInMinutesMin": 112
    },
    {
      "id": "24a988f2-a4c1-4218-ab07-609f7e326f84",
      "title": "Poivrons farcis au boeuf et au cari",
      "image": "images/24a988f2-a4c1-4218-ab07-609f7e326f84_0.jpg",
      "servings": "6 portion(s)",
      "readyInMinutes": 117,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poivrons (jaunes",
        "de patates douces",
        "oignon",
        "d'huile dolive",
        "de boeuf haché maigre",
        "gousses d'ail",
        "de poudre de cari",
        "pincée de poivre de cayenne",
        "tomates italiennes",
        "boîte de 540 de haricots blancs",
        "de miel",
        "de persil plat ciselé",
        "sel et poivre",
        "yogourt nature"
      ],
      "searchText": "poivrons farcis au boeuf et au cari poivrons (jaunes de patates douces oignon d'huile dolive de boeuf haché maigre gousses d'ail de poudre de cari pincée de poivre de cayenne tomates italiennes boîte de 540 de haricots blancs de miel de persil plat ciselé sel et poivre yogourt nature",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/1111-poivrons-farcis-au-boeuf-et-au-cari",
      "sourceRating": 5,
      "sourceRatingCount": 95,
      "translatedTitles": {
        "en": "Stuffed peppers with beef and curry"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 45,
      "readyInMinutesMin": 117
    },
    {
      "id": "f80c2f72-0383-4a7f-b6dc-411f3b7efca9",
      "title": "Poke Bowl",
      "image": "images/f80c2f72-0383-4a7f-b6dc-411f3b7efca9_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 176,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "soy sauce",
        "mirin or rice vinegar",
        "toasted sesame oil",
        "granulated sugar",
        "red pepper",
        "sushi-grade tuna (yellowfin",
        "scallion",
        "sesame seeds",
        "sushi or calrose rice",
        "rice vinegar",
        "granulated sugar",
        "kosher salt",
        "kewpie mayonnaise",
        "sriracha or hot sauce of choice",
        "store-bought seaweed salad",
        "shelled and cooked edamame",
        "ripe avocado",
        "mango",
        "persian cucumber",
        "scallion",
        "radishes",
        "pickled ginger",
        "furikake"
      ],
      "searchText": "poke bowl soy sauce mirin or rice vinegar toasted sesame oil granulated sugar red pepper sushi-grade tuna (yellowfin scallion sesame seeds sushi or calrose rice rice vinegar granulated sugar kosher salt kewpie mayonnaise sriracha or hot sauce of choice store-bought seaweed salad shelled and cooked edamame ripe avocado mango persian cucumber scallion radishes pickled ginger furikake",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024634-poke-bowl?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 914,
      "translatedTitles": {
        "fr": "Poke Bowl"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 171
    },
    {
      "id": "94ac7881-71a0-4144-9870-714fac7224ab",
      "title": "Poke Bowl",
      "image": "images/94ac7881-71a0-4144-9870-714fac7224ab_0.jpg",
      "servings": "4",
      "readyInMinutes": 168,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "soy sauce",
        "mirin or rice vinegar",
        "toasted sesame oil",
        "granulated sugar",
        "red pepper",
        "sushi-grade tuna (yellowfin",
        "scallion",
        "sesame seeds",
        "sushi or calrose rice",
        "rice vinegar",
        "granulated sugar",
        "kosher salt",
        "kewpie mayonnaise",
        "sriracha or hot sauce of choice",
        "store-bought seaweed salad",
        "shelled and cooked edamame",
        "ripe avocado",
        "mango",
        "persian cucumber",
        "scallion",
        "radishes",
        "pickled ginger",
        "furikake"
      ],
      "searchText": "poke bowl soy sauce mirin or rice vinegar toasted sesame oil granulated sugar red pepper sushi-grade tuna (yellowfin scallion sesame seeds sushi or calrose rice rice vinegar granulated sugar kosher salt kewpie mayonnaise sriracha or hot sauce of choice store-bought seaweed salad shelled and cooked edamame ripe avocado mango persian cucumber scallion radishes pickled ginger furikake",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024634-poke-bowl?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 914,
      "translatedTitles": {
        "fr": "Poke Bowl"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 163
    },
    {
      "id": "2c3bc375-551d-4b78-a84f-8b73b08dadb3",
      "title": "Pollo a la Piña (Pineapple Chicken)",
      "image": "images/2c3bc375-551d-4b78-a84f-8b73b08dadb3_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 73,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "orange juice",
        "to 5 guajillo chiles",
        "chipotle chiles in adobo",
        "oregano",
        "¼ cinnamon",
        "½ boneless",
        "vegetable oil",
        "½ pineapple or 1 of pineapple rings",
        "½ onion",
        "garlic cloves",
        "kosher salt",
        "warm corn tortillas"
      ],
      "searchText": "pollo a la piña (pineapple chicken) orange juice to 5 guajillo chiles chipotle chiles in adobo oregano ¼ cinnamon ½ boneless vegetable oil ½ pineapple or 1 of pineapple rings ½ onion garlic cloves kosher salt warm corn tortillas",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026321-pollo-a-la-pina-pineapple-chicken?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1210,
      "translatedTitles": {
        "fr": "Pollo a la Piña (Poulet Ananas)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 50,
      "readyInMinutesMin": 69
    },
    {
      "id": "1957bb30-c2fc-474f-9655-81a8561046e4",
      "title": "Pollo a la Piña (Pineapple Chicken)",
      "image": "images/1957bb30-c2fc-474f-9655-81a8561046e4_0.jpg",
      "servings": "4",
      "readyInMinutes": 73,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "orange juice",
        "to 5 guajillo chiles",
        "chipotle chiles in adobo",
        "oregano",
        "¼ cinnamon",
        "½ boneless",
        "vegetable oil",
        "½ pineapple or 1 of pineapple rings",
        "½ onion",
        "garlic cloves",
        "kosher salt",
        "warm corn tortillas"
      ],
      "searchText": "pollo a la piña (pineapple chicken) orange juice to 5 guajillo chiles chipotle chiles in adobo oregano ¼ cinnamon ½ boneless vegetable oil ½ pineapple or 1 of pineapple rings ½ onion garlic cloves kosher salt warm corn tortillas",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026321-pollo-a-la-pina-pineapple-chicken?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1210,
      "translatedTitles": {
        "fr": "Pollo a la Piña (Poulet à l'Ananas)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 50,
      "readyInMinutesMin": 69
    },
    {
      "id": "9e4dcc92-8226-4104-b8bf-9f8661c3da51",
      "title": "Pommes de terre grelots rôties à l'érable",
      "image": "images/9e4dcc92-8226-4104-b8bf-9f8661c3da51_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 60,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pommes de terre grelots",
        "d'huile d'olive",
        "gousses d'ail",
        "de sirop d'érable",
        "de graines de coriandre concassées",
        "de poivre noir concassé",
        "de paes hachées grossièrement",
        "sel"
      ],
      "searchText": "pommes de terre grelots rôties à l'érable pommes de terre grelots d'huile d'olive gousses d'ail de sirop d'érable de graines de coriandre concassées de poivre noir concassé de paes hachées grossièrement sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/1058-pommes-de-terre-grelots-roties-a-l-erable",
      "sourceRating": 5,
      "sourceRatingCount": 33,
      "translatedTitles": {
        "en": "Maple Roasted Baby Potatoes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 55
    },
    {
      "id": "1ffbcc8c-e38b-43f7-b5c4-02b13f07871b",
      "title": "Potage au chou-fleur",
      "image": "images/1ffbcc8c-e38b-43f7-b5c4-02b13f07871b_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 44,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "sel et poivre"
      ],
      "searchText": "potage au chou-fleur oignon sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4955-potage-au-chou-fleur",
      "sourceRating": 5,
      "sourceRatingCount": 86,
      "translatedTitles": {
        "en": "Cauliflower Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 9,
      "readyInMinutesMin": 29
    },
    {
      "id": "95fe4c79-c8b5-49a7-bd96-a896471cc8b3",
      "title": "Potage aux asperges et au cari",
      "image": "images/95fe4c79-c8b5-49a7-bd96-a896471cc8b3_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de beurre ou d’huile de noix de coco vierge",
        "petit oignon haché",
        "de pommes de terre pelées",
        "de poudre de cari de madras",
        "de sel",
        "d’eau",
        "d’asperges",
        "boîte de lait de coco",
        "jus de lime ou de citron",
        "garnitures",
        "yogourt nature",
        "pelures d’asperges blanchies",
        "croûtons",
        "filet d’huile d’olive"
      ],
      "searchText": "potage aux asperges et au cari de beurre ou d’huile de noix de coco vierge petit oignon haché de pommes de terre pelées de poudre de cari de madras de sel d’eau d’asperges boîte de lait de coco jus de lime ou de citron garnitures yogourt nature pelures d’asperges blanchies croûtons filet d’huile d’olive plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/soupes-potages/potage-aux-asperges-et-au-cari/",
      "sourceRating": 4.83,
      "sourceRatingCount": 12,
      "translatedTitles": {
        "en": "Asparagus and Curry Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 42
    },
    {
      "id": "25b5850e-7c83-47ba-a12c-187f84e1c7cd",
      "title": "Potage aux courges poivrées, pommes & gingembre",
      "image": "images/25b5850e-7c83-47ba-a12c-187f84e1c7cd_0.jpg",
      "servings": "Pour 6-8 personnes",
      "readyInMinutes": 88,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "courges poivrées",
        "sel et poivre",
        "c. à soupe de beurre",
        "tasse d’oignon jaune",
        "pommes",
        "gousse d’ail",
        "c. à thé de poudre de cari",
        "c. à soupe de gingembre frais",
        "c. à thé de vinaigre de cidre de pomme",
        "tasses de bouillon de poulet options de remplacement ou bouillon de légumes",
        "tasse de crème options de remplacement ou de crème",
        "graines de citrouille"
      ],
      "searchText": "potage aux courges poivrées, pommes & gingembre courges poivrées sel et poivre c. à soupe de beurre tasse d’oignon jaune pommes gousse d’ail c. à thé de poudre de cari c. à soupe de gingembre frais c. à thé de vinaigre de cidre de pomme tasses de bouillon de poulet options de remplacement ou bouillon de légumes tasse de crème options de remplacement ou de crème graines de citrouille plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/entrees/potages/potage-aux-courges-poivrees-pommes-gingembre/",
      "translatedTitles": {
        "en": "Acorn Squash, Apple & Ginger Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 83
    },
    {
      "id": "2165bb9b-2c5a-491e-b61d-883cb35c87d3",
      "title": "Potage citrouille et fenouil",
      "image": "images/2165bb9b-2c5a-491e-b61d-883cb35c87d3_0.jpg",
      "servings": "Rendement : Environ 2L (8 tasses)",
      "readyInMinutes": 108,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "citrouille de 1",
        "gousses d’ail en chemise",
        "d’huile d’olive",
        "gros bulbe de fenouil",
        "petit oignon",
        "conserve de 398 de lait de coco",
        "de bouillon de poulet ou de légumes",
        "de sel",
        "noix de muscade fraîchement râpé",
        "sel et poivre",
        "croûtons de base ou à l’ail",
        "graines de citrouille",
        "piment de cayenne ou d’espelette",
        "filet d’huile d’olive"
      ],
      "searchText": "potage citrouille et fenouil citrouille de 1 gousses d’ail en chemise d’huile d’olive gros bulbe de fenouil petit oignon conserve de 398 de lait de coco de bouillon de poulet ou de légumes de sel noix de muscade fraîchement râpé sel et poivre croûtons de base ou à l’ail graines de citrouille piment de cayenne ou d’espelette filet d’huile d’olive plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/soupes-potages/potage-citrouille-et-fenouil/",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Pumpkin and Fennel Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 108
    },
    {
      "id": "05026b9e-6c77-4aea-8536-f777a3aef1a1",
      "title": "Potage Saint-Germain",
      "image": "images/05026b9e-6c77-4aea-8536-f777a3aef1a1_0.jpg",
      "servings": "6",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignons",
        "de beurre",
        "pomme de terre",
        "de petits pois surgelés",
        "de laitue hachée au choix (frisée",
        "de crème à cuisson",
        "croûtons",
        "feuilles de cerfeuil frais"
      ],
      "searchText": "potage saint-germain oignons de beurre pomme de terre de petits pois surgelés de laitue hachée au choix (frisée de crème à cuisson croûtons feuilles de cerfeuil frais plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5739-potage-saint-germain",
      "sourceRating": 5,
      "sourceRatingCount": 56,
      "translatedTitles": {
        "en": "Potage Saint-Germain"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 54
    },
    {
      "id": "2cc13152-8b5c-4536-a3b8-6f0892ead916",
      "title": "Potage vert sapin",
      "image": "images/2cc13152-8b5c-4536-a3b8-6f0892ead916_0.jpg",
      "servings": "8 portion(s)",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "branches de céleri",
        "poireau",
        "gousses d’ail",
        "d’huile d’olive",
        "de pommes de terre russet pelées et coupées en dés",
        "branche de romarin frais",
        "de bébés épinards",
        "crème sûre",
        "quelques branches de romarin frais",
        "de fromage feta émietté",
        "de grains de grenade",
        "branche de céleri",
        "quelques feuilles de céleri",
        "de croûtons de pain brioché",
        "de ciboulette ciselée"
      ],
      "searchText": "potage vert sapin branches de céleri poireau gousses d’ail d’huile d’olive de pommes de terre russet pelées et coupées en dés branche de romarin frais de bébés épinards crème sûre quelques branches de romarin frais de fromage feta émietté de grains de grenade branche de céleri quelques feuilles de céleri de croûtons de pain brioché de ciboulette ciselée",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6271-potage-vert-sapin",
      "sourceRating": 5,
      "sourceRatingCount": 41,
      "translatedTitles": {
        "en": "Forest Green Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 50
    },
    {
      "id": "99b1cd2b-9013-43c2-863b-51457d35a11a",
      "title": "Potage vert sapin",
      "image": "images/99b1cd2b-9013-43c2-863b-51457d35a11a_0.jpg",
      "servings": "8",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "branches de céleri",
        "poireau",
        "gousses d’ail",
        "d’huile d’olive",
        "de pommes de terre russet pelées et coupées en dés",
        "branche de romarin frais",
        "de bébés épinards",
        "crème sûre",
        "quelques branches de romarin frais",
        "de fromage feta émietté",
        "de grains de grenade",
        "branche de céleri",
        "quelques feuilles de céleri",
        "de croûtons de pain brioché",
        "de ciboulette ciselée"
      ],
      "searchText": "potage vert sapin branches de céleri poireau gousses d’ail d’huile d’olive de pommes de terre russet pelées et coupées en dés branche de romarin frais de bébés épinards crème sûre quelques branches de romarin frais de fromage feta émietté de grains de grenade branche de céleri quelques feuilles de céleri de croûtons de pain brioché de ciboulette ciselée",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6271-potage-vert-sapin",
      "sourceRating": 5,
      "sourceRatingCount": 41,
      "translatedTitles": {
        "en": "Pine Green Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 54
    },
    {
      "id": "9f92c686-b245-442d-bae1-cc13a636a882",
      "title": "Potato-Crusted Quiche",
      "image": "images/9f92c686-b245-442d-bae1-cc13a636a882_0.jpg",
      "servings": "5 servings",
      "readyInMinutes": 70,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "russet potatoes",
        "olive oil",
        "salt",
        "½ pepper",
        "grated parmesan cheese",
        "eggs",
        "milk",
        "½ tomato",
        "¼ green onions",
        "½ bacon",
        "½ shredded cheddar cheese",
        "garlic powder"
      ],
      "searchText": "potato-crusted quiche russet potatoes olive oil salt ½ pepper grated parmesan cheese eggs milk ½ tomato ¼ green onions ½ bacon ½ shredded cheddar cheese garlic powder",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://tasty.co/recipe/potato-crusted-quiche",
      "sourceRating": 4.9,
      "sourceRatingCount": 1170,
      "translatedTitles": {
        "fr": "Quiche à croûte de pommes de terre"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 70
    },
    {
      "id": "4c129b25-b82d-4703-95b8-df9a0bcf8915",
      "title": "Pouding de chia au café et beurre d’amandes, sirop érable-cannelle",
      "image": "images/4c129b25-b82d-4703-95b8-df9a0bcf8915_0.jpg",
      "servings": "3 à 4",
      "readyInMinutes": 25,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de lait d’amandes",
        "tasse de café espresso ou café noir",
        "c. à soupe de sirop d’érable de préférence ambré pour son goût riche",
        "c. à thé de vanille",
        "tasse de beurre d’amandes",
        "tasse de graines de chia blanches + 2 c. à soupe",
        "¼ c. à thé (1",
        "tasse de sirop d’érable de préférence ambré pour son goût riche",
        "c. à thé (2"
      ],
      "searchText": "pouding de chia au café et beurre d’amandes, sirop érable-cannelle tasse de lait d’amandes tasse de café espresso ou café noir c. à soupe de sirop d’érable de préférence ambré pour son goût riche c. à thé de vanille tasse de beurre d’amandes tasse de graines de chia blanches + 2 c. à soupe ¼ c. à thé (1 tasse de sirop d’érable de préférence ambré pour son goût riche c. à thé (2",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/pouding-de-chia-au-cafe-et-beurre-damandes-sirop-erable-cannelle/",
      "translatedTitles": {
        "en": "Coffee and almond butter chia pudding, maple-cinnamon syrup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 10,
      "readyInMinutesMin": 25
    },
    {
      "id": "1be1a2bb-0a96-4431-8d7e-938002748b81",
      "title": "Poulet au cari",
      "image": "images/1be1a2bb-0a96-4431-8d7e-938002748b81_0.jpg",
      "servings": "4",
      "readyInMinutes": 15,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "demi-poitrines de poulet désossées et sans la peau",
        "de poudre de cari",
        "d’huile d’olive",
        "sel et poivre"
      ],
      "searchText": "poulet au cari demi-poitrines de poulet désossées et sans la peau de poudre de cari d’huile d’olive sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5757-poulet-au-cari",
      "sourceRating": 4,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Curried Chicken"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 15
    },
    {
      "id": "0147a160-3f0b-452b-af5d-e7b2e388a7c9",
      "title": "Poulet aux olives",
      "image": "images/0147a160-3f0b-452b-af5d-e7b2e388a7c9_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 85,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poulet entier coupé en 8 morceaux",
        "d’huile d’olive",
        "de sirop d’érable ou de miel",
        "de vinaigre de cidre",
        "de bouillon de poulet",
        "gousses d’ail hachées",
        "de feuilles de thym frais ou 10 d’herbes de provence.",
        "feuilles de laurier brisées",
        "d’olives vertes dénoyautées entières ou coupées en 2",
        "d’abricots secs coupés en 2 ou 4",
        "sel et poivre du moulin"
      ],
      "searchText": "poulet aux olives poulet entier coupé en 8 morceaux d’huile d’olive de sirop d’érable ou de miel de vinaigre de cidre de bouillon de poulet gousses d’ail hachées de feuilles de thym frais ou 10 d’herbes de provence. feuilles de laurier brisées d’olives vertes dénoyautées entières ou coupées en 2 d’abricots secs coupés en 2 ou 4 sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/poulet-aux-olives/",
      "sourceRating": 4.79,
      "sourceRatingCount": 33,
      "translatedTitles": {
        "en": "Chicken with Olives"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "34b2a4d9-e2c5-4700-beb6-881f490d6f54",
      "title": "Poulet bouilli maison",
      "image": "images/34b2a4d9-e2c5-4700-beb6-881f490d6f54_0.jpg",
      "servings": "1000",
      "readyInMinutes": 168,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignons",
        "clous de girofle",
        "poireaux",
        "carottes",
        "tiges céleri",
        "poulet entier",
        "feuilles de laurier",
        "tasses eau",
        "c.à thé poivre en grains",
        "c.à thé sel",
        "étamine/coton à fromage"
      ],
      "searchText": "poulet bouilli maison oignons clous de girofle poireaux carottes tiges céleri poulet entier feuilles de laurier tasses eau c.à thé poivre en grains c.à thé sel étamine/coton à fromage",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.soscuisine.com/recette/poulet-bouilli-maison",
      "sourceRating": 4.5,
      "sourceRatingCount": 33,
      "translatedTitles": {
        "en": "Homemade Boiled Chicken"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 168
    },
    {
      "id": "e245d3ee-e2a5-4913-8300-ce00f52b6225",
      "title": "Poulet haché à la citronnelle (larb)",
      "servings": "4",
      "readyInMinutes": 23,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de poulet haché",
        "d’huile véétale",
        "petit oignon rouge",
        "gousses d’ail",
        "piments oiseaux rouges",
        "feuilles de lime kaffir",
        "de citronnelle hachée finement",
        "de sauce soya",
        "de sauce de poisson",
        "de sucre",
        "de jus de lime",
        "oignons verts",
        "de coriandre ciselée",
        "de menthe ciselée",
        "quartiers de lime"
      ],
      "searchText": "poulet haché à la citronnelle (larb) de poulet haché d’huile véétale petit oignon rouge gousses d’ail piments oiseaux rouges feuilles de lime kaffir de citronnelle hachée finement de sauce soya de sauce de poisson de sucre de jus de lime oignons verts de coriandre ciselée de menthe ciselée quartiers de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8238-poulet-hache-a-la-citronnelle-larb",
      "image": "images/e245d3ee-e2a5-4913-8300-ce00f52b6225_0.jpg",
      "sourceRating": 4,
      "sourceRatingCount": 21,
      "translatedTitles": {
        "en": "Lemongrass Minced Chicken (Larb)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 23
    },
    {
      "id": "1b1ac40c-bc8d-429e-bba0-563cd7dff845",
      "title": "Poulet huli-huli",
      "image": "images/1b1ac40c-bc8d-429e-bba0-563cd7dff845_0.jpg",
      "servings": "8",
      "readyInMinutes": 689,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de cassonade léèrement tassée",
        "de jus d’ananas",
        "de ketchup",
        "de sauce soya",
        "de vinaigre de riz",
        "de gingembre haché finement",
        "gousses d’ail",
        "pilons de poulet sans la peau"
      ],
      "searchText": "poulet huli-huli de cassonade léèrement tassée de jus d’ananas de ketchup de sauce soya de vinaigre de riz de gingembre haché finement gousses d’ail pilons de poulet sans la peau",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7583-poulet-huli-huli",
      "sourceRating": 5,
      "sourceRatingCount": 51,
      "translatedTitles": {
        "en": "Huli-Huli Chicken"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 569
    },
    {
      "id": "7cbde660-22bf-4544-975c-b92ef86a7ac2",
      "title": "Poulet popcorn et sauce piquante au miel",
      "image": "images/7cbde660-22bf-4544-975c-b92ef86a7ac2_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 784,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poitrines de poulet",
        "tasses de babeurre",
        "c. à soupe de sel",
        "tasse de farine de maïs",
        "tasse de farine de pois chiches",
        "huile",
        "rendement : 500",
        "tasse de miel d’été d’anicet",
        "tasse de sauce piquante des miels d’anicet"
      ],
      "searchText": "poulet popcorn et sauce piquante au miel poitrines de poulet tasses de babeurre c. à soupe de sel tasse de farine de maïs tasse de farine de pois chiches huile rendement : 500 tasse de miel d’été d’anicet tasse de sauce piquante des miels d’anicet",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/6416/poulet-popcorn-et-sauce-piquante-au-miel?fbclid=IwAR2CyS4UzSw8C7QnWwO-TgWz09csRa9DHUTPk6A2pD7DhbFk8acGEg29_k8",
      "sourceRating": 4,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Popcorn Chicken and Spicy Honey Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 52,
      "readyInMinutesMin": 774
    },
    {
      "id": "0ef3c4ad-7062-4f86-8969-07f20a87bfc3",
      "title": "Poulet rôti aux légumes",
      "image": "images/0ef3c4ad-7062-4f86-8969-07f20a87bfc3_0.jpg",
      "servings": "4",
      "readyInMinutes": 156,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poulet",
        "de sirop d’érable",
        "d’huile d’olive",
        "poulet entier d’environ 1",
        "carottes moyennes",
        "petit rutaa",
        "oignons moyens",
        "de pommes de terre grelots",
        "de thym frais ciselé",
        "sel et poivre",
        "sauce",
        "boîte de 284 de bouillon de poulet concentré non dilué réduit en sel",
        "de fécule de maïs",
        "gousses d’ail"
      ],
      "searchText": "poulet rôti aux légumes poulet de sirop d’érable d’huile d’olive poulet entier d’environ 1 carottes moyennes petit rutaa oignons moyens de pommes de terre grelots de thym frais ciselé sel et poivre sauce boîte de 284 de bouillon de poulet concentré non dilué réduit en sel de fécule de maïs gousses d’ail",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6437-poulet-roti-aux-legumes",
      "sourceRating": 4,
      "sourceRatingCount": 118,
      "translatedTitles": {
        "en": "Roasted Chicken with Vegetables"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 48,
      "readyInMinutesMin": 156
    },
    {
      "id": "aaf08e34-94b2-4d9a-b243-6405c75608d5",
      "title": "Poulet rôti et légumes d’hiver de Josée di Stasio",
      "servings": "6",
      "readyInMinutes": 367,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poulet de 1",
        "de sel",
        "ou 3 oignons jaunes émincés finement",
        "gousses d’ail",
        "carottes",
        "pommes de terre jaunes",
        "petit céleri-rave",
        "d’huile d’olive",
        "de thym frais haché finement",
        "ou 10 de thym séché",
        "au goût",
        "citron"
      ],
      "searchText": "poulet rôti et légumes d’hiver de josée di stasio poulet de 1 de sel ou 3 oignons jaunes émincés finement gousses d’ail carottes pommes de terre jaunes petit céleri-rave d’huile d’olive de thym frais haché finement ou 10 de thym séché au goût citron plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.iga.net/fr/recettes_inspirantes/recettes/poulet_roti_et_legumes_dhiver",
      "image": "images/aaf08e34-94b2-4d9a-b243-6405c75608d5_0.webp",
      "translatedTitles": {
        "en": "Roasted Chicken and Winter Vegetables by Josée di Stasio"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 247
    },
    {
      "id": "aa35bbd7-4bc4-4d4a-b448-1856ea108897",
      "title": "Poulet toscan",
      "image": "images/aa35bbd7-4bc4-4d4a-b448-1856ea108897_0.jpg",
      "servings": "4",
      "readyInMinutes": 81,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de hauts de cuisses de poulet désossés et sans la peau",
        "d’huile d’olive",
        "oignons verts",
        "de vin blanc",
        "de bouillon de poulet",
        "branche de romarin frais",
        "d’olives noires et vertes",
        "sel et poivre"
      ],
      "searchText": "poulet toscan de hauts de cuisses de poulet désossés et sans la peau d’huile d’olive oignons verts de vin blanc de bouillon de poulet branche de romarin frais d’olives noires et vertes sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6146-poulet-toscan",
      "sourceRating": 5,
      "sourceRatingCount": 186,
      "translatedTitles": {
        "en": "Tuscan Chicken"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 76
    },
    {
      "id": "9df8d53a-e39a-4136-a35d-d7ba87caccea",
      "title": "Poutine de haricots",
      "image": "images/9df8d53a-e39a-4136-a35d-d7ba87caccea_0.jpg",
      "servings": "2 portions",
      "readyInMinutes": 68,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "gousse d’ail",
        "de petits pois frais ou surgelés",
        "tige de thym",
        "feuille de laurier",
        "c. à soupe de racine de raifort râpée",
        "t. de crème m..",
        "de haricots verts",
        "sachet de fromage en grains",
        "½ citron",
        "huile d’olive",
        "piment d’espelette",
        "sel et poivre"
      ],
      "searchText": "poutine de haricots oignon gousse d’ail de petits pois frais ou surgelés tige de thym feuille de laurier c. à soupe de racine de raifort râpée t. de crème m.. de haricots verts sachet de fromage en grains ½ citron huile d’olive piment d’espelette sel et poivre plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/5976/poutine-de-haricots",
      "translatedTitles": {
        "en": "Bean Poutine"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 68
    },
    {
      "id": "fbc44f6c-1231-4339-b8f4-4b2811686b0b",
      "title": "Pulled Pork Eggs Benedict",
      "image": "images/fbc44f6c-1231-4339-b8f4-4b2811686b0b_0.jpg",
      "servings": "2 people",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "english muffins (halved",
        "leftover pulled pork",
        "smoked paprika",
        "poached eggs",
        "hot sauce",
        "parsley",
        "salt and pepper",
        "pinch smoked paprika",
        "melted butter",
        "egg yolks",
        "+ lemon juice",
        "salt",
        "cayenne pepper"
      ],
      "searchText": "pulled pork eggs benedict english muffins (halved leftover pulled pork smoked paprika poached eggs hot sauce parsley salt and pepper pinch smoked paprika melted butter egg yolks + lemon juice salt cayenne pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://waystomyheart.com/pulled-pork-eggs-benedict/",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "fr": "Œufs Bénédictine au Porc Effiloché"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 29
    },
    {
      "id": "55be2ca8-3d2a-45d7-aa79-c6ba68c4cc93",
      "title": "Pulled Pork Sandwiches",
      "image": "images/55be2ca8-3d2a-45d7-aa79-c6ba68c4cc93_0.jpg",
      "servings": "8 to 10 servings",
      "readyInMinutes": 395,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "coriander seed",
        "cumin seed",
        "black peppercorns",
        "coarse kosher salt",
        "dry mustard powder",
        "chile powder",
        "dark brown sugar",
        "boneless pork shoulder",
        "hamburger or brioche buns",
        "ketchup",
        "packed dark brown sugar",
        "molasses",
        "garlic cloves",
        "cider vinegar",
        "worcestershire sauce",
        "sweet or hot paprika",
        "black pepper",
        "dry mustard powder",
        "pinch of cayenne",
        "dash of hot sauce",
        "head green cabe",
        "red onion",
        "jalapeño",
        "mayonnaise",
        "cider vinegar",
        "- olive oil",
        "coarse kosher salt",
        "black pepper"
      ],
      "searchText": "pulled pork sandwiches coriander seed cumin seed black peppercorns coarse kosher salt dry mustard powder chile powder dark brown sugar boneless pork shoulder hamburger or brioche buns ketchup packed dark brown sugar molasses garlic cloves cider vinegar worcestershire sauce sweet or hot paprika black pepper dry mustard powder pinch of cayenne dash of hot sauce head green cabe red onion jalapeño mayonnaise cider vinegar - olive oil coarse kosher salt black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1014733-pulled-pork-sandwiches?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3038,
      "translatedTitles": {
        "fr": "Sandwichs au porc effiloché"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 329
    },
    {
      "id": "9460cd2d-b6be-4139-8d71-13cb36a319f5",
      "title": "Pulled Pork Sandwiches",
      "image": "images/9460cd2d-b6be-4139-8d71-13cb36a319f5_0.jpg",
      "servings": "8",
      "readyInMinutes": 395,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "coriander seed",
        "cumin seed",
        "black peppercorns",
        "coarse kosher salt",
        "dry mustard powder",
        "chile powder",
        "dark brown sugar",
        "boneless pork shoulder",
        "hamburger or brioche buns",
        "ketchup",
        "packed dark brown sugar",
        "molasses",
        "garlic cloves",
        "cider vinegar",
        "worcestershire sauce",
        "sweet or hot paprika",
        "black pepper",
        "dry mustard powder",
        "pinch of cayenne",
        "dash of hot sauce",
        "head green cabe",
        "red onion",
        "jalapeño",
        "mayonnaise",
        "cider vinegar",
        "- olive oil",
        "coarse kosher salt",
        "black pepper"
      ],
      "searchText": "pulled pork sandwiches coriander seed cumin seed black peppercorns coarse kosher salt dry mustard powder chile powder dark brown sugar boneless pork shoulder hamburger or brioche buns ketchup packed dark brown sugar molasses garlic cloves cider vinegar worcestershire sauce sweet or hot paprika black pepper dry mustard powder pinch of cayenne dash of hot sauce head green cabe red onion jalapeño mayonnaise cider vinegar - olive oil coarse kosher salt black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1014733-pulled-pork-sandwiches?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3038,
      "translatedTitles": {
        "fr": "Sandwichs au porc effiloché"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 329
    },
    {
      "id": "deed4514-7621-46cc-8264-f142b501177d",
      "title": "Punch de Noël",
      "image": "images/deed4514-7621-46cc-8264-f142b501177d_0.jpg",
      "servings": "9",
      "readyInMinutes": 67,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de grand marnier ou autre liqueur d'orange",
        "de rhum brun",
        "gousse de vanille",
        "quelques grappes de groseilles à grappes rouges",
        "quelques tranches d'oranges",
        "de soda",
        "glaçons"
      ],
      "searchText": "punch de noël de grand marnier ou autre liqueur d'orange de rhum brun gousse de vanille quelques grappes de groseilles à grappes rouges quelques tranches d'oranges de soda glaçons apéritif",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/230-punch-de-noel",
      "sourceRating": 5,
      "sourceRatingCount": 27,
      "translatedTitles": {
        "en": "Christmas Punch"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 7,
      "readyInMinutesMin": 67
    },
    {
      "id": "f21eafaf-56d5-4d61-8560-27df6b37aada",
      "title": "Punch de Noël tutti frutti",
      "image": "images/f21eafaf-56d5-4d61-8560-27df6b37aada_0.jpg",
      "servings": "12",
      "readyInMinutes": 3,
      "healthScore": 0,
      "dishTypes": [
        "beverage"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "litres de jus de neberge froid",
        "de brandy",
        "de triple sec",
        "sac de 500 de fruits rouges surgelés",
        "boîte de 540 de litchis avec le sirop",
        "oranges"
      ],
      "searchText": "punch de noël tutti frutti litres de jus de neberge froid de brandy de triple sec sac de 500 de fruits rouges surgelés boîte de 540 de litchis avec le sirop oranges boisson",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7705-punch-de-noel-tutti-frutti",
      "sourceRating": 5,
      "sourceRatingCount": 2,
      "translatedTitles": {
        "en": "Tutti Frutti Christmas Punch"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 3,
      "readyInMinutesMin": 3
    },
    {
      "id": "bd22dfdf-b850-4a06-abd6-e34da4ed6ab7",
      "title": "Purée de chou-fleur et roquette",
      "image": "images/bd22dfdf-b850-4a06-abd6-e34da4ed6ab7_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "paquet de 142 de roquette",
        "de dés de pommes de terre russet ou yukon gold",
        "de beurre salé",
        "le zeste d’un citron",
        "muscade fraîchement râpée",
        "sel et poivre du moulin"
      ],
      "searchText": "purée de chou-fleur et roquette paquet de 142 de roquette de dés de pommes de terre russet ou yukon gold de beurre salé le zeste d’un citron muscade fraîchement râpée sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/accompagnements/puree-de-chou-fleur-et-roquette/",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Cauliflower and Arugula Purée"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 35
    },
    {
      "id": "313e4203-a221-46c3-8838-bd8617dc89f8",
      "title": "Quesadillas",
      "image": "images/313e4203-a221-46c3-8838-bd8617dc89f8_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 52,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "haricots noirs",
        "huile d'olive",
        "sauce piquante",
        "sel et poivre",
        "huile d'olive",
        "poivron rouge",
        "oignon",
        "cumin",
        "tortillas de maïs",
        "tranches de fromage monterey jack"
      ],
      "searchText": "quesadillas haricots noirs huile d'olive sauce piquante sel et poivre huile d'olive poivron rouge oignon cumin tortillas de maïs tranches de fromage monterey jack plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/497/quesadillas",
      "translatedTitles": {
        "en": "Quesadillas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 52
    },
    {
      "id": "f0621d3f-3cbb-4efc-bd31-3798acf961b6",
      "title": "Quesadillas au poulet",
      "image": "images/f0621d3f-3cbb-4efc-bd31-3798acf961b6_0.jpg",
      "servings": "1",
      "readyInMinutes": 12,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grandes tortillas de 25 cm de diamètre",
        "de poulet cuit effiloché",
        "de fromage cheddar râpé",
        "salsa",
        "crème sure",
        "guacamole"
      ],
      "searchText": "quesadillas au poulet grandes tortillas de 25 cm de diamètre de poulet cuit effiloché de fromage cheddar râpé salsa crème sure guacamole",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/5771-quesadillas-au-poulet",
      "sourceRating": 5,
      "sourceRatingCount": 37,
      "translatedTitles": {
        "en": "Chicken Quesadillas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 12
    },
    {
      "id": "038265d8-54cf-4ed6-9983-5864301266d9",
      "title": "Quick Tomato, White Bean and Kale Soup",
      "image": "images/038265d8-54cf-4ed6-9983-5864301266d9_0.jpg",
      "servings": "Serves 4 to 6",
      "readyInMinutes": 73,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "onion",
        "carrot",
        "stick celery",
        "salt to taste",
        "garlic cloves",
        "ounce tomatoes",
        "water",
        "tomato paste",
        "oregano",
        "yukon gold potato",
        "a bouquet garni made with a bay leaf",
        "kale",
        "white beans",
        "ly pepper",
        "grated parmesan for serving"
      ],
      "searchText": "quick tomato, white bean and kale soup olive oil onion carrot stick celery salt to taste garlic cloves ounce tomatoes water tomato paste oregano yukon gold potato a bouquet garni made with a bay leaf kale white beans ly pepper grated parmesan for serving",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1014524-quick-tomato-white-bean-and-kale-soup?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4488,
      "translatedTitles": {
        "fr": "Soupe rapide aux tomates, haricots blancs et chou frisé"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 43,
      "readyInMinutesMin": 63
    },
    {
      "id": "e2b5b079-8ac2-4946-b4f0-3a7fa4c96303",
      "title": "Quick Tomato, White Bean and Kale Soup",
      "image": "images/e2b5b079-8ac2-4946-b4f0-3a7fa4c96303_0.jpg",
      "servings": "4",
      "readyInMinutes": 73,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "onion",
        "carrot",
        "stick celery",
        "salt to taste",
        "garlic cloves",
        "ounce tomatoes",
        "water",
        "tomato paste",
        "oregano",
        "yukon gold potato",
        "a bouquet garni made with a bay leaf",
        "kale",
        "white beans",
        "ly pepper",
        "grated parmesan for serving"
      ],
      "searchText": "quick tomato, white bean and kale soup olive oil onion carrot stick celery salt to taste garlic cloves ounce tomatoes water tomato paste oregano yukon gold potato a bouquet garni made with a bay leaf kale white beans ly pepper grated parmesan for serving",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1014524-quick-tomato-white-bean-and-kale-soup?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4488,
      "translatedTitles": {
        "fr": "Soupe rapide aux tomates, haricots blancs et chou frisé"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 43,
      "readyInMinutesMin": 63
    },
    {
      "id": "e713907f-34d7-4f78-9c3b-ed595d8301b2",
      "title": "Quinoa burgers in pita bread with sriracha mayo",
      "image": "images/e713907f-34d7-4f78-9c3b-ed595d8301b2_0.jpg",
      "servings": "1",
      "readyInMinutes": 71,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "quinoa",
        "sun tomatoes",
        "green onions",
        "eggs",
        "feta cheese",
        "black pepper",
        "",
        "butter",
        "sriracha mayo",
        "mayonnaise",
        "sour cream",
        "sriracha"
      ],
      "searchText": "quinoa burgers in pita bread with sriracha mayo quinoa sun tomatoes green onions eggs feta cheese black pepper  butter sriracha mayo mayonnaise sour cream sriracha",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://scandinaviansimpleeating.com/2019/10/19/quinoa-burgers-served-in-pita-bread-with-sriracha-mayo/",
      "translatedTitles": {
        "fr": "Burgers de quinoa dans du pain pita avec de la mayonnaise sriracha"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 47,
      "readyInMinutesMin": 71
    },
    {
      "id": "641db78a-9433-41f9-ab61-297a524de09f",
      "title": "Quinoa Falafel with Tahini Sauce",
      "image": "images/641db78a-9433-41f9-ab61-297a524de09f_0.jpg",
      "servings": "14 serving",
      "readyInMinutes": 70,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "quinoa",
        "s low sodium chickpeas",
        "onion",
        "garlic cloves",
        "parsley",
        "cumin",
        "coriander",
        "sesame oil",
        "cornstarch",
        "salt",
        "water",
        "cooking spray",
        "wheat pitas",
        "long english cucumber",
        "tomatoes",
        "tahini",
        "water",
        "lemons",
        "garlic clove",
        "salt"
      ],
      "searchText": "quinoa falafel with tahini sauce quinoa s low sodium chickpeas onion garlic cloves parsley cumin coriander sesame oil cornstarch salt water cooking spray wheat pitas long english cucumber tomatoes tahini water lemons garlic clove salt",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://ifoodreal.com/quinoa-falafel/",
      "sourceRating": 4.91,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "fr": "Falafels de quinoa avec sauce tahini"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "79ea3b55-6c9c-493a-a237-0471ba5ac8e1",
      "title": "Radicchio Salad with Citrus",
      "image": "images/79ea3b55-6c9c-493a-a237-0471ba5ac8e1_0.jpg",
      "servings": "6",
      "readyInMinutes": 55,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "slices sourdough bread",
        "plus 3 - olive oil",
        "kosher salt",
        "black pepper",
        "walnuts",
        "citrus fruits",
        "head radicchio",
        "arugula",
        "crumbled feta cheese"
      ],
      "searchText": "radicchio salad with citrus slices sourdough bread plus 3 - olive oil kosher salt black pepper walnuts citrus fruits head radicchio arugula crumbled feta cheese",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.simplyrecipes.com/recipes/radicchio_salad_with_citrus/",
      "translatedTitles": {
        "fr": "Salade de radicchio aux agrumes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 55
    },
    {
      "id": "2c6dc506-1c47-458e-8163-50731e188256",
      "title": "Pilons de poulet moutarde et miel à la mijoteuse",
      "image": "images/2c6dc506-1c47-458e-8163-50731e188256_0.jpg",
      "servings": "1",
      "readyInMinutes": 314,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de moutarde de dijon",
        "de miel",
        "de sauce worcestershire",
        "de vinaigre de cidre",
        "d’assaisonnement au chili",
        "pincée de poivre de cayenne",
        "pilons de poulet sans la peau",
        "d’huile d’olive",
        "sel et poivre"
      ],
      "searchText": "pilons de poulet moutarde et miel à la mijoteuse de moutarde de dijon de miel de sauce worcestershire de vinaigre de cidre d’assaisonnement au chili pincée de poivre de cayenne pilons de poulet sans la peau d’huile d’olive sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://journalmetro.com/inspiration/a-table/2775282/recette-pilons-poulet/",
      "translatedTitles": {
        "en": "Slow Cooker Honey Mustard Chicken Drumsticks"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 194
    },
    {
      "id": "e86280c3-a788-4253-9010-61afcf629a4b",
      "title": "Lasagne aux saucisses italiennes et aux légumes",
      "image": "images/e86280c3-a788-4253-9010-61afcf629a4b_0.jpg",
      "servings": "1",
      "readyInMinutes": 150,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sauce aux légumes et aux saucisses",
        "de champignons blancs",
        "oignon",
        "branche de céleri",
        "carotte",
        "gousses d’ail",
        "de chair de saucisses italiennes douces",
        "d’huile d’olive",
        "boîte de 796 de tomates italiennes en dés",
        "de bouillon de poulet ou d’eau",
        "d’origan séché",
        "de flocons de piment broyé",
        "béchamel",
        "de beurre",
        "de farine tout usage non blanchie",
        "de lait",
        "de fromage parmesan frais râpé",
        "garniture",
        "pâtes à lasagne cuites al dente",
        "de fromage mozzarella râpé",
        "préparation",
        "sauce aux légumes et aux saucisses"
      ],
      "searchText": "lasagne aux saucisses italiennes et aux légumes sauce aux légumes et aux saucisses de champignons blancs oignon branche de céleri carotte gousses d’ail de chair de saucisses italiennes douces d’huile d’olive boîte de 796 de tomates italiennes en dés de bouillon de poulet ou d’eau d’origan séché de flocons de piment broyé béchamel de beurre de farine tout usage non blanchie de lait de fromage parmesan frais râpé garniture pâtes à lasagne cuites al dente de fromage mozzarella râpé préparation sauce aux légumes et aux saucisses",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/4de065e9-9df0-47ac-8552-5e62856d495c__7C___0.html",
      "translatedTitles": {
        "en": "Italian Sausage and Vegetable Lasagna"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 45,
      "readyInMinutesMin": 150
    },
    {
      "id": "96cb86df-71a2-4d55-9f9e-4040350ebfe1",
      "title": "Salade de rotinis au thon et à l’avocat",
      "image": "images/96cb86df-71a2-4d55-9f9e-4040350ebfe1_0.jpg",
      "servings": "1",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de rotinis",
        "oignon vert",
        "avocats",
        "citron",
        "de mayonnaise",
        "boîtes de 198 de thon dans l’huile",
        "poivron rouge",
        "de roquette"
      ],
      "searchText": "salade de rotinis au thon et à l’avocat de rotinis oignon vert avocats citron de mayonnaise boîtes de 198 de thon dans l’huile poivron rouge de roquette",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/fb2cf64c-e37b-45a6-b507-f0bd3c50c851__7C___0.html?utm_content=ulink&utm_source=lpp&utm_medium=referral&utm_campaign=internal+share",
      "translatedTitles": {
        "en": "Rotini Salad with Tuna and Avocado"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "8ddb3b4c-3b6c-4d4a-b623-377c2035d794",
      "title": "Osso buco de bison",
      "image": "images/8ddb3b4c-3b6c-4d4a-b623-377c2035d794_0.jpg",
      "servings": "1",
      "readyInMinutes": 236,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "livres d’osso buco de bison",
        "farine pour saupoudrer",
        "sel et poivre fraîchement moulu au goût",
        "c. à table d’huile d’olive ou de beurre",
        "oignons moyens",
        "carottes moyennes",
        "branches de céleri",
        "½ de tasse de vin rouge sec",
        "gousses d’ail émincées",
        "boîte de tomate en dés avec le jus",
        "½ tasses de bouillon de bœuf faible en sodium",
        "c. à thé de thym séché",
        "c. à thé d’origan séché",
        "c. à thé de basilic séché",
        "feuille de laurier",
        "piments de tabasco entiers",
        "¼ tasse de persil haché",
        "parmesan râpé",
        "citron coupé en quartier"
      ],
      "searchText": "osso buco de bison livres d’osso buco de bison farine pour saupoudrer sel et poivre fraîchement moulu au goût c. à table d’huile d’olive ou de beurre oignons moyens carottes moyennes branches de céleri ½ de tasse de vin rouge sec gousses d’ail émincées boîte de tomate en dés avec le jus ½ tasses de bouillon de bœuf faible en sodium c. à thé de thym séché c. à thé d’origan séché c. à thé de basilic séché feuille de laurier piments de tabasco entiers ¼ tasse de persil haché parmesan râpé citron coupé en quartier",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.northforkbison.com/fr/recette-dosso-buco-bison/",
      "translatedTitles": {
        "en": "Bison Osso Buco"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 58,
      "readyInMinutesMin": 175
    },
    {
      "id": "47c84469-6a0f-4fc3-9acb-4ceb4931d6ea",
      "title": "Tarte aux pommes",
      "image": "images/47c84469-6a0f-4fc3-9acb-4ceb4931d6ea_0.jpg",
      "servings": "1",
      "readyInMinutes": 14,
      "healthScore": 0,
      "dishTypes": [
        "dessert"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "les ingrédients pour réaliser ta super tarte au pommes:",
        "la pâte brisée",
        "cl de lait ;",
        "de farine ;",
        "cuillères à soupe de sucre ;",
        "de beurre mou coupé en dés.",
        "le topping",
        "grosses pommes ;",
        "gourde de fruits mixés andros kidifruit ou de la compote de pommes."
      ],
      "searchText": "tarte aux pommes les ingrédients pour réaliser ta super tarte au pommes: la pâte brisée cl de lait ; de farine ; cuillères à soupe de sucre ; de beurre mou coupé en dés. le topping grosses pommes ; gourde de fruits mixés andros kidifruit ou de la compote de pommes. dessert",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://blog.pandacraft.com/2020/04/tarte-pommes/",
      "translatedTitles": {
        "en": "Apple Pie"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 14
    },
    {
      "id": "47561865-5e78-48f6-84a3-c0e29a27c40d",
      "title": "Salade panzanella aux lentilles marinées",
      "image": "images/47561865-5e78-48f6-84a3-c0e29a27c40d_0.jpg",
      "servings": "1",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pour une salade de format familial",
        "ingrédients",
        "lentilles marinées",
        "d'huile d'olive",
        "de moutarde de dijon",
        "de vinaigre de vin blanc",
        "de mélange d'herbes italiennes séchées",
        "petite échalote française",
        "de lentilles noires béluga cuites ou",
        "boîte de 540 de lentilles vertes",
        "égouttées",
        "croûtons",
        "tranches de pain",
        "d'huile d'olive",
        "de levure alimentaire en flocons",
        "gousse d'ail",
        "pincée de sel",
        "salade",
        "de roquette",
        "concombres",
        "tomates jaunes",
        "bouquet de basilic",
        "huile d'olive",
        "jus de citron",
        "sel et poivre"
      ],
      "searchText": "salade panzanella aux lentilles marinées pour une salade de format familial ingrédients lentilles marinées d'huile d'olive de moutarde de dijon de vinaigre de vin blanc de mélange d'herbes italiennes séchées petite échalote française de lentilles noires béluga cuites ou boîte de 540 de lentilles vertes égouttées croûtons tranches de pain d'huile d'olive de levure alimentaire en flocons gousse d'ail pincée de sel salade de roquette concombres tomates jaunes bouquet de basilic huile d'olive jus de citron sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Marinated Lentil Panzanella Salad"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "9618b723-30d3-4bb3-a85e-7d33c4386428",
      "title": "Truite barbecue",
      "image": "images/9618b723-30d3-4bb3-a85e-7d33c4386428_0.jpg",
      "servings": "1",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "truites",
        "grains d’aneth",
        "cuillères à soupe d’huile",
        "gros champignons de paris",
        "persil",
        "beurre blanc :",
        "dl de vin blanc sec",
        "verre de vinaigre de cidre",
        "échalotes",
        "de beurre",
        "sel",
        "poivre"
      ],
      "searchText": "truite barbecue truites grains d’aneth cuillères à soupe d’huile gros champignons de paris persil beurre blanc : dl de vin blanc sec verre de vinaigre de cidre échalotes de beurre sel poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.pisciculturedemonchel.com/recettes/truite-barbecue/",
      "translatedTitles": {
        "en": "Barbecue Trout"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 35
    },
    {
      "id": "098c5f46-7f76-4e37-928c-327e2d85fafa",
      "title": "Rôti de palette braisé au vin blanc et à la moutarde",
      "image": "images/098c5f46-7f76-4e37-928c-327e2d85fafa_0.jpg",
      "servings": "1",
      "readyInMinutes": 208,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "rôti de palette de bœuf",
        "échalotes françaises",
        "oignons moyens",
        "gousses d’ail",
        "moutarde de dijon",
        "vin blanc",
        "bouillon de bœuf",
        "romarin",
        "ciboulette",
        "crème à cuisson",
        "huile",
        "grains de poivre vert",
        "poivre",
        "sel"
      ],
      "searchText": "rôti de palette braisé au vin blanc et à la moutarde rôti de palette de bœuf échalotes françaises oignons moyens gousses d’ail moutarde de dijon vin blanc bouillon de bœuf romarin ciboulette crème à cuisson huile grains de poivre vert poivre sel plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://lp.ca/qY9Byy",
      "translatedTitles": {
        "en": "Chuck Roast Braised in White Wine and Mustard"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 178
    },
    {
      "id": "9667680d-567d-44be-82c1-88cebcdbeb9e",
      "title": "Rhubarb Crisp",
      "image": "images/9667680d-567d-44be-82c1-88cebcdbeb9e_0.jpg",
      "servings": "6 to 8 servings",
      "readyInMinutes": 94,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cold butter",
        "to 3 rhubarb",
        "white sugar",
        "orange or lemon juice",
        "orange or lemon zest",
        "brown sugar",
        "all-purpose flour",
        "cinnamon",
        "pinch salt",
        "rolled oats",
        "pes"
      ],
      "searchText": "rhubarb crisp cold butter to 3 rhubarb white sugar orange or lemon juice orange or lemon zest brown sugar all-purpose flour cinnamon pinch salt rolled oats pes",
      "isPersonalRecipe": true,
      "nutritionScore": 40,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1013147-rhubarb-crisp?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 5385,
      "translatedTitles": {
        "fr": "Croustade à la rhubarbe"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 44,
      "readyInMinutesMin": 79
    },
    {
      "id": "04565a38-dd36-42e8-9fee-d0125f07753c",
      "title": "Rice Noodles With Spicy Pork and Herbs",
      "image": "images/04565a38-dd36-42e8-9fee-d0125f07753c_0.jpg",
      "servings": "Serves 4",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "thin",
        "rice vinegar",
        "soy sauce",
        "black vinegar",
        "chile oil",
        "sugar",
        "ola or other neutral oil",
        "pork",
        "salt",
        "garlic cloves",
        "inch piece ginger",
        "scallions",
        "yacai (sichuan preserved vegetables",
        "handful of herbs like mint",
        "salted",
        "breakfast radishes"
      ],
      "searchText": "rice noodles with spicy pork and herbs thin rice vinegar soy sauce black vinegar chile oil sugar ola or other neutral oil pork salt garlic cloves inch piece ginger scallions yacai (sichuan preserved vegetables handful of herbs like mint salted breakfast radishes",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1018852-rice-noodles-with-spicy-pork-and-herbs?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 1719,
      "translatedTitles": {
        "fr": "Nouilles de riz au porc épicé et aux herbes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 47
    },
    {
      "id": "46c2b27b-e04f-47f3-b38d-6d3dc233f404",
      "title": "Ricotta and Peach Crostini With Pistachios",
      "image": "images/46c2b27b-e04f-47f3-b38d-6d3dc233f404_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ly squeezed lemon juice",
        "kosher salt",
        "ly black pepper",
        "olive oil",
        "peaches",
        "slices from center of a",
        "baby arugula",
        "ricotta",
        "toasted pistachios",
        "flaky sea salt"
      ],
      "searchText": "ricotta and peach crostini with pistachios ly squeezed lemon juice kosher salt ly black pepper olive oil peaches slices from center of a baby arugula ricotta toasted pistachios flaky sea salt",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1013204-ricotta-and-peach-crostini-with-pistachios?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 133,
      "translatedTitles": {
        "fr": "Crostini à la Ricotta et aux Pêches avec Pistaches"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 33
    },
    {
      "id": "8215ed0e-8e65-4952-9b5f-52577e7d7e9f",
      "title": "Ricotta and Peach Crostini With Pistachios",
      "image": "images/8215ed0e-8e65-4952-9b5f-52577e7d7e9f_0.jpg",
      "servings": "4",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ly squeezed lemon juice",
        "kosher salt",
        "ly black pepper",
        "olive oil",
        "peaches",
        "slices from center of a",
        "baby arugula",
        "ricotta",
        "toasted pistachios",
        "flaky sea salt"
      ],
      "searchText": "ricotta and peach crostini with pistachios ly squeezed lemon juice kosher salt ly black pepper olive oil peaches slices from center of a baby arugula ricotta toasted pistachios flaky sea salt",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1013204-ricotta-and-peach-crostini-with-pistachios?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 133,
      "translatedTitles": {
        "fr": "Crostini à la Ricotta et aux Pêches avec Pistaches"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 33
    },
    {
      "id": "4bd79069-a48f-4e65-89f6-504db6b2d340",
      "title": "Risotto à la courge musquée",
      "image": "images/4bd79069-a48f-4e65-89f6-504db6b2d340_0.jpg",
      "servings": "4",
      "readyInMinutes": 31,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignon",
        "huile d’olive",
        "riz arborio",
        "bouillon de légumes",
        "courge musquée surgelée",
        "fromage parmesan",
        "poivre du moulin"
      ],
      "searchText": "risotto à la courge musquée oignon huile d’olive riz arborio bouillon de légumes courge musquée surgelée fromage parmesan poivre du moulin plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/risotto-courge-musquee/",
      "sourceRating": 3.5,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Butternut Squash Risotto"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 30
    },
    {
      "id": "e224d031-cef7-43f5-ae83-19b0a4ad9fa8",
      "title": "Riz au maïs et aux haricots noirs",
      "image": "images/e224d031-cef7-43f5-ae83-19b0a4ad9fa8_0.jpg",
      "servings": "4",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "huile d’olive",
        "oignon espagnol",
        "gousses d’ail",
        "tasses de riz 7 grains d’uncle ben’s",
        "tasses de bouillon de poulet",
        "tasse de persil frais",
        "c. à thé de thym séché",
        "c. à thé d’origan séché",
        "c. à thé de cumin moulu",
        "tasse de maïs en grains deux couleurs congelés",
        "tasse d’haricots noirs en ne",
        "de tomates raisins",
        "quartiers de lime",
        "sel et poivre du moulin"
      ],
      "searchText": "riz au maïs et aux haricots noirs huile d’olive oignon espagnol gousses d’ail tasses de riz 7 grains d’uncle ben’s tasses de bouillon de poulet tasse de persil frais c. à thé de thym séché c. à thé d’origan séché c. à thé de cumin moulu tasse de maïs en grains deux couleurs congelés tasse d’haricots noirs en ne de tomates raisins quartiers de lime sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://lecoupdegrace.ca/recette/riz-au-mais-et-aux-haricots-noirs/",
      "sourceRating": 4.3,
      "sourceRatingCount": 19,
      "translatedTitles": {
        "en": "Corn and Black Bean Rice"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 46
    },
    {
      "id": "828b7b43-fa1b-41d5-84bf-2b635f5f7c7d",
      "title": "Riz frit au bœuf et à la courge",
      "image": "images/828b7b43-fa1b-41d5-84bf-2b635f5f7c7d_0.jpg",
      "servings": "4",
      "readyInMinutes": 29,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de courge butternut coupée en dés",
        "d’huile d’olive",
        "de bouillon de poulet",
        "de bœuf haché mi-maigre",
        "de poudre de cari",
        "gousses d’ail",
        "de sauce soya",
        "de riz basmati cuit",
        "oignons verts",
        "quartiers de lime"
      ],
      "searchText": "riz frit au bœuf et à la courge de courge butternut coupée en dés d’huile d’olive de bouillon de poulet de bœuf haché mi-maigre de poudre de cari gousses d’ail de sauce soya de riz basmati cuit oignons verts quartiers de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7767-riz-frit-au-b-uf-et-a-la-courge",
      "sourceRating": 4,
      "sourceRatingCount": 48,
      "translatedTitles": {
        "en": "Beef and Squash Fried Rice"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 29
    },
    {
      "id": "a9999aab-9aa8-4e7c-be9a-63249483c430",
      "title": "Roasted Broccoli With Vinegar-Mustard Glaze",
      "image": "images/a9999aab-9aa8-4e7c-be9a-63249483c430_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 32,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "broccoli",
        "- olive oil",
        "kosher salt and black pepper",
        "unsalted butter",
        "sherry or red wine vinegar",
        "dijon mustard"
      ],
      "searchText": "roasted broccoli with vinegar-mustard glaze broccoli - olive oil kosher salt and black pepper unsalted butter sherry or red wine vinegar dijon mustard",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022031-roasted-broccoli-with-vinegar-mustard-glaze?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 5207,
      "translatedTitles": {
        "fr": "Brocoli Rôti Avec Glaçage Vinaigre-Moutarde"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 27
    },
    {
      "id": "b6c9081a-0112-4ac5-ab52-af813fc20867",
      "title": "Roasted Broccoli With Vinegar-Mustard Glaze",
      "image": "images/b6c9081a-0112-4ac5-ab52-af813fc20867_0.jpg",
      "servings": "4",
      "readyInMinutes": 32,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "broccoli",
        "- olive oil",
        "kosher salt and black pepper",
        "unsalted butter",
        "sherry or red wine vinegar",
        "dijon mustard"
      ],
      "searchText": "roasted broccoli with vinegar-mustard glaze broccoli - olive oil kosher salt and black pepper unsalted butter sherry or red wine vinegar dijon mustard",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022031-roasted-broccoli-with-vinegar-mustard-glaze?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 5207,
      "translatedTitles": {
        "fr": "Brocoli Rôti à la Glaçage Vinaigre-Moutarde"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 27
    },
    {
      "id": "355d1cdb-5f45-40aa-bc6d-454612daa24f",
      "title": "Roasted Chicken Thighs With Peaches, Basil and Ginger",
      "image": "images/355d1cdb-5f45-40aa-bc6d-454612daa24f_0.jpg",
      "servings": "3 servings",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "hard peaches (about 1 or 2 to 3 ones",
        "boneless",
        "- olive oil",
        "dry sherry",
        "basil",
        "garlic cloves",
        "piece ginger root",
        "kosher salt",
        "black pepper",
        "crusty bread or rice"
      ],
      "searchText": "roasted chicken thighs with peaches, basil and ginger hard peaches (about 1 or 2 to 3 ones boneless - olive oil dry sherry basil garlic cloves piece ginger root kosher salt black pepper crusty bread or rice",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1012681-roasted-chicken-thighs-with-peaches-basil-and-ginger?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3637,
      "translatedTitles": {
        "fr": "Cuisses de poulet rôties aux pêches, basilic et gingembre"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 35
    },
    {
      "id": "2fcb063c-27d2-48f0-b4eb-b5b056b87070",
      "title": "Roasted Eggplant With Crispy Chickpeas and Cashew Sauce",
      "image": "images/2fcb063c-27d2-48f0-b4eb-b5b056b87070_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 52,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "globe eggplants",
        "salt and pepper",
        "olive oil",
        "chickpeas",
        "roasted cashews",
        "tahini",
        "red pepper",
        "garlic cloves",
        "lemon",
        "to orange",
        "arugula or salad greens of your choice"
      ],
      "searchText": "roasted eggplant with crispy chickpeas and cashew sauce globe eggplants salt and pepper olive oil chickpeas roasted cashews tahini red pepper garlic cloves lemon to orange arugula or salad greens of your choice",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026278-roasted-eggplant-with-crispy-chickpeas-and-cashew-sauce?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 256,
      "translatedTitles": {
        "fr": "Aubergine Rôtie avec Pois Chiches Croustillants et Sauce aux Noix de Cajou"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 47
    },
    {
      "id": "a771046f-8e61-40f2-92e4-a9ebdbd43b91",
      "title": "Roasted Eggplant With Crispy Chickpeas and Cashew Sauce",
      "image": "images/a771046f-8e61-40f2-92e4-a9ebdbd43b91_0.jpg",
      "servings": "4",
      "readyInMinutes": 52,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "globe eggplants",
        "salt and pepper",
        "olive oil",
        "chickpeas",
        "roasted cashews",
        "tahini",
        "red pepper",
        "garlic cloves",
        "lemon",
        "to orange",
        "arugula or salad greens of your choice"
      ],
      "searchText": "roasted eggplant with crispy chickpeas and cashew sauce globe eggplants salt and pepper olive oil chickpeas roasted cashews tahini red pepper garlic cloves lemon to orange arugula or salad greens of your choice",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026278-roasted-eggplant-with-crispy-chickpeas-and-cashew-sauce?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 256,
      "translatedTitles": {
        "fr": "Aubergine Rôtie Avec Pois Chiches Croustillants et Sauce aux Noix de Cajou"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 47
    },
    {
      "id": "ea785130-79b5-4739-a6f9-7eb2c828e9e2",
      "title": "Rösti, saumon fumé et crème sure",
      "image": "images/ea785130-79b5-4739-a6f9-7eb2c828e9e2_0.jpg",
      "servings": "1",
      "readyInMinutes": 61,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de crème sure ou de crème fraîche liberté",
        "c. à soupe de raifort préparé ou de moutarde de dijon",
        "le zeste râpé de 1/2 citron",
        "aneth frais ciselé ou ciboulette fraîche ou persil plat",
        "sel et poivre du moulin",
        "pomme de terre idaho ou yukon gold",
        "patate douce*",
        "oignons verts",
        "huile d'olive",
        "beurre",
        "saumon fumé",
        "sel et poivre du moulin"
      ],
      "searchText": "rösti, saumon fumé et crème sure tasse de crème sure ou de crème fraîche liberté c. à soupe de raifort préparé ou de moutarde de dijon le zeste râpé de 1/2 citron aneth frais ciselé ou ciboulette fraîche ou persil plat sel et poivre du moulin pomme de terre idaho ou yukon gold patate douce* oignons verts huile d'olive beurre saumon fumé sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/3357/rosti-saumon-fume-et-creme-sure",
      "translatedTitles": {
        "en": "Rösti, Smoked Salmon and Sour Cream"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 51,
      "readyInMinutesMin": 51
    },
    {
      "id": "0168b999-c742-47e1-b1bf-9774e05ad7b6",
      "title": "Röstis à la truite fumée et à la crème sure parfumée à la lime",
      "image": "images/0168b999-c742-47e1-b1bf-9774e05ad7b6_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 72,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "panais",
        "pommes de terre",
        "de beurre",
        "de crème sure",
        "le jus de 1/2 lime",
        "de ciboulette fraîche",
        "tabasco",
        "sel et poivre",
        "de truite fumée ou autre poisson fumé",
        "ciboulette"
      ],
      "searchText": "röstis à la truite fumée et à la crème sure parfumée à la lime panais pommes de terre de beurre de crème sure le jus de 1/2 lime de ciboulette fraîche tabasco sel et poivre de truite fumée ou autre poisson fumé ciboulette",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4461-rostis-a-la-truite-fumee-et-a-la-creme-sure-parfumee-a-la-lime",
      "sourceRating": 4,
      "sourceRatingCount": 9,
      "translatedTitles": {
        "en": "Röstis with smoked trout and lime-scented sour cream"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 72,
      "readyInMinutesMin": 72
    },
    {
      "id": "3ef81857-c9da-4942-8e71-b36a685ac749",
      "title": "Rôti de dindon de Noël (le meilleur)",
      "servings": "8",
      "readyInMinutes": 165,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "saumure",
        "litres d’eau",
        "de sel",
        "de cassonade",
        "de grains de poivre concassés",
        "feuilles de laurier",
        "rôti de dinde désossé d’environ 1",
        "farce",
        "oignon",
        "gousse d’ail",
        "de neberges fraîches ou surgelées",
        "de beurre",
        "de porc haché maigre",
        "poire",
        "de vin fortifié (tel que porto",
        "de bouillon de poulet",
        "de chapelure",
        "pincée de muscade moulue",
        "sauce",
        "oignon",
        "gousses d’ail",
        "de beurre",
        "de farine tout usage non blanchie",
        "de bouillon de poulet",
        "de vin fortifié (tel que porto"
      ],
      "searchText": "rôti de dindon de noël (le meilleur) saumure litres d’eau de sel de cassonade de grains de poivre concassés feuilles de laurier rôti de dinde désossé d’environ 1 farce oignon gousse d’ail de neberges fraîches ou surgelées de beurre de porc haché maigre poire de vin fortifié (tel que porto de bouillon de poulet de chapelure pincée de muscade moulue sauce oignon gousses d’ail de beurre de farine tout usage non blanchie de bouillon de poulet de vin fortifié (tel que porto",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8183-roti-de-dindon-de-noel-le-meilleur",
      "image": "images/3ef81857-c9da-4942-8e71-b36a685ac749_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 44,
      "translatedTitles": {
        "en": "Christmas Turkey Roast (the best)"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "849c36ff-49a5-4f08-8113-4071e3188c6d",
      "title": "Rôti de palette à la façon de Janette Bertrand",
      "image": "images/849c36ff-49a5-4f08-8113-4071e3188c6d_0.jpg",
      "servings": "4",
      "readyInMinutes": 201,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "rôti de palette",
        "sachet soupe à l’oignon en poudre",
        "au goût légumes"
      ],
      "searchText": "rôti de palette à la façon de janette bertrand rôti de palette sachet soupe à l’oignon en poudre au goût légumes",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/105/roti-palette-facon-janette-bertrand",
      "sourceRating": 4.5,
      "sourceRatingCount": 85,
      "translatedTitles": {
        "en": "Pot Roast, Janette Bertrand's Way"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 9,
      "readyInMinutesMin": 201
    },
    {
      "id": "c0ae71cf-4c85-4ac2-ba9b-188c3ccea405",
      "title": "Rôti de porc aux pommes et à l’érable",
      "servings": "6",
      "readyInMinutes": 94,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "farine",
        "rôti de longe de porc de 1",
        "de beurre",
        "de sirop d’érable",
        "oignon",
        "de moutarde de dijon",
        "de vin blanc",
        "pommes cortland",
        "de bouillon de poulet",
        "feuille de laurier",
        "de crème à cuisson",
        "sel et poivre"
      ],
      "searchText": "rôti de porc aux pommes et à l’érable farine rôti de longe de porc de 1 de beurre de sirop d’érable oignon de moutarde de dijon de vin blanc pommes cortland de bouillon de poulet feuille de laurier de crème à cuisson sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4512-roti-de-porc-aux-pommes-et-a-l--erable",
      "image": "images/c0ae71cf-4c85-4ac2-ba9b-188c3ccea405_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 106,
      "translatedTitles": {
        "en": "Pork roast with apples and maple"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 93
    },
    {
      "id": "a4e92ce0-949f-4601-88d4-7eeac8f6bbe5",
      "title": "Roulé de saumon fumé",
      "image": "images/a4e92ce0-949f-4601-88d4-7eeac8f6bbe5_0.jpg",
      "servings": "12 pièces",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de fromage à la crème",
        "zeste d’un citron",
        "de ciboulette hachée",
        "sel et poivre au goût",
        "feuilles de nori",
        "tranches de saumon fumé"
      ],
      "searchText": "roulé de saumon fumé de fromage à la crème zeste d’un citron de ciboulette hachée sel et poivre au goût feuilles de nori tranches de saumon fumé apéritif",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.lesrecettesdecaty.com/fr/recettes/entrees-et-soupes/roule-de-saumon-fume/",
      "translatedTitles": {
        "en": "Smoked salmon roll"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "da6390df-0bc1-4f53-8b8f-76037b6c2b00",
      "title": "Rouleaux de printemps au poulet barbecue & sauce aux arachides",
      "image": "images/da6390df-0bc1-4f53-8b8f-76037b6c2b00_0.jpg",
      "servings": "Pour 6 à 8 rouleaux",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasses de poulet cuit",
        "c. à soupe de gingembre mariné",
        "de tasse de sauce barbecue",
        "à 16 grandes feuilles de riz",
        "de tasse de beurre d’arachide",
        "de tasse de sauce hoisin",
        "c. à soupe de vinaigre de riz",
        "de tasse d’eau",
        "bouquet de coriandre fraîche",
        "tasse de chou rouge",
        "concombre",
        "poivron"
      ],
      "searchText": "rouleaux de printemps au poulet barbecue & sauce aux arachides tasses de poulet cuit c. à soupe de gingembre mariné de tasse de sauce barbecue à 16 grandes feuilles de riz de tasse de beurre d’arachide de tasse de sauce hoisin c. à soupe de vinaigre de riz de tasse d’eau bouquet de coriandre fraîche tasse de chou rouge concombre poivron",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/poulet-volaille/rouleaux-de-printemps-au-poulet-barbecue-sauce-aux-arachides/",
      "translatedTitles": {
        "en": "BBQ Chicken Spring Rolls & Peanut Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 59,
      "readyInMinutesMin": 49
    },
    {
      "id": "82b66a87-ffb8-4ed3-bd58-478a55d022df",
      "title": "Rouleaux de printemps aux crevettes et concombres, sauce crémeuse au tahini",
      "image": "images/82b66a87-ffb8-4ed3-bd58-478a55d022df_0.jpg",
      "servings": "1",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de tahini",
        "c. à soupe d’huile de sésame grillé",
        "gousse d’ail",
        "c. à soupe de sauce tamari",
        "c. à soupe de vinaigre de riz",
        "c. à soupe de miel",
        "c. à soupe de sambal oelek",
        "tasse d’eau très chaude",
        "c. à soupe de sauce tamari",
        "c. à soupe de miel",
        "c. à soupe de jus de lime",
        "c. à thé d’huile de sésame grillée",
        "c. à thé (2",
        "c. à soupe d’huile de ola",
        "de crevettes crues déveinées et décortiquées",
        "à 10 feuilles de riz",
        "concombres libanais",
        "de vermicelles de riz",
        "tasse de carottes en julienne",
        "tasse de radis chinois en julienne",
        "tasse de feuilles de coriandre fraîche ou de menthe fraîche",
        "tasse de gingembre mariné"
      ],
      "searchText": "rouleaux de printemps aux crevettes et concombres, sauce crémeuse au tahini tasse de tahini c. à soupe d’huile de sésame grillé gousse d’ail c. à soupe de sauce tamari c. à soupe de vinaigre de riz c. à soupe de miel c. à soupe de sambal oelek tasse d’eau très chaude c. à soupe de sauce tamari c. à soupe de miel c. à soupe de jus de lime c. à thé d’huile de sésame grillée c. à thé (2 c. à soupe d’huile de ola de crevettes crues déveinées et décortiquées à 10 feuilles de riz concombres libanais de vermicelles de riz tasse de carottes en julienne tasse de radis chinois en julienne tasse de feuilles de coriandre fraîche ou de menthe fraîche tasse de gingembre mariné",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/rouleau-de-printemps-aux-crevettes-et-concombres-sauce-cremeuse-au-tahini/",
      "translatedTitles": {
        "en": "Shrimp and Cucumber Spring Rolls, Creamy Tahini Sauce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 59,
      "readyInMinutesMin": 58
    },
    {
      "id": "028cad89-f114-40bf-a5ac-a716ee5fca73",
      "title": "Salade asiatique",
      "image": "images/028cad89-f114-40bf-a5ac-a716ee5fca73_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poisson grillé",
        "concombre",
        "poivron rouge",
        "champignons blancs",
        "coeur de laitue boston",
        "fèves germées",
        "asperge",
        "oignon doux",
        "sirop d'érable",
        "vinaigre de riz",
        "sauce soya",
        "gousse d'ail",
        "gingembre",
        "lime",
        "sambal oelek",
        "huile de sésame",
        "graines de sésame grillées"
      ],
      "searchText": "salade asiatique poisson grillé concombre poivron rouge champignons blancs coeur de laitue boston fèves germées asperge oignon doux sirop d'érable vinaigre de riz sauce soya gousse d'ail gingembre lime sambal oelek huile de sésame graines de sésame grillées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.zeste.ca/recettes/salade-asiatique",
      "translatedTitles": {
        "en": "Asian Salad"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "1c60f574-6da3-4c09-b083-228687334882",
      "title": "Salade asperge bacon œufs pochés",
      "servings": "1",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "belles grosses asperges de l’île d’orléans",
        "une larme d’huile d’olive",
        "gros œufs de ferme",
        "tranches de 90 chacune du bacon de la ferme turlo",
        "échalote française ciselée",
        "de vin blanc",
        "de vinaigre blanc pour la cuisson des œufs",
        "sel et poivre du moulin"
      ],
      "searchText": "salade asperge bacon œufs pochés belles grosses asperges de l’île d’orléans une larme d’huile d’olive gros œufs de ferme tranches de 90 chacune du bacon de la ferme turlo échalote française ciselée de vin blanc de vinaigre blanc pour la cuisson des œufs sel et poivre du moulin plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://plus.lapresse.ca/screens/cee3567f-ed95-42d2-8f24-38dae978d988__7C___0.html?utm_medium=ulink&utm_campaign=internal+share&utm_content=screen",
      "image": "images/1c60f574-6da3-4c09-b083-228687334882_0.jpg",
      "translatedTitles": {
        "en": "Asparagus Bacon Poached Egg Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 43
    },
    {
      "id": "943d9225-f66c-4edd-b5b6-4a9c824ccf48",
      "title": "Salade craquante des Fêtes",
      "image": "images/943d9225-f66c-4edd-b5b6-4a9c824ccf48_0.jpg",
      "servings": "330 ml (1 ⅓ tasse) de vinaigrette",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "d’huile d’olive",
        "d’échalotes grises",
        "de moutarde de dijon",
        "de miel",
        "de vinaigre de cidre",
        "sel et poivre au goût",
        "chou rouge",
        "escarole ou autre laitue craquante",
        "céleri émincé",
        "julienne de pommes vertes",
        "graines de grenade",
        "roquette",
        "sel et poivre"
      ],
      "searchText": "salade craquante des fêtes d’huile d’olive d’échalotes grises de moutarde de dijon de miel de vinaigre de cidre sel et poivre au goût chou rouge escarole ou autre laitue craquante céleri émincé julienne de pommes vertes graines de grenade roquette sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/salades-et-bols/salade-craquante-des-fetes/?t&utm_source=perplexity",
      "translatedTitles": {
        "en": "Crunchy Holiday Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 38
    },
    {
      "id": "2ef4c41b-86aa-4ad0-899b-e2211f91eae7",
      "title": "Salade croquante au pesto",
      "image": "images/2ef4c41b-86aa-4ad0-899b-e2211f91eae7_0.jpg",
      "servings": "6",
      "readyInMinutes": 22,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "fenouil",
        "radis",
        "concombre libanais",
        "de feuillage",
        "de basilic frais",
        "citron",
        "de graines de tournesol",
        "",
        "poivre",
        "fleur de sel"
      ],
      "searchText": "salade croquante au pesto fenouil radis concombre libanais de feuillage de basilic frais citron de graines de tournesol  poivre fleur de sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/1908/salade-croquante-pesto",
      "translatedTitles": {
        "en": "Crunchy Pesto Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 22
    },
    {
      "id": "7703f790-d36e-431a-8b93-51e9e7e13bf1",
      "title": "Salade d'endives aux poires et radis noirs, croûtons de chèvre cendré",
      "image": "images/7703f790-d36e-431a-8b93-51e9e7e13bf1_0.jpg",
      "servings": "4",
      "readyInMinutes": 24,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salade d'endives",
        "endives",
        "poires fermes mais mûres",
        "à 1 radis noir",
        "pruneaux séchés",
        "d'huile d'olive",
        "de vinaigre balsamique",
        "fleur de sel",
        "poivre du moulin",
        "croûtons",
        "bûchette de chèvre cendré",
        "longs croûtons de pain uette"
      ],
      "searchText": "salade d'endives aux poires et radis noirs, croûtons de chèvre cendré salade d'endives endives poires fermes mais mûres à 1 radis noir pruneaux séchés d'huile d'olive de vinaigre balsamique fleur de sel poivre du moulin croûtons bûchette de chèvre cendré longs croûtons de pain uette",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/3914-salade-d-endives-aux-poires-et-radis-noirs-croutons-de-chevre-cendre",
      "sourceRating": 4,
      "sourceRatingCount": 3,
      "translatedTitles": {
        "en": "Endive salad with pears and black radishes, ash goat cheese croutons"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 24
    },
    {
      "id": "8a9a78cc-2f10-44d9-ae5e-3b4d66b9328d",
      "title": "Salade de chou classique",
      "image": "images/8a9a78cc-2f10-44d9-ae5e-3b4d66b9328d_0.jpg",
      "servings": "1",
      "readyInMinutes": 23,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de chou rouge",
        "c. à thé de sucre",
        "c. à thé de sel casher",
        "grosse carotte",
        "de mayonnaise",
        "de vinaigre blanc",
        "c. à thé de graines de céleri",
        "de persil"
      ],
      "searchText": "salade de chou classique de chou rouge c. à thé de sucre c. à thé de sel casher grosse carotte de mayonnaise de vinaigre blanc c. à thé de graines de céleri de persil",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://fr.chatelaine.com/recettes/salades/salade-de-chou-classique/",
      "translatedTitles": {
        "en": "Classic Cabbage Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 8,
      "readyInMinutesMin": 23
    },
    {
      "id": "83009bd7-1d7d-43fa-bfb4-972e30d23406",
      "title": "Salade de concombre, pois chiches croustillants et feta fouettée",
      "image": "images/83009bd7-1d7d-43fa-bfb4-972e30d23406_0.jpg",
      "servings": "1",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pois chiches croustillants",
        "conserve de 540 de pois chiches",
        "d'huile véétale",
        "d'origan séché",
        "de sel",
        "poivre",
        "feta fouettée",
        "de feta sans produits laitiers",
        "de crème sans produits laitiers",
        "d'huile d'olive",
        "de jus de citron",
        "de miel",
        "de sel",
        "salade de concombre",
        "concombres anglais",
        "oignons verts",
        "d'aneth frais haché grossièrement",
        "de vinaigre de vin blanc",
        "de miel",
        "d'huile d'olive",
        "de sel",
        "poivre"
      ],
      "searchText": "salade de concombre, pois chiches croustillants et feta fouettée pois chiches croustillants conserve de 540 de pois chiches d'huile véétale d'origan séché de sel poivre feta fouettée de feta sans produits laitiers de crème sans produits laitiers d'huile d'olive de jus de citron de miel de sel salade de concombre concombres anglais oignons verts d'aneth frais haché grossièrement de vinaigre de vin blanc de miel d'huile d'olive de sel poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Cucumber, Crispy Chickpea and Whipped Feta Salad"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "61f633cc-2041-411f-8c00-c80c34e2855b",
      "title": "SALADE DE COUSCOUS ISRAÉLIEN, HALLOUMI GRILLÉ ET AMANDES",
      "servings": "1",
      "readyInMinutes": 53,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "une tasse bombée de couscous israelien",
        "½ tasse d'amande",
        "¾ de tasse de petits pois",
        "cuillères à table d'huile d'olive",
        "poivre du moulin au goût",
        "le zeste et le jus d'un citron",
        "concombre libanais",
        "de tasse de feta",
        "quelques branches de menthe fraiche",
        "quelques branches de persil plat",
        "d'halloumi",
        "de la pancetta"
      ],
      "searchText": "salade de couscous israélien, halloumi grillé et amandes une tasse bombée de couscous israelien ½ tasse d'amande ¾ de tasse de petits pois cuillères à table d'huile d'olive poivre du moulin au goût le zeste et le jus d'un citron concombre libanais de tasse de feta quelques branches de menthe fraiche quelques branches de persil plat d'halloumi de la pancetta",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://emiliemurmure.com/salade-de-couscous-israelien-halloumi-grille-et-amandes/",
      "image": "images/61f633cc-2041-411f-8c00-c80c34e2855b_0.jpg",
      "translatedTitles": {
        "en": "ISRAELI COUSCOUS SALAD, GRILLED HALLOUMI AND ALMONDS"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 51
    },
    {
      "id": "33a6899c-2e46-4f90-a4a8-bef36fcdf6a7",
      "title": "Salade de crabe",
      "image": "images/33a6899c-2e46-4f90-a4a8-bef36fcdf6a7_0.jpg",
      "servings": "4",
      "readyInMinutes": 17,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. tige d'échalote",
        "de chair de crabe",
        "de légumes confits",
        "c. de poivre",
        "de sauce worcestershire",
        "citron",
        "gousse d'ail",
        "oignon ciselé",
        "légumes au goût",
        "mayonnaise au goût",
        "tabasco au goût",
        "feta",
        "micropousses",
        "edamames",
        "carottes",
        "concombres",
        "mesclun",
        "fleurs comestibles"
      ],
      "searchText": "salade de crabe c. tige d'échalote de chair de crabe de légumes confits c. de poivre de sauce worcestershire citron gousse d'ail oignon ciselé légumes au goût mayonnaise au goût tabasco au goût feta micropousses edamames carottes concombres mesclun fleurs comestibles plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Crab Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 17
    },
    {
      "id": "22a59297-0c8d-4941-bd13-048ca85b2102",
      "title": "Salade de fruits verte de Noël",
      "image": "images/22a59297-0c8d-4941-bd13-048ca85b2102_0.jpg",
      "servings": "6",
      "readyInMinutes": 31,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pomme verte non pelée",
        "de jus de lime",
        "de raisins verts sans pépins",
        "kiwis",
        "de sucre"
      ],
      "searchText": "salade de fruits verte de noël pomme verte non pelée de jus de lime de raisins verts sans pépins kiwis de sucre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7198-salade-de-fruits-verte-de-noel",
      "sourceRating": 4,
      "sourceRatingCount": 5,
      "translatedTitles": {
        "en": "Christmas Green Fruit Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 31
    },
    {
      "id": "f8c3bcda-90b4-42a9-8260-7b2d646f58c6",
      "title": "Salade de kale, de poulet grillé & vinaigrette piri-piri",
      "image": "images/f8c3bcda-90b4-42a9-8260-7b2d646f58c6_0.jpg",
      "servings": "1",
      "readyInMinutes": 62,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "à 6 hauts de cuisse de poulet",
        "un filet d’huile d’olive",
        "pour la vinaigrette piri-piri",
        "½ tasse d’huile d’olive",
        "¼ tasse de vinaigre de vin blanc",
        "gousse d’ail hachée finement",
        "piment fort rouge haché ou 1 c. à thé de flocons de chili",
        "c. à soupe de moutarde de dijon",
        "sel et poivre",
        "pour la salade",
        "tasses de chou frisé",
        "tasses de laitue romaine",
        "¼ tasse de fromage féta émietté",
        "½ tasse de noix au choix",
        "tasse de fruits de saison coupés en bouchées"
      ],
      "searchText": "salade de kale, de poulet grillé & vinaigrette piri-piri à 6 hauts de cuisse de poulet un filet d’huile d’olive pour la vinaigrette piri-piri ½ tasse d’huile d’olive ¼ tasse de vinaigre de vin blanc gousse d’ail hachée finement piment fort rouge haché ou 1 c. à thé de flocons de chili c. à soupe de moutarde de dijon sel et poivre pour la salade tasses de chou frisé tasses de laitue romaine ¼ tasse de fromage féta émietté ½ tasse de noix au choix tasse de fruits de saison coupés en bouchées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/salades-et-bols/salade-de-kale-de-poulet-grille-vinaigrette-piri-piri/",
      "translatedTitles": {
        "en": "Kale Salad, Grilled Chicken & Piri-Piri Vinaigrette"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 45,
      "readyInMinutesMin": 56
    },
    {
      "id": "6b731bfa-1483-4472-a53c-25094014d858",
      "title": "Salade de laitue romaine grillée, noix et érable",
      "image": "images/6b731bfa-1483-4472-a53c-25094014d858_0.jpg",
      "servings": "4",
      "readyInMinutes": 27,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de yogourt grec nature",
        "d’huile d’olive",
        "de vinaigre de cidre de pomme",
        "de sirop d’érable",
        "de moutarde de dijon",
        "de paes hachées",
        "de graines de tournesol",
        "cœurs de laitue romaine",
        "de neberges séchées",
        "au goût"
      ],
      "searchText": "salade de laitue romaine grillée, noix et érable de yogourt grec nature d’huile d’olive de vinaigre de cidre de pomme de sirop d’érable de moutarde de dijon de paes hachées de graines de tournesol cœurs de laitue romaine de neberges séchées au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.rachellebery.ca/fr/recettes/salade-de-laitue-romaine-grillee-noix-et-erable/",
      "translatedTitles": {
        "en": "Grilled Romaine Lettuce, Nut, and Maple Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 26
    },
    {
      "id": "9ca29192-a97d-452e-9e4c-6a9e0573c826",
      "title": "Salade de légumes grillés à l'ail",
      "image": "images/9ca29192-a97d-452e-9e4c-6a9e0573c826_0.jpg",
      "servings": "1",
      "readyInMinutes": 52,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vinaigrette",
        "petite gousse d’ail",
        "pincée de flocons de piment fort broyés",
        "de moutarde de dijon",
        "de sucre",
        "de vinaigre de vin blanc",
        "d’huile d’olive",
        "fleur de sel",
        "poivre",
        "salade",
        "de petites asperges",
        "courgettes",
        "poivrons",
        "oignons verts entiers",
        "de champignons blancs",
        "d’huile d’olive",
        "de tomates cerises coupées en deux"
      ],
      "searchText": "salade de légumes grillés à l'ail vinaigrette petite gousse d’ail pincée de flocons de piment fort broyés de moutarde de dijon de sucre de vinaigre de vin blanc d’huile d’olive fleur de sel poivre salade de petites asperges courgettes poivrons oignons verts entiers de champignons blancs d’huile d’olive de tomates cerises coupées en deux",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5708-salade-de-legumes-grilles-a-l-ail",
      "sourceRating": 5,
      "sourceRatingCount": 33,
      "translatedTitles": {
        "en": "Grilled Garlic Vegetable Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 40,
      "readyInMinutesMin": 50
    },
    {
      "id": "796226fa-411f-4fb3-90b2-9ad20cf6e577",
      "title": "Salade de légumes grillés à la provençale",
      "image": "images/796226fa-411f-4fb3-90b2-9ad20cf6e577_0.jpg",
      "servings": "1",
      "readyInMinutes": 27,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "aubergine coupée en tranches de 1/2 po d'épaisseur",
        "poivrons coupés en quatre sur la longueur",
        "petit oignon rouge",
        "cuillères à table d' huile aromatisée à l'ail",
        "tranches de pain au levain ou de pain de campagne de 1 po (2",
        "tomates coupées en morceaux de 3/4 po ou 2 t de tomates cerises coupées en deux",
        "de fromage de chèvre émietté",
        "olives noires kalamata coupées en deux",
        "cuillères à table de pignons léèrement grillés",
        "sel et poivre noir du moulin",
        "vinaigrette au pesto",
        "fibres 5",
        "sodium 534 mg",
        "protéines 13",
        "calories 505",
        "total gras 37",
        "cholestérol 28 mg",
        "gras saturés 6",
        "total glucides 34"
      ],
      "searchText": "salade de légumes grillés à la provençale aubergine coupée en tranches de 1/2 po d'épaisseur poivrons coupés en quatre sur la longueur petit oignon rouge cuillères à table d' huile aromatisée à l'ail tranches de pain au levain ou de pain de campagne de 1 po (2 tomates coupées en morceaux de 3/4 po ou 2 t de tomates cerises coupées en deux de fromage de chèvre émietté olives noires kalamata coupées en deux cuillères à table de pignons léèrement grillés sel et poivre noir du moulin vinaigrette au pesto fibres 5 sodium 534 mg protéines 13 calories 505 total gras 37 cholestérol 28 mg gras saturés 6 total glucides 34",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.coupdepouce.com/cuisine/entrees-et-accompagnements/recette/salade-de-legumes-grilles-a-la-provencale",
      "translatedTitles": {
        "en": "Provençal Grilled Vegetable Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 24
    },
    {
      "id": "d96d2e94-610e-4201-b67a-22b259764263",
      "title": "Salade de légumineuses à la grecque",
      "image": "images/d96d2e94-610e-4201-b67a-22b259764263_0.jpg",
      "servings": "Pour 4-6 personnes",
      "readyInMinutes": 15,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boîte de 540 de pois chiches",
        "tasse de haricots noirs",
        "tasse d’oignon rouge",
        "tasse de concombre",
        "tomate",
        "tasse d’edamames surgelés",
        "tasse de fromage féta",
        "une poignée de persil frais",
        "sel et poivre",
        "pour la vinaigrette",
        "le jus d’un citron",
        "c. à soupe d’huile véétale",
        "c. à thé d’origan séché",
        "sel et poivre"
      ],
      "searchText": "salade de légumineuses à la grecque boîte de 540 de pois chiches tasse de haricots noirs tasse d’oignon rouge tasse de concombre tomate tasse d’edamames surgelés tasse de fromage féta une poignée de persil frais sel et poivre pour la vinaigrette le jus d’un citron c. à soupe d’huile véétale c. à thé d’origan séché sel et poivre plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/legumineuses/salade-de-legumineuses-a-la-grecque/",
      "translatedTitles": {
        "en": "Greek Legume Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 15
    },
    {
      "id": "10a592d7-22ed-4306-98a2-0deaef1c8796",
      "title": "Salade de papaye verte",
      "image": "images/10a592d7-22ed-4306-98a2-0deaef1c8796_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 17,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de sauce de poisson",
        "de jus de lime",
        "de sucre de ne ou de cassonade",
        "gousses d’ail",
        "piment oiseau épépiné et haché finement",
        "de papaye verte coupée en julienne (environ 1 papaye de 450 /1",
        "carotte",
        "de tomates cerises",
        "d’arachides salées",
        "de feuilles de basilic thaï déchirées"
      ],
      "searchText": "salade de papaye verte de sauce de poisson de jus de lime de sucre de ne ou de cassonade gousses d’ail piment oiseau épépiné et haché finement de papaye verte coupée en julienne (environ 1 papaye de 450 /1 carotte de tomates cerises d’arachides salées de feuilles de basilic thaï déchirées",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/10214-salade-de-papaye-verte",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Green Papaya Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 17
    },
    {
      "id": "245f9912-85d5-4ae0-8a84-6eb2ddfc5f44",
      "title": "Salade de pêche, concombre et ricotta maison",
      "image": "images/245f9912-85d5-4ae0-8a84-6eb2ddfc5f44_0.jpg",
      "servings": "4",
      "readyInMinutes": 34,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pêche",
        "½ fenouil",
        "concombre libanais",
        "de persil frais",
        "de ciboulette fraîche",
        "de vinaigrette à l’échalote confite",
        "au goût sel",
        "de ricotta maison",
        "basilic"
      ],
      "searchText": "salade de pêche, concombre et ricotta maison pêche ½ fenouil concombre libanais de persil frais de ciboulette fraîche de vinaigrette à l’échalote confite au goût sel de ricotta maison basilic",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/4920/salade-peche-concombre-ricotta-maison",
      "sourceRating": 4,
      "sourceRatingCount": 2,
      "translatedTitles": {
        "en": "Peach, Cucumber and Homemade Ricotta Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 34
    },
    {
      "id": "4d7bfa51-73c7-42ab-92f5-feab468d52b9",
      "title": "Salade de pois chiches, concombre & herbes fraîches",
      "image": "images/4d7bfa51-73c7-42ab-92f5-feab468d52b9_0.jpg",
      "servings": "Pour 6",
      "readyInMinutes": 19,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de pois chiches",
        "tasse de céleri",
        "tasse de concombre",
        "tasse d’oignon rouge",
        "carotte",
        "tasse de persil plat",
        "tasse de basilic",
        "tasse de coriandre fraîche",
        "tasse de fromage féta",
        "le jus d’un citron",
        "c. à soupe d’huile d’olive options de remplacement ou d’huile véétale",
        "c. à soupe de vinaigre balsamique",
        "c. à thé de fleur de sel",
        "poivre"
      ],
      "searchText": "salade de pois chiches, concombre & herbes fraîches de pois chiches tasse de céleri tasse de concombre tasse d’oignon rouge carotte tasse de persil plat tasse de basilic tasse de coriandre fraîche tasse de fromage féta le jus d’un citron c. à soupe d’huile d’olive options de remplacement ou d’huile véétale c. à soupe de vinaigre balsamique c. à thé de fleur de sel poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/legumineuses/salade-de-pois-chiches-concombre-herbes-fraiches/",
      "translatedTitles": {
        "en": "Chickpea, Cucumber & Fresh Herb Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 19
    },
    {
      "id": "0bbec46c-e1b7-4b00-b562-e6db840d5ca0",
      "title": "Salade de raviolis aux poireaux et aux asperges",
      "image": "images/0bbec46c-e1b7-4b00-b562-e6db840d5ca0_0.jpg",
      "servings": "4",
      "readyInMinutes": 30,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poireau",
        "herbes fraîches",
        "asperges",
        "citron",
        "raviolis au fromage",
        "petits pois surgelés",
        "jeunes épinards",
        "huile d’olive",
        "poivre du moulin",
        "fleur de sel"
      ],
      "searchText": "salade de raviolis aux poireaux et aux asperges poireau herbes fraîches asperges citron raviolis au fromage petits pois surgelés jeunes épinards huile d’olive poivre du moulin fleur de sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/salade-de-raviolis-aux-poireaux-et-aux-asperges/",
      "sourceRating": 4.5,
      "sourceRatingCount": 8,
      "translatedTitles": {
        "en": "Ravioli Salad with Leeks and Asparagus"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 30
    },
    {
      "id": "044fabc1-ad5b-4f40-8c78-fd44fb1f7d5e",
      "title": "Salade de roquette, melon d'eau, asperge & feta",
      "image": "images/044fabc1-ad5b-4f40-8c78-fd44fb1f7d5e_0.jpg",
      "servings": "1",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "fines asperges",
        "tasses de melon d'eau coupées en cubes",
        "bonnes poignées de roquette",
        "une poignée de pousse de tournesol",
        "de feta émiettée",
        "tasse de bleuets",
        "fraises coupées en 2 ou 4",
        "feuilles de basilic ciselées",
        "cuillères à soupe d'huile d'olive",
        "une cuillère à soupe de vinaigre de cidre de pomme",
        "une gousse d'ail râpée finement",
        "sel de mer et poivre du moulin"
      ],
      "searchText": "salade de roquette, melon d'eau, asperge & feta fines asperges tasses de melon d'eau coupées en cubes bonnes poignées de roquette une poignée de pousse de tournesol de feta émiettée tasse de bleuets fraises coupées en 2 ou 4 feuilles de basilic ciselées cuillères à soupe d'huile d'olive une cuillère à soupe de vinaigre de cidre de pomme une gousse d'ail râpée finement sel de mer et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://emiliemurmure.com/salade-de-roquette-asperge-melon-deau-et-feta/",
      "translatedTitles": {
        "en": "Arugula, Watermelon, Asparagus & Feta Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 37
    },
    {
      "id": "0d321ca2-2ef4-46b4-a09f-8d4c032d9320",
      "title": "salade de tartare de saumon épicé, maïs et chips de pita",
      "image": "images/0d321ca2-2ef4-46b4-a09f-8d4c032d9320_0.jpg",
      "servings": "2",
      "readyInMinutes": 41,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "pain pita",
        "d'huile d'olive",
        "d'épices à steak de montréal",
        "de grains de maïs surgelés",
        "de laitue iceberg",
        "petite échalote française",
        "de saumon très frais sans la peau",
        "en dés",
        "de mayonnaise",
        "de vinaigre de vin rouge",
        "de sauce piri-piri",
        "de sauce worcestershire",
        "de paprika fumé"
      ],
      "searchText": "salade de tartare de saumon épicé, maïs et chips de pita pain pita d'huile d'olive d'épices à steak de montréal de grains de maïs surgelés de laitue iceberg petite échalote française de saumon très frais sans la peau en dés de mayonnaise de vinaigre de vin rouge de sauce piri-piri de sauce worcestershire de paprika fumé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceRating": 5,
      "sourceRatingCount": 6,
      "translatedTitles": {
        "en": "spicy salmon tartare salad, corn and pita chips"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 41
    },
    {
      "id": "f9346d77-5cc5-4af5-bd27-81b31655a65b",
      "title": "Salade de tomates au bacon et au fromage halloumi grillés",
      "image": "images/f9346d77-5cc5-4af5-bd27-81b31655a65b_0.jpg",
      "servings": "4",
      "readyInMinutes": 46,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tranches de pain uette de 1 cm d’épaisseur",
        "de fromage halloumi",
        "d’huile d’olive",
        "tranches épaisses de bacon de 1 cm d’épaisseur",
        "tomates de couleurs variées",
        "de feuilles de basilic déchirées",
        "de feuilles de persil déchirées",
        "citron"
      ],
      "searchText": "salade de tomates au bacon et au fromage halloumi grillés tranches de pain uette de 1 cm d’épaisseur de fromage halloumi d’huile d’olive tranches épaisses de bacon de 1 cm d’épaisseur tomates de couleurs variées de feuilles de basilic déchirées de feuilles de persil déchirées citron",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/9143-salade-de-tomates-au-bacon-et-au-fromage-halloumi-grilles",
      "sourceRating": 5,
      "sourceRatingCount": 11,
      "translatedTitles": {
        "en": "Tomato salad with grilled bacon and halloumi cheese"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 46
    },
    {
      "id": "f9bbec59-8e6c-4203-932b-daa665c7d9f7",
      "title": "Salade façon grecque",
      "image": "images/f9bbec59-8e6c-4203-932b-daa665c7d9f7_0.jpg",
      "servings": "1",
      "readyInMinutes": 36,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de feta",
        "tomates moyennes",
        "belle tranche de pastèque",
        "oignons rouges",
        "mini concombres",
        "olives noires de kalamata",
        "de roquette",
        "feuilles de menthe",
        "brins de coriandre",
        "brins de persil plat",
        "bonne pincée d’origan",
        "cuil. à soupe d’huile d’olive",
        "le jus de 1/2 citron",
        "sel",
        "poivre"
      ],
      "searchText": "salade façon grecque de feta tomates moyennes belle tranche de pastèque oignons rouges mini concombres olives noires de kalamata de roquette feuilles de menthe brins de coriandre brins de persil plat bonne pincée d’origan cuil. à soupe d’huile d’olive le jus de 1/2 citron sel poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.marieclaire.fr/cuisine/salade-facon-grecque,1193832.asp",
      "translatedTitles": {
        "en": "Greek-style Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 36
    },
    {
      "id": "c8d20dcd-99f0-4d99-980e-30d89824b6ac",
      "title": "Salade fattouche",
      "image": "images/c8d20dcd-99f0-4d99-980e-30d89824b6ac_0.jpg",
      "servings": "6",
      "readyInMinutes": 59,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "croûtons de pita",
        "pains pitas",
        "d’huile d’olive",
        "sel et poivre",
        "vinaigrette",
        "de jus de citron",
        "d’huile d’olive",
        "de miel",
        "petite gousse d’ail",
        "sel et poivre",
        "légumes",
        "concombres libanais non pelés",
        "poivron rouge",
        "litre de laitue romaine déchiquetée",
        "de tomates cerises",
        "oignons verts"
      ],
      "searchText": "salade fattouche croûtons de pita pains pitas d’huile d’olive sel et poivre vinaigrette de jus de citron d’huile d’olive de miel petite gousse d’ail sel et poivre légumes concombres libanais non pelés poivron rouge litre de laitue romaine déchiquetée de tomates cerises oignons verts",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6148-salade-fattouche",
      "sourceRating": 4,
      "sourceRatingCount": 15,
      "translatedTitles": {
        "en": "Fattoush Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 59
    },
    {
      "id": "8a06c9ef-97ae-486a-b4de-0bb956bb03e9",
      "title": "Salade fattouche classique",
      "image": "images/8a06c9ef-97ae-486a-b4de-0bb956bb03e9_0.jpg",
      "servings": "1",
      "readyInMinutes": 26,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "laitue iceberg coupée grossièrement",
        "⁄2 poivron rouge épépiné et coupé en dés de 2 cm",
        "⁄2 poivron jaune épépiné et coupé en dés de 2 cm",
        "⁄2 poivron orange épépiné et coupé en dés de 2 cm",
        "radis en fines tranches",
        "feuilles de menthe fraîche ciselées",
        "c. à table de persil frisé haché",
        "c. à table de zaatar",
        "c. à table de sumac",
        "grosse tomate coupée en dés de 2 cm",
        "concombres libanais coupés en dés de 2cm",
        "vinaigrette",
        "⁄4 tasse d’huile d’olive",
        "c. à table de vinaigre de vin rouge",
        "⁄2 citron",
        "tasse de feuilles de pourpier",
        "c. à thé d’ail haché",
        "garniture",
        "tasse de morceaux de pitas croustillants au zaatar"
      ],
      "searchText": "salade fattouche classique laitue iceberg coupée grossièrement ⁄2 poivron rouge épépiné et coupé en dés de 2 cm ⁄2 poivron jaune épépiné et coupé en dés de 2 cm ⁄2 poivron orange épépiné et coupé en dés de 2 cm radis en fines tranches feuilles de menthe fraîche ciselées c. à table de persil frisé haché c. à table de zaatar c. à table de sumac grosse tomate coupée en dés de 2 cm concombres libanais coupés en dés de 2cm vinaigrette ⁄4 tasse d’huile d’olive c. à table de vinaigre de vin rouge ⁄2 citron tasse de feuilles de pourpier c. à thé d’ail haché garniture tasse de morceaux de pitas croustillants au zaatar",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.salutbonjour.ca/2021/02/20/salade-fattouche-classique",
      "translatedTitles": {
        "en": "Classic Fattoush Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 26
    },
    {
      "id": "13bda484-f5e0-4987-a216-21f3e323fdbb",
      "title": "Salade grecque",
      "image": "images/13bda484-f5e0-4987-a216-21f3e323fdbb_0.jpg",
      "servings": "4",
      "readyInMinutes": 22,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vinaigrette",
        "d’huile d’olive",
        "de jus de citron",
        "d’olives noires dénoyautées dans l’huile",
        "de persil plat ciselé",
        "de sucre",
        "de moutarde de dijon",
        "salade",
        "tomates",
        "concombre anglais",
        "poivron jaune",
        "de fromage feta coupé en dés",
        "d’oignon rouge"
      ],
      "searchText": "salade grecque vinaigrette d’huile d’olive de jus de citron d’olives noires dénoyautées dans l’huile de persil plat ciselé de sucre de moutarde de dijon salade tomates concombre anglais poivron jaune de fromage feta coupé en dés d’oignon rouge",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5551-salade-grecque",
      "sourceRating": 5,
      "sourceRatingCount": 164,
      "translatedTitles": {
        "en": "Greek Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 22,
      "readyInMinutesMin": 22
    },
    {
      "id": "15748701-074a-4c88-8efe-8b4787840857",
      "title": "Salade verte et vinaigrette à la papaye",
      "image": "images/15748701-074a-4c88-8efe-8b4787840857_0.jpg",
      "servings": "10",
      "readyInMinutes": 25,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vinaigrette",
        "petite papaye d’environ 600",
        "d’eau",
        "d’huile de ola",
        "de sirop d’érable",
        "de vinaigre balsamique blanc",
        "salade",
        "de laitue romaine ou frisée verte déchiquetée",
        "concombres libanais",
        "de noix de coco fraîche émincée",
        "fleurs comestibles"
      ],
      "searchText": "salade verte et vinaigrette à la papaye vinaigrette petite papaye d’environ 600 d’eau d’huile de ola de sirop d’érable de vinaigre balsamique blanc salade de laitue romaine ou frisée verte déchiquetée concombres libanais de noix de coco fraîche émincée fleurs comestibles",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/7584-salade-verte-et-vinaigrette-a-la-papaye",
      "sourceRating": 5,
      "sourceRatingCount": 2,
      "translatedTitles": {
        "en": "Green salad and papaya vinaigrette"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "0e650e85-53b4-4030-9ef9-f75ef30ecaa4",
      "title": "Salmon With Avocado and Cilantro Salad",
      "image": "images/0e650e85-53b4-4030-9ef9-f75ef30ecaa4_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salmon fillet",
        "limes",
        "olive oil",
        "garlic cloves",
        "coriander",
        "salt",
        "scallions",
        "cumin",
        "jalapeño or fresno chile",
        "avocados",
        "packed watercress",
        "torn cilantro leaves and delicate sprigs"
      ],
      "searchText": "salmon with avocado and cilantro salad salmon fillet limes olive oil garlic cloves coriander salt scallions cumin jalapeño or fresno chile avocados packed watercress torn cilantro leaves and delicate sprigs",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025955-salmon-with-avocado-and-cilantro-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 785,
      "translatedTitles": {
        "fr": "Saumon avec Salade d'Avocat et de Coriandre"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 49
    },
    {
      "id": "8a99815e-ccaa-4e52-9452-6792878f3bc5",
      "title": "Salpicón de Pescado (Spicy Citrus-Marinated Fish)",
      "image": "images/8a99815e-ccaa-4e52-9452-6792878f3bc5_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 40,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "boneless",
        "to 2 habanero chiles",
        "garlic cloves",
        "lime juice",
        "orange juice",
        "- olive oil",
        "kosher salt and ly pepper",
        "roma tomatoes",
        "red onion",
        "radishes",
        "avocado",
        "cilantro leaves with tender stems",
        "tostadas or warm tortillas"
      ],
      "searchText": "salpicón de pescado (spicy citrus-marinated fish) boneless to 2 habanero chiles garlic cloves lime juice orange juice - olive oil kosher salt and ly pepper roma tomatoes red onion radishes avocado cilantro leaves with tender stems tostadas or warm tortillas",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026323-salpicon-de-pescado-spicy-citrus-marinated-fish?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 452,
      "translatedTitles": {
        "fr": "Salpicón de Pescado (Poisson épicé mariné aux agrumes)"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "e6be7268-13f6-462d-9d5d-4aeb43ef4000",
      "title": "Salsa Verde Cruda",
      "image": "images/e6be7268-13f6-462d-9d5d-4aeb43ef4000_0.jpg",
      "servings": "Make 1 1/4 cups",
      "readyInMinutes": 13,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tomatillos",
        "coarsely cilantro",
        "jalapeño",
        "garlic clove",
        "kosher salt",
        "pepper"
      ],
      "searchText": "salsa verde cruda tomatillos coarsely cilantro jalapeño garlic clove kosher salt pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/salsa-verde-cruda",
      "translatedTitles": {
        "fr": "Salsa Verde Cruda"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 13
    },
    {
      "id": "ed32ae42-4c17-4ecb-a7c3-2b2d648cea90",
      "title": "Sandwich BLT (Bacon-Laitue-Tomate)",
      "image": "images/ed32ae42-4c17-4ecb-a7c3-2b2d648cea90_0.jpg",
      "servings": "2",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tranches de bacon",
        "tranches de pain",
        "de mayonnaise",
        "feuilles de laitue frisée",
        "à 4 tranches de tomate",
        "sel et poivre"
      ],
      "searchText": "sandwich blt (bacon-laitue-tomate) tranches de bacon tranches de pain de mayonnaise feuilles de laitue frisée à 4 tranches de tomate sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7176-sandwich-blt-bacon-laitue-tomate",
      "sourceRating": 5,
      "sourceRatingCount": 2,
      "translatedTitles": {
        "en": "BLT Sandwich (Bacon-Lettuce-Tomato)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 42
    },
    {
      "id": "fe1d7e32-7f7f-47e7-adfe-b8f901e59f87",
      "title": "Sandwich gargantuesque",
      "servings": "10",
      "readyInMinutes": 64,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poivrons rouges et jaunes",
        "miche de pain de campagne de 23 cm de diamètre",
        "de beurre",
        "de tapenade aux tomates séchées et olives",
        "à 5 tranches fines de 8 variétés de viandes froides au choix",
        "tranches de mozzarella",
        "de coeurs d'artichauts",
        "de noix de pin"
      ],
      "searchText": "sandwich gargantuesque poivrons rouges et jaunes miche de pain de campagne de 23 cm de diamètre de beurre de tapenade aux tomates séchées et olives à 5 tranches fines de 8 variétés de viandes froides au choix tranches de mozzarella de coeurs d'artichauts de noix de pin plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/535-sandwich-gargantuesque",
      "image": "images/fe1d7e32-7f7f-47e7-adfe-b8f901e59f87_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Gargantuan Sandwich"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 64
    },
    {
      "id": "fbeb7e72-4524-4c84-a737-1df083264745",
      "title": "Sandwich gargantuesque",
      "image": "images/fbeb7e72-4524-4c84-a737-1df083264745_0.jpg",
      "servings": "10",
      "readyInMinutes": 64,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poivrons rouges et jaunes",
        "miche de pain de campagne de 23 cm de diamètre",
        "de beurre",
        "de tapenade aux tomates séchées et olives",
        "à 5 tranches fines de 8 variétés de viandes froides au choix",
        "tranches de mozzarella",
        "de coeurs d'artichauts",
        "de noix de pin"
      ],
      "searchText": "sandwich gargantuesque poivrons rouges et jaunes miche de pain de campagne de 23 cm de diamètre de beurre de tapenade aux tomates séchées et olives à 5 tranches fines de 8 variétés de viandes froides au choix tranches de mozzarella de coeurs d'artichauts de noix de pin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "http://www.ricardocuisine.com/recettes/535-sandwich-gargantuesque",
      "sourceRating": 5,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Gargantuan Sandwich"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 64
    },
    {
      "id": "cea1d930-892d-4314-982d-a37748672cc0",
      "title": "Saumon à la crème et aux épinards",
      "image": "images/cea1d930-892d-4314-982d-a37748672cc0_0.jpg",
      "servings": "4",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe d’huile d’olive",
        "tasse d’échalotes françaises",
        "gousse d’ail",
        "c. à thé (2",
        "tasse de vin blanc",
        "tasses (1",
        "tasse de bouillon de poulet",
        "c. à thé (1",
        "poivre au goût",
        "filets de saumon sans la peau",
        "c. à thé de graines de fenouil ou d’aneth broyées ou de coriandre moulue",
        "sel et poivre",
        "tasse de crème de soya belsoy",
        "zeste de 1/2 citron bien lavé"
      ],
      "searchText": "saumon à la crème et aux épinards c. à soupe d’huile d’olive tasse d’échalotes françaises gousse d’ail c. à thé (2 tasse de vin blanc tasses (1 tasse de bouillon de poulet c. à thé (1 poivre au goût filets de saumon sans la peau c. à thé de graines de fenouil ou d’aneth broyées ou de coriandre moulue sel et poivre tasse de crème de soya belsoy zeste de 1/2 citron bien lavé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/saumon-a-la-creme-et-aux-epinards/",
      "translatedTitles": {
        "en": "Salmon with Cream and Spinach"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 45
    },
    {
      "id": "daeac5c1-5623-4bab-a0d7-000e2bd7bd28",
      "title": "Saumon sur planche d'érable",
      "image": "images/daeac5c1-5623-4bab-a0d7-000e2bd7bd28_0.jpg",
      "servings": "4",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "planche d'érable ou de cèdre non traitée d'environ 38 x 15 cm",
        "de filet de saumon",
        "marinade aux herbes",
        "d'huile d'olive",
        "le jus de 1 lime ou de 1/2 citron",
        "de miel",
        "d'herbes fraîches (ciboulette",
        "sel et poivre",
        "marinade teriyaki",
        "de sauce soya",
        "de mirin",
        "de vinaigre de riz",
        "de jus de citron",
        "de cassonade",
        "d'huile de sésame grillé",
        "gousses d'ail",
        "oignon vert",
        "poivre"
      ],
      "searchText": "saumon sur planche d'érable planche d'érable ou de cèdre non traitée d'environ 38 x 15 cm de filet de saumon marinade aux herbes d'huile d'olive le jus de 1 lime ou de 1/2 citron de miel d'herbes fraîches (ciboulette sel et poivre marinade teriyaki de sauce soya de mirin de vinaigre de riz de jus de citron de cassonade d'huile de sésame grillé gousses d'ail oignon vert poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/721-saumon-sur-planche-d-erable",
      "sourceRating": 5,
      "sourceRatingCount": 27,
      "translatedTitles": {
        "en": "Salmon on Maple Plank"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "529860e5-bced-4d99-b555-7c7af9de3d41",
      "title": "Sauté asiatique au canard",
      "image": "images/529860e5-bced-4d99-b555-7c7af9de3d41_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "carotte",
        "courgette",
        "cuisses de ard confites",
        "sauce aux huîtres",
        "huile véétale",
        "huile de sésame",
        "poireau",
        "gousses d'ail",
        "cm gingembre frais",
        "poivron rouge",
        "pois mange-tout",
        "germes de soja",
        "sauce soja",
        "sucre",
        "graines de sésame"
      ],
      "searchText": "sauté asiatique au canard carotte courgette cuisses de ard confites sauce aux huîtres huile véétale huile de sésame poireau gousses d'ail cm gingembre frais poivron rouge pois mange-tout germes de soja sauce soja sucre graines de sésame",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/1015/saute-asiatique-au-canard",
      "translatedTitles": {
        "en": "Asian Duck Stir-fry"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 33
    },
    {
      "id": "6c7d3b3b-c46b-4e68-869e-9b31fa6ef420",
      "title": "Sauté de tofu aux noix de cajou",
      "image": "images/6c7d3b3b-c46b-4e68-869e-9b31fa6ef420_0.jpg",
      "servings": "4",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sauce",
        "de sauce chili",
        "de sauce soya",
        "de mirin",
        "sauté de tofu",
        "bloc de 454 de tofu ferme",
        "de fécule de maïs",
        "d’huile d’arachide ou d’olive",
        "oignons verts",
        "de gingembre frais haché",
        "gousses d’ail",
        "de noix de cajou non salées et grillées",
        "de coriandre fraîche ciselée",
        "sel et poivre"
      ],
      "searchText": "sauté de tofu aux noix de cajou sauce de sauce chili de sauce soya de mirin sauté de tofu bloc de 454 de tofu ferme de fécule de maïs d’huile d’arachide ou d’olive oignons verts de gingembre frais haché gousses d’ail de noix de cajou non salées et grillées de coriandre fraîche ciselée sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5601-saute-de-tofu-aux-noix-de-cajou",
      "sourceRating": 5,
      "sourceRatingCount": 200,
      "translatedTitles": {
        "en": "Tofu Stir-fry with Cashews"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 33
    },
    {
      "id": "730b20c6-4254-4760-9209-dc0ae2362e90",
      "title": "Saveurs du Bas-Saint-Laurent",
      "servings": "1",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de flétan bien épais",
        "courge spaghetti",
        "demi-livre de beurre",
        "paquets de roquette",
        "de pistaches écalées",
        "de parmesan râpé",
        "¼ tasse d’huile d’olive",
        "sel et poivre au goût"
      ],
      "searchText": "saveurs du bas-saint-laurent de flétan bien épais courge spaghetti demi-livre de beurre paquets de roquette de pistaches écalées de parmesan râpé ¼ tasse d’huile d’olive sel et poivre au goût",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://saveursbsl.com/recette/pave-de-fletan-par-philippe-trepanier-auberge-du-mange-grenouille/",
      "image": "images/730b20c6-4254-4760-9209-dc0ae2362e90_0.jpg",
      "translatedTitles": {
        "en": "Flavors of Bas-Saint-Laurent"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "f6729a03-bb14-4e26-a1b4-16de20c999aa",
      "title": "Saveurs du Bas-Saint-Laurent",
      "servings": "1",
      "readyInMinutes": 24,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "une uette de pain ciabbatta",
        "un panier de fraises 1 livre",
        "de fromage",
        "c. à soupe de basilic",
        "sirop de balsamique"
      ],
      "searchText": "saveurs du bas-saint-laurent une uette de pain ciabbatta un panier de fraises 1 livre de fromage c. à soupe de basilic sirop de balsamique",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://saveursbsl.com/recette/recette-du-mois-de-decembre-bruschetta-fraise-fromage-et-basilic-par-suzie-quimper/",
      "image": "images/f6729a03-bb14-4e26-a1b4-16de20c999aa_0.jpg",
      "translatedTitles": {
        "en": "Flavors of Bas-Saint-Laurent"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 24
    },
    {
      "id": "97e9d66b-bd51-4302-9038-b388897c7542",
      "title": "Sesame Salmon Bowls",
      "image": "images/97e9d66b-bd51-4302-9038-b388897c7542_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 66,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unseasoned rice vinegar",
        "granulated sugar",
        "kosher salt",
        "sushi rice",
        "skinless salmon fillet",
        "toasted sesame oil",
        "low-sodium soy sauce",
        "distilled white vinegar",
        "safflower or ola oil",
        "coarsely scallions",
        "ginger",
        "persian cucumbers",
        "green coleslaw mix",
        "avocado",
        "torn toasted nori sheets"
      ],
      "searchText": "sesame salmon bowls unseasoned rice vinegar granulated sugar kosher salt sushi rice skinless salmon fillet toasted sesame oil low-sodium soy sauce distilled white vinegar safflower or ola oil coarsely scallions ginger persian cucumbers green coleslaw mix avocado torn toasted nori sheets",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022255-sesame-salmon-bowls?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 9592,
      "translatedTitles": {
        "fr": "Bols de saumon au sésame"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 66
    },
    {
      "id": "9bc1108f-ab97-4dae-bd3a-e91811476c61",
      "title": "Sheet Pan Shrimp Nachos",
      "image": "images/9bc1108f-ab97-4dae-bd3a-e91811476c61_0.jpg",
      "servings": "4 people",
      "readyInMinutes": 40,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ounce sea queen shrimp",
        "½ chili powder",
        "½ garlic powder",
        "salt and pepper",
        "cherry tomatoes",
        "jalapeño pepper",
        "½ red onion",
        "¼ cilantro",
        "lime",
        "clancy’s restaurant style tortilla chips",
        "ounce happy farms shredded mexi style cheese",
        "simply nature black beans",
        "head green leaf lettuce",
        "avocado",
        "guacamole",
        "jalapeños",
        "lime wedges",
        "ounce block happy farms monterey jack cheese",
        "flour",
        "⅔ milk"
      ],
      "searchText": "sheet pan shrimp nachos ounce sea queen shrimp ½ chili powder ½ garlic powder salt and pepper cherry tomatoes jalapeño pepper ½ red onion ¼ cilantro lime clancy’s restaurant style tortilla chips ounce happy farms shredded mexi style cheese simply nature black beans head green leaf lettuce avocado guacamole jalapeños lime wedges ounce block happy farms monterey jack cheese flour ⅔ milk",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.howsweeteats.com/2020/08/sheet-pan-shrimp-nachos/",
      "sourceRating": 5,
      "sourceRatingCount": 47,
      "translatedTitles": {
        "fr": "Nachos aux crevettes sur plaque de cuisson"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 40
    },
    {
      "id": "722072d1-09f4-440f-9dda-638538dffbf3",
      "title": "Sheet-Pan Bibimbap",
      "image": "images/722072d1-09f4-440f-9dda-638538dffbf3_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 62,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oyster mushrooms",
        "sweet potato",
        "red onion",
        "packed coarsely tus or curly kale",
        "olive oil",
        "kosher salt and black pepper",
        "cooked -grain white rice",
        "eggs",
        "toasted sesame oil",
        "gochujang",
        "kimchi"
      ],
      "searchText": "sheet-pan bibimbap oyster mushrooms sweet potato red onion packed coarsely tus or curly kale olive oil kosher salt and black pepper cooked -grain white rice eggs toasted sesame oil gochujang kimchi",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022131-sheet-pan-bibimbap",
      "sourceRating": 5,
      "sourceRatingCount": 7782,
      "translatedTitles": {
        "fr": "Bibimbap en plaque"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 54
    },
    {
      "id": "2d3a4f57-18ed-4765-b7b9-e2e2e2bbd849",
      "title": "Sheet-Pan Chicken Tikka Thighs",
      "image": "images/2d3a4f57-18ed-4765-b7b9-e2e2e2bbd849_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 82,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "full-fat greek or indian yogurt",
        "ginger paste or ly grated ginger",
        "garlic paste or ly grated garlic",
        "kashmiri red chile powder",
        "garam masala",
        "cumin",
        "turmeric",
        "salt",
        "vegetable oil",
        "boneless",
        "bell peppers",
        "red onion",
        "cumin seeds",
        "cooked rice"
      ],
      "searchText": "sheet-pan chicken tikka thighs full-fat greek or indian yogurt ginger paste or ly grated ginger garlic paste or ly grated garlic kashmiri red chile powder garam masala cumin turmeric salt vegetable oil boneless bell peppers red onion cumin seeds cooked rice",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025554-sheet-pan-chicken-tikka-thighs?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3277,
      "translatedTitles": {
        "fr": "Cuisses de Poulet Tikka à la Plaque"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 76
    },
    {
      "id": "a804617d-d11e-48cb-90df-a8a32b1e63a2",
      "title": "Sheet-Pan Coconut Shrimp and Sweet Potatoes",
      "image": "images/a804617d-d11e-48cb-90df-a8a32b1e63a2_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 123,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unsweetened coconut milk",
        "sriracha",
        "garlic cloves",
        "piece ginger",
        "bunch scallions",
        "red-pepper flakes",
        "kosher salt (diamond crystal",
        "cilantro",
        "limes",
        "shelled shrimp",
        "sweet potato",
        "- olive oil"
      ],
      "searchText": "sheet-pan coconut shrimp and sweet potatoes unsweetened coconut milk sriracha garlic cloves piece ginger bunch scallions red-pepper flakes kosher salt (diamond crystal cilantro limes shelled shrimp sweet potato - olive oil",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025038-sheet-pan-coconut-shrimp-and-sweet-potatoes?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2564,
      "translatedTitles": {
        "fr": "Crevettes et patates douces à la noix de coco sur une plaque"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 106
    },
    {
      "id": "ac0fcaf6-5bcf-4224-947e-f1caf5d3b914",
      "title": "Sheet-Pan Coconut Shrimp and Sweet Potatoes",
      "image": "images/ac0fcaf6-5bcf-4224-947e-f1caf5d3b914_0.jpg",
      "servings": "4",
      "readyInMinutes": 123,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unsweetened coconut milk",
        "sriracha",
        "garlic cloves",
        "piece ginger",
        "bunch scallions",
        "red-pepper flakes",
        "kosher salt (diamond crystal",
        "cilantro",
        "limes",
        "shelled shrimp",
        "sweet potato",
        "- olive oil"
      ],
      "searchText": "sheet-pan coconut shrimp and sweet potatoes unsweetened coconut milk sriracha garlic cloves piece ginger bunch scallions red-pepper flakes kosher salt (diamond crystal cilantro limes shelled shrimp sweet potato - olive oil",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025038-sheet-pan-coconut-shrimp-and-sweet-potatoes?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 2564,
      "translatedTitles": {
        "fr": "Crevettes à la noix de coco et patates douces en plaque"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 106
    },
    {
      "id": "8d28a5f8-b76f-4f2b-8c39-1a2dff26d255",
      "title": "Sheet-Pan Lemon-Ricotta Pancakes",
      "image": "images/8d28a5f8-b76f-4f2b-8c39-1a2dff26d255_0.jpg",
      "servings": "6 servings",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [
        "breakfast"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unsalted butter",
        "milk",
        "lemon",
        "/256 all-purpose flour",
        "baking powder",
        "baking soda",
        "kosher salt",
        "eggs",
        "-milk ricotta",
        "/100 granulated sugar",
        "almond ct",
        "heavy cream",
        "powdered sugar",
        "lemon"
      ],
      "searchText": "sheet-pan lemon-ricotta pancakes unsalted butter milk lemon /256 all-purpose flour baking powder baking soda kosher salt eggs -milk ricotta /100 granulated sugar almond ct heavy cream powdered sugar lemon",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025980-sheet-pan-lemon-ricotta-pancakes?smid=url-share",
      "sourceRating": 5,
      "sourceRatingCount": 297,
      "translatedTitles": {
        "fr": "Pancakes Citron-Ricotta à la Plaque"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 50
    },
    {
      "id": "5a474cab-f43b-4582-b464-203a359a5be2",
      "title": "Sheet-Pan Salmon and Broccoli With Sesame and Ginger",
      "image": "images/5a474cab-f43b-4582-b464-203a359a5be2_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "toasted sesame oil",
        "soy sauce or tamari",
        "rice vinegar",
        "honey",
        "piece ginger",
        "garlic clove",
        "broccoli",
        "scallions",
        "olive oil",
        "kosher salt and black pepper",
        "skin-on salmon fillets",
        "lime",
        "sesame seeds"
      ],
      "searchText": "sheet-pan salmon and broccoli with sesame and ginger toasted sesame oil soy sauce or tamari rice vinegar honey piece ginger garlic clove broccoli scallions olive oil kosher salt and black pepper skin-on salmon fillets lime sesame seeds",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1020765-sheet-pan-salmon-and-broccoli-with-sesame-and-ginger?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 6412,
      "translatedTitles": {
        "fr": "Saumon et Brocoli à la Plaque avec Sésame et Gingembre"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 37
    },
    {
      "id": "bfbdf513-d816-4d05-9f29-b386adb38581",
      "title": "Shoyu Ramen",
      "image": "images/bfbdf513-d816-4d05-9f29-b386adb38581_0.jpg",
      "servings": "6 servings",
      "readyInMinutes": 440,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "low-sodium soy sauce",
        "mirin",
        "sake",
        "granulated sugar",
        "eggs",
        "toasted sesame oil",
        "garlic cloves",
        "piece ginger",
        "dashi",
        "chicken broth",
        "low-sodium soy sauce",
        "kosher salt",
        "white or black pepper",
        "s or ramen noodles",
        "chashu",
        "menma",
        "narutomaki",
        "cooked and wood ear mushrooms",
        "cooked corn kernels",
        "scallion",
        "nori",
        "la-yu"
      ],
      "searchText": "shoyu ramen low-sodium soy sauce mirin sake granulated sugar eggs toasted sesame oil garlic cloves piece ginger dashi chicken broth low-sodium soy sauce kosher salt white or black pepper s or ramen noodles chashu menma narutomaki cooked and wood ear mushrooms cooked corn kernels scallion nori la-yu",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1024748-shoyu-ramen?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 186,
      "translatedTitles": {
        "fr": "Shoyu Ramen"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "4f771670-b17b-43a9-8ebd-93b0f60577ae",
      "title": "Skillet Gnocchi With Miso Butter and Asparagus",
      "image": "images/4f771670-b17b-43a9-8ebd-93b0f60577ae_0.jpg",
      "servings": "3 to 4 servings",
      "readyInMinutes": 17,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "vegetable or ola oil",
        "shelf-stable potato gnocchi",
        "unsalted butter",
        "white miso",
        "sherry vinegar",
        "black pepper",
        "bunch asparagus",
        "salt",
        "packed baby arugula"
      ],
      "searchText": "skillet gnocchi with miso butter and asparagus vegetable or ola oil shelf-stable potato gnocchi unsalted butter white miso sherry vinegar black pepper bunch asparagus salt packed baby arugula",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026745-skillet-gnocchi-with-miso-butter-and-asparagus?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 5019,
      "translatedTitles": {
        "fr": "Gnocchis à la poêle avec beurre au miso et asperges"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 14
    },
    {
      "id": "0f6ccd83-940a-40ab-8a2c-d26aef449333",
      "title": "Skillet Meatballs With Peaches, Basil and Lime",
      "image": "images/0f6ccd83-940a-40ab-8a2c-d26aef449333_0.jpg",
      "servings": "3 to 4 servings",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "finely grated or ginger",
        "garlic cloves",
        "cumin",
        "kosher salt",
        "pork (or turkey or chicken",
        "panko or other plain bread crumbs",
        "finely basil",
        "- olive oil",
        "wine (dry white",
        "ripe peaches or nectarines",
        "thinly white or red onion",
        "lime",
        "white rice or coconut rice"
      ],
      "searchText": "skillet meatballs with peaches, basil and lime finely grated or ginger garlic cloves cumin kosher salt pork (or turkey or chicken panko or other plain bread crumbs finely basil - olive oil wine (dry white ripe peaches or nectarines thinly white or red onion lime white rice or coconut rice",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1021402-skillet-meatballs-with-peaches-basil-and-lime?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 7765,
      "translatedTitles": {
        "fr": "Boulettes de viande à la poêle aux pêches, basilic et citron vert"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 33
    },
    {
      "id": "899038bd-0628-4342-b65c-a4102b9e206a",
      "title": "Skillet Pork Chops and Apples With Miso Caramel",
      "image": "images/899038bd-0628-4342-b65c-a4102b9e206a_0.jpg",
      "servings": "2 to 3 servings",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "light brown sugar",
        "apple cider vinegar",
        "white miso",
        "bone-in pork chops",
        "salt",
        "black pepper",
        "neutral oil",
        "or 1 granny smith or other tart-crisp apples"
      ],
      "searchText": "skillet pork chops and apples with miso caramel light brown sugar apple cider vinegar white miso bone-in pork chops salt black pepper neutral oil or 1 granny smith or other tart-crisp apples",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1023628-skillet-pork-chops-and-apples-with-miso-caramel?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3873,
      "translatedTitles": {
        "fr": "Côtelettes de porc et pommes à la poêle avec caramel au miso"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 33
    },
    {
      "id": "50f77119-a797-449c-beca-a141680cae34",
      "title": "Slow Cooker BBQ Pulled Pork",
      "image": "images/50f77119-a797-449c-beca-a141680cae34_0.jpg",
      "servings": "6 to 8 servings",
      "readyInMinutes": 1231,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "garlic powder",
        "onion powder",
        "hot or sweet smoked paprika",
        "salt",
        "black pepper",
        "to 4 boneless pork shoulder or pork butt",
        "vegetable oil",
        "yellow onion",
        "dark soda",
        "to 1 1/2 homemade or store-bought barbecue sauce",
        "hot sauce"
      ],
      "searchText": "slow cooker bbq pulled pork garlic powder onion powder hot or sweet smoked paprika salt black pepper to 4 boneless pork shoulder or pork butt vegetable oil yellow onion dark soda to 1 1/2 homemade or store-bought barbecue sauce hot sauce",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1020497-slow-cooker-bbq-pulled-pork?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 3861,
      "translatedTitles": {
        "fr": "Porc effiloché BBQ à la mijoteuse"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 31,
      "readyInMinutesMin": 511
    },
    {
      "id": "7698849a-8838-40c3-ad5d-e8dff8764ee1",
      "title": "Slow Cooker Creamy Tomato Lentil Soup",
      "image": "images/7698849a-8838-40c3-ad5d-e8dff8764ee1_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 263,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "12 tomatoes",
        "red lentils",
        "garlic cloves",
        "basil sprig plus 1 roughly basil",
        "tomato paste",
        "olive oil",
        "kosher salt",
        "sugar",
        "oregano",
        "black pepper",
        "juice of 1 lemon",
        "heavy cream"
      ],
      "searchText": "slow cooker creamy tomato lentil soup 12 tomatoes red lentils garlic cloves basil sprig plus 1 roughly basil tomato paste olive oil kosher salt sugar oregano black pepper juice of 1 lemon heavy cream",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1027173-slow-cooker-creamy-tomato-lentil-soup?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 3820,
      "translatedTitles": {
        "fr": "Soupe crémeuse de tomates et lentilles à la mijoteuse"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 263
    },
    {
      "id": "d43a7ab6-723c-47f2-a4fc-a8b751ad533e",
      "title": "Slow Cooker White Chicken Chili",
      "image": "images/d43a7ab6-723c-47f2-a4fc-a8b751ad533e_0.jpg",
      "servings": "6 to 8 servings",
      "readyInMinutes": 414,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "unsalted butter",
        "yellow or red onion",
        "kosher salt",
        "garlic cloves",
        "jalapeño",
        "s green chiles",
        "cumin",
        "onion powder",
        "oregano",
        "cayenne",
        "boneless",
        "chicken stock",
        "s great northern beans",
        "corn",
        "finely cilantro",
        "lime",
        "pickled jalapeño slices"
      ],
      "searchText": "slow cooker white chicken chili unsalted butter yellow or red onion kosher salt garlic cloves jalapeño s green chiles cumin onion powder oregano cayenne boneless chicken stock s great northern beans corn finely cilantro lime pickled jalapeño slices",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1019905-slow-cooker-white-chicken-chili?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 10335,
      "translatedTitles": {
        "fr": "Chili blanc au poulet à la mijoteuse"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 44,
      "readyInMinutesMin": 293
    },
    {
      "id": "c6f09e7d-57c4-47f3-9edc-3af664bc24f9",
      "title": "Slow-Cooker Jalapeño Pulled Pork",
      "image": "images/c6f09e7d-57c4-47f3-9edc-3af664bc24f9_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 393,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grapeseed or vegetable oil",
        "½ to 3 boneless pork shoulder",
        "salt",
        "pickled jalapeño slices",
        "fish sauce",
        "brown sugar"
      ],
      "searchText": "slow-cooker jalapeño pulled pork grapeseed or vegetable oil ½ to 3 boneless pork shoulder salt pickled jalapeño slices fish sauce brown sugar",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025359-slow-cooker-jalapeno-pulled-pork",
      "sourceRating": 5,
      "sourceRatingCount": 952,
      "translatedTitles": {
        "fr": "Porc effiloché au jalapeño à la mijoteuse"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 269
    },
    {
      "id": "c0f34cb1-a0a6-4c5a-ac0f-4666cd8dca9f",
      "title": "Slow-Roasted Salmon with Walnut-Olive Vinaigrette",
      "image": "images/c0f34cb1-a0a6-4c5a-ac0f-4666cd8dca9f_0.jpg",
      "servings": "1",
      "readyInMinutes": 79,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "¾ - olive oil",
        "smoked paprika",
        "grated lemon zest plus 3 lemon juice",
        "side of salmon",
        "¾ kosher salt",
        "¾ black pepper",
        "½ finely flat-leaf parsley",
        "¼ walnuts",
        "¼ champagne vinegar or white wine vinegar",
        "¼ pitted kalamata olives",
        "¼ pitted castelvetrano olives"
      ],
      "searchText": "slow-roasted salmon with walnut-olive vinaigrette ¾ - olive oil smoked paprika grated lemon zest plus 3 lemon juice side of salmon ¾ kosher salt ¾ black pepper ½ finely flat-leaf parsley ¼ walnuts ¼ champagne vinegar or white wine vinegar ¼ pitted kalamata olives ¼ pitted castelvetrano olives main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.foodandwine.com/recipes/slow-roasted-salmon-with-walnut-olive-vinaigrette?utm_source=facebook.com&utm_medium=social&utm_campaign=foodandwine&utm_content=video&utm_term=20210904",
      "translatedTitles": {
        "fr": "Saumon rôti lentement avec une vinaigrette aux noix et aux olives"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 74
    },
    {
      "id": "90047986-a81e-47a8-b1c4-5af8a8f88d18",
      "title": "Soupe à l'ancienne aux lentilles, à l'avoine et au thym",
      "image": "images/90047986-a81e-47a8-b1c4-5af8a8f88d18_0.jpg",
      "servings": "1",
      "readyInMinutes": 49,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gros filet d’huile de cuisson véétale",
        "gousses d’ail",
        "échalotes",
        "⁄2 c. à thé d’herbes salées",
        "c. à thé de sirop d’érable",
        "c. à thé de thym séché",
        "c. à thé de graines de céleri",
        "carotte",
        "branches de céleri",
        "de rutaa",
        "pomme de terre",
        "feuilles de laurier",
        "de lentilles du puy",
        "c. à soupe de jus de citron",
        "de flocons d’avoine",
        "poivre du moulin",
        "garniture : persil plat frais"
      ],
      "searchText": "soupe à l'ancienne aux lentilles, à l'avoine et au thym gros filet d’huile de cuisson véétale gousses d’ail échalotes ⁄2 c. à thé d’herbes salées c. à thé de sirop d’érable c. à thé de thym séché c. à thé de graines de céleri carotte branches de céleri de rutaa pomme de terre feuilles de laurier de lentilles du puy c. à soupe de jus de citron de flocons d’avoine poivre du moulin garniture : persil plat frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://journalmetro.com/inspiration/a-table/2941119/soupe-a-lancienne-aux-lentilles-a-lavoine-et-au-thym/",
      "translatedTitles": {
        "en": "Old-fashioned Lentil, Oat, and Thyme Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 49
    },
    {
      "id": "c7b23c94-b3a2-4004-8c3f-c0c441f74cb1",
      "title": "Soupe à la dinde & au riz sauvage",
      "image": "images/c7b23c94-b3a2-4004-8c3f-c0c441f74cb1_0.jpg",
      "servings": "1",
      "readyInMinutes": 77,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe d’huile véétale",
        "oignon",
        "tasse de navet",
        "tasse de carottes",
        "tasse de céleri",
        "tasses de bouillon de poulet",
        "tasses de dinde",
        "tasse de riz sauvage",
        "feuilles de laurier",
        "de tasse de persil italien frais",
        "sel et poivre"
      ],
      "searchText": "soupe à la dinde & au riz sauvage c. à soupe d’huile véétale oignon tasse de navet tasse de carottes tasse de céleri tasses de bouillon de poulet tasses de dinde tasse de riz sauvage feuilles de laurier de tasse de persil italien frais sel et poivre plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/plats-principaux/soupes-plats/soupe-a-la-dinde-au-riz-sauvage/",
      "translatedTitles": {
        "en": "Turkey & Wild Rice Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 77
    },
    {
      "id": "d3cf4e11-9386-404d-bbb8-5895e990adfe",
      "title": "Soupe asiatique aux nouilles udon et aux crevettes nordiques",
      "image": "images/d3cf4e11-9386-404d-bbb8-5895e990adfe_0.jpg",
      "servings": "4",
      "readyInMinutes": 24,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gingembre frais",
        "bouillon de poulet maison ou du commerce",
        "sauce de poisson",
        "huile de sésame grillé",
        "anis étoilés",
        "carottes",
        "mini bok choys",
        "nouilles udon précuites",
        "crevettes nordiques surgelées",
        "coriandre fraîche",
        "lime",
        "sauce piquante sriracha"
      ],
      "searchText": "soupe asiatique aux nouilles udon et aux crevettes nordiques gingembre frais bouillon de poulet maison ou du commerce sauce de poisson huile de sésame grillé anis étoilés carottes mini bok choys nouilles udon précuites crevettes nordiques surgelées coriandre fraîche lime sauce piquante sriracha",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://savourer.ca/recette/soupe-asiatique-aux-nouilles-udon-et-aux-crevettes/",
      "sourceRating": 4.5,
      "sourceRatingCount": 17,
      "translatedTitles": {
        "en": "Asian Udon Noodle Soup with Nordic Shrimp"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 17,
      "readyInMinutesMin": 20
    },
    {
      "id": "2054c88e-e4f6-4e7f-9cc2-090fa8a0052e",
      "title": "Soupe au cheddar et au brocoli",
      "servings": "4",
      "readyInMinutes": 29,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "échalote française",
        "gousse d’ail",
        "de beurre",
        "fines tranches de jambon",
        "de farine tout usage",
        "une pincée de muscade moulue",
        "de bouillon de poulet",
        "de crème ou à cuisson",
        "de moutarde à l’ancienne",
        "de fromage cheddar jaune doux râpé",
        "litre de brocoli en fleurettes",
        "sel et poivre"
      ],
      "searchText": "soupe au cheddar et au brocoli échalote française gousse d’ail de beurre fines tranches de jambon de farine tout usage une pincée de muscade moulue de bouillon de poulet de crème ou à cuisson de moutarde à l’ancienne de fromage cheddar jaune doux râpé litre de brocoli en fleurettes sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5343-soupe-au-cheddar-et-au-brocoli",
      "image": "images/2054c88e-e4f6-4e7f-9cc2-090fa8a0052e_0.jpg",
      "sourceRating": 5,
      "sourceRatingCount": 89,
      "translatedTitles": {
        "en": "Cheddar and Broccoli Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 29
    },
    {
      "id": "2fefd7ea-eee4-4c97-898b-b4b310222e14",
      "title": "Soupe aux crevettes épicées et légumes croquants",
      "image": "images/2fefd7ea-eee4-4c97-898b-b4b310222e14_0.jpg",
      "servings": "1",
      "readyInMinutes": 91,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "gros oignon blanc en morceaux",
        "pouce de gingembre frais coupé en 4 ou 2 c. à soupe de gingembre mariné",
        "c. à soupe de graines de coriandre",
        "bâtons de nelle",
        "bâton de citronnelle coupé en 2 sur la longueur",
        "anis étoilés",
        "c. à soupe de beurre",
        "les os de 1 poulet",
        "pilons de poulet",
        "tasses d’eau chaude",
        "tasse de sauce de poisson",
        "c. à soupe de sauce hoisin",
        "c. à soupe de sirop d’érable",
        "fleur de sel"
      ],
      "searchText": "soupe aux crevettes épicées et légumes croquants gros oignon blanc en morceaux pouce de gingembre frais coupé en 4 ou 2 c. à soupe de gingembre mariné c. à soupe de graines de coriandre bâtons de nelle bâton de citronnelle coupé en 2 sur la longueur anis étoilés c. à soupe de beurre les os de 1 poulet pilons de poulet tasses d’eau chaude tasse de sauce de poisson c. à soupe de sauce hoisin c. à soupe de sirop d’érable fleur de sel",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://lp.ca/a9mHqW",
      "translatedTitles": {
        "en": "Spicy Shrimp Soup with Crispy Vegetables"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 91
    },
    {
      "id": "12c9737d-318a-4f63-8655-f6e56dd6cc10",
      "title": "Soupe aux lentilles",
      "image": "images/12c9737d-318a-4f63-8655-f6e56dd6cc10_0.jpg",
      "servings": "4",
      "readyInMinutes": 36,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "oignons",
        "gousses d'ail",
        "d'huile d'olive",
        "carottes",
        "de lentilles rouges",
        "harissa ou autre pâte de piment fort"
      ],
      "searchText": "soupe aux lentilles oignons gousses d'ail d'huile d'olive carottes de lentilles rouges harissa ou autre pâte de piment fort",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/95-soupe-aux-lentilles",
      "sourceRating": 5,
      "sourceRatingCount": 93,
      "translatedTitles": {
        "en": "Lentil Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 36
    },
    {
      "id": "43d5a37f-5f5c-4002-ab2c-dadcea2c0de9",
      "title": "Soupe aux tomates et au riz",
      "image": "images/43d5a37f-5f5c-4002-ab2c-dadcea2c0de9_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 49,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de 1 à 2 gousses d’ail",
        "d’huile d’olive",
        "conserve de tomates italiennes en dés ou entières* de 398",
        "d’eau",
        "de sel",
        "à 2 de sucre",
        "de riz arborio ou autre riz au choix",
        "de mini courgettes coupées en tronçons d’environ 1 cm ou de pâtissons coupés en fins quartiers ou de cubes de courgettes",
        "de feuilles de basilic frais déchirées et plus pour la garniture",
        "de fromage mozzarella frais coupé en petits cubes",
        "filet d’huile d’olive",
        "sel et poivre du moulin"
      ],
      "searchText": "soupe aux tomates et au riz de 1 à 2 gousses d’ail d’huile d’olive conserve de tomates italiennes en dés ou entières* de 398 d’eau de sel à 2 de sucre de riz arborio ou autre riz au choix de mini courgettes coupées en tronçons d’environ 1 cm ou de pâtissons coupés en fins quartiers ou de cubes de courgettes de feuilles de basilic frais déchirées et plus pour la garniture de fromage mozzarella frais coupé en petits cubes filet d’huile d’olive sel et poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/plats-principaux/soupes-repas/soupe-aux-tomates-et-au-riz/",
      "sourceRating": 5,
      "sourceRatingCount": 1,
      "translatedTitles": {
        "en": "Tomato and Rice Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 46
    },
    {
      "id": "9f60d152-5425-4dc9-bb93-ef40251cc64c",
      "title": "Soupe minestrone",
      "image": "images/9f60d152-5425-4dc9-bb93-ef40251cc64c_0.jpg",
      "servings": "8 portions",
      "readyInMinutes": 101,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "huile d'olive",
        "oignon",
        "carotte",
        "branche de céleri",
        "tranches de pancetta",
        "gousses d'ail",
        "feuille de laurier",
        "vin rouge",
        "tomates en dés",
        "ou 2 croûtes de parmesan",
        "sel et poivre",
        "pomme de terre à chair blanche",
        "pâtes à soupe au choix",
        "haricots verts",
        "courgette",
        "haricots blancs",
        "origan frais"
      ],
      "searchText": "soupe minestrone huile d'olive oignon carotte branche de céleri tranches de pancetta gousses d'ail feuille de laurier vin rouge tomates en dés ou 2 croûtes de parmesan sel et poivre pomme de terre à chair blanche pâtes à soupe au choix haricots verts courgette haricots blancs origan frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/1343/soupe-minestrone?fbclid=IwAR0TawrCWKKGjwqOYQxG2QipbIjweEpbH-C30tgGYtzEo-DXNojlWBtRf4U",
      "translatedTitles": {
        "en": "Minestrone soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 49,
      "readyInMinutesMin": 96
    },
    {
      "id": "d756c203-6aaa-434f-bd53-c7457c2a0ecd",
      "title": "Soupe Phô aux légumes",
      "image": "images/d756c203-6aaa-434f-bd53-c7457c2a0ecd_0.jpg",
      "servings": "4",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe d’huile d’olive",
        "oignon moyen",
        "c. à soupe de gingembre frais",
        "gousses d’ail",
        "litres de bouillon de légumes",
        "c. à soupe de sauce de poisson",
        "anis étoilés",
        "clous de girofle",
        "petit bâton de nelle",
        "sel et poivre",
        "paquet de 450 de nouilles de riz",
        "de légumes au choix (brocoli",
        "de germes de haricot",
        "de champignons",
        "oignons verts",
        "coriandre fraîche",
        "basilic thaï",
        "quartiers de lime",
        "sauce sriracha ou hoisin"
      ],
      "searchText": "soupe phô aux légumes c. à soupe d’huile d’olive oignon moyen c. à soupe de gingembre frais gousses d’ail litres de bouillon de légumes c. à soupe de sauce de poisson anis étoilés clous de girofle petit bâton de nelle sel et poivre paquet de 450 de nouilles de riz de légumes au choix (brocoli de germes de haricot de champignons oignons verts coriandre fraîche basilic thaï quartiers de lime sauce sriracha ou hoisin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/5780/soupe-pho-aux-legumes",
      "sourceRating": 4,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Vegetable Pho Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 35
    },
    {
      "id": "803eeac5-78c2-46ef-806b-51c47bdd9fb7",
      "title": "Soupe rafraîchie au concombre et au yogourt",
      "image": "images/803eeac5-78c2-46ef-806b-51c47bdd9fb7_0.jpg",
      "servings": "4",
      "readyInMinutes": 15,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de concombre",
        "d'yogourt nature",
        "de lait",
        "½ ail",
        "d'oignon vert",
        "au goût sel et poivre",
        "de menthe",
        "de ciboulette"
      ],
      "searchText": "soupe rafraîchie au concombre et au yogourt de concombre d'yogourt nature de lait ½ ail d'oignon vert au goût sel et poivre de menthe de ciboulette",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/4308/soupe-froide-concombre-yogourt",
      "sourceRating": 5,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Chilled Cucumber and Yogurt Soup"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "edb1eff9-07d5-4cc8-ae61-19e668b7a041",
      "title": "Soupe ramen au beurre d'arachide et au tofu croustillant",
      "image": "images/edb1eff9-07d5-4cc8-ae61-19e668b7a041_0.jpg",
      "servings": "4",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tofu croustillant",
        "d'huile véétale",
        "bloc de 450 de tofu ferme bien épongé et émietté",
        "de sauce soya",
        "de sriracha",
        "de sirop d'érable",
        "soupe ramen",
        "de beurre d'arachide crémeux",
        "de miso",
        "de sauce soya",
        "de sriracha",
        "de jus de lime",
        "de jus d'orange frais",
        "de sirop d'érable",
        "d'huile véétale",
        "gousses d'ail hachées",
        "conserve de 398 de lait de coco",
        "de bouillon de légumes",
        "bok choy coupés en deux dans le sens de la longueur",
        "de nouilles ramen",
        "feuilles de coriandre fraîche",
        "oignon vert émincé finement",
        "huile épicée au chili"
      ],
      "searchText": "soupe ramen au beurre d'arachide et au tofu croustillant tofu croustillant d'huile véétale bloc de 450 de tofu ferme bien épongé et émietté de sauce soya de sriracha de sirop d'érable soupe ramen de beurre d'arachide crémeux de miso de sauce soya de sriracha de jus de lime de jus d'orange frais de sirop d'érable d'huile véétale gousses d'ail hachées conserve de 398 de lait de coco de bouillon de légumes bok choy coupés en deux dans le sens de la longueur de nouilles ramen feuilles de coriandre fraîche oignon vert émincé finement huile épicée au chili",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "translatedTitles": {
        "en": "Peanut Butter and Crispy Tofu Ramen Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 36
    },
    {
      "id": "28a0a52e-df54-44ed-ba2e-ff5b3771028b",
      "title": "Soupe ramen au lait de coco, au poulet et au bok choy",
      "image": "images/28a0a52e-df54-44ed-ba2e-ff5b3771028b_0.jpg",
      "servings": "2",
      "readyInMinutes": 62,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bouillon",
        "de hauts de cuisses de poulet désossés et sans la peau",
        "d’huile véétale",
        "de bouillon de poulet réduit en sodium",
        "boîte de 398 de lait de coco",
        "pâte de cari",
        "de tiges de coriandre",
        "gousse d’ail",
        "tige de citronnelle de 2",
        "morceau de gingembre frais de 1",
        "à 1 petit piment oiseau",
        "de pâte de tomates",
        "de sauce de poisson",
        "de paprika doux",
        "de curcuma",
        "garnitures",
        "de nouilles ramen",
        "de bébés bok choy ou tat soy",
        "oignons verts ciselés",
        "feuilles de coriandre",
        "quartiers de lime",
        "oignons frits"
      ],
      "searchText": "soupe ramen au lait de coco, au poulet et au bok choy bouillon de hauts de cuisses de poulet désossés et sans la peau d’huile véétale de bouillon de poulet réduit en sodium boîte de 398 de lait de coco pâte de cari de tiges de coriandre gousse d’ail tige de citronnelle de 2 morceau de gingembre frais de 1 à 1 petit piment oiseau de pâte de tomates de sauce de poisson de paprika doux de curcuma garnitures de nouilles ramen de bébés bok choy ou tat soy oignons verts ciselés feuilles de coriandre quartiers de lime oignons frits plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8663-soupe-ramen-au-lait-de-coco-au-poulet-et-au-bok-choy",
      "sourceRating": 5,
      "sourceRatingCount": 76,
      "translatedTitles": {
        "en": "Coconut Milk, Chicken and Bok Choy Ramen Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 41,
      "readyInMinutesMin": 62
    },
    {
      "id": "f1c9cf6a-9383-4755-b134-e36da55b7f38",
      "title": "Soupe ramen aux boulettes épicées",
      "image": "images/f1c9cf6a-9383-4755-b134-e36da55b7f38_0.jpg",
      "servings": "4 portions",
      "readyInMinutes": 96,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de porc haché",
        "tasse de chapelure de céréales de type rice krispies sans gluten",
        "c. à soupe de gingembre frais râpé finement",
        "petite gousse d’ail hachée",
        "c. à soupe de pâte de tomates",
        "c. à thé de sauce piquante harissa",
        "c. à thé (2",
        "œuf",
        "tasse de basilic frais haché",
        "c. à thé (2",
        "huile d’olive pour badigeonner les boulettes",
        "c. à soupe d’huile d’olive",
        "oignon rouge",
        "c. à soupe de gingembre frais râpé finement",
        "gousse d’ail",
        "c. à thé de sauce piquante harissa",
        "c. à soupe de pâte de tomates",
        "anis étoilés",
        "bâton de nelle",
        "tasses (1",
        "tasses d’eau",
        "c. à thé (2",
        "c. à soupe de miso sans gluten",
        "de nouilles ramen sans gluten",
        "tasse de basilic thaï ou ordinaire frais"
      ],
      "searchText": "soupe ramen aux boulettes épicées de porc haché tasse de chapelure de céréales de type rice krispies sans gluten c. à soupe de gingembre frais râpé finement petite gousse d’ail hachée c. à soupe de pâte de tomates c. à thé de sauce piquante harissa c. à thé (2 œuf tasse de basilic frais haché c. à thé (2 huile d’olive pour badigeonner les boulettes c. à soupe d’huile d’olive oignon rouge c. à soupe de gingembre frais râpé finement gousse d’ail c. à thé de sauce piquante harissa c. à soupe de pâte de tomates anis étoilés bâton de nelle tasses (1 tasses d’eau c. à thé (2 c. à soupe de miso sans gluten de nouilles ramen sans gluten tasse de basilic thaï ou ordinaire frais",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://tastecanada.org/soupe-ramen-aux-boulettes-epicees/",
      "translatedTitles": {
        "en": "Spicy Meatball Ramen Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 94
    },
    {
      "id": "62d09c9d-1491-41f3-829a-8bb28d5f5d1d",
      "title": "Soupe Ramen aux oignons caramélisés, à l’érable et au boeuf",
      "image": "images/62d09c9d-1491-41f3-829a-8bb28d5f5d1d_0.jpg",
      "servings": "4 à 6",
      "readyInMinutes": 45,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse d’huile d’olive",
        "oignons rouges émincés",
        "gousses d’ail",
        "c. à soupe de gingembre frais haché",
        "c. à thé (1",
        "c. à soupe de sirop d’érable",
        "tasses (1",
        "c. à soupe de miso de riz",
        "c. à soupe d’huile d’olive",
        "de filet de boeuf",
        "sel et poivre",
        "oeufs",
        "de nouilles de riz",
        "à 10 mini bok choy",
        "quelques feuilles de coriandre fraîche"
      ],
      "searchText": "soupe ramen aux oignons caramélisés, à l’érable et au boeuf tasse d’huile d’olive oignons rouges émincés gousses d’ail c. à soupe de gingembre frais haché c. à thé (1 c. à soupe de sirop d’érable tasses (1 c. à soupe de miso de riz c. à soupe d’huile d’olive de filet de boeuf sel et poivre oeufs de nouilles de riz à 10 mini bok choy quelques feuilles de coriandre fraîche",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/soupe-ramen-aux-oignons-caramelises-a-lerable-et-au-boeuf/",
      "translatedTitles": {
        "en": "Ramen Soup with Caramelized Onions, Maple, and Beef"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "b3ac0c10-dbda-4b2b-99a6-0d4979659ddf",
      "title": "Soupe thaïe aux crevettes et au lait de coco",
      "image": "images/b3ac0c10-dbda-4b2b-99a6-0d4979659ddf_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "champignons shiitakes",
        "piment jalapeño",
        "d’huile véétale",
        "gousses d’ail",
        "de gingembre frais haché",
        "de pâte de tomates",
        "de poudre de cari",
        "de paprika doux",
        "de nelle moulue",
        "boîtes de 398 de lait de coco",
        "de bouillon de poulet",
        "de pois mange-tout",
        "limes",
        "lime",
        "de crevettes crues",
        "oignons verts"
      ],
      "searchText": "soupe thaïe aux crevettes et au lait de coco champignons shiitakes piment jalapeño d’huile véétale gousses d’ail de gingembre frais haché de pâte de tomates de poudre de cari de paprika doux de nelle moulue boîtes de 398 de lait de coco de bouillon de poulet de pois mange-tout limes lime de crevettes crues oignons verts plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4907-soupe-thaie-aux-crevettes-et-au-lait-de-coco",
      "sourceRating": 5,
      "sourceRatingCount": 105,
      "translatedTitles": {
        "en": "Thai Shrimp and Coconut Milk Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 50
    },
    {
      "id": "213b1052-dbf3-441b-9ce0-5a9c87fc3678",
      "title": "Soupe thaïe aux crevettes et au lait de coco",
      "image": "images/213b1052-dbf3-441b-9ce0-5a9c87fc3678_0.jpg",
      "servings": "4",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "champignons shiitakes",
        "piment jalapeño",
        "d’huile véétale",
        "gousses d’ail",
        "de gingembre frais haché",
        "de pâte de tomates",
        "de poudre de cari",
        "de paprika doux",
        "de nelle moulue",
        "boîtes de 398 de lait de coco",
        "de bouillon de poulet",
        "de pois mange-tout",
        "limes",
        "lime",
        "de crevettes crues",
        "oignons verts"
      ],
      "searchText": "soupe thaïe aux crevettes et au lait de coco champignons shiitakes piment jalapeño d’huile véétale gousses d’ail de gingembre frais haché de pâte de tomates de poudre de cari de paprika doux de nelle moulue boîtes de 398 de lait de coco de bouillon de poulet de pois mange-tout limes lime de crevettes crues oignons verts",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/4907-soupe-thaie-aux-crevettes-et-au-lait-de-coco",
      "sourceRating": 5,
      "sourceRatingCount": 105,
      "translatedTitles": {
        "en": "Thai Shrimp and Coconut Milk Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 41
    },
    {
      "id": "d24d3a6e-54b3-4775-9dd5-19d2f8fa8a22",
      "title": "Soupe tonkinoise au poulet de Kim Thuy",
      "image": "images/d24d3a6e-54b3-4775-9dd5-19d2f8fa8a22_0.jpg",
      "servings": "6",
      "readyInMinutes": 258,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "bouillon",
        "un morceau d’environ 10 cm de gingembre frais non pelé",
        "oignons",
        "de graines de coriandre",
        "poulet entier d’environ 2 (4",
        "litres d’eau",
        "de sauce au poisson",
        "garniture",
        "de vermicelles de riz",
        "de fèves germées",
        "oignon",
        "oignons verts",
        "de feuilles de coriandre fraîche",
        "de basilic frais thaïlandais",
        "à 4 feuilles de kaffir",
        "piment fort frais",
        "lime"
      ],
      "searchText": "soupe tonkinoise au poulet de kim thuy bouillon un morceau d’environ 10 cm de gingembre frais non pelé oignons de graines de coriandre poulet entier d’environ 2 (4 litres d’eau de sauce au poisson garniture de vermicelles de riz de fèves germées oignon oignons verts de feuilles de coriandre fraîche de basilic frais thaïlandais à 4 feuilles de kaffir piment fort frais lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5623-soupe-tonkinoise-au-poulet-de-kim-thuy",
      "sourceRating": 4,
      "sourceRatingCount": 13,
      "translatedTitles": {
        "en": "Kim Thuy's Chicken Tonkinese Soup"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 258
    },
    {
      "id": "109c606c-e596-4b15-9e23-d927110b0cbf",
      "title": "Soupe won-ton et saumon au sésame",
      "image": "images/109c606c-e596-4b15-9e23-d927110b0cbf_0.jpg",
      "servings": "4",
      "readyInMinutes": 60,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "won-ton",
        "champignons blancs moyens",
        "de veau haché maigre",
        "de sauce aux huîtres",
        "de sambal oelek",
        "carrés de pâte à won-ton",
        "bouillon",
        "oignon rouge moyen",
        "gousses d’ail",
        "de gingembre frais pelé et émincé",
        "d’huile d’olive",
        "litre de bouillon de poulet",
        "de sauce soya",
        "d’huile de sésame grillé",
        "de pois sucrés parés et coupés en rondelles",
        "feuilles de coriandre fraîche",
        "sel et poivre",
        "saumon",
        "de saumon",
        "de graines de sésame",
        "d’huile d’olive"
      ],
      "searchText": "soupe won-ton et saumon au sésame won-ton champignons blancs moyens de veau haché maigre de sauce aux huîtres de sambal oelek carrés de pâte à won-ton bouillon oignon rouge moyen gousses d’ail de gingembre frais pelé et émincé d’huile d’olive litre de bouillon de poulet de sauce soya d’huile de sésame grillé de pois sucrés parés et coupés en rondelles feuilles de coriandre fraîche sel et poivre saumon de saumon de graines de sésame d’huile d’olive plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/6588-soupe-won-ton-et-saumon-au-sesame",
      "sourceRating": 5,
      "sourceRatingCount": 23,
      "translatedTitles": {
        "en": "Won-ton and Sesame Salmon Soup"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "4b2b1057-97ec-43a7-9d8e-630c7d0c7f5a",
      "title": "Soupe-repas de crevettes au bouillon parfumé",
      "image": "images/4b2b1057-97ec-43a7-9d8e-630c7d0c7f5a_0.jpg",
      "servings": "6 portions",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "l de bouillon de lait de coco",
        "l de légumes verts (épinards",
        "de nouilles soba ou de riz",
        "crevettes moyennes",
        "coriandre ou oignons verts ciselés",
        "quartiers de lime et piment en tranches fines"
      ],
      "searchText": "soupe-repas de crevettes au bouillon parfumé l de bouillon de lait de coco l de légumes verts (épinards de nouilles soba ou de riz crevettes moyennes coriandre ou oignons verts ciselés quartiers de lime et piment en tranches fines",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.joseedistasio.ca/recettes/soupes-potages/soupe-repas-de-crevettes-au-bouillon-parfume/",
      "sourceRating": 5,
      "sourceRatingCount": 3,
      "translatedTitles": {
        "en": "Shrimp Meal Soup with Fragrant Broth"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 13,
      "readyInMinutesMin": 48
    },
    {
      "id": "65f15329-2414-42c9-b6e5-3fea6a4bdd72",
      "title": "Spiced Chickpea Salad With Tahini and Pita Chips",
      "image": "images/65f15329-2414-42c9-b6e5-3fea6a4bdd72_0.jpg",
      "servings": "4 main-course servings",
      "readyInMinutes": 70,
      "healthScore": 0,
      "dishTypes": [
        "side dish"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "s chickpeas",
        "to 1 - olive oil",
        "garlic cloves",
        "cumin",
        "sweet paprika",
        "salt and pepper",
        "tahini",
        "ly squeezed juice of 1 lemon",
        "garlic clove",
        "warm water",
        "olive oil",
        "about 10 kale",
        "store-bought or homemade pita chips",
        "handful of roughly flat-leaf parsley",
        "handful of roughly mint",
        "or 2 cucumbers",
        "lemon"
      ],
      "searchText": "spiced chickpea salad with tahini and pita chips s chickpeas to 1 - olive oil garlic cloves cumin sweet paprika salt and pepper tahini ly squeezed juice of 1 lemon garlic clove warm water olive oil about 10 kale store-bought or homemade pita chips handful of roughly flat-leaf parsley handful of roughly mint or 2 cucumbers lemon plat d'accompagnement",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1020187-spiced-chickpea-salad-with-tahini-and-pita-chips?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4718,
      "translatedTitles": {
        "fr": "Salade de pois chiches épicée au tahini et aux chips de pita"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 36,
      "readyInMinutesMin": 65
    },
    {
      "id": "c1544dd6-6f06-4996-8fe4-c2195ae65f66",
      "title": "Spicy Shrimp Puttanesca",
      "image": "images/c1544dd6-6f06-4996-8fe4-c2195ae65f66_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salt",
        "spaghetti",
        "- olive oil",
        "garlic cloves",
        "oil-packed anchovy fillets",
        "castelvetrano olives",
        "drained capers",
        "red pepper",
        "tomato paste",
        "peeled and deveined shrimp",
        "unsalted butter",
        "parsley",
        "lemon"
      ],
      "searchText": "spicy shrimp puttanesca salt spaghetti - olive oil garlic cloves oil-packed anchovy fillets castelvetrano olives drained capers red pepper tomato paste peeled and deveined shrimp unsalted butter parsley lemon",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026743-spicy-shrimp-puttanesca?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1243,
      "translatedTitles": {
        "fr": "Puttanesca de Crevettes Épicée"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 39
    },
    {
      "id": "86030025-a31b-4019-9eab-bbaa5cde77fd",
      "title": "Spinach Artichoke Dip",
      "image": "images/86030025-a31b-4019-9eab-bbaa5cde77fd_0.jpg",
      "servings": "2 to 3 cups",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "garlic clove",
        "ounce bunch spinach",
        "pinch of red-pepper flakes",
        "kosher salt and black pepper",
        "quartered artichoke hearts",
        "cream cheese",
        "mozzarella",
        "sour cream or full-fat greek yogurt",
        "pecorino romano or parmesan"
      ],
      "searchText": "spinach artichoke dip olive oil garlic clove ounce bunch spinach pinch of red-pepper flakes kosher salt and black pepper quartered artichoke hearts cream cheese mozzarella sour cream or full-fat greek yogurt pecorino romano or parmesan",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1018248-spinach-artichoke-dip?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 7056,
      "translatedTitles": {
        "fr": "Trempette aux épinards et artichauts"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 23,
      "readyInMinutesMin": 29
    },
    {
      "id": "f34a01ef-6ff1-4c7e-a663-738d3f0ddad3",
      "title": "Strawberry Salad with Balsamic",
      "image": "images/f34a01ef-6ff1-4c7e-a663-738d3f0ddad3_0.jpg",
      "servings": "4",
      "readyInMinutes": 41,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "¼ balsamic vinegar",
        "strawberries",
        "halved cherry tomatoes",
        "halved mini mozzarella balls",
        "ripe avocado",
        "⅓ pes",
        "⅓ loosely packed basil",
        "- olive oil",
        "sea salt and ly black pepper"
      ],
      "searchText": "strawberry salad with balsamic ¼ balsamic vinegar strawberries halved cherry tomatoes halved mini mozzarella balls ripe avocado ⅓ pes ⅓ loosely packed basil - olive oil sea salt and ly black pepper",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/strawberry-salad/",
      "sourceRating": 5,
      "sourceRatingCount": 46,
      "translatedTitles": {
        "fr": "Salade de fraises au balsamique"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 11,
      "readyInMinutesMin": 34
    },
    {
      "id": "8b2e8f94-f967-47f1-9a27-85e3597119d6",
      "title": "Stuffed Cabbage With Lemony Rice and Sumac",
      "image": "images/8b2e8f94-f967-47f1-9a27-85e3597119d6_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 127,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "–14 savoy or green cabe leaves",
        "kosher salt",
        "¾ long-grain white rice",
        "¼ - olive oil",
        "onion",
        "½ pine nuts",
        "finely mixed tender herbs (such as parsley",
        "⅓ golden or brown raisins",
        ". sumac",
        ". lemon juice",
        "egg",
        "ly black pepper",
        ". unsalted butter",
        "sour cream",
        "sumac"
      ],
      "searchText": "stuffed cabbage with lemony rice and sumac –14 savoy or green cabe leaves kosher salt ¾ long-grain white rice ¼ - olive oil onion ½ pine nuts finely mixed tender herbs (such as parsley ⅓ golden or brown raisins . sumac . lemon juice egg ly black pepper . unsalted butter sour cream sumac plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/stuffed-cabbage-with-lemony-rice-and-sumac",
      "sourceRating": 5,
      "sourceRatingCount": 22,
      "translatedTitles": {
        "fr": "Chou Farci Au Riz Citronné Et Au Sumac"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 77,
      "readyInMinutesMin": 112
    },
    {
      "id": "7fca1ae2-e383-4fb3-81ea-78acee5359f7",
      "title": "Stuffed Peppers With Chickpeas and Cheese",
      "image": "images/7fca1ae2-e383-4fb3-81ea-78acee5359f7_0.jpg",
      "servings": "3 to 4 servings",
      "readyInMinutes": 115,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "- olive oil",
        "red",
        "fine sea or table salt and ly black pepper",
        "bunch scallions",
        "jalapeño",
        "garlic cloves",
        "s chickpeas",
        "tomato paste",
        "cumin",
        "chili powder",
        "lemon juice",
        "/4 grated -sharp cheddar",
        "parsley"
      ],
      "searchText": "stuffed peppers with chickpeas and cheese - olive oil red fine sea or table salt and ly black pepper bunch scallions jalapeño garlic cloves s chickpeas tomato paste cumin chili powder lemon juice /4 grated -sharp cheddar parsley plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025609-stuffed-peppers-with-chickpeas-and-cheese?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1638,
      "translatedTitles": {
        "fr": "Poivrons Farcis aux Pois Chiches et au Fromage"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 50,
      "readyInMinutesMin": 105
    },
    {
      "id": "25329e6e-0788-4bea-af9d-6bac98272623",
      "title": "Sweet and Salty Frozen Grapes",
      "image": "images/25329e6e-0788-4bea-af9d-6bac98272623_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 734,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "red or green seedless grapes off the stem",
        "grated lemon zest",
        "sugar",
        "aleppo chile flakes or other mild chile flakes like urfa",
        "kosher salt"
      ],
      "searchText": "sweet and salty frozen grapes red or green seedless grapes off the stem grated lemon zest sugar aleppo chile flakes or other mild chile flakes like urfa kosher salt",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1027126-sweet-and-salty-frozen-grapes?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 367,
      "translatedTitles": {
        "fr": "Raisins Congelés Sucrés et Salés"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 14,
      "readyInMinutesMin": 374
    },
    {
      "id": "e00ce79f-8376-4efe-86e4-cf16912068f3",
      "title": "Sweet Corn & Arugula Panzanella",
      "image": "images/e00ce79f-8376-4efe-86e4-cf16912068f3_0.jpg",
      "servings": "4 to 6 as a side",
      "readyInMinutes": 50,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "- olive oil",
        "sherry vinegar",
        "½ dijon mustard",
        "¼ sea salt",
        "shallot",
        "garlic cloves",
        "cubed -grain bread",
        "ears corn",
        "tomatoes",
        "arugula",
        "pinches of red pepper flakes",
        "flaky sea salt",
        "½ basil",
        "shaved pecorino cheese"
      ],
      "searchText": "sweet corn & arugula panzanella - olive oil sherry vinegar ½ dijon mustard ¼ sea salt shallot garlic cloves cubed -grain bread ears corn tomatoes arugula pinches of red pepper flakes flaky sea salt ½ basil shaved pecorino cheese",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.loveandlemons.com/sweet-corn-panzanella/",
      "translatedTitles": {
        "fr": "Panzanella de maïs doux et de roquette"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 50
    },
    {
      "id": "4999c689-6fee-45f8-bc74-fc06ad5ca859",
      "title": "Sweet Potato Shepherd’s Pie",
      "image": "images/4999c689-6fee-45f8-bc74-fc06ad5ca859_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 125,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "sweet potatoes",
        "unsalted butter",
        "smoked paprika",
        "salt and black pepper",
        "- olive oil",
        "yellow onion",
        "cumin",
        "cinnamon",
        "cayenne",
        "garlic cloves",
        "lamb",
        "chickpeas",
        "pitted dates",
        "parsley",
        "tomato paste",
        "all-purpose flour",
        "beef broth"
      ],
      "searchText": "sweet potato shepherd’s pie sweet potatoes unsalted butter smoked paprika salt and black pepper - olive oil yellow onion cumin cinnamon cayenne garlic cloves lamb chickpeas pitted dates parsley tomato paste all-purpose flour beef broth",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025155-sweet-potato-shepherds-pie?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1059,
      "translatedTitles": {
        "fr": "Hachis Parmentier à la patate douce"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 57,
      "readyInMinutesMin": 108
    },
    {
      "id": "875f3e10-b0b6-41a9-ae93-da3f4b421118",
      "title": "Tacos",
      "image": "images/875f3e10-b0b6-41a9-ae93-da3f4b421118_0.jpg",
      "servings": "1",
      "readyInMinutes": 61,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de riz brun à grain court",
        "tasse d’eau",
        "c à soupe d’huile véétale",
        "oignon émincé",
        "c à soupe d’assaisonnement pour chili",
        "c à soupe de poudre d’oignon",
        "c à soupe de ketchup",
        "boîte de 19 de haricots rouges rincés et égouttés",
        "de tasse de lait de soya",
        "sel",
        "petites tortillas",
        "laitue iceberg",
        "tomate coupée en dés"
      ],
      "searchText": "tacos tasse de riz brun à grain court tasse d’eau c à soupe d’huile véétale oignon émincé c à soupe d’assaisonnement pour chili c à soupe de poudre d’oignon c à soupe de ketchup boîte de 19 de haricots rouges rincés et égouttés de tasse de lait de soya sel petites tortillas laitue iceberg tomate coupée en dés",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.lacuisinedejeanphilippe.com/recipe/tacos/",
      "translatedTitles": {
        "en": "Tacos"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 51
    },
    {
      "id": "b6e03aa7-91e4-48de-884d-1b986cebf4a0",
      "title": "Tacos à la patate douce et aux haricots noirs, crème sure au jalapeno",
      "image": "images/b6e03aa7-91e4-48de-884d-1b986cebf4a0_0.jpg",
      "servings": "4 à 6",
      "readyInMinutes": 62,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "grosses patates douces",
        "c. à soupe d’huile d’olive",
        "c. à thé de poudre de chili",
        "petites gousses d’ail",
        "c. à thé (2",
        "poivre",
        "c. à soupe d’huile d’olive",
        "boîte de 398 de haricots noirs",
        "c. à thé (2",
        "c. à thé (2",
        "c. à thé de sel",
        "tasse de crème de soya de type belsoy",
        "c. à soupe de vinaigre de vin blanc",
        "tasse de coriandre fraîche",
        "tasse d’oignons verts hachés",
        "piment jalapeno",
        "c. à thé de miel",
        "c. à thé de sel",
        "poivre",
        "à 12 tortillas sans gluten",
        "feuilles de coriandre fraîches",
        "concombres libanais",
        "quartiers de lime"
      ],
      "searchText": "tacos à la patate douce et aux haricots noirs, crème sure au jalapeno grosses patates douces c. à soupe d’huile d’olive c. à thé de poudre de chili petites gousses d’ail c. à thé (2 poivre c. à soupe d’huile d’olive boîte de 398 de haricots noirs c. à thé (2 c. à thé (2 c. à thé de sel tasse de crème de soya de type belsoy c. à soupe de vinaigre de vin blanc tasse de coriandre fraîche tasse d’oignons verts hachés piment jalapeno c. à thé de miel c. à thé de sel poivre à 12 tortillas sans gluten feuilles de coriandre fraîches concombres libanais quartiers de lime",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/plats-vegetariens/tacos-a-la-patate-douce-et-aux-haricots-noirs-creme-sure-au-jalapeno/",
      "translatedTitles": {
        "en": "Sweet Potato and Black Bean Tacos, Jalapeno Sour Cream"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 37,
      "readyInMinutesMin": 62
    },
    {
      "id": "78a2ff23-90a9-42fe-8099-e46a89dee211",
      "title": "Tacos au poulet",
      "image": "images/78a2ff23-90a9-42fe-8099-e46a89dee211_0.jpg",
      "servings": "4",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "préparation au poulet",
        "oignon",
        "gousses d'ail",
        "d'huile d'olive",
        "de poulet haché",
        "de poudre de chili",
        "d'origan séché",
        "de jus de lime",
        "de persil frais",
        "tabasco au goût",
        "sel et poivre",
        "coquilles pour tacos",
        "garniture",
        "grandes feuilles de laitue iceberg",
        "de fromage cheddar râpé",
        "avocats",
        "de tomates coupées en dés",
        "oignons verts",
        "de crème sure",
        "salsa du commerce",
        "coriandre fraîche"
      ],
      "searchText": "tacos au poulet préparation au poulet oignon gousses d'ail d'huile d'olive de poulet haché de poudre de chili d'origan séché de jus de lime de persil frais tabasco au goût sel et poivre coquilles pour tacos garniture grandes feuilles de laitue iceberg de fromage cheddar râpé avocats de tomates coupées en dés oignons verts de crème sure salsa du commerce coriandre fraîche",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/214-tacos-au-poulet",
      "sourceRating": 5,
      "sourceRatingCount": 25,
      "translatedTitles": {
        "en": "Chicken Tacos"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 42
    },
    {
      "id": "fda3cd96-1e74-4863-a0fd-0de6dfc4967c",
      "title": "Tacos de boeuf maison",
      "image": "images/fda3cd96-1e74-4863-a0fd-0de6dfc4967c_0.jpg",
      "servings": "4 à 6",
      "readyInMinutes": 51,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "c. à soupe d’huile d’olive",
        "oignon moyen",
        "gousses d’ail",
        "piment jalapeno",
        "c. à thé de cumin",
        "c. à thé d’origan séché",
        "c. à thé de poudre de chili",
        "gr. de boeuf haché",
        "sel et poivre",
        "boîte de 398 de tomates cerises ou en dés",
        "tasse de coriandre fraîche avec les tiges",
        "tortillas de maïs ou quantité au goût",
        "laitue iceberg émincée",
        "guacamole ou du commerce",
        "oignons rouges marinés",
        "salsa du commerce"
      ],
      "searchText": "tacos de boeuf maison c. à soupe d’huile d’olive oignon moyen gousses d’ail piment jalapeno c. à thé de cumin c. à thé d’origan séché c. à thé de poudre de chili gr. de boeuf haché sel et poivre boîte de 398 de tomates cerises ou en dés tasse de coriandre fraîche avec les tiges tortillas de maïs ou quantité au goût laitue iceberg émincée guacamole ou du commerce oignons rouges marinés salsa du commerce",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.kpourkatrine.com/fr/recettes/tacos-de-boeuf-maison/",
      "translatedTitles": {
        "en": "Homemade Beef Tacos"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 26,
      "readyInMinutesMin": 46
    },
    {
      "id": "17438589-46b4-4df4-9053-a95238bf42e2",
      "title": "Tacos de porc braisé",
      "image": "images/17438589-46b4-4df4-9053-a95238bf42e2_0.jpg",
      "servings": "6 portion(s)",
      "readyInMinutes": 234,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "rôti de porc désossé dans l’épaule d’environ 1",
        "boîte de 284 de consommé de boeuf",
        "boîte de 398 de tomates concassées",
        "de jus de lime",
        "de jus d’orange",
        "de coriandre fraîche",
        "gousses d’ail",
        "de piment chipotle moulu",
        "de poudre de chili",
        "sel et poivre",
        "grosses tomates",
        "d’oignon haché",
        "de jus de lime",
        "de coriandre fraîche ciselée",
        "coquilles pour tacos",
        "de laitue iceberg émincée",
        "crème sure au goût",
        "queso fresco ou fromage feta"
      ],
      "searchText": "tacos de porc braisé rôti de porc désossé dans l’épaule d’environ 1 boîte de 284 de consommé de boeuf boîte de 398 de tomates concassées de jus de lime de jus d’orange de coriandre fraîche gousses d’ail de piment chipotle moulu de poudre de chili sel et poivre grosses tomates d’oignon haché de jus de lime de coriandre fraîche ciselée coquilles pour tacos de laitue iceberg émincée crème sure au goût queso fresco ou fromage feta",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5136-tacos-de-porc-braise",
      "sourceRating": 5,
      "sourceRatingCount": 19,
      "translatedTitles": {
        "en": "Braised Pork Tacos"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 234
    },
    {
      "id": "4ff5cd8b-7aac-4727-8d74-d8dc0fc63121",
      "title": "Tacos ou fajitas au bœuf effiloché",
      "image": "images/4ff5cd8b-7aac-4727-8d74-d8dc0fc63121_0.jpg",
      "servings": "10",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "poivron rouge",
        "de huile de ola",
        "ail",
        "champignon portobello",
        "de rôti de palette à la façon de janette bertrand",
        "de cumin moulu",
        "tortilla",
        "de fromage monterey jack",
        "tomate",
        "de crème sure​",
        "de laitue iceberg",
        "environ coriandre",
        "au goût sel et poivre"
      ],
      "searchText": "tacos ou fajitas au bœuf effiloché poivron rouge de huile de ola ail champignon portobello de rôti de palette à la façon de janette bertrand de cumin moulu tortilla de fromage monterey jack tomate de crème sure​ de laitue iceberg environ coriandre au goût sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://ici.radio-canada.ca/mordu/recettes/69/fajitas-boeuf",
      "sourceRating": 2,
      "sourceRatingCount": 4,
      "translatedTitles": {
        "en": "Pulled Beef Tacos or Fajitas"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 33,
      "readyInMinutesMin": 29
    },
    {
      "id": "0044809b-6bac-4edb-a675-44aabbb3f4a8",
      "title": "Tacos poisson",
      "servings": "4",
      "readyInMinutes": 48,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [],
      "searchText": "tacos poisson plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.lapresse.ca/gourmand/recettes/202002/26/01-5262486-tacos-de-poisson-dines.php",
      "image": "images/0044809b-6bac-4edb-a675-44aabbb3f4a8_0.jpg",
      "translatedTitles": {
        "en": "Fish Tacos"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 48
    },
    {
      "id": "ed666626-d3d0-4083-87f4-f34ba93ae2b1",
      "title": "Tajine de poulet aux olives et au citron confit",
      "image": "images/ed666626-d3d0-4083-87f4-f34ba93ae2b1_0.jpg",
      "servings": "1",
      "readyInMinutes": 115,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "à 3 c. à soupe d'huile d'olive",
        "poulet d'environ 2 coupé en morceaux et sans peau ou 6 cuisses de poulet",
        "gros oignon haché",
        "à 4 gousses d'ail écrasées",
        "c. à thé de gingembre frais haché",
        "citron confit ou 2 citrons frais biologiques*",
        "bâton de nelle ou 1/2 c. à thé ( 2",
        "c. à thé de curcuma",
        "une bonne pincée de safran",
        "une bonne poignée de coriandre hachée",
        "une bonne poignée de persil plat haché",
        "tasses d'eau ou plus",
        "c. à thé de ras-el-hanout",
        "tasse d'olives violettes ou vertes",
        "sel de mer et poivre noir du moulin"
      ],
      "searchText": "tajine de poulet aux olives et au citron confit à 3 c. à soupe d'huile d'olive poulet d'environ 2 coupé en morceaux et sans peau ou 6 cuisses de poulet gros oignon haché à 4 gousses d'ail écrasées c. à thé de gingembre frais haché citron confit ou 2 citrons frais biologiques* bâton de nelle ou 1/2 c. à thé ( 2 c. à thé de curcuma une bonne pincée de safran une bonne poignée de coriandre hachée une bonne poignée de persil plat haché tasses d'eau ou plus c. à thé de ras-el-hanout tasse d'olives violettes ou vertes sel de mer et poivre noir du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://cuisinez.telequebec.tv/recettes/3212/tajine-de-poulet-aux-olives-et-au-citron-confit",
      "translatedTitles": {
        "en": "Chicken Tagine with Olives and Preserved Lemon"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 115
    },
    {
      "id": "c0ed83fc-cf07-4979-b089-1e316e1adb3e",
      "title": "Tartare de betteraves",
      "image": "images/c0ed83fc-cf07-4979-b089-1e316e1adb3e_0.jpg",
      "servings": "Pour 2 portions",
      "readyInMinutes": 9,
      "healthScore": 0,
      "dishTypes": [
        "appetizer"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tasse de betteraves déjà cuites",
        "c. à soupe de chapelure panko",
        "croûtons de pain",
        "c. à soupe de mayonnaise",
        "c. à soupe de cornichons gherkins",
        "c. à thé de câpres",
        "petite échalote française",
        "c. à thé de moutarde de dijon",
        "c. à thé de vinaigre de cidre",
        "quelques gouttes de tabasco",
        "sel et poivre"
      ],
      "searchText": "tartare de betteraves tasse de betteraves déjà cuites c. à soupe de chapelure panko croûtons de pain c. à soupe de mayonnaise c. à soupe de cornichons gherkins c. à thé de câpres petite échalote française c. à thé de moutarde de dijon c. à thé de vinaigre de cidre quelques gouttes de tabasco sel et poivre",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.troisfoisparjour.com/fr/recettes/entrees/tartares/tartare-de-betteraves/",
      "translatedTitles": {
        "en": "Beetroot Tartare"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 9,
      "readyInMinutesMin": 9
    },
    {
      "id": "8afed4b2-0b48-41bb-b908-1e67d1dc5db9",
      "title": "Tartare de boeuf (le meilleur)",
      "image": "images/8afed4b2-0b48-41bb-b908-1e67d1dc5db9_0.jpg",
      "servings": "4 portion(s)",
      "readyInMinutes": 21,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de jus de citron",
        "de moutarde de dijon",
        "de moutarde à l’ancienne",
        "jaune d’oeuf",
        "de câpres",
        "de sambal oelek",
        "d’huile d’olive",
        "d’intérieur de ronde de boeuf très frais",
        "de persil plat ciselé",
        "de ciboulette ciselée",
        "d’échalote française hachée finement"
      ],
      "searchText": "tartare de boeuf (le meilleur) de jus de citron de moutarde de dijon de moutarde à l’ancienne jaune d’oeuf de câpres de sambal oelek d’huile d’olive d’intérieur de ronde de boeuf très frais de persil plat ciselé de ciboulette ciselée d’échalote française hachée finement",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/5812-tartare-de-boeuf-le-meilleur",
      "sourceRating": 5,
      "sourceRatingCount": 166,
      "translatedTitles": {
        "en": "Beef Tartare (the best)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 21
    },
    {
      "id": "46b00317-f61e-4e9e-b466-68e477ac4d6a",
      "title": "Tartare de saumon (le meilleur)",
      "image": "images/46b00317-f61e-4e9e-b466-68e477ac4d6a_0.jpg",
      "servings": "4",
      "readyInMinutes": 23,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de saumon frais",
        "d’échalote française hachée finement",
        "de vinaigre de vin blanc",
        "d’eau",
        "d’huile d’olive",
        "de ciboulette ciselée",
        "de jus de citron",
        "de persil plat ciselé finement",
        "de moutarde à l’ancienne",
        "de câpres hachées",
        "de sauce tabasco",
        "glaçons"
      ],
      "searchText": "tartare de saumon (le meilleur) de saumon frais d’échalote française hachée finement de vinaigre de vin blanc d’eau d’huile d’olive de ciboulette ciselée de jus de citron de persil plat ciselé finement de moutarde à l’ancienne de câpres hachées de sauce tabasco glaçons",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7056-tartare-de-saumon-le-meilleur",
      "sourceRating": 5,
      "sourceRatingCount": 153,
      "translatedTitles": {
        "en": "Salmon Tartare (the best)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 23
    },
    {
      "id": "f71b47b3-abc4-45e1-946b-0b0dd11c9d71",
      "title": "Tarte à la citrouille (la meilleure)",
      "image": "images/f71b47b3-abc4-45e1-946b-0b0dd11c9d71_0.jpg",
      "servings": "8",
      "readyInMinutes": 106,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "croûte",
        "de farine tout usage non blanchie",
        "de sucre",
        "de sel",
        "de beurre non salé froid",
        "de yogourt nature",
        "garniture",
        "de fécule de maïs",
        "de muscade moulue",
        "œufs",
        "de purée de citrouille nature du commerce",
        "boîte de 300 de lait condensé sucré",
        "de crème",
        "de sucre à glacer"
      ],
      "searchText": "tarte à la citrouille (la meilleure) croûte de farine tout usage non blanchie de sucre de sel de beurre non salé froid de yogourt nature garniture de fécule de maïs de muscade moulue œufs de purée de citrouille nature du commerce boîte de 300 de lait condensé sucré de crème de sucre à glacer",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/7181-tarte-a-la-citrouille-la-meilleure",
      "sourceRating": 4,
      "sourceRatingCount": 83,
      "translatedTitles": {
        "en": "Pumpkin Pie (the best)"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 101
    },
    {
      "id": "402f9700-d586-486f-bfa2-8da102f5e858",
      "title": "Taverna Salad",
      "image": "images/402f9700-d586-486f-bfa2-8da102f5e858_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "plus 2 - olive oil",
        "red wine vinegar",
        "garlic",
        "oregano",
        "salt and pepper",
        "tomatoes",
        "chickpeas",
        "orange or yellow bell pepper",
        "english cucumber",
        "pitted kalamata olives",
        "parsley",
        "red onion or shallot",
        "capers",
        "scallions",
        "pita",
        "block halloumi cheese"
      ],
      "searchText": "taverna salad plus 2 - olive oil red wine vinegar garlic oregano salt and pepper tomatoes chickpeas orange or yellow bell pepper english cucumber pitted kalamata olives parsley red onion or shallot capers scallions pita block halloumi cheese",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025202-taverna-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 8691,
      "translatedTitles": {
        "fr": "Salade Taverna"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 43,
      "readyInMinutesMin": 41
    },
    {
      "id": "3303f113-bff0-4e1d-b44c-ff062e912fd7",
      "title": "Taverna Salad",
      "image": "images/3303f113-bff0-4e1d-b44c-ff062e912fd7_0.jpg",
      "servings": "4",
      "readyInMinutes": 41,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "plus 2 - olive oil",
        "red wine vinegar",
        "garlic",
        "oregano",
        "salt and pepper",
        "tomatoes",
        "chickpeas",
        "orange or yellow bell pepper",
        "english cucumber",
        "pitted kalamata olives",
        "parsley",
        "red onion or shallot",
        "capers",
        "scallions",
        "pita",
        "block halloumi cheese"
      ],
      "searchText": "taverna salad plus 2 - olive oil red wine vinegar garlic oregano salt and pepper tomatoes chickpeas orange or yellow bell pepper english cucumber pitted kalamata olives parsley red onion or shallot capers scallions pita block halloumi cheese",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1025202-taverna-salad?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 8691,
      "translatedTitles": {
        "fr": "Salade Taverna"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 41,
      "readyInMinutesMin": 39
    },
    {
      "id": "e7ae8638-f074-49e0-ab25-4402b509dad0",
      "title": "Thai Basil Beef Rice Bowls with Peanut Lime Sauce",
      "image": "images/e7ae8638-f074-49e0-ab25-4402b509dad0_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "beef",
        "vegetable oil",
        "cloves garlic",
        "thai basil leaves",
        "soy sauce",
        "oyster sauce",
        "fish sauce",
        "sugar",
        "red pepper flakes",
        "cooked jasmine rice",
        "creamy peanut butter",
        "lime juice",
        "soy sauce",
        "honey",
        "water",
        "sesame oil",
        "garlic",
        "peanuts",
        "lime wedges",
        "cilantro"
      ],
      "searchText": "thai basil beef rice bowls with peanut lime sauce beef vegetable oil cloves garlic thai basil leaves soy sauce oyster sauce fish sauce sugar red pepper flakes cooked jasmine rice creamy peanut butter lime juice soy sauce honey water sesame oil garlic peanuts lime wedges cilantro",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.lorachef.com/thai-basil-beef-rice-bowls-with-peanut-lime-sauce/",
      "translatedTitles": {
        "fr": "Bols de riz au bœuf, basilic thaï et sauce arachide-citron vert"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 34,
      "readyInMinutesMin": 40
    },
    {
      "id": "61ed3a12-b8b2-42bf-b71c-46c32193f66d",
      "title": "Thai-Style Coconut Curry Chicken Tacos",
      "image": "images/61ed3a12-b8b2-42bf-b71c-46c32193f66d_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ola oil",
        "thai red curry paste",
        "garlic",
        "boneless",
        "salt and pepper",
        "unsweetened full-fat coconut milk",
        "lime juice",
        "tomato",
        "finely red onion",
        "cilantro leaves and tender stems",
        "corn tortillas",
        "avocado"
      ],
      "searchText": "thai-style coconut curry chicken tacos ola oil thai red curry paste garlic boneless salt and pepper unsweetened full-fat coconut milk lime juice tomato finely red onion cilantro leaves and tender stems corn tortillas avocado",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1019815-thai-style-coconut-curry-chicken-tacos?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1588,
      "translatedTitles": {
        "fr": "Tacos au poulet, curry de noix de coco à la thaïlandaise"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 28,
      "readyInMinutesMin": 41
    },
    {
      "id": "8178101a-989f-42b5-9288-7eeb24872842",
      "title": "Thai-Style Coconut Curry Chicken Tacos",
      "image": "images/8178101a-989f-42b5-9288-7eeb24872842_0.jpg",
      "servings": "4",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "ola oil",
        "thai red curry paste",
        "garlic",
        "boneless",
        "salt and pepper",
        "unsweetened full-fat coconut milk",
        "lime juice",
        "tomato",
        "finely red onion",
        "cilantro leaves and tender stems",
        "corn tortillas",
        "avocado"
      ],
      "searchText": "thai-style coconut curry chicken tacos ola oil thai red curry paste garlic boneless salt and pepper unsweetened full-fat coconut milk lime juice tomato finely red onion cilantro leaves and tender stems corn tortillas avocado",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1019815-thai-style-coconut-curry-chicken-tacos?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 1588,
      "translatedTitles": {
        "fr": "Tacos de poulet au curry de coco à la thaïlandaise"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 42
    },
    {
      "id": "0261f2d9-32ca-48ef-9f53-7ca365e01dff",
      "title": "This 'supereasy ramen' recipe shows how easy it is to make the Japanese noodle dish at home",
      "image": "images/0261f2d9-32ca-48ef-9f53-7ca365e01dff_0.jpg",
      "servings": "Servings: 5",
      "readyInMinutes": 22,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "water",
        "half a soy sauce",
        "japanese mentsuyu soup base sauce",
        "oyster sauce",
        "chicken soup stock",
        "chicken oil",
        "sesame seed oil",
        "some grated garlic and grated sesame seeds"
      ],
      "searchText": "this 'supereasy ramen' recipe shows how easy it is to make the japanese noodle dish at home water half a soy sauce japanese mentsuyu soup base sauce oyster sauce chicken soup stock chicken oil sesame seed oil some grated garlic and grated sesame seeds",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://apnews.com/article/recipe-ramen-japan-food-07d1574a9e0337573077cacd0b7c7a82?utm_campaign=mb&utm_medium=newsletter&utm_source=morning_brew",
      "translatedTitles": {
        "fr": "Cette recette de 'ramen super facile' montre à quel point il est simple de préparer ce plat de nouilles japonais à la maison"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 12,
      "readyInMinutesMin": 22
    },
    {
      "id": "160972ee-cfb9-49bd-bf39-3ca302bd95c2",
      "title": "Tobiko Pasta",
      "image": "images/160972ee-cfb9-49bd-bf39-3ca302bd95c2_0.jpg",
      "servings": "4 to 6 servings",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salt",
        "spaghetti or linguine",
        "cream cheese",
        "chunk -sharp white cheddar or parmesan",
        "soy sauce",
        "wasabi paste",
        "heaping tobiko",
        "nori"
      ],
      "searchText": "tobiko pasta salt spaghetti or linguine cream cheese chunk -sharp white cheddar or parmesan soy sauce wasabi paste heaping tobiko nori",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1026397-tobiko-pasta?smid=ck-recipe-iOS-share",
      "sourceRating": 4,
      "sourceRatingCount": 288,
      "translatedTitles": {
        "fr": "Pâtes au Tobiko"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 15,
      "readyInMinutesMin": 32
    },
    {
      "id": "290d1259-c960-4996-88a9-752161bf893c",
      "title": "Tomato-Poached Fish With Chile Oil and Herbs",
      "image": "images/290d1259-c960-4996-88a9-752161bf893c_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 43,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "garlic cloves",
        "shallot",
        "red-pepper flakes",
        "kosher salt and black pepper",
        "fish sauce",
        "fluke",
        "cilantro",
        "mint",
        "limes",
        "tortillas"
      ],
      "searchText": "tomato-poached fish with chile oil and herbs olive oil garlic cloves shallot red-pepper flakes kosher salt and black pepper fish sauce fluke cilantro mint limes tortillas",
      "isPersonalRecipe": true,
      "nutritionScore": 55,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1020279-tomato-poached-fish-with-chile-oil-and-herbs?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 5741,
      "translatedTitles": {
        "fr": "Poisson poché à la tomate avec huile pimentée et herbes"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 32,
      "readyInMinutesMin": 36
    },
    {
      "id": "13bfcb04-df22-473e-adef-d46063f45b3c",
      "title": "Tortellini au fromage à la mijoteuse",
      "image": "images/13bfcb04-df22-473e-adef-d46063f45b3c_0.jpg",
      "servings": "1",
      "readyInMinutes": 511,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de boeuf haché maigre",
        "de saucisses italiennes sans les boyaux",
        "tasses de sauce marinara",
        "tasse de champignons frais tranchés",
        "conserve de tomates en dés avec leur jus",
        "pqt de tortellinis au fromage",
        "tasse de mozzarella râpé",
        "tasse de cheddar râpé"
      ],
      "searchText": "tortellini au fromage à la mijoteuse de boeuf haché maigre de saucisses italiennes sans les boyaux tasses de sauce marinara tasse de champignons frais tranchés conserve de tomates en dés avec leur jus pqt de tortellinis au fromage tasse de mozzarella râpé tasse de cheddar râpé",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.recettesquebecoises.com/recette/15720-tortellini-au-fromage-a-la-mijoteuse",
      "translatedTitles": {
        "en": "Cheese Tortellini in a Slow Cooker"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 16,
      "readyInMinutesMin": 451
    },
    {
      "id": "accae100-34f5-4c8d-ae0e-2a6ea286de63",
      "title": "Trois saveurs de muffins sur une plaque",
      "image": "images/accae100-34f5-4c8d-ae0e-2a6ea286de63_0.jpg",
      "servings": "24",
      "readyInMinutes": 101,
      "healthScore": 0,
      "dishTypes": [
        "snack"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "patate douce et épices",
        "patate douce d’environ 340",
        "de graines de citrouille",
        "pomme et dattes",
        "de purée de pommes non sucrée",
        "de dattes",
        "de gros flocons d’avoine",
        "courgettes et chocolat",
        "de courgettes",
        "de pépites de chocolat noir ou au lait",
        "de cacao tamisé",
        "mélange pour muffins de base",
        "de farine tout usage non blanchie",
        "de farine de blé entier",
        "de céréales de son",
        "œufs",
        "de sucre",
        "d’huile d’olive",
        "de yogourt nature"
      ],
      "searchText": "trois saveurs de muffins sur une plaque patate douce et épices patate douce d’environ 340 de graines de citrouille pomme et dattes de purée de pommes non sucrée de dattes de gros flocons d’avoine courgettes et chocolat de courgettes de pépites de chocolat noir ou au lait de cacao tamisé mélange pour muffins de base de farine tout usage non blanchie de farine de blé entier de céréales de son œufs de sucre d’huile d’olive de yogourt nature collation",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.ricardocuisine.com/recettes/8580-trois-saveurs-de-muffins-sur-une-plaque",
      "sourceRating": 5,
      "sourceRatingCount": 10,
      "translatedTitles": {
        "en": "Three flavors of muffins on a sheet pan"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 35,
      "readyInMinutesMin": 99
    },
    {
      "id": "f9b3e303-5426-435c-8395-e7cbbe86b52c",
      "title": "Tuna Ceviche or Tartare With Avocado",
      "image": "images/f9b3e303-5426-435c-8395-e7cbbe86b52c_0.jpg",
      "servings": "Serves four to six",
      "readyInMinutes": 47,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "albacore or yellowfin tuna",
        "red onion",
        "garlic clove",
        "to 2 serrano or jalapeño chiles",
        "capers",
        "ripe avocado",
        "salt",
        "ly pepper to taste",
        "lime juice",
        "olive oil",
        "to 1/2 cilantro to taste",
        "leaf lettuce"
      ],
      "searchText": "tuna ceviche or tartare with avocado albacore or yellowfin tuna red onion garlic clove to 2 serrano or jalapeño chiles capers ripe avocado salt ly pepper to taste lime juice olive oil to 1/2 cilantro to taste leaf lettuce",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1014316-tuna-ceviche-or-tartare-with-avocado?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 619,
      "translatedTitles": {
        "fr": "Ceviche ou tartare de thon à l'avocat"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 27,
      "readyInMinutesMin": 47
    },
    {
      "id": "d017e2c8-24e6-5eee-8b68-931c0196bf5a",
      "title": "Tuna Nicoise Salad",
      "image": "images/d017e2c8-24e6-5eee-8b68-931c0196bf5a_0.jpg",
      "servings": "4",
      "readyInMinutes": 54,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "cooked tuna steaks or 2 s of tuna",
        "potatoes",
        "fine french beans",
        "tomatoes",
        "romaine lettuce",
        "red onion",
        "hard-boiled eggs",
        "black olives",
        "parsley",
        "olive oil",
        "red wine vinegar",
        "garlic cloves",
        "salt",
        "black pepper"
      ],
      "searchText": "tuna nicoise salad cooked tuna steaks or 2 s of tuna potatoes fine french beans tomatoes romaine lettuce red onion hard-boiled eggs black olives parsley olive oil red wine vinegar garlic cloves salt black pepper main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceRating": 5,
      "sourceRatingCount": 19,
      "translatedTitles": {
        "fr": "Salade Niçoise au Thon"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 29,
      "readyInMinutesMin": 49
    },
    {
      "id": "4c036aaf-a018-44ab-bcad-c6a588563149",
      "title": "Œufs écossais à la saucisse",
      "image": "images/4c036aaf-a018-44ab-bcad-c6a588563149_0.jpg",
      "servings": "1",
      "readyInMinutes": 67,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "œufs dans leur coquille",
        "de saucisses de toulouse ou italiennes douces",
        "oignons verts",
        "de moutarde de dijon",
        "panure",
        "de farine tout usage non blanchie",
        "œuf",
        "de chapelure",
        "huile de ola"
      ],
      "searchText": "œufs écossais à la saucisse œufs dans leur coquille de saucisses de toulouse ou italiennes douces oignons verts de moutarde de dijon panure de farine tout usage non blanchie œuf de chapelure huile de ola",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/48126c70-2973-46d1-8ee6-046a1912e28e__7C___0.html",
      "translatedTitles": {
        "en": "Sausage Scotch Eggs"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 46,
      "readyInMinutesMin": 67
    },
    {
      "id": "f911f13e-7560-4c6a-a929-92ef387a86f9",
      "title": "Vegan Gyros With Grilled Tofu And Tzatziki Sauce",
      "image": "images/f911f13e-7560-4c6a-a929-92ef387a86f9_0.jpg",
      "servings": "4 Gyros",
      "readyInMinutes": 40,
      "healthScore": 0,
      "dishTypes": [
        "sauce"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "firm tofu",
        "oil",
        "tamari",
        "balsamic vinegar",
        "brown sugar",
        "tomato paste",
        "granulated garlic",
        "salt",
        "pinch of pepper",
        "dill",
        "coriander",
        "oregano",
        "cumin",
        "cinnamon",
        "recipe 1o minute tzatziki sauce",
        "pitas",
        "tomatoes",
        "about half english cucumber",
        "or so",
        "red onion",
        "hummus",
        "black olives",
        "french fries",
        "herbs like dill"
      ],
      "searchText": "vegan gyros with grilled tofu and tzatziki sauce firm tofu oil tamari balsamic vinegar brown sugar tomato paste granulated garlic salt pinch of pepper dill coriander oregano cumin cinnamon recipe 1o minute tzatziki sauce pitas tomatoes about half english cucumber or so red onion hummus black olives french fries herbs like dill",
      "isPersonalRecipe": true,
      "nutritionScore": 45,
      "originalLanguage": "en",
      "sourceUrl": "https://thecheekychickpea.com/vegan-gyros/",
      "sourceRating": 5,
      "sourceRatingCount": 6,
      "translatedTitles": {
        "fr": "Gyros végétaliens au tofu grillé et sauce Tzatziki"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "4b019b0c-1ab0-473b-987f-5d018922f66e",
      "title": "VEGAN STEAKHOUSE DINNER - WINE GLAZED MUSHROOMS, CHARRED VEGGIE DEMI, AND CREAMY MASHED POTATOES",
      "image": "images/4b019b0c-1ab0-473b-987f-5d018922f66e_0.jpg",
      "servings": "1",
      "readyInMinutes": 0,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "eggplant “steaks”:",
        "eggplants",
        "cumin seed",
        "brown mustard seed",
        "peppercorn medley",
        "½ dill seed",
        "granulated garlic",
        "onion powder",
        "smoked paprika",
        "mushroom powder",
        "rosemary",
        "cayenne or red pepper flakes",
        "basting jus:",
        "dry red wine",
        "beet juice",
        "sprigs of rosemary",
        "vegan bouillon",
        "vegan butter",
        "¼ soy sauce or tamari",
        "vegan worcestershire",
        "liquid aminos",
        "steakhouse red wine-glazed mushrooms:",
        "trumpet mushrooms",
        "- olive oil",
        "shiitake mushrooms",
        "vegan butter",
        "shallot",
        "garlic cloves",
        "⅓ red wine",
        "½ mushroom stock",
        "good amount of cracked black pepper",
        "splash of vegan worcestershire sauce",
        "pinch of picked thyme",
        "creamy roasted garlic mash:",
        "yukon gold potatoes",
        "kosher salt and ly black pepper",
        "vegan butter",
        "⅓ vegan cream or plant-based milk",
        "roasted garlic cloves",
        "chives",
        "charred vegetable melange demi glace:",
        "mixed mushrooms",
        "eggplant",
        "carrots",
        "celery stalks",
        "garlic cloves",
        "olive oil",
        "plum tomatoes",
        "onions",
        "tomato paste",
        "red wine",
        "strip of kombu*",
        "bay leaf",
        "of peppercorns",
        "sprigs rosemary or thyme",
        "mushroom broth",
        "liquid aminos",
        "dandelion greens"
      ],
      "searchText": "vegan steakhouse dinner - wine glazed mushrooms, charred veggie demi, and creamy mashed potatoes eggplant “steaks”: eggplants cumin seed brown mustard seed peppercorn medley ½ dill seed granulated garlic onion powder smoked paprika mushroom powder rosemary cayenne or red pepper flakes basting jus: dry red wine beet juice sprigs of rosemary vegan bouillon vegan butter ¼ soy sauce or tamari vegan worcestershire liquid aminos steakhouse red wine-glazed mushrooms: trumpet mushrooms - olive oil shiitake mushrooms vegan butter shallot garlic cloves ⅓ red wine ½ mushroom stock good amount of cracked black pepper splash of vegan worcestershire sauce pinch of picked thyme creamy roasted garlic mash: yukon gold potatoes kosher salt and ly black pepper vegan butter ⅓ vegan cream or plant-based milk roasted garlic cloves chives charred vegetable melange demi glace: mixed mushrooms eggplant carrots celery stalks garlic cloves olive oil plum tomatoes onions tomato paste red wine strip of kombu* bay leaf of peppercorns sprigs rosemary or thyme mushroom broth liquid aminos dandelion greens",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.gordonramsay.com/gr/recipes/vegansteakdinner",
      "translatedTitles": {
        "fr": "DÎNER STEAKHOUSE VÉGAN - CHAMPIGNONS GLAÇÉS AU VIN, DEMI DE LÉGUMES GRILLÉS ET PURÉE DE POMMES DE TERRE CRÉMEUSE"
      },
      "languages": [
        "en",
        "fr"
      ]
    },
    {
      "id": "942e36a3-21c9-417d-bbf6-2572cf085f50",
      "title": "Vegan Tantanmen With Pan-Fried Tofu",
      "image": "images/942e36a3-21c9-417d-bbf6-2572cf085f50_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 77,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "kosher salt and black pepper",
        "ramen noodles",
        "to 4 - olive oil",
        "-firm tofu",
        "shiitake mushrooms",
        "vegetable stock",
        "piece kombu",
        "soy or oat milk",
        "chinese or japanese sesame paste",
        "soy sauce",
        "sesame oil",
        "rice vinegar",
        "granulated sugar",
        "chile oil",
        "corn",
        "scallions",
        "roasted sesame seeds"
      ],
      "searchText": "vegan tantanmen with pan-fried tofu kosher salt and black pepper ramen noodles to 4 - olive oil -firm tofu shiitake mushrooms vegetable stock piece kombu soy or oat milk chinese or japanese sesame paste soy sauce sesame oil rice vinegar granulated sugar chile oil corn scallions roasted sesame seeds",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1022099-vegan-tantanmen-with-pan-fried-tofu",
      "sourceRating": 4,
      "sourceRatingCount": 3319,
      "translatedTitles": {
        "fr": "Tantanmen Vegan au Tofu Poêlé"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 50,
      "readyInMinutesMin": 75
    },
    {
      "id": "20a57e64-1f86-4328-8dae-36321b88e464",
      "title": "Velouté de carottes aux fruits de la passion et au lait de coco, croûte de pain au foie gras poêlé",
      "image": "images/20a57e64-1f86-4328-8dae-36321b88e464_0.jpg",
      "servings": "4",
      "readyInMinutes": 55,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de carottes",
        "oignon",
        "cm de gingembre frais",
        "cuillère à soupe d'huile d'olive",
        "orange",
        "cuillère à soupe d'eau de fleur d'oranger",
        "cl de lait de coco",
        "cl de bouillon de légumes",
        "cuillère à soupe de crème de coco",
        "fruits de la passion",
        "brins de thym",
        "de foie gras frais",
        "tranches fines de pain"
      ],
      "searchText": "velouté de carottes aux fruits de la passion et au lait de coco, croûte de pain au foie gras poêlé de carottes oignon cm de gingembre frais cuillère à soupe d'huile d'olive orange cuillère à soupe d'eau de fleur d'oranger cl de lait de coco cl de bouillon de légumes cuillère à soupe de crème de coco fruits de la passion brins de thym de foie gras frais tranches fines de pain",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.elle.fr/Noel/Cuisine/Recettes-de-Noel/Veloute-de-carottes-aux-fruits-de-la-passion-et-au-lait-de-coco-croute-de-pain-au-foie-gras-poele-3970892",
      "sourceRating": 3.56,
      "sourceRatingCount": 99,
      "translatedTitles": {
        "en": "Carrot Velouté with Passion Fruit and Coconut Milk, Foie Gras Toasts"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 55
    },
    {
      "id": "cc277ed4-7227-49fe-8c25-479ecf2af1c4",
      "title": "Velouté de carottes aux fruits de la passion et au lait de coco, croûte de pain au foie gras poêlé",
      "image": "images/cc277ed4-7227-49fe-8c25-479ecf2af1c4_0.jpg",
      "servings": "4",
      "readyInMinutes": 55,
      "healthScore": 0,
      "dishTypes": [
        "soup"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "de carottes",
        "oignon",
        "cm de gingembre frais",
        "cuillère à soupe d'huile d'olive",
        "orange",
        "cuillère à soupe d'eau de fleur d'oranger",
        "cl de lait de coco",
        "cl de bouillon de légumes",
        "cuillère à soupe de crème de coco",
        "fruits de la passion",
        "brins de thym",
        "de foie gras frais",
        "tranches fines de pain"
      ],
      "searchText": "velouté de carottes aux fruits de la passion et au lait de coco, croûte de pain au foie gras poêlé de carottes oignon cm de gingembre frais cuillère à soupe d'huile d'olive orange cuillère à soupe d'eau de fleur d'oranger cl de lait de coco cl de bouillon de légumes cuillère à soupe de crème de coco fruits de la passion brins de thym de foie gras frais tranches fines de pain",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.elle.fr/Noel/Cuisine/Recettes-de-Noel/Veloute-de-carottes-aux-fruits-de-la-passion-et-au-lait-de-coco-croute-de-pain-au-foie-gras-poele-3970892",
      "sourceRating": 3.56,
      "sourceRatingCount": 99,
      "translatedTitles": {
        "en": "Carrot Velouté with Passion Fruit and Coconut Milk, Pan-fried Foie Gras Bread Crust"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 55
    },
    {
      "id": "ad256745-48c9-47b1-9656-d1d79c1353a9",
      "title": "Salade de maïs à la mexicaine",
      "image": "images/ad256745-48c9-47b1-9656-d1d79c1353a9_0.jpg",
      "servings": "1",
      "readyInMinutes": 35,
      "healthScore": 0,
      "dishTypes": [
        "salad"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "épis de maïs épluchés",
        "poivron jaune",
        "½ oignon rouge",
        "piments jalapeños",
        "tasses de coriandre fraîche",
        "de fromage feta émietté",
        "⅓ tasse de graines de tournesol grillées*",
        "vinaigrette",
        "c. à soupe d’huile d’olive vierge",
        "c. à soupe de jus de lime",
        "c. à soupe de jus d’orange",
        "c. à thé de miel",
        "c. à thé d’origan séché",
        "c. à thé de cumin moulu",
        "¼ c. à thé (1",
        "poivre du moulin"
      ],
      "searchText": "salade de maïs à la mexicaine épis de maïs épluchés poivron jaune ½ oignon rouge piments jalapeños tasses de coriandre fraîche de fromage feta émietté ⅓ tasse de graines de tournesol grillées* vinaigrette c. à soupe d’huile d’olive vierge c. à soupe de jus de lime c. à soupe de jus d’orange c. à thé de miel c. à thé d’origan séché c. à thé de cumin moulu ¼ c. à thé (1 poivre du moulin",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://plus.lapresse.ca/screens/dbbfdd4d-2d4a-45f5-a9ca-2cffe46edfe4__7C___0.html?utm_content=ulink&utm_source=lpp&utm_medium=referral&utm_campaign=internal+share",
      "translatedTitles": {
        "en": "Mexican Corn Salad"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 20,
      "readyInMinutesMin": 35
    },
    {
      "id": "e58d0aea-8cf8-484e-bc53-cd177578b6ab",
      "title": "Walnut-Rosemary Crusted Salmon",
      "image": "images/e58d0aea-8cf8-484e-bc53-cd177578b6ab_0.jpg",
      "servings": "4",
      "readyInMinutes": 33,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "dijon mustard",
        "clove garlic",
        "¼ lemon zest",
        "lemon juice",
        "rosemary",
        "½ honey",
        "½ kosher salt",
        "¼ red pepper",
        "panko breadcrumbs",
        "finely walnuts",
        "- olive oil",
        "skinless salmon fillet",
        "olive oil cooking spray",
        "parsley and lemon wedges for garnish"
      ],
      "searchText": "walnut-rosemary crusted salmon dijon mustard clove garlic ¼ lemon zest lemon juice rosemary ½ honey ½ kosher salt ¼ red pepper panko breadcrumbs finely walnuts - olive oil skinless salmon fillet olive oil cooking spray parsley and lemon wedges for garnish",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.eatingwell.com/recipe/267223/walnut-rosemary-crusted-salmon/",
      "translatedTitles": {
        "fr": "Saumon en Croûte de Noix et Romarin"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 21,
      "readyInMinutesMin": 29
    },
    {
      "id": "09949306-2370-4085-a304-10a326de6acf",
      "title": "Walnut-Rosemary Crusted Salmon",
      "image": "images/09949306-2370-4085-a304-10a326de6acf_0.jpg",
      "servings": "1",
      "readyInMinutes": 37,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "dijon mustard",
        "clove garlic",
        "¼ lemon zest",
        "lemon juice",
        "rosemary",
        "½ honey",
        "½ kosher salt",
        "¼ red pepper",
        "panko breadcrumbs",
        "finely walnuts",
        "- olive oil",
        "skinless salmon fillet",
        "olive oil cooking spray",
        "parsley and lemon wedges for garnish"
      ],
      "searchText": "walnut-rosemary crusted salmon dijon mustard clove garlic ¼ lemon zest lemon juice rosemary ½ honey ½ kosher salt ¼ red pepper panko breadcrumbs finely walnuts - olive oil skinless salmon fillet olive oil cooking spray parsley and lemon wedges for garnish",
      "isPersonalRecipe": true,
      "nutritionScore": 65,
      "originalLanguage": "en",
      "sourceUrl": "https://www.eatingwell.com/recipe/267223/walnut-rosemary-crusted-salmon/",
      "translatedTitles": {
        "fr": "Saumon en croûte de noix et romarin"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 33
    },
    {
      "id": "f7ec738f-3342-4bbc-a722-d5c6a6455411",
      "title": "Weight Loss Wonder Soup",
      "image": "images/f7ec738f-3342-4bbc-a722-d5c6a6455411_0.jpg",
      "servings": "5 servings",
      "readyInMinutes": 103,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "olive oil",
        "onions)",
        "green bell pepper)",
        "cabe)",
        "tomatoes)",
        "bunch celery)",
        "water"
      ],
      "searchText": "weight loss wonder soup olive oil onions) green bell pepper) cabe) tomatoes) bunch celery) water main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://homemadehooplah.com/weight-loss-wonder-soup/",
      "sourceRating": 4.42,
      "sourceRatingCount": 162,
      "translatedTitles": {
        "fr": "Soupe Merveilleuse pour la Perte de Poids"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 38,
      "readyInMinutesMin": 88
    },
    {
      "id": "41719baf-2155-4556-a198-ff0122d14c8a",
      "title": "Wraps au halloumi et avocat",
      "servings": "1",
      "readyInMinutes": 18,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "tranches de halloumi",
        "tortillas de blé entier",
        "tasse d'hummus ou mayonnaise",
        "laitue ou feuilles d'épinards",
        "petite carotte râpée",
        "oignon vert",
        "avocat tranché"
      ],
      "searchText": "wraps au halloumi et avocat tranches de halloumi tortillas de blé entier tasse d'hummus ou mayonnaise laitue ou feuilles d'épinards petite carotte râpée oignon vert avocat tranché plat principal",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "fr",
      "sourceUrl": "https://www.noovomoi.ca/cuisiner/recettes/recette.wraps-au-halloumi-et-avocat.1.11117206.html",
      "image": "images/41719baf-2155-4556-a198-ff0122d14c8a_0.jpg",
      "translatedTitles": {
        "en": "Halloumi and Avocado Wraps"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 18,
      "readyInMinutesMin": 18
    },
    {
      "id": "c615a1dd-31cc-418c-aec1-0cf41c9af56d",
      "title": "Yotam Ottolenghi’s Jerusalem Lamb Shawarma",
      "image": "images/c615a1dd-31cc-418c-aec1-0cf41c9af56d_0.jpg",
      "servings": "Serves 8",
      "readyInMinutes": 442,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "black peppercorns",
        "cloves",
        "cardamom pods",
        "fenugreek seeds",
        "fennel seeds",
        "cumin seeds",
        "star anise",
        "cinnamon stick",
        "grated nutmeg",
        "ginger",
        "sweet paprika",
        "sumac",
        "kosher salt",
        "inch piece of ginger",
        "garlic cloves",
        "cilantro",
        "-squeezed lemon juice",
        "peanut or other neutral oil",
        "leg of lamb"
      ],
      "searchText": "yotam ottolenghi’s jerusalem lamb shawarma black peppercorns cloves cardamom pods fenugreek seeds fennel seeds cumin seeds star anise cinnamon stick grated nutmeg ginger sweet paprika sumac kosher salt inch piece of ginger garlic cloves cilantro -squeezed lemon juice peanut or other neutral oil leg of lamb",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1018119-yotam-ottolenghis-jerusalem-lamb-shawarma?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 676,
      "translatedTitles": {
        "fr": "Shawarma d'agneau de Jérusalem de Yotam Ottolenghi"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 25,
      "readyInMinutesMin": 436
    },
    {
      "id": "f52254d7-1261-4e03-9b0c-3c477c549088",
      "title": "Za’atar Fish and Chips",
      "image": "images/f52254d7-1261-4e03-9b0c-3c477c549088_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 113,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "red onion",
        ". apple cider vinegar",
        "kosher salt",
        "½ . yukon gold potatoes",
        ". - olive oil",
        "¼-. skinless",
        ". za’atar",
        "¾ pitted castelvetrano olives",
        "½ coarsely mint",
        "za’atar"
      ],
      "searchText": "za’atar fish and chips red onion . apple cider vinegar kosher salt ½ . yukon gold potatoes . - olive oil ¼-. skinless . za’atar ¾ pitted castelvetrano olives ½ coarsely mint za’atar",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://www.bonappetit.com/recipe/zaatar-fish-and-chips",
      "sourceRating": 4.3,
      "sourceRatingCount": 42,
      "translatedTitles": {
        "fr": "Za’atar Fish and Chips"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 19,
      "readyInMinutesMin": 58
    },
    {
      "id": "f431d04e-d876-44a6-b222-b73e02d1364f",
      "title": "Za’atar Roasted Tofu With Chickpeas, Tomatoes and Lemony Tahini",
      "image": "images/f431d04e-d876-44a6-b222-b73e02d1364f_0.jpg",
      "servings": "4 servings",
      "readyInMinutes": 66,
      "healthScore": 0,
      "dishTypes": [],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "firm tofu",
        "chickpeas",
        "pint cherry or grape tomatoes",
        "salt and pepper",
        "garlic cloves",
        "lemons",
        "- olive oil",
        "za’atar dry spice mix",
        "oregano or marjoram",
        "flat-leaf parsley",
        "soy sauce",
        "tahini",
        "honey",
        "leafy greens"
      ],
      "searchText": "za’atar roasted tofu with chickpeas, tomatoes and lemony tahini firm tofu chickpeas pint cherry or grape tomatoes salt and pepper garlic cloves lemons - olive oil za’atar dry spice mix oregano or marjoram flat-leaf parsley soy sauce tahini honey leafy greens",
      "isPersonalRecipe": true,
      "nutritionScore": 60,
      "originalLanguage": "en",
      "sourceUrl": "https://cooking.nytimes.com/recipes/1023630-zaatar-roasted-tofu-with-chickpeas-tomatoes-and-lemony-tahini?smid=ck-recipe-iOS-share",
      "sourceRating": 5,
      "sourceRatingCount": 4638,
      "translatedTitles": {
        "fr": "Tofu Rôti au Za'atar Avec Pois Chiches, Tomates et Tahini Citronné"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 30,
      "readyInMinutesMin": 66
    },
    {
      "id": "ae7fc86a-cdd9-4052-8231-54e95d9b2c59",
      "title": "Za’atar Salmon & Tahini From Ottolenghi Test Kitchen",
      "image": "images/ae7fc86a-cdd9-4052-8231-54e95d9b2c59_0.jpg",
      "servings": "Serves 4",
      "readyInMinutes": 42,
      "healthScore": 0,
      "dishTypes": [
        "main course"
      ],
      "cuisines": [],
      "diets": [],
      "ingredients": [
        "salmon fillets",
        "za’atar",
        "sumac",
        "olive oil",
        "baby spinach or other tender green of choice",
        "tahini",
        "garlic cloves",
        "ly squeezed lemon juice",
        "roughly cilantro leaves",
        "kosher salt and ly black pepper"
      ],
      "searchText": "za’atar salmon & tahini from ottolenghi test kitchen salmon fillets za’atar sumac olive oil baby spinach or other tender green of choice tahini garlic cloves ly squeezed lemon juice roughly cilantro leaves kosher salt and ly black pepper main dish",
      "isPersonalRecipe": true,
      "nutritionScore": 50,
      "originalLanguage": "en",
      "sourceUrl": "https://food52.com/recipes/86926-sauteed-salmon-recipe-with-tahini-greens/amp",
      "translatedTitles": {
        "fr": "Saumon au Za’atar & Tahini de Ottolenghi Test Kitchen"
      },
      "languages": [
        "en",
        "fr"
      ],
      "handsOnMinutes": 24,
      "readyInMinutesMin": 41
    }
  ]
}
